import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Decimal: { input: any; output: any; }
  HexString: { input: any; output: any; }
  PreciseDateTime: { input: string; output: string; }
  ReleaseType: { input: any; output: any; }
};

export type AccessCode = {
  __typename?: 'AccessCode';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  type: AccessCodeType;
};

export enum AccessCodeFailureReason {
  NotFound = 'NOT_FOUND'
}

export type AccessCodeInput = {
  active: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccessCodeType>;
};

export enum AccessCodeType {
  /** Standard entry code used for a student's first session */
  Entry = 'ENTRY',
  /** Re-entry code that authorises a subsequent session after an exit */
  Reentry = 'REENTRY'
}

/** Access group for a question */
export enum AccessGroup {
  Restricted = 'RESTRICTED',
  Subject = 'SUBJECT',
  University = 'UNIVERSITY'
}

/** Access role for a question */
export enum AccessRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

/**
 * Gradebook result access summary describing the last access to a unique
 * external service via the result.
 */
export type AccessSummary = {
  __typename?: 'AccessSummary';
  accessCount: Scalars['Int']['output'];
  lastAccess: Scalars['PreciseDateTime']['output'];
  memberSummaries: Array<MemberSummary>;
  service: GradebookService;
};

export type AddQuestionBanksToAssessmentInput = {
  filter: QuestionBankFilterInput;
  questionBankNodes: Array<QuestionBankNodes>;
};

/** A representation of an answer to a question block */
export type AnswerBlock = {
  __typename?: 'AnswerBlock';
  /** Attachments to this answer block */
  blockAttachments: Array<BlockAttachment>;
  /** Special Block name, used for naming classic editor blocks. */
  blockName: Maybe<Scalars['String']['output']>;
  /** Bookmarked by the student. */
  bookmark: Maybe<Scalars['Boolean']['output']>;
  /** Explicit student confirmation on completed attempt */
  confirm: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  latestBlockSnapshot: Maybe<BlockSnapshot>;
  /** Tree layout node ID for the block */
  nodeId: Scalars['ID']['output'];
  /** Numeric ordering */
  order: Maybe<Scalars['Int']['output']>;
  /** Labelled ordering */
  orderLabel: Maybe<Scalars['String']['output']>;
  /** Tree layout parent node ID for this block */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  /** Points alloted to this answer. */
  points: Maybe<Scalars['Int']['output']>;
  /** Tree layout previous node ID for this block */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  /** Question being answered by the Answer block */
  question: Maybe<Question>;
  /** Question ID that this Answer is answering */
  questionId: Maybe<Scalars['ID']['output']>;
  /** Shuffle answer options */
  shuffle: Maybe<Scalars['Boolean']['output']>;
  /** Skipped by the student. */
  skip: Maybe<Scalars['Boolean']['output']>;
};

/** Known editing block names */
export enum AnswerBlockName {
  Body = 'body',
  Notes = 'notes',
  References = 'references'
}

/** API status information */
export type ApiStatusType = {
  __typename?: 'ApiStatusType';
  hasBrightspaceApi: Scalars['Boolean']['output'];
  hasCanvasApi: Scalars['Boolean']['output'];
};

/**
 * A Cadmus Assessment
 *
 * Contains information available to all roles. Wraps some Subject information
 * and the latest Instruction sheet.
 */
export type Assessment = {
  __typename?: 'Assessment';
  /** Submission due date for on-time submissions, set in the LMS. */
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Assessment Edition */
  edition: Scalars['Int']['output'];
  /** Font family/size controls (the FontMarks editor extension). */
  enableFontControls: Scalars['Boolean']['output'];
  /** Assessment cut-off date, set in the LMS. */
  endDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Grading reminder date, set in the LMS. */
  gradingDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Predicate checking if at least 1 save has been made in the Assessment. */
  hasSave: Scalars['Boolean']['output'];
  /** Predicate checking if at least 1 submission has been made in the Assessment. */
  hasSubmission: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** LTI Custom Parameters from source LMS. */
  ltiCustomParams: Maybe<CustomParams>;
  /** All the LTI 1.1 and 1.3 services recorded for this Assessment. */
  ltiServices: Array<LtiService>;
  /** Institutions LMS Tool Provider used to launch this Assessment. */
  ltiTool: InstitutionTool;
  name: Scalars['String']['output'];
  /** Schoolyear Exam linked to this assessment. */
  schoolyearExam: Maybe<SchoolyearExam>;
  /** Assessment wide settings. */
  settings: Maybe<AssessmentSettings>;
  /** Assessment submission start date set in the LMS. */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  /** @deprecated Use the subject name from subject.name instead */
  subjectName: Scalars['String']['output'];
  /** All Tasks belonging to this Assessment. */
  tasks: Array<Task>;
  /**
   * The current teacher's satisfaction survey state for a given moment.
   *
   * `active` is true — i.e. the rating card should still be shown — only when
   * all of these hold: the `teacher_satisfaction_survey` feature flag is
   * enabled, the session is not impersonated, and the teacher has neither rated
   * nor dismissed the prompt (no row exists).
   */
  teacherSatisfaction: TeacherSurvey;
};


/**
 * A Cadmus Assessment
 *
 * Contains information available to all roles. Wraps some Subject information
 * and the latest Instruction sheet.
 */
export type AssessmentSubjectArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


/**
 * A Cadmus Assessment
 *
 * Contains information available to all roles. Wraps some Subject information
 * and the latest Instruction sheet.
 */
export type AssessmentTeacherSatisfactionArgs = {
  moment: Moment;
};

/** A student's email-sharing consent state for a group assessment. */
export type AssessmentEmailConsent = {
  __typename?: 'AssessmentEmailConsent';
  /** Latest consent choice; null if the student has never answered. */
  consent: Maybe<Scalars['Boolean']['output']>;
  /** Mirror of the assessment setting `group_show_email_to_students`. */
  enabled: Scalars['Boolean']['output'];
};

/**
 * A lightweight assessment search result — just enough to label an option
 * in a search/autocomplete UI.
 */
export type AssessmentOption = {
  __typename?: 'AssessmentOption';
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  name: Scalars['String']['output'];
};

/** Enum of Assessment presets */
export enum AssessmentPreset {
  Classic = 'CLASSIC',
  Group = 'GROUP',
  Multiformat = 'MULTIFORMAT',
  Viva = 'VIVA'
}

export type AssessmentProgressResponse = {
  __typename?: 'AssessmentProgressResponse';
  charter: ProgressSection;
  peer: ProgressSection;
  work: WorkProgress;
};

/** Settings for an Assessment */
export type AssessmentSettings = {
  __typename?: 'AssessmentSettings';
  allowGenerativeAi: Maybe<Scalars['Boolean']['output']>;
  anonymousMarking: Maybe<Scalars['Boolean']['output']>;
  assessmentType: AssessmentType;
  copyleaksEnabled: Scalars['Boolean']['output'];
  countFootnotes: Scalars['Boolean']['output'];
  countReferences: Scalars['Boolean']['output'];
  doubleBlindMarkingEnabled: Scalars['Boolean']['output'];
  draftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  draftEnabled: Scalars['Boolean']['output'];
  draftScoringEnabled: Scalars['Boolean']['output'];
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examAccessCodeEnabled: Scalars['Boolean']['output'];
  examAutoSubmissionDisabled: Scalars['Boolean']['output'];
  examBacktrackDisabled: Scalars['Boolean']['output'];
  examEndDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examInactivityTimeout: Maybe<Scalars['Int']['output']>;
  examIpFilter: Maybe<Scalars['String']['output']>;
  examIpFilterEnabled: Scalars['Boolean']['output'];
  examLdbEnabled: Scalars['Boolean']['output'];
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examReadingTimeDisabled: Scalars['Boolean']['output'];
  examReentryPreventionEnabled: Scalars['Boolean']['output'];
  examSchoolyearEnabled: Scalars['Boolean']['output'];
  examStartDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examTiming: ExamTiming;
  examType: Array<Scalars['String']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  feedbackDate: Maybe<Scalars['PreciseDateTime']['output']>;
  feedbackDateDisabled: Scalars['Boolean']['output'];
  groupAssessmentEnabled: Scalars['Boolean']['output'];
  groupChangeRequestCutoff: Maybe<Scalars['PreciseDateTime']['output']>;
  groupChangeRequestsEnabled: Scalars['Boolean']['output'];
  groupCharterAcceptanceRequired: Scalars['Boolean']['output'];
  /** Charter is usable by students: enabled AND a published charter form exists. */
  groupCharterAvailable: Scalars['Boolean']['output'];
  groupCharterDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  groupCharterEnabled: Scalars['Boolean']['output'];
  groupDraftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  groupDraftEnabled: Scalars['Boolean']['output'];
  groupDraftFeedbackAlwaysAvailable: Scalars['Boolean']['output'];
  /** @deprecated Use group-level finalised field instead */
  groupFinalised: Scalars['Boolean']['output'];
  groupHideMembersName: Scalars['Boolean']['output'];
  groupReportMaxGrade: Maybe<Scalars['Int']['output']>;
  groupReportWeight: Maybe<Scalars['Int']['output']>;
  groupSelfEnrollmentDeadline: Maybe<Scalars['PreciseDateTime']['output']>;
  groupSelfEnrollmentEnabled: Scalars['Boolean']['output'];
  groupShowEmailToStudents: Scalars['Boolean']['output'];
  groupWorkAttachmentEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  individualDraftFeedbackAlwaysAvailable: Scalars['Boolean']['output'];
  individualReportDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  individualReportEnabled: Scalars['Boolean']['output'];
  individualReportMaxGrade: Maybe<Scalars['Int']['output']>;
  individualReportWeight: Maybe<Scalars['Int']['output']>;
  individualWorkAttachmentEnabled: Scalars['Boolean']['output'];
  lateResubmissionEnabled: Scalars['Boolean']['output'];
  /** @deprecated Use `late_submission_time_limit` instead */
  lateResubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  lateSubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  markingAclEnabled: Scalars['Boolean']['output'];
  markingTool: Maybe<MarkingTool>;
  markingToolPdf: Maybe<MarkingToolPdf>;
  maxGrade: Scalars['Int']['output'];
  openDate: Maybe<Scalars['PreciseDateTime']['output']>;
  peerEvaluationDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  peerEvaluationEnabled: Scalars['Boolean']['output'];
  peerEvaluationMaxGrade: Maybe<Scalars['Int']['output']>;
  peerEvaluationMaxScaleFactor: Scalars['Float']['output'];
  peerEvaluationMinScaleFactor: Scalars['Float']['output'];
  peerEvaluationMode: PeerEvaluationMode;
  peerEvaluationWeight: Maybe<Scalars['Int']['output']>;
  referencingStyle: Maybe<Scalars['String']['output']>;
  referencingStyleEnabled: Scalars['Boolean']['output'];
  releaseDate: Maybe<Scalars['PreciseDateTime']['output']>;
  restrictMarkingToolPdf: Scalars['Boolean']['output'];
  rubricDisplayDisabled: Scalars['Boolean']['output'];
  selfEvaluationEnabled: Scalars['Boolean']['output'];
  selfEvaluationMaxGrade: Maybe<Scalars['Int']['output']>;
  selfEvaluationMode: SelfEvaluationMode;
  selfEvaluationWeight: Maybe<Scalars['Int']['output']>;
  sentimentCheckEnabled: Scalars['Boolean']['output'];
  sentimentCheckFirstCheckAt: Maybe<Scalars['PreciseDateTime']['output']>;
  sentimentCheckIntervalInHr: Maybe<Scalars['Int']['output']>;
  sentimentCheckScheduleType: SentimentCheckScheduleType;
  sentimentCheckSchedules: Maybe<Array<SentimentCheckSchedule>>;
  sentimentCheckSkipEnabled: Scalars['Boolean']['output'];
  smartAutomarkingEnabled: Scalars['Boolean']['output'];
  spellCheckDisabled: Scalars['Boolean']['output'];
  /** @deprecated Use `openDate` instead */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  submissionPdfDisabled: Scalars['Boolean']['output'];
  submitAttemptLimit: Maybe<Scalars['Int']['output']>;
  tiiDraftSViewReports: Scalars['Int']['output'];
  tiiSViewReports: Scalars['Int']['output'];
  timeLimit: Maybe<Scalars['Int']['output']>;
  timeLimitEnabled: Scalars['Boolean']['output'];
  vivaCameraRequiredDisabled: Scalars['Boolean']['output'];
  vivaEnabled: Scalars['Boolean']['output'];
  vivaReattemptWindowSeconds: Maybe<Scalars['Int']['output']>;
  /** @deprecated Whole minutes, rounded up. Use `vivaReattemptWindowSeconds`. */
  vivaReattemptWindowTime: Maybe<Scalars['Int']['output']>;
  vivaSourceTask: Maybe<VivaSourceTask>;
  /** @deprecated Use `vivaSourceTask` instead */
  vivaSourceTaskId: Maybe<Scalars['ID']['output']>;
  weight: Maybe<Scalars['Float']['output']>;
  weightEnabled: Scalars['Boolean']['output'];
  wordLimit: Maybe<Scalars['Int']['output']>;
  wordLimitEnabled: Scalars['Boolean']['output'];
  wordLimitGroup: Maybe<Scalars['Int']['output']>;
};

export type AssessmentSettingsInput = {
  allowGenerativeAi?: InputMaybe<Scalars['Boolean']['input']>;
  anonymousMarking?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentType?: InputMaybe<AssessmentType>;
  copyleaksEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  countFootnotes?: InputMaybe<Scalars['Boolean']['input']>;
  countReferences?: InputMaybe<Scalars['Boolean']['input']>;
  doubleBlindMarkingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  draftDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  draftEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  draftScoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examAccessCodeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examAutoSubmissionDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  examBacktrackDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examInactivityTimeout?: InputMaybe<Scalars['Int']['input']>;
  examIpFilter?: InputMaybe<Scalars['String']['input']>;
  examIpFilterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examLdbEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examReadingTime?: InputMaybe<Scalars['Int']['input']>;
  examReadingTimeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  examReentryPreventionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examSchoolyearEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examStartDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examTiming?: InputMaybe<ExamTiming>;
  examType?: InputMaybe<Array<Scalars['String']['input']>>;
  examWritingTime?: InputMaybe<Scalars['Int']['input']>;
  feedbackDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  feedbackDateDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupAssessmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupChangeRequestCutoff?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupChangeRequestsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupCharterAcceptanceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  groupCharterDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupCharterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupDraftDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupDraftEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupDraftFeedbackAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  groupFinalised?: InputMaybe<Scalars['Boolean']['input']>;
  groupHideMembersName?: InputMaybe<Scalars['Boolean']['input']>;
  groupReportWeight?: InputMaybe<Scalars['Int']['input']>;
  groupSelfEnrollmentDeadline?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupSelfEnrollmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupShowEmailToStudents?: InputMaybe<Scalars['Boolean']['input']>;
  groupWorkAttachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  individualDraftFeedbackAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  individualReportDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  individualReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  individualReportWeight?: InputMaybe<Scalars['Int']['input']>;
  individualWorkAttachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lateResubmissionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lateSubmissionTimeLimit?: InputMaybe<Scalars['Int']['input']>;
  markingAclEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  markingTool?: InputMaybe<MarkingTool>;
  maxGrade?: InputMaybe<Scalars['Int']['input']>;
  peerEvaluationDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  peerEvaluationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  peerEvaluationMaxScaleFactor?: InputMaybe<Scalars['Float']['input']>;
  peerEvaluationMinScaleFactor?: InputMaybe<Scalars['Float']['input']>;
  peerEvaluationMode?: InputMaybe<PeerEvaluationMode>;
  peerEvaluationWeight?: InputMaybe<Scalars['Int']['input']>;
  referencingStyle?: InputMaybe<Scalars['String']['input']>;
  referencingStyleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  rubricDisplayDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  selfEvaluationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  selfEvaluationMode?: InputMaybe<SelfEvaluationMode>;
  selfEvaluationWeight?: InputMaybe<Scalars['Int']['input']>;
  sentimentCheckEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sentimentCheckFirstCheckAt?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  sentimentCheckIntervalInHr?: InputMaybe<Scalars['Int']['input']>;
  sentimentCheckScheduleType?: InputMaybe<SentimentCheckScheduleType>;
  sentimentCheckSchedules?: InputMaybe<Array<SentimentCheckScheduleInput>>;
  sentimentCheckSkipEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spellCheckDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  submissionPdfDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  submitAttemptLimit?: InputMaybe<Scalars['Int']['input']>;
  tiiDraftSViewReports?: InputMaybe<Scalars['Int']['input']>;
  tiiSViewReports?: InputMaybe<Scalars['Int']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  timeLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  vivaCameraRequiredDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  vivaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  vivaReattemptWindowSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Whole minutes. Use `vivaReattemptWindowSeconds`. */
  vivaReattemptWindowTime?: InputMaybe<Scalars['Int']['input']>;
  vivaSourceTaskId?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
  wordLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wordLimitGroup?: InputMaybe<Scalars['Int']['input']>;
};

/** Cadmus assessments can be assignments or exams. */
export enum AssessmentType {
  Assignment = 'ASSIGNMENT',
  Exam = 'EXAM'
}

/** Automarking status of the field outcome */
export enum AutomarkStatus {
  Complete = 'COMPLETE',
  Processing = 'PROCESSING'
}

/** A background job running in an Assessment. */
export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  id: Scalars['ID']['output'];
  kind: BackgroundJobKind;
  state: BackgroundJobState;
};

/** Known kinds of background jobs in an Assessment. */
export enum BackgroundJobKind {
  RosterSync = 'ROSTER_SYNC'
}

/** States of a background job. */
export enum BackgroundJobState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Discarded = 'DISCARDED',
  Executing = 'EXECUTING',
  Scheduled = 'SCHEDULED'
}

/** Base type of a response. Used to determine the type of response expected. */
export enum BaseType {
  Coords = 'coords',
  DirectedPair = 'directed_pair',
  Float = 'float',
  Identifier = 'identifier',
  Range = 'range',
  Record = 'record',
  String = 'string'
}

/** A single blank in a fill-in-the-blanks response. */
export type Blank = {
  __typename?: 'Blank';
  id: Scalars['String']['output'];
  phrases: Array<Scalars['String']['output']>;
};

export type BlanksInput = {
  id: Scalars['String']['input'];
  phrases: Array<Scalars['String']['input']>;
};

/** Response as a fill-in-the-blanks type. */
export type BlanksResponse = {
  __typename?: 'BlanksResponse';
  /** Whether the matching is case sensitive */
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  matchBlanks: Array<Blank>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
};

export type BlanksResponseInput = {
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  matchBlanks: Array<BlanksInput>;
  /** Between 0.0 and 1.0 inclusive. */
  matchSimilarity?: InputMaybe<Scalars['Float']['input']>;
};

/** Block Attachment associated with an AnswerBlock */
export type BlockAttachment = {
  __typename?: 'BlockAttachment';
  fileExtension: Maybe<Scalars['String']['output']>;
  fileSize: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  mediaUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The user who uploaded this attachment */
  uploadedBy: Maybe<User>;
  uploadedById: Maybe<Scalars['ID']['output']>;
};

/** A snapshot of a block inside a work */
export type BlockSnapshot = {
  __typename?: 'BlockSnapshot';
  answerBlockId: Scalars['ID']['output'];
  /** Special Block name, used for naming classic editor blocks. */
  blockName: Maybe<Scalars['String']['output']>;
  /** Special ID for client side caching. Defaults to the actual ID */
  cacheId: Scalars['ID']['output'];
  /** Serialised Snapshot contents */
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

/** Response as a binary choice. */
export type BooleanResponse = {
  __typename?: 'BooleanResponse';
  isTrue: Maybe<Scalars['Boolean']['output']>;
};

export type BooleanResponseInput = {
  isTrue: Scalars['Boolean']['input'];
};

/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApi = {
  __typename?: 'BrightspaceApi';
  /** Brightspace Provider authorization URL */
  authorizeUrl: Scalars['String']['output'];
  authorized: Scalars['Boolean']['output'];
  groups: Array<BrightspaceGroup>;
};


/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApiAuthorizeUrlArgs = {
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
  redirectTo: InputMaybe<Scalars['String']['input']>;
};


/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApiGroupsArgs = {
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
};

/**
 * Brightspace OrgUnit object, directly mapped from the Brightspace REST API.
 *
 * See https://docs.valence.desire2learn.com/res/orgunit.html.
 */
export type BrightspaceGroup = {
  __typename?: 'BrightspaceGroup';
  code: Maybe<Scalars['String']['output']>;
  /** Brightspace Group ID. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  students: Maybe<Array<BrightspaceUser>>;
  totalStudents: Scalars['Int']['output'];
};

export enum BrightspaceScopeKeyType {
  /** Default scope */
  Default = 'DEFAULT',
  /** scope for getting groups */
  GetGroups = 'GET_GROUPS'
}

/**
 * Brightspace User object, directly mapped from the Brightspace REST API.
 *
 * See https://docs.valence.desire2learn.com/res/user.html#User.
 */
export type BrightspaceUser = {
  __typename?: 'BrightspaceUser';
  /** Brightspace User ID. */
  id: Scalars['ID']['output'];
};

export type BuildMarkerRubricInput = {
  fieldRubricId?: InputMaybe<Scalars['ID']['input']>;
  kind: MarkerRubricKind;
  questionSetQuestionId?: InputMaybe<Scalars['ID']['input']>;
  sourceMarkerRubricId?: InputMaybe<Scalars['ID']['input']>;
  taskBlockId?: InputMaybe<Scalars['ID']['input']>;
};

export type BuildMarkerRubricPayload = {
  __typename?: 'BuildMarkerRubricPayload';
  fieldRubric: Maybe<FieldRubric>;
  markerRubric: MarkerRubric;
  questionSetQuestion: Maybe<QuestionSetQuestion>;
  taskBlock: Maybe<TaskBlock>;
};

/** Return type for cancelRelease mutation. */
export type CancelReleasePayload = {
  __typename?: 'CancelReleasePayload';
  /** Latest state of the task. */
  task: Task;
};

/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApi = {
  __typename?: 'CanvasApi';
  /** Canvas Provider authorization URL */
  authorizeUrl: Scalars['String']['output'];
  authorized: Scalars['Boolean']['output'];
  groupSets: Array<CanvasGroupSet>;
  groups: Array<CanvasGroup>;
  sections: Array<CanvasSection>;
};


/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApiAuthorizeUrlArgs = {
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
  redirectTo: InputMaybe<Scalars['String']['input']>;
};


/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApiGroupSetsArgs = {
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
};


/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApiGroupsArgs = {
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
  groupSetId: Scalars['ID']['input'];
};


/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApiSectionsArgs = {
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
};

/**
 * Canvas Group object, directly mapped from the Canvas REST API.
 *
 * See https://canvas.instructure.com/doc/api/groups.html.
 */
export type CanvasGroup = {
  __typename?: 'CanvasGroup';
  groupCategoryId: Maybe<Scalars['ID']['output']>;
  /** Canvas Group ID. */
  id: Scalars['ID']['output'];
  members: Maybe<Array<CanvasUser>>;
  membersCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** One Canvas group to import as a Cadmus marking group: its LMS id, name, and matched members. */
export type CanvasGroupInput = {
  externalId: Scalars['String']['input'];
  groupSet?: InputMaybe<Scalars['String']['input']>;
  /** Cadmus user_ids of the group's members, already matched by the frontend */
  memberUserIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  /** LMS id of the Canvas section this group belongs to, if any */
  sectionExternalId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Canvas Group Category (group set) object, directly mapped from the Canvas
 * REST API.
 *
 * See https://canvas.instructure.com/doc/api/group_categories.html.
 */
export type CanvasGroupSet = {
  __typename?: 'CanvasGroupSet';
  /** Canvas Group Category ID. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum CanvasScopeKeyType {
  /** Default scope */
  Default = 'DEFAULT',
  /** scope for getting assignment overrides */
  GetAssignmentOverrides = 'GET_ASSIGNMENT_OVERRIDES',
  /** scope for reading Canvas groups */
  GetGroups = 'GET_GROUPS',
  /** scope for getting section */
  GetSections = 'GET_SECTIONS'
}

/**
 * Canvas Section object, directly mapped from the Canvas REST API.
 *
 * See https://canvas.instructure.com/doc/api/sections.html.
 */
export type CanvasSection = {
  __typename?: 'CanvasSection';
  courseId: Scalars['ID']['output'];
  /** Canvas Section ID. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sisCourseId: Maybe<Scalars['ID']['output']>;
  students: Maybe<Array<CanvasUser>>;
  totalStudents: Scalars['Int']['output'];
};

/** One Canvas section to import as a Cadmus Section: its LMS id, name, and matched students. */
export type CanvasSectionInput = {
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** Cadmus user_ids of the section's members already enrolled in the assessment */
  userIds: Array<Scalars['ID']['input']>;
};

/**
 * Canvas User object, directly mapped from the Canvas REST API.
 *
 * See https://canvas.instructure.com/doc/api/users.html#User.
 */
export type CanvasUser = {
  __typename?: 'CanvasUser';
  /** Canvas User ID. */
  id: Scalars['ID']['output'];
  /** Canvas User full name. */
  name: Scalars['String']['output'];
  /** Canvas SIS User ID. */
  sisUserId: Maybe<Scalars['ID']['output']>;
};

/**
 * Cardinality of the expected response in a Question as defined in the QTI spec.
 *
 * A question can have a single, multiple, or requirement for an ordered correct
 * response expressed as its cardinality.
 */
export enum Cardinality {
  Multiple = 'multiple',
  Ordered = 'ordered',
  Single = 'single'
}

export type ChangeAssessmentPresetResult = {
  __typename?: 'ChangeAssessmentPresetResult';
  assessmentSettings: AssessmentSettings;
  task: Task;
};

/** Charter for assessment group */
export type Charter = {
  __typename?: 'Charter';
  allMembersAccepted: Scalars['Boolean']['output'];
  editors: Array<CharterEditor>;
  feedbackThreads: Array<Thread>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  latestAgreement: Maybe<CharterAgreement>;
  milestones: Array<CharterMilestone>;
};

/** Charter agreements */
export type CharterAgreement = {
  __typename?: 'CharterAgreement';
  acceptedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  studentId: Scalars['String']['output'];
  unlockedAt: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Input for student's agreemeent to the charter,
 *   the `charter_id` is passed to identify the charter and
 *   the student's `id` is taken from the context
 */
export type CharterAgreementInput = {
  charterId: Scalars['ID']['input'];
};

/** Charter editor for students */
export type CharterEditor = {
  __typename?: 'CharterEditor';
  charterFormSectionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  snapshotDoc: Maybe<Scalars['String']['output']>;
  snapshotVersion: Maybe<Scalars['Int']['output']>;
  /** Stream Identifier for Editor */
  streamUuid: Scalars['String']['output'];
};

/**
 * Input to save the editor state by passing the `editor_id`
 *   and the `snapshot_doc` and `snapshot_version` at every save of the
 *   editor
 */
export type CharterEditorInput = {
  editorId: Scalars['ID']['input'];
  snapshotDoc: Scalars['String']['input'];
  snapshotVersion: Scalars['Int']['input'];
};

/** Charter Form created by the teacher for assessment */
export type CharterForm = {
  __typename?: 'CharterForm';
  editedAt: Maybe<Scalars['DateTime']['output']>;
  hasUnpublishedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  publishTimestamp: Maybe<Scalars['DateTime']['output']>;
  published: Scalars['Boolean']['output'];
  sections: Array<CharterFormSection>;
};

export type CharterFormInput = {
  charterFormId: Scalars['ID']['input'];
  sections?: InputMaybe<Array<CharterFormSectionInput>>;
};

export type CharterFormSection = {
  __typename?: 'CharterFormSection';
  /** Soft delete */
  deleted: Scalars['Boolean']['output'];
  /** Toggle if this section will be shown to students */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  milestonePresets: Maybe<Array<MilestonePresetType>>;
  /** Description of the section as a serialised ProseMirror document */
  promptDoc: Maybe<Scalars['String']['output']>;
  /** Sort order of the section */
  rank: Maybe<Scalars['Int']['output']>;
  title: Maybe<Scalars['String']['output']>;
  type: CharterFormSectionType;
  /** Number of words allowed. Only used if it is an input type section */
  wordLimit: Maybe<Scalars['Int']['output']>;
  /** Toggle if word limit is enabled for this section. Only used if it is an input type section */
  wordLimitEnabled: Scalars['Boolean']['output'];
};

export type CharterFormSectionInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can be null for new sections */
  id?: InputMaybe<Scalars['ID']['input']>;
  milestonePresets?: InputMaybe<Array<MilestonePresetInput>>;
  promptDoc?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CharterFormSectionType>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
  wordLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Different form sections creatable in a charter form */
export enum CharterFormSectionType {
  Instruction = 'INSTRUCTION',
  Milestone = 'MILESTONE',
  Overview = 'OVERVIEW',
  TextInput = 'TEXT_INPUT'
}

/** Charter milestones */
export type CharterMilestone = {
  __typename?: 'CharterMilestone';
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

/** Charter section types that can have threads. */
export enum CharterSectionType {
  Editor = 'EDITOR',
  Milestone = 'MILESTONE'
}

/** A single choice in a response with an ID and label text. */
export type Choice = {
  __typename?: 'Choice';
  id: Scalars['String']['output'];
  isCorrect: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
};

export type ChoiceInput = {
  id: Scalars['String']['input'];
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
};

export type ChoiceInteraction = {
  __typename?: 'ChoiceInteraction';
  choices: Array<SimpleChoice>;
  /** Optional Category label */
  label: Maybe<Scalars['String']['output']>;
  /** Maximum number of choices the user can select */
  maxChoices: Scalars['Int']['output'];
};

export type ChoiceInteractionInput = {
  choices: Array<SimpleChoiceInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
};

/** Cadmus Class information for an Assessment. */
export type Class = {
  __typename?: 'Class';
  /** How the groups were setup for the assessment. */
  groupType: GroupType;
  /** List of all groups and their members */
  groups: Array<Group>;
  /** Class assessment ID */
  id: Scalars['ID']['output'];
  /** List of student enrollments in a class, including deleted enrollments. */
  students: Array<Enrollment>;
};

/** A full Class list with works and stats. */
export type ClassList = {
  __typename?: 'ClassList';
  /** List of Enrollments in a Class */
  enrollments: Array<Enrollment>;
  id: Scalars['ID']['output'];
};

/** Enum for the different Class List tab contexts. */
export enum ClassTab {
  /** Drafts tab */
  Drafts = 'DRAFTS',
  /** Finals tab */
  Finals = 'FINALS',
  /** Students or Progress tab */
  Students = 'STUDENTS'
}

export type Comment = {
  __typename?: 'Comment';
  content: Scalars['String']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  smartCommentId: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['PreciseDateTime']['output'];
};

/** CommentRelease represents a snapshot of a comment at the time of feedback release. */
export type CommentRelease = {
  __typename?: 'CommentRelease';
  content: Scalars['String']['output'];
  createdBy: User;
  /** The ID of the Comment`. */
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export enum CompleteSocraticTurnError {
  /** @deprecated Never returned; a repeat carrying the same media returns the dialogue. */
  AlreadyCompleted = 'ALREADY_COMPLETED',
  /** This turn already holds a recording, from a different upload. */
  ConflictingRecording = 'CONFLICTING_RECORDING'
}

export type CompleteSocraticTurnInput = {
  /** Duration of the recorded media in seconds. */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  mediaId: Scalars['ID']['input'];
  /** URL of the recorded media associated with this turn. */
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  /** When the client stopped recording. Optional; the server falls back to its own clock. */
  recordingCompletedAt?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  /** When the client began recording. Optional; written only if the server never recorded a start. */
  recordingStartedAt?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  turnId: Scalars['ID']['input'];
};

export type CompleteSocraticTurnPayload = {
  __typename?: 'CompleteSocraticTurnPayload';
  dialogue: Maybe<SocraticDialogue>;
  error: Maybe<CompleteSocraticTurnError>;
};

export type CompleteSubmissionOutcomesPayload = {
  __typename?: 'CompleteSubmissionOutcomesPayload';
  submissionOutcomes: Array<SubmissionOutcome>;
  updatedCount: Scalars['Int']['output'];
};

/**
 * Overview of marking and moderation data for in-progress (`base`) and released (`provisional`, `final`) feedback.
 * Includes weighted totals and scores by component (`group`, `individual`, `peer`, `self`).
 *
 * ### Component States
 * * `complete`: `weight` > 0 and `score` exists. (Released for `final`/`provisional`; marking started for `base`).
 * * `incomplete`: `weight` > 0 but null `score`. (Not released or marking not started).
 * * `disabled`: Not enabled in AssessmentSettings (entire component will be null e.g, `%ComponentBreakdown{group: null}`).
 * * `zero-weight`: `weight = 0`. Still required and must be completed/marked before release; contributes 0 to total/grades.
 */
export type ComponentBreakdown = {
  __typename?: 'ComponentBreakdown';
  group: Maybe<ComponentScore>;
  individual: Maybe<ComponentScore>;
  peer: Maybe<ComponentScore>;
  self: Maybe<ComponentScore>;
  total: WeightedScore;
};

/** Marking and moderation data for all components. */
export type ComponentScore = {
  __typename?: 'ComponentScore';
  /**
   * The max score set in AssessmentSettings (default 100) for the component.
   * E.g., `individual_report_max_grade`, `self_evaluation_max_grade`.
   */
  maxScore: Scalars['Int']['output'];
  /**
   * Adjustment applied to this component's score during moderation.
   * E.g. `WorkOutcome.moderator_modifier`
   */
  moderatorModifier: Scalars['Float']['output'];
  /**
   * Applied raw (pre-weight) marker adjustment folded into this component.
   * Surfaces the delta separately from `score` (which keeps the marked value);
   * `weighted_score` already reflects it.
   */
  modifiersTotal: Scalars['Float']['output'];
  /**
   * Deduction applied to this component (positive float >= 0.0).
   * E.g., `1.0` reduces the component score by 1.0.
   */
  penaltyScore: Scalars['Float']['output'];
  /**
   * Unweighted raw score.
   * * `final`/`provisional`: Non-null only if component is released.
   * * `base`: Non-null if any marking exists.
   */
  score: Maybe<Scalars['Float']['output']>;
  /**
   * Percentage contribution (0-100) of this component to the total grade.
   * Derived from AssessmentSettings. Zero-weight components have weight `0`.
   * E.g., `individual_report_weight`
   */
  weight: Scalars['Int']['output'];
  /** The max_score scaled by the component's weight contribution. */
  weightedMaxScore: Scalars['Float']['output'];
  /** The moderator_modifier scaled by the component's weight contribution. */
  weightedModeratorModifier: Scalars['Float']['output'];
  /** The penalty_score scaled by the component's weight contribution. */
  weightedPenaltyScore: Scalars['Float']['output'];
  /**
   * Score scaled by `weight`.
   * * `final`/`provisional`: Non-null only if component is released.
   * * `base`: Non-null if any marking exists.
   */
  weightedScore: Maybe<Scalars['Float']['output']>;
};

export type ContributedRange = {
  __typename?: 'ContributedRange';
  from: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
};

export type Contribution = {
  __typename?: 'Contribution';
  asOfVersion: Scalars['Int']['output'];
  members: Array<MemberContribution>;
};

/** Conversation event payload for subscriptions - can be either a comment event or title change */
export type ConversationEvent = {
  __typename?: 'ConversationEvent';
  comment: Maybe<Comment>;
  eventType: ConversationEventType;
  threadId: Scalars['ID']['output'];
  title: Maybe<Scalars['String']['output']>;
};

/** Conversation event types for subscriptions */
export enum ConversationEventType {
  CommentAdded = 'COMMENT_ADDED',
  CommentEdited = 'COMMENT_EDITED',
  TitleEdited = 'TITLE_EDITED'
}

/**
 * The result of copying a released instruction sheet into an Assessment.
 *
 * The sheet sets the destination's preset, so the copy reports the Assessment's
 * settings alongside the Task the content landed in.
 */
export type CopyAssessmentResult = {
  __typename?: 'CopyAssessmentResult';
  assessmentSettings: AssessmentSettings;
  task: Task;
};

/** Country information */
export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateGraderMarkerRubricInput = {
  fieldRubricId: Scalars['ID']['input'];
};

export type CreateGraderMarkerRubricPayload = {
  __typename?: 'CreateGraderMarkerRubricPayload';
  fieldRubric: FieldRubric;
  markerRubric: MarkerRubric;
};

export type CreateMarkerRubricInput = {
  format: MarkerRubricFormat;
  kind: MarkerRubricKind;
  reversedScale: Scalars['Boolean']['input'];
};

export type CreateQuestionBankFileOriginInput = {
  filename: Scalars['String']['input'];
  filepath: Scalars['String']['input'];
};

export type CreateQuestionBankInput = {
  /** @deprecated Deprecated. Use fields instead */
  blanksResponse?: InputMaybe<BlanksResponseInput>;
  /** @deprecated Deprecated. Use fields instead */
  booleanResponse?: InputMaybe<BooleanResponseInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  /** @deprecated Deprecated. Use fields instead */
  editorResponse?: InputMaybe<EditorResponseInput>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<InputMaybe<QuestionFieldInput>>>;
  fileOriginId?: InputMaybe<Scalars['ID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filepath?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Deprecated. Use fields instead */
  multiResponse?: InputMaybe<MultiResponseInput>;
  points?: InputMaybe<Scalars['Int']['input']>;
  promptDoc: Scalars['String']['input'];
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage?: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  scope: QuestionBankScope;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** @deprecated Deprecated. Use fields instead */
  shortResponse?: InputMaybe<ShortResponseInput>;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateQuestionMarkerRubricInput = {
  taskBlockId: Scalars['ID']['input'];
};

export type CreateQuestionMarkerRubricPayload = {
  __typename?: 'CreateQuestionMarkerRubricPayload';
  markerRubric: MarkerRubric;
  taskBlock: TaskBlock;
};

export type CreateQuestionSelectionPayload = {
  __typename?: 'CreateQuestionSelectionPayload';
  /** Array index of incomplete rule */
  incompleteRuleIndex: Maybe<Scalars['Int']['output']>;
  /** N questions required */
  requiredQuestionCount: Maybe<Scalars['Int']['output']>;
  /** N sets required */
  requiredSetsQuantity: Maybe<Scalars['Int']['output']>;
  /** N questions found */
  selectedQuestionCount: Maybe<Scalars['Int']['output']>;
  /** Fulfilled QuestionSelection generation. */
  selection: Maybe<QuestionSelection>;
};

export type CreateSchoolyearDashboardUrlPayload = {
  __typename?: 'CreateSchoolyearDashboardUrlPayload';
  url: Maybe<Scalars['String']['output']>;
};

export type CreateSchoolyearSettingsUrlPayload = {
  __typename?: 'CreateSchoolyearSettingsUrlPayload';
  url: Maybe<Scalars['String']['output']>;
};

export type CreateSkillInput = {
  skill: Scalars['String']['input'];
};

export type CreateSmartCommentInput = {
  commentId?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  maxScore: Scalars['Int']['input'];
  rangeFrom?: InputMaybe<Scalars['Int']['input']>;
  rangeTo: Scalars['Int']['input'];
  skillId: Scalars['ID']['input'];
};

export enum CreateSocraticDialogueError {
  /** Attempt number exceeds maximum allowed */
  AttemptNumberGtMaxAttempts = 'ATTEMPT_NUMBER_GT_MAX_ATTEMPTS',
  /** Outside reattempt window */
  OutsideReattemptWindow = 'OUTSIDE_REATTEMPT_WINDOW'
}

export type CreateSocraticDialoguePayload = {
  __typename?: 'CreateSocraticDialoguePayload';
  error: Maybe<CreateSocraticDialogueError>;
  session: Maybe<SocraticSession>;
};

/** Creation attributes for a TaskBlock and linked Question */
export type CreateTaskBlockInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
  questionType: QuestionType;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Criterion = {
  __typename?: 'Criterion';
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** Whether any outcomes exist for this Criterion. */
  hasOutcomes: Scalars['Boolean']['output'];
  id: Maybe<Scalars['ID']['output']>;
  maxScore: Maybe<Scalars['Int']['output']>;
  order: Scalars['Int']['output'];
  scaleItems: Array<ScaleItem>;
  skill: Maybe<LearningOutcomeSkill>;
  /** Learning Outcome Skill with Criterion title as fallback. */
  title: Maybe<Scalars['String']['output']>;
};

export type CriterionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maxScore?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
  scaleItems: Array<ScaleItemInput>;
  skillId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CriterionOutcome = {
  __typename?: 'CriterionOutcome';
  id: Scalars['ID']['output'];
  markerRubricCriterion: Criterion;
  markerRubricCriterionId: Scalars['ID']['output'];
  markerRubricScaleItemId: Scalars['ID']['output'];
  markerScore: Scalars['Float']['output'];
  /** For Peer Evaluations: the student that marked this outcome. */
  markerUserId: Maybe<Scalars['ID']['output']>;
  /** For Peer Evaluations: when the student published their evaluation. */
  publishedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** For Peer Evaluations: the student that received this outcome. */
  targetUserId: Maybe<Scalars['ID']['output']>;
  /** For Peer Evaluations: when a student evaluated a target user, updated this outcome. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
};

/**
 * CriterionOutcomeRelease represents a snapshot of a criterion outcome at release time.
 * Contains the rubric-based marking for a specific criterion.
 */
export type CriterionOutcomeRelease = {
  __typename?: 'CriterionOutcomeRelease';
  id: Scalars['ID']['output'];
  markerRubricCriterionId: Scalars['ID']['output'];
  markerRubricScaleItemId: Scalars['ID']['output'];
  /** Null for students when the rubric hides per-criterion scores. */
  markerScore: Maybe<Scalars['Float']['output']>;
};

/** Custom params captured for a user during LTI launches. */
export type CustomParams = {
  __typename?: 'CustomParams';
  brightspaceUserId: Maybe<Scalars['ID']['output']>;
  canvasAssignmentId: Maybe<Scalars['ID']['output']>;
  canvasSubmissionId: Maybe<Scalars['ID']['output']>;
  canvasUserId: Maybe<Scalars['ID']['output']>;
  lisPersonSourcedid: Maybe<Scalars['String']['output']>;
  moodleAttemptReopenMethod: Maybe<Scalars['String']['output']>;
};

export type DeletedContribution = {
  __typename?: 'DeletedContribution';
  anchor: Scalars['Int']['output'];
  deletedById: Maybe<Scalars['ID']['output']>;
  marks: Array<DeletedMark>;
  media: Maybe<DeletedMedia>;
  node: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type DeletedMark = {
  __typename?: 'DeletedMark';
  attrs: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type DeletedMedia = {
  __typename?: 'DeletedMedia';
  customWidth: Maybe<Scalars['Float']['output']>;
  imageAlign: Maybe<Scalars['String']['output']>;
  src: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  width: Maybe<Scalars['String']['output']>;
};

export type DeletedMember = {
  __typename?: 'DeletedMember';
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

/** All possible Disciplines in Cadmus */
export enum Discipline {
  ArchitectureBuilding = 'ARCHITECTURE_BUILDING',
  Business = 'BUSINESS',
  ComputingIt = 'COMPUTING_IT',
  Design = 'DESIGN',
  Education = 'EDUCATION',
  Engineering = 'ENGINEERING',
  HumanitiesLanguages = 'HUMANITIES_LANGUAGES',
  Law = 'LAW',
  Mathematics = 'MATHEMATICS',
  MediaCommunication = 'MEDIA_COMMUNICATION',
  MedicineHealth = 'MEDICINE_HEALTH',
  PerformingFineArts = 'PERFORMING_FINE_ARTS',
  Science = 'SCIENCE',
  SocialScience = 'SOCIAL_SCIENCE'
}

export type DocumentBase = {
  __typename?: 'DocumentBase';
  baseDoc: Scalars['String']['output'];
  /** @deprecated Always 0; the scrubber bounds on snapshot ticks. Slated for removal. */
  headVersion: Scalars['Int']['output'];
};

export type DocumentStep = {
  __typename?: 'DocumentStep';
  data: Scalars['String']['output'];
  userId: Maybe<Scalars['ID']['output']>;
  version: Scalars['Int']['output'];
};

export type DocumentWindow = {
  __typename?: 'DocumentWindow';
  baseVersion: Scalars['Int']['output'];
  document: Maybe<Scalars['String']['output']>;
  /** @deprecated Always 0; the scrubber bounds on snapshot ticks. Slated for removal. */
  headVersion: Scalars['Int']['output'];
  steps: Array<DocumentStep>;
};

/** Response as a rich text editor. */
export type EditorResponse = {
  __typename?: 'EditorResponse';
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type EditorResponseInput = {
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Different kinds of client-side Editors */
export enum EditorType {
  Prosemirror = 'PROSEMIRROR',
  Slate = 'SLATE'
}

/** A class Enrollment. */
export type Enrollment = {
  __typename?: 'Enrollment';
  /**
   * Access code used by the Student in the enrollment.
   * @deprecated Use `verified_codes` instead
   */
  accessCode: Maybe<AccessCode>;
  /** Index of the enrollment for anonymous marking */
  anonymousIndex: Maybe<Scalars['Int']['output']>;
  /** LTI Custom params */
  customParams: CustomParams;
  deleted: Scalars['Boolean']['output'];
  deletedBy: Maybe<User>;
  id: Scalars['ID']['output'];
  /** Total number of re-entry verifications across the student's sessions in this enrollment. */
  reentryCount: Scalars['Int']['output'];
  /** Section this student belongs to (null = not in any section) */
  sectionId: Maybe<Scalars['ID']['output']>;
  /** Source LMS' SIS ID for the enrolled user */
  sisUserId: Maybe<Scalars['String']['output']>;
  /** Enrollment synced at date if the enrollment is inserted/updated through roster sync not lti launch */
  syncedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Tags for the enrollment */
  tags: Array<Tag>;
  /** Enrolled user */
  user: User;
  /** List of all the verified access codes used by the student in the enrollment. */
  verifiedCodes: Maybe<Array<VerifiedCode>>;
  /** Work started under the Enrollment, if any */
  work: Maybe<Work>;
  workSettings: Maybe<WorkSettings>;
};

/** Entity thread event payload for subscriptions */
export type EntityThreadEvent = {
  __typename?: 'EntityThreadEvent';
  criterionId: Maybe<Scalars['ID']['output']>;
  entityId: Maybe<Scalars['ID']['output']>;
  entityType: Maybe<EntityType>;
  eventType: EntityThreadEventType;
  resolvedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  resolvedBy: Maybe<User>;
  status: ThreadStatus;
  threadId: Scalars['ID']['output'];
};

/** Entity thread event types for subscriptions */
export enum EntityThreadEventType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Linked = 'LINKED',
  Resolved = 'RESOLVED',
  Unlinked = 'UNLINKED',
  Unresolved = 'UNRESOLVED'
}

/** Entity types associated with threads. */
export enum EntityType {
  AnswerBlock = 'ANSWER_BLOCK',
  Charter = 'CHARTER',
  FieldOutcome = 'FIELD_OUTCOME',
  PeerOutcome = 'PEER_OUTCOME',
  SubmissionOutcome = 'SUBMISSION_OUTCOME'
}

/** Type of examination time windowing strategy. */
export enum ExamTiming {
  Live = 'LIVE',
  Window = 'WINDOW'
}

export type ExceptionInput = {
  feedbackModeration?: InputMaybe<FeedbackModerationDecisionInput>;
  flagReason?: InputMaybe<Scalars['String']['input']>;
  scoreModeration?: InputMaybe<ScoreModerationDecisionInput>;
  workOutcomeIds: Array<Scalars['ID']['input']>;
};

export type ExtendedInteraction = {
  __typename?: 'ExtendedInteraction';
  attachmentEnabled: Maybe<Scalars['Boolean']['output']>;
  referencingEnabled: Maybe<Scalars['Boolean']['output']>;
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type ExtendedInteractionInput = {
  attachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Valid conflic actions for extensions sync types */
export enum ExtensionConflictActionType {
  Override = 'OVERRIDE',
  Skip = 'SKIP'
}

/** A feature flag and whether it is enabled for the requesting context. */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum FeedbackLevel {
  Answer = 'ANSWER',
  Feedback = 'FEEDBACK',
  Mark = 'MARK'
}

/** Moderation decisions for feedback of a submission outcome. */
export enum FeedbackModerationDecision {
  Custom = 'CUSTOM',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Input for feedback moderation decision. :highest and :lowest resolve per-outcome to :primary or :secondary. */
export enum FeedbackModerationDecisionInput {
  Custom = 'CUSTOM',
  Highest = 'HIGHEST',
  Lowest = 'LOWEST',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Types of Feedback Release Rule. */
export enum FeedbackReleaseBasePool {
  All = 'ALL',
  Empty = 'EMPTY'
}

/** Feedback Release Rule to release feedback to students in the future. */
export type FeedbackReleaseRule = {
  __typename?: 'FeedbackReleaseRule';
  basePool: FeedbackReleaseBasePool;
  excludedStudentIds: Array<Scalars['ID']['output']>;
  excludedTags: Array<Scalars['String']['output']>;
  executedAt: Maybe<Scalars['DateTime']['output']>;
  executedStudentIds: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  includedGroupIds: Array<Scalars['ID']['output']>;
  includedStudentIds: Array<Scalars['ID']['output']>;
  includedTags: Array<Scalars['String']['output']>;
  releaseType: FeedbackReleaseType;
  ruleKind: ReleaseRuleKind;
  scheduledAt: Maybe<Scalars['DateTime']['output']>;
};

export type FeedbackReleaseRuleInput = {
  basePool: FeedbackReleaseBasePool;
  excludedStudentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includedGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedStudentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  releaseType?: InputMaybe<FeedbackReleaseType>;
  ruleKind: ReleaseRuleKind;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum FeedbackReleaseType {
  Final = 'FINAL',
  Provisional = 'PROVISIONAL'
}

/**
 * Assessment-wide Feedback Visibility. Controls level of feedback visible to
 * the students after it is released. They are unique on AssessmentID and
 * ReleaseType.
 */
export type FeedbackVisibility = {
  __typename?: 'FeedbackVisibility';
  feedbackViewLevel: FeedbackLevel;
  id: Scalars['ID']['output'];
  jointRelease: Scalars['Boolean']['output'];
  notifyStudents: Scalars['Boolean']['output'];
  releaseType: FeedbackReleaseType;
  showPeerComments: Scalars['Boolean']['output'];
  showPeerScores: Scalars['Boolean']['output'];
  withFeedbackPdf: Scalars['Boolean']['output'];
};

export type FeedbackVisibilityInput = {
  feedbackViewLevel: FeedbackLevel;
  jointRelease?: InputMaybe<Scalars['Boolean']['input']>;
  notifyStudents?: InputMaybe<Scalars['Boolean']['input']>;
  releaseType?: InputMaybe<FeedbackReleaseType>;
  showPeerComments?: InputMaybe<Scalars['Boolean']['input']>;
  showPeerScores?: InputMaybe<Scalars['Boolean']['input']>;
  withFeedbackPdf: Scalars['Boolean']['input'];
};

/** Outcome on a single field in a question. */
export type FieldOutcome = {
  __typename?: 'FieldOutcome';
  /** Single answer if given */
  answer: Maybe<Scalars['String']['output']>;
  /** Similarity score for the answer */
  answerSimilarity: Maybe<Scalars['Float']['output']>;
  /** Multiple answers if given */
  answers: Maybe<Array<Scalars['String']['output']>>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  /** Status of the automarking */
  automarkStatus: Maybe<AutomarkStatus>;
  comments: Maybe<Array<Comment>>;
  docContent: Maybe<Scalars['String']['output']>;
  docStreamUuid: Maybe<Scalars['ID']['output']>;
  docVersion: Maybe<Scalars['Int']['output']>;
  fieldRubricId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Unique identifier within the question */
  identifier: Scalars['String']['output'];
  markerScore: Maybe<Scalars['Float']['output']>;
  referencesDocContent: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Maybe<Scalars['Int']['output']>;
  /** Marking outcome from using a MarkerRubric to score the parent Outcome. */
  rubricOutcome: RubricOutcome;
  score: Maybe<Scalars['Float']['output']>;
  /** Best matched expected response value */
  targetValue: Maybe<Scalars['String']['output']>;
};

/**
 * FieldOutcomeRelease represents a snapshot of a field outcome at release time.
 * Contains the marking and feedback for a specific field within a question.
 */
export type FieldOutcomeRelease = {
  __typename?: 'FieldOutcomeRelease';
  /** Single answer if given */
  answer: Maybe<Scalars['String']['output']>;
  /** Similarity score for the answer */
  answerSimilarity: Maybe<Scalars['Float']['output']>;
  /** Multiple answers if given */
  answers: Maybe<Array<Scalars['String']['output']>>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  commentReleases: Array<CommentRelease>;
  criterionOutcomeReleases: Array<CriterionOutcomeRelease>;
  docContent: Maybe<Scalars['String']['output']>;
  docStreamUuid: Maybe<Scalars['ID']['output']>;
  docVersion: Maybe<Scalars['Int']['output']>;
  fieldRubricId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Unique identifier within the question */
  identifier: Scalars['String']['output'];
  markerScore: Maybe<Scalars['Float']['output']>;
  referencesDocContent: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Maybe<Scalars['Int']['output']>;
  score: Scalars['Float']['output'];
  /** Best matched expected response value */
  targetValue: Maybe<Scalars['String']['output']>;
  threadReleases: Array<ThreadRelease>;
};

export type FieldResponse = {
  __typename?: 'FieldResponse';
  /** Single answer */
  answer: Maybe<Scalars['String']['output']>;
  /** Multiple answers (such as ranges) */
  answers: Maybe<Array<Scalars['String']['output']>>;
  count: Scalars['Int']['output'];
  /** If the response was correct. */
  isCorrect: Scalars['Boolean']['output'];
  /** @deprecated Use `answer` instead. */
  response: Maybe<Scalars['String']['output']>;
  /** Best similarity score from 0 to 1 if the response was not correct. */
  similarity: Maybe<Scalars['Float']['output']>;
};

/** Rubric for a single field across all questions in the assessment task. */
export type FieldRubric = {
  __typename?: 'FieldRubric';
  /** Whether the field is automarked. */
  automarked: Scalars['Boolean']['output'];
  baseType: Maybe<BaseType>;
  caseSensitive: Scalars['Boolean']['output'];
  /** List of accepted position area answers */
  correctAreas: Maybe<Array<PositionArea>>;
  /** List of accepted numerical range answers */
  correctRanges: Maybe<Array<NumericRange>>;
  errorMargin: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  markerChanges: Maybe<FieldRubricChanges>;
  markerRubric: Maybe<MarkerRubric>;
  moderatorChanges: Maybe<FieldRubricChanges>;
  partialScoring: Scalars['Boolean']['output'];
  /** Aggregate of all responses provided to the field. */
  responses: Array<FieldResponse>;
  similarity: Maybe<Scalars['Float']['output']>;
  /** String matching strategy */
  strategy: Maybe<MatchStrategy>;
  /** List of accepted answers */
  values: Maybe<Array<Scalars['String']['output']>>;
};

/** Overriding change tracking made by marker or moderator to a FieldRubric. */
export type FieldRubricChanges = {
  __typename?: 'FieldRubricChanges';
  id: Scalars['ID']['output'];
  valuesAdded: Array<Scalars['String']['output']>;
  valuesRemoved: Array<Scalars['String']['output']>;
};

export type FindSimilarQuestionsInput = {
  excludeQuestionIds: Array<Scalars['ID']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GenerateSocraticQuestionsPayload = {
  __typename?: 'GenerateSocraticQuestionsPayload';
  pool: Maybe<SocraticQuestionerPool>;
};

export type GenerateSocraticStudentQuestionsPayload = {
  __typename?: 'GenerateSocraticStudentQuestionsPayload';
  taskBlock: Maybe<SocraticQuestionerTaskBlock>;
};

/** The input object which represents the global portion of the user's settings. */
export type GlobalUserSettingsInput = {
  /** User must be shown the IA onboarding */
  showIaOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  showUserpilotOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Grade information for a Result.
 *
 * A grade stored as a floating point numeric value between 0 and 1. For display
 * however, this value has to be mulitplied by the latest released maximum grade
 * point requirements. The display is also string formatted with 2-digit padding
 * and 2-decimal point accuracy.
 */
export type Grade = {
  __typename?: 'Grade';
  /** Human formatted representation of the grade */
  display: Scalars['String']['output'];
  /** Maximum score possible */
  max: Scalars['Int']['output'];
  /** Actual 0-1 grade value */
  value: Scalars['Float']['output'];
};

/** Background processing result for a Submission against a Result. */
export type GradebookReceipt = {
  __typename?: 'GradebookReceipt';
  /** Email receipt sent to student. */
  emailComplete: Scalars['Boolean']['output'];
  /** Submission PDF or Record sent to the LMS. */
  lmsComplete: Scalars['Boolean']['output'];
  /** LMS Stage is snoozed until this date. */
  lmsSnooze: Maybe<Scalars['DateTime']['output']>;
  /** PDF WorkArtifact ID for complete render of the Submission. */
  pdfArtifactId: Maybe<Scalars['ID']['output']>;
  /** Submission PDF sent to Turnitin. */
  turnitinComplete: Scalars['Boolean']['output'];
};

/** Known service integrations into the Cadmus Gradebook result */
export enum GradebookService {
  Cadmusgrader = 'CADMUSGRADER',
  Moodlegrader = 'MOODLEGRADER',
  Speedgrader = 'SPEEDGRADER',
  Turnitin = 'TURNITIN'
}

/** A group of students in an assessment */
export type Group = {
  __typename?: 'Group';
  /** Group members whose enrollment has not been withdrawn */
  activeGroupMembers: Array<GroupMember>;
  code: Maybe<Scalars['String']['output']>;
  /** Whether this group has been finalised */
  finalised: Scalars['Boolean']['output'];
  /** The date and time when this group was finalised */
  finalisedAt: Maybe<Scalars['DateTime']['output']>;
  groupMembers: Array<GroupMember>;
  groupSet: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  marker: Maybe<User>;
  markerId: Maybe<Scalars['ID']['output']>;
  /** The maximum number of students that can be in a group */
  maxLimit: Maybe<Scalars['Int']['output']>;
  /**
   * Deprecated: use :group_members or :active_group_members instead
   * @deprecated Use groupMembers or activeGroupMembers instead
   */
  members: Array<User>;
  /** The minimum number of students required to be in a group */
  minLimit: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  questionId: Maybe<Scalars['String']['output']>;
  /** Section this group is scoped to (null = whole-class group) */
  sectionId: Maybe<Scalars['ID']['output']>;
  /** Tags attached to this group */
  tags: Array<GroupTag>;
  workSettings: Maybe<WorkSettings>;
};

export enum GroupChangeDecision {
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export enum GroupChangeRequestStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Withdrawn = 'WITHDRAWN'
}

export type GroupExtensionInput = {
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  updateReason?: InputMaybe<Scalars['String']['input']>;
};

export type GroupInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  groupSet?: InputMaybe<Scalars['String']['input']>;
  maxLimit?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  minLimit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sectionId?: InputMaybe<Scalars['ID']['input']>;
};

/** A marker assigned to a group member. */
export type GroupMarker = {
  __typename?: 'GroupMarker';
  groupMemberId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  marker: Maybe<User>;
  markerId: Maybe<Scalars['ID']['output']>;
  markerPlaceholder: Maybe<Scalars['String']['output']>;
  role: MarkerRole;
};

/** A member of a group in an assessment. */
export type GroupMember = {
  __typename?: 'GroupMember';
  /** Avatar colourset, de-conflicted within the group */
  colourset: Scalars['Int']['output'];
  groupMarkers: Array<GroupMarker>;
  id: Scalars['ID']['output'];
  /** Whether this member's enrollment is currently active (not withdrawn) */
  isActive: Scalars['Boolean']['output'];
  user: Maybe<User>;
};

/** A member removal the sync refused because the member already submitted work. */
export type GroupMemberConflict = {
  __typename?: 'GroupMemberConflict';
  groupId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type GroupMembershipInput = {
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GroupRule = {
  markerId?: InputMaybe<Scalars['String']['input']>;
  markerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Section to form these groups within (null = whole-class) */
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  totalStudents?: InputMaybe<Scalars['Int']['input']>;
};

/** Group-formation settings persisted alongside setup_groups. */
export type GroupSettingsInput = {
  groupChangeRequestCutoff?: InputMaybe<Scalars['DateTime']['input']>;
  groupChangeRequestsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupFinalised?: InputMaybe<Scalars['Boolean']['input']>;
  groupHideMembersName?: InputMaybe<Scalars['Boolean']['input']>;
  groupShowEmailToStudents?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Tag attached to a Group */
export type GroupTag = {
  __typename?: 'GroupTag';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

/** Purpose of the groups setup in an Assessment */
export enum GroupType {
  Question = 'QUESTION',
  Student = 'STUDENT'
}

export type GroupUpdateInput = {
  addedMembers?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  markerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removedMembers?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ImportCanvasGroupsInput = {
  /** The chosen Canvas group set (category) id; v1 syncs one set at a time */
  groupSet?: InputMaybe<Scalars['String']['input']>;
  groups: Array<CanvasGroupInput>;
  /** The distinct Canvas sections the groups above belong to; upserted as Cadmus Sections and linked to their groups. */
  sections: Array<ImportCanvasSectionRef>;
};

/** One distinct Canvas section referenced by the imported groups: its LMS id and name. */
export type ImportCanvasSectionRef = {
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ImportCanvasSectionsInput = {
  sections: Array<CanvasSectionInput>;
};

/** Result of importing Canvas groups as Cadmus marking groups. */
export type ImportGroupsResult = {
  __typename?: 'ImportGroupsResult';
  addedMembers: Scalars['Int']['output'];
  adopted: Scalars['Int']['output'];
  /** Member removals skipped because the member already submitted work. */
  conflicts: Array<GroupMemberConflict>;
  created: Scalars['Int']['output'];
  deleted: Scalars['Int']['output'];
  orphaned: Scalars['Int']['output'];
  removedMembers: Scalars['Int']['output'];
  renamed: Scalars['Int']['output'];
  /** Active students not placed in any LMS group */
  ungrouped: Array<Scalars['ID']['output']>;
  /**
   * external_ids of groups whose Canvas section couldn't be resolved for
   * linking. The groups themselves are still imported — only the Section link
   * is missing.
   */
  unlinked: Array<Scalars['String']['output']>;
  /**
   * LMS member ids present in the upload with no matching Cadmus enrolment.
   *
   * Empty when the frontend uploads pre-matched Cadmus ids (it reports match
   * failures itself); populated by unattended syncs, which upload raw LMS ids.
   */
  unmatched: Array<Scalars['ID']['output']>;
};

/** Input for importing library question to task block */
export type ImportLibraryQuestionInput = {
  questionId: Scalars['ID']['input'];
  questionVersionId?: InputMaybe<Scalars['ID']['input']>;
  taskBlockId: Scalars['ID']['input'];
};

/**
 * A rubric to import from a JSON file. Reuses the marker-rubric fields and adds
 * a `version` naming the contract the file was written against. `id`/`skill_id`
 * on criteria are ignored — import always creates criteria fresh.
 */
export type ImportMarkerRubricInput = {
  criteria: Array<CriterionInput>;
  format: MarkerRubricFormat;
  hideScores: Scalars['Boolean']['input'];
  kind?: InputMaybe<MarkerRubricKind>;
  reversedScale: Scalars['Boolean']['input'];
  version: Scalars['String']['input'];
};

export type ImportSectionsInput = {
  assignments: Array<SectionAssignmentInput>;
};

/** Result of importing a section roster, including roster mismatches. */
export type ImportSectionsResult = {
  __typename?: 'ImportSectionsResult';
  sections: Array<Section>;
  /** user_ids enrolled in the assessment but absent from the upload */
  ungroupedStudents: Array<Scalars['ID']['output']>;
  /** user_ids present in the upload but not enrolled in the assessment */
  unmatchedStudents: Array<Scalars['ID']['output']>;
};

export type ImportSmartCommentInput = {
  content: Scalars['String']['input'];
  maxScore: Scalars['Int']['input'];
  rangeFrom?: InputMaybe<Scalars['Int']['input']>;
  rangeTo: Scalars['Int']['input'];
  skillId: Scalars['ID']['input'];
};

export type ImportSmartCommentsResult = {
  __typename?: 'ImportSmartCommentsResult';
  /** Content of entries that were skipped because they duplicated another entry in the same import, or an existing smart comment for the same skill. */
  skippedDuplicates: Array<Scalars['String']['output']>;
  smartComments: Array<SmartComment>;
};

/** Cadmus Institution. */
export type Institution = {
  __typename?: 'Institution';
  /**
   * Institution has the Access Code feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  accessCodeFeatureEnabled: Scalars['Boolean']['output'];
  apiStatus: ApiStatusType;
  /**
   * Institution has the Cadmus Grader feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  cadmusGraderFeatureEnabled: Scalars['Boolean']['output'];
  /** Institution's country of origin information. Also known as home country. */
  country: Country;
  /** Custom declaration Rich text JSON from contentful */
  customDeclarationText: Maybe<Scalars['String']['output']>;
  /**
   * Institution has the Exams feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  examsFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Feature flags enabled for the institution.
   * @deprecated Use query-level `featureFlags`
   */
  features: InstitutionFeatures;
  id: Scalars['ID']['output'];
  /**
   * Institution has the LDB feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  ldbFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Institution has the Moodle Grader feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  moodlegraderFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Institution has the Multiformat Task feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  multiformatFeatureEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  /**
   * Institution has the Turnitin Feedback Studio feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  turnitinGraderFeatureEnabled: Scalars['Boolean']['output'];
};

/** Institution feature flags. */
export type InstitutionFeatures = {
  __typename?: 'InstitutionFeatures';
  accessCode: Scalars['Boolean']['output'];
  adminAccess: Scalars['Boolean']['output'];
  advancedMarking: Scalars['Boolean']['output'];
  autoExtensionSync: Scalars['Boolean']['output'];
  cadmusGrader: Scalars['Boolean']['output'];
  exams: Scalars['Boolean']['output'];
  extensionSyncing: Scalars['Boolean']['output'];
  groupAssessment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  labsContextualiser: Scalars['Boolean']['output'];
  moodleGrader: Scalars['Boolean']['output'];
  multiformat: Scalars['Boolean']['output'];
  respondusLdb: Scalars['Boolean']['output'];
  schoolyear: Scalars['Boolean']['output'];
  smartAutomarking: Scalars['Boolean']['output'];
  timeline: Scalars['Boolean']['output'];
  turnitin: Scalars['Boolean']['output'];
  turnitinGrader: Scalars['Boolean']['output'];
  viva: Scalars['Boolean']['output'];
};

/** Institution LMS Tool Provider information. */
export type InstitutionTool = {
  __typename?: 'InstitutionTool';
  familyCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type IssueAssigneeInput = {
  userId: Scalars['ID']['input'];
};

/** Lifecycle of a recorded Issue state. What changed is in changedFields. */
export enum IssueChangeKind {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export enum IssueStatus {
  Blocked = 'BLOCKED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export enum IssueType {
  Milestone = 'MILESTONE',
  Task = 'TASK'
}

/** Status information on a background Job */
export type Job = {
  __typename?: 'Job';
  assessmentId: Scalars['ID']['output'];
  conflict: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /** Final result URL if available */
  resultUrl: Maybe<Scalars['String']['output']>;
};

export type LearningOutcomeSkill = {
  __typename?: 'LearningOutcomeSkill';
  id: Scalars['ID']['output'];
  skill: Scalars['String']['output'];
};

/** An LTI Service like AGS or NRPS. */
export type LtiService = {
  __typename?: 'LtiService';
  id: Scalars['ID']['output'];
  isLtiPluginAgs: Scalars['Boolean']['output'];
  /** LTI Advantage (V2) services have OAuth2 token issuers */
  issuer: Maybe<Scalars['String']['output']>;
  metaUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/**
 * A Mailing List representation which can be active or in-active depending on
 * the `subscribed` field.
 */
export type MailingList = {
  __typename?: 'MailingList';
  id: Scalars['String']['output'];
  members: Array<Scalars['String']['output']>;
  subscribed: Scalars['Boolean']['output'];
};

export type MarkFieldOutcomeInput = {
  fieldOutcomeId: Scalars['ID']['input'];
  scaleItemId?: InputMaybe<Scalars['Int']['input']>;
  score: Scalars['Float']['input'];
};

export type MarkFieldOutcomePayload = {
  __typename?: 'MarkFieldOutcomePayload';
  fieldOutcome: FieldOutcome;
  questionOutcome: QuestionOutcome;
  workOutcome: WorkOutcome;
};

export type MarkPeerOutcomeInput = {
  scaleItemId: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
};

export type MarkSubmissionOutcomeInput = {
  scaleItemId?: InputMaybe<Scalars['Int']['input']>;
  score: Scalars['Float']['input'];
  submissionOutcomeId: Scalars['Int']['input'];
};

export type MarkSubmissionOutcomePayload = {
  __typename?: 'MarkSubmissionOutcomePayload';
  studentOutcomes: Array<StudentOutcome>;
  submissionOutcome: SubmissionOutcome;
  workOutcome: WorkOutcome;
};

/** Distinct students and groups with marking. */
export type MarkedCounts = {
  __typename?: 'MarkedCounts';
  groupCount: Scalars['Int']['output'];
  studentCount: Scalars['Int']['output'];
};

export type MarkerAdjustmentPayload = {
  __typename?: 'MarkerAdjustmentPayload';
  studentOutcome: StudentOutcome;
};

/** Input for creating or updating markers assigned to members. */
export type MarkerForMembersInput = {
  markerId?: InputMaybe<Scalars['ID']['input']>;
  markerPlaceholder?: InputMaybe<Scalars['String']['input']>;
  role: MarkerRole;
  userIds: Array<Scalars['ID']['input']>;
};

export enum MarkerRole {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type MarkerRubric = {
  __typename?: 'MarkerRubric';
  assessmentId: Scalars['ID']['output'];
  /** @deprecated Use `location` field instead. */
  assessmentName: Scalars['String']['output'];
  criteria: Array<Criterion>;
  format: MarkerRubricFormat;
  /** Has un-published changes over the last published version. */
  hasChanges: Scalars['Boolean']['output'];
  /** Hide scores from student view. */
  hideScores: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: MarkerRubricKind;
  location: MarkerRubricLocation;
  /** @deprecated Use `has_outcomes` field of each criteria instead. */
  markingExists: Scalars['Boolean']['output'];
  /** Last publish timestamp */
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use `location` field instead. */
  questionShortPrompt: Maybe<Scalars['String']['output']>;
  reversedScale: Scalars['Boolean']['output'];
  /** Lifecycle state of the rubric. */
  state: MarkerRubricState;
  /** Timestamp of the last save. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
};

/**
 * The format of the MarkerRubric determines how Scale Items are defined for
 * each Criterion:
 *
 *   * `:percentage` – Each criterion's scale items represent percentage ranges
 *   * `:points` – Each criterion defines a range of possible point values.
 *   * `:absolute` – Each criterion allows selection of a single, fixed point value.
 */
export enum MarkerRubricFormat {
  Absolute = 'ABSOLUTE',
  Percentage = 'PERCENTAGE',
  Points = 'POINTS'
}

export type MarkerRubricInput = {
  criteria: Array<CriterionInput>;
  format: MarkerRubricFormat;
  hideScores: Scalars['Boolean']['input'];
  kind?: InputMaybe<MarkerRubricKind>;
  reversedScale: Scalars['Boolean']['input'];
};

/** Kinds of Marker Rubrics for different purposes. */
export enum MarkerRubricKind {
  Extended = 'EXTENDED',
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Peer = 'PEER'
}

/** Location of a MarkerRubric within an Assessment. */
export type MarkerRubricLocation = {
  __typename?: 'MarkerRubricLocation';
  /** assessment name */
  assessment: Scalars['String']['output'];
  /** path within the assessment */
  path: Scalars['String']['output'];
  /** question ID for extended marker rubrics */
  questionId: Maybe<Scalars['ID']['output']>;
};

/** Lifecycle state of a MarkerRubric. */
export enum MarkerRubricState {
  /** Has draft changes (or was never released) */
  Draft = 'DRAFT',
  /** Has draft changes that fail publish-level validation */
  DraftError = 'DRAFT_ERROR',
  /** Published with no pending draft changes */
  Released = 'RELEASED'
}

export enum MarkerRubricStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** Scope of the marker in the submission outcome. */
export enum MarkerScope {
  Average = 'AVERAGE',
  Custom = 'CUSTOM',
  Main = 'MAIN',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Marker scopes allowed for creation of marking outcomes. */
export enum MarkerScopeInput {
  Custom = 'CUSTOM',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export enum MarkingRole {
  Marker = 'MARKER',
  Moderator = 'MODERATOR'
}

/** Marking tool used for the assessment. */
export enum MarkingTool {
  Cadmusgrader = 'CADMUSGRADER',
  Moodlegrader = 'MOODLEGRADER',
  Speedgrader = 'SPEEDGRADER',
  Turnitin = 'TURNITIN'
}

/**
 * Restrict student result view via the PDF sent to the LMS marking tool.
 *
 *   * UnmarkedOnly - Show un-marked responses only
 *
 *   * UnmarkedAndAutomarkedSummary - Show un-marked responses and auto-mark
 *     summary
 */
export enum MarkingToolPdf {
  UnmarkedAndAutomarkedSummary = 'UNMARKED_AND_AUTOMARKED_SUMMARY',
  UnmarkedOnly = 'UNMARKED_ONLY'
}

export type MatchInteraction = {
  __typename?: 'MatchInteraction';
  /** Answer options that can be selected for matching */
  sourceSet: Array<SimpleChoice>;
  /** Prompts that are matched against */
  targetSet: Array<SimpleChoice>;
};

export type MatchInteractionInput = {
  sourceSet: Array<SimpleChoiceInput>;
  targetSet: Array<SimpleChoiceInput>;
};

/** Matching strategy used to auto-mark a string Field */
export enum MatchStrategy {
  Exact = 'EXACT',
  Levdist = 'LEVDIST',
  Smart = 'SMART'
}

export type MemberContribution = {
  __typename?: 'MemberContribution';
  deletions: Array<DeletedContribution>;
  ranges: Array<ContributedRange>;
  userId: Scalars['ID']['output'];
};

export type MemberProgress = {
  __typename?: 'MemberProgress';
  lastEventTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  status: ProgressStatus;
  userId: Scalars['ID']['output'];
  workId: Maybe<Scalars['ID']['output']>;
};

export type MemberSummary = {
  __typename?: 'MemberSummary';
  accessCount: Scalars['Int']['output'];
  lastAccess: Scalars['PreciseDateTime']['output'];
  userId: Scalars['ID']['output'];
};

/** A Message sent in a Class from an enrolled user. */
export type Message = {
  __typename?: 'Message';
  decidedAt: Maybe<Scalars['DateTime']['output']>;
  decision: Maybe<GroupChangeDecision>;
  decisionNote: Maybe<Scalars['String']['output']>;
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  messageType: MessageRequestType;
  reason: Maybe<Scalars['String']['output']>;
  /** @deprecated Use decidedAt */
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  sourceUserId: Scalars['ID']['output'];
  /** Derived from :deleted, :decision, :resolved_at and :expires_at — see Cadmus.Message.ClassMessage.status/2. */
  status: GroupChangeRequestStatus;
  updatedAt: Scalars['PreciseDateTime']['output'];
};

export type MessageInput = {
  /** @deprecated Server sets expiry */
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  messageType: MessageRequestType;
  reason?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Ignored; group change requests target the lecturers */
  targetUserId?: InputMaybe<Scalars['ID']['input']>;
};

export enum MessageRequestType {
  GroupChange = 'GROUP_CHANGE'
}

export type Metadata = {
  __typename?: 'Metadata';
  /** ID of the BlockAttachment this thread is about */
  blockAttachmentId: Maybe<Scalars['Int']['output']>;
  /** Display name of the file */
  blockAttachmentName: Maybe<Scalars['String']['output']>;
  /** ID of the charter editor associated with this thread. */
  charterEditorId: Maybe<Scalars['ID']['output']>;
  /** Type of charter section this thread is associated with, can be 'Editor' or 'Milestone'. */
  charterSectionType: Maybe<CharterSectionType>;
};

/** Input for charter milestone details for updating it */
export type MilestoneInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** can be null for new milestones */
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Milestone preset type for charter form section */
export type MilestonePresetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Datetime when the milestone is due */
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Unique identifier for the milestone preset */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Title for the milestone */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Milestone preset type for charter form section */
export type MilestonePresetType = {
  __typename?: 'MilestonePresetType';
  description: Maybe<Scalars['String']['output']>;
  /** Datetime this milestone is due */
  dueDate: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the milestone preset */
  id: Scalars['ID']['output'];
  /** Title for the milestone */
  title: Maybe<Scalars['String']['output']>;
};

/** Derived moderation values computed from the moderation decision on a :main SubmissionOutcome. */
export type ModerationOutcome = {
  __typename?: 'ModerationOutcome';
  bodyDoc: Maybe<Scalars['String']['output']>;
  feedbackModerationId: Maybe<Scalars['ID']['output']>;
  /** The marker's additive adjustment on top of the rubric outcome score. */
  markerModifier: Maybe<Scalars['Float']['output']>;
  referencesDoc: Maybe<Scalars['String']['output']>;
  /** Rubric outcome derived from the moderation decision. */
  rubricOutcome: Maybe<RubricOutcome>;
  score: Maybe<Scalars['Float']['output']>;
  scoreModerationId: Maybe<Scalars['ID']['output']>;
};

/** Moderation Penalty Rule to apply penalties on feedback release. */
export type ModerationPenaltyRule = {
  __typename?: 'ModerationPenaltyRule';
  canStack: Scalars['Boolean']['output'];
  excludedStudentIds: Maybe<Array<Scalars['ID']['output']>>;
  formatUnit: Maybe<PenaltyFormatUnit>;
  id: Scalars['ID']['output'];
  includedGroupIds: Array<Scalars['ID']['output']>;
  includedTags: Maybe<Array<Scalars['String']['output']>>;
  minutesLateBy: Maybe<Scalars['Int']['output']>;
  penaltyScore: Scalars['Float']['output'];
  penaltyType: ModerationPenaltyType;
  reason: Maybe<Scalars['String']['output']>;
  ruleKind: PenaltyRuleKind;
  scoreUnit: PenaltyScoreUnit;
};

export type ModerationPenaltyRuleInput = {
  canStack: Scalars['Boolean']['input'];
  excludedStudentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  formatUnit: PenaltyFormatUnit;
  id?: InputMaybe<Scalars['ID']['input']>;
  includedGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  minutesLateBy?: InputMaybe<Scalars['Int']['input']>;
  penaltyScore: Scalars['Float']['input'];
  penaltyType: ModerationPenaltyType;
  reason?: InputMaybe<Scalars['String']['input']>;
  ruleKind: PenaltyRuleKind;
  scoreUnit?: InputMaybe<PenaltyScoreUnit>;
};

export enum ModerationPenaltyType {
  Custom = 'CUSTOM',
  MoreThan = 'MORE_THAN'
}

/**
 * A question in the moderation "Questions" view, fully computed on the server:
 * the instruction-sheet question-tree node merged with its rubric, response
 * counts, and rates. Resolves from `Marking.Moderation.QuestionSummary`.
 */
export type ModerationQuestion = {
  __typename?: 'ModerationQuestion';
  answerable: Maybe<Scalars['Boolean']['output']>;
  automarked: Scalars['Boolean']['output'];
  body: Maybe<QuestionBody>;
  hasMarkerChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  longLabel: Maybe<Scalars['String']['output']>;
  maxScore: Maybe<Scalars['Float']['output']>;
  nodeId: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  parentNodeId: Maybe<Scalars['ID']['output']>;
  questionId: Scalars['ID']['output'];
  questionType: QuestionType;
  rates: Maybe<QuestionRates>;
  rubric: Maybe<QuestionRubric>;
  score: Maybe<Scalars['Float']['output']>;
  shortLabel: Maybe<Scalars['String']['output']>;
  shortPrompt: Maybe<Scalars['String']['output']>;
};

/** The moment in the teacher's workflow at which satisfaction is asked. */
export enum Moment {
  /** After releasing feedback to students */
  Feedback = 'FEEDBACK',
  /** After releasing an assessment to students */
  Setup = 'SETUP'
}

/** Response as multiple choice selections. */
export type MultiResponse = {
  __typename?: 'MultiResponse';
  cardinality: Maybe<Cardinality>;
  choices: Array<Choice>;
  partialScoring: Maybe<Scalars['Boolean']['output']>;
};

export type MultiResponseInput = {
  choices: Array<ChoiceInput>;
  /** Partial scoring for multiple choice questions. */
  partialScoring?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * One notification for the student.
 *
 * `tier` and `tone` are null on notifications the student cannot act on: both
 * are ordering and urgency signals for the ranked list, and a status that
 * depends on someone else has neither.
 */
export type Notification = {
  __typename?: 'Notification';
  /** What the student can do about this. Null when it depends on someone else. */
  action: Maybe<NotificationAction>;
  /** One or two sentences explaining why this is here. */
  detail: Scalars['String']['output'];
  /** Position in the ranking ladder (1-6); lower ranks more urgent. Null when the student cannot act on this. */
  tier: Maybe<Scalars['Int']['output']>;
  /** Short label, e.g. "Set up your group's task board". */
  title: Scalars['String']['output'];
  /** Visual urgency to render with. Null when the student cannot act on this. */
  tone: Maybe<NotificationTone>;
  /** Stable identifier for what this notification is, e.g. "no_tasks". */
  type: Scalars['String']['output'];
};

/** What the reader can do about a notification. */
export type NotificationAction = {
  __typename?: 'NotificationAction';
  /** Label for the button or link, e.g. "Go to task board". */
  label: Scalars['String']['output'];
  /** Where this action takes the reader, when it targets something. */
  targetKind: Maybe<NotificationTargetKind>;
};

/** Where a notification's action takes the reader. */
export enum NotificationTargetKind {
  Contact = 'CONTACT',
  GroupPage = 'GROUP_PAGE',
  GroupTask = 'GROUP_TASK',
  IndividualTask = 'INDIVIDUAL_TASK',
  PeerTask = 'PEER_TASK',
  Thread = 'THREAD'
}

/** Visual urgency of a notification, from most (RED) to least (GREY) urgent. */
export enum NotificationTone {
  Amber = 'AMBER',
  Grey = 'GREY',
  Red = 'RED'
}

export type NumericRange = {
  __typename?: 'NumericRange';
  end: Scalars['Float']['output'];
  identifier: Scalars['ID']['output'];
  start: Scalars['Float']['output'];
};

export type NumericRangeInput = {
  end: Scalars['Float']['input'];
  identifier: Scalars['String']['input'];
  start: Scalars['Float']['input'];
};

/** Mutation return for `captureOnboardingInput`. */
export type OnboardingPayload = {
  __typename?: 'OnboardingPayload';
  subject: Maybe<Subject>;
  userSettings: Maybe<UserSettings>;
};

/**
 * Originality scan of a Result's current submission.
 *
 * The score itself is on the Result, as `copyleaksSimilarityScore`; this is the
 * scan's own state, which is what tells a score that has not arrived yet from one
 * that never will.
 */
export type Originality = {
  __typename?: 'Originality';
  /** When the provider returned a score */
  scoredAt: Maybe<Scalars['DateTime']['output']>;
  /** How far the scan has reached; see OriginalityStatus */
  status: OriginalityStatus;
  /** When the document reached the provider */
  submittedAt: Maybe<Scalars['DateTime']['output']>;
};

/**
 * How far an originality scan has reached.
 *
 * Only `PENDING`, `SUBMITTED`, `SCORED` and `FAILED` are reachable today. `HELD`
 * needs a Check Credits submission, which is never made, and the two report
 * states need the export pipeline, which is not built.
 */
export enum OriginalityStatus {
  CollectingReport = 'COLLECTING_REPORT',
  Failed = 'FAILED',
  Held = 'HELD',
  Pending = 'PENDING',
  Ready = 'READY',
  Scored = 'SCORED',
  Submitted = 'SUBMITTED'
}

/** A lightweight signal that an assessment's student outcomes have changed. */
export type OutcomeSyncSignal = {
  __typename?: 'OutcomeSyncSignal';
  /** How many student outcomes changed in this batch. */
  changedCount: Scalars['Int']['output'];
  /** IDs of the students whose outcomes changed in this batch. */
  studentIds: Array<Scalars['ID']['output']>;
};

export type OutcomesDeletedPayload = {
  __typename?: 'OutcomesDeletedPayload';
  outcomesDeleted: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

/** A past instruction, which includes information about each assessment and its related, latest released instructions. */
export type PastInstructionSheet = {
  __typename?: 'PastInstructionSheet';
  assessment: Assessment;
  id: Scalars['ID']['output'];
  sheet: Sheet;
};

/** How peer evaluation scores affect the final grade. :component adds the peer score as a grade component; :scaling applies a scale factor to the group report score. */
export enum PeerEvaluationMode {
  Component = 'COMPONENT',
  Scaling = 'SCALING'
}

/** Marking outcome when a student peer evaluates another peer in a group. */
export type PeerOutcome = {
  __typename?: 'PeerOutcome';
  /** DEPRECATED: Use is_complete instead. When all group members published their complete evaluations of the target_user_id */
  completedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** All Criterion selections made by peers against this Peer Outcome */
  criterionOutcomes: Array<CriterionOutcome>;
  /** When this student finished evaluating all their peers — the last time they touched an evaluation they authored. Inferred from activity, not an explicit submit: post-due drafts count. Nil while has_evaluated_all_peers is false, or when they had nobody to evaluate. Compare against the peer evaluation due date to show lateness. */
  evaluationsSubmittedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** When the peer outcome was used for the Students Gradebook Result */
  feedbackReleasedTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Criterion selections that the current user has made on this Peer Outcome. */
  givenCriterionOutcomes: Array<CriterionOutcome>;
  /**
   * Scale factor applied to the group report score. Present when peer
   * evaluation is enabled in scaling mode. Computed per member as
   * `sqrt(peer_score / average_group_peer_score)`, clamped to
   * `[peer_evaluation_min_scale_factor, peer_evaluation_max_scale_factor]`.
   * Students who did not complete every assigned peer evaluation receive
   * `peer_evaluation_min_scale_factor` and are excluded from the group
   * average used to derive other members' factors.
   */
  groupReportScaleFactor: Maybe<Scalars['Float']['output']>;
  /** Whether this student submitted their self evaluation. True when self_evaluation is disabled. */
  hasCompletedSelfEvaluation: Maybe<Scalars['Boolean']['output']>;
  /** Whether this student completed every assigned peer evaluation. Pre-due requires published criterion outcomes for each (peer × criterion); post-due drafts also count, so a student who filled every score but did not finalise is still considered complete. */
  hasEvaluatedAllPeers: Maybe<Scalars['Boolean']['output']>;
  /** Whether every required peer published a complete evaluation of this student (all criteria covered by every required peer). */
  hasReceivedAllEvaluations: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Whether the peer outcome is complete (all required evaluations submitted and published). Replaces completed_at logic.
   * @deprecated Use has_received_all_evaluations and has_completed_self_evaluation instead.
   */
  isComplete: Maybe<Scalars['Boolean']['output']>;
  /** Max score for peer evaluation, taken from assessment settings */
  peerMaxScore: Maybe<Scalars['Int']['output']>;
  /** Computed peer score, only available when is_complete is true and the assessment has peer_evaluations enabled */
  peerScore: Maybe<Scalars['Float']['output']>;
  /** Max score for self evaluation, taken from assessment settings */
  selfMaxScore: Maybe<Scalars['Int']['output']>;
  /** Precomputed self score, only available when is_complete is true, and the assessment has self_evaluations enabled */
  selfScore: Maybe<Scalars['Float']['output']>;
  /** Student being evaluated */
  targetUserId: Scalars['ID']['output'];
};

export enum PenaltyFormatUnit {
  Custom = 'CUSTOM',
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

/** Scope a moderation penalty rule applies to. */
export enum PenaltyRuleKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Peer = 'PEER'
}

/** Format of Moderation Penalty Value Unit. */
export enum PenaltyScoreUnit {
  Percentage = 'PERCENTAGE',
  Points = 'POINTS'
}

/** A single position area in a position object response. */
export type PositionArea = {
  __typename?: 'PositionArea';
  coords: Array<Scalars['Float']['output']>;
  identifier: Scalars['ID']['output'];
  shape: Shape;
};

export type PositionAreaInput = {
  coords: Array<Scalars['Float']['input']>;
  identifier: Scalars['String']['input'];
  shape: Shape;
};

export type PositionObjectInteraction = {
  __typename?: 'PositionObjectInteraction';
  /** Label for the position object */
  label: Maybe<Scalars['String']['output']>;
  /** Maximum number of choices the user can select */
  maxChoices: Scalars['Int']['output'];
};

export type PositionObjectInteractionInput = {
  /** Label for the interaction */
  label: Scalars['String']['input'];
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
};

export type PrintArchiveInput = {
  assessmentName: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProgressItem = {
  __typename?: 'ProgressItem';
  entityId: Scalars['ID']['output'];
  lastEventTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  members: Array<MemberProgress>;
  overallStatus: ProgressStatus;
};

export type ProgressSection = {
  __typename?: 'ProgressSection';
  items: Array<ProgressItem>;
  statistics: ProgressStatistics;
};

export type ProgressStatistics = {
  __typename?: 'ProgressStatistics';
  accessedCount: Scalars['Int']['output'];
  inProgressCount: Scalars['Int']['output'];
  notStartedCount: Scalars['Int']['output'];
  submittedCount: Scalars['Int']['output'];
  viewedCount: Scalars['Int']['output'];
};

export enum ProgressStatus {
  /** The student reached the assessment home page without opening a task. Derived from their work row, which the LTI launch creates server side, so it survives a session too short for a page-open event. Group assessments only — a single-task launch opens the work and reports :viewed. Work only: launching says nothing about the charter or the peer evaluation. */
  Accessed = 'ACCESSED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Submitted = 'SUBMITTED',
  /** The student opened the component itself: the work instructions, the charter, or the peer evaluation. Derived from a page-open event, or from the work row alone where launching the assessment opens the work outright. */
  Viewed = 'VIEWED'
}

/** SubmissionOutcome used in progress table for double-blind marking. Relax visibility rules to show progress to markers. Should not expose score. */
export type ProgressSubmissionOutcome = {
  __typename?: 'ProgressSubmissionOutcome';
  completedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  markerScope: MarkerScope;
};

/** Issue for Assessment Group's Project Management Board */
export type ProjectIssue = {
  __typename?: 'ProjectIssue';
  /** List of user IDs assigned to the issue. */
  assignees: Array<Scalars['ID']['output']>;
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['DateTime']['output']>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
  status: IssueStatus;
  title: Scalars['String']['output'];
  type: IssueType;
  updatedAt: Scalars['PreciseDateTime']['output'];
};

/** Input to update Project Issues for Group Assessment */
export type ProjectIssueInput = {
  assignees?: InputMaybe<Array<IssueAssigneeInput>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID of an existing issue or null for new issues. */
  id?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<IssueStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IssueType>;
};

/**
 * One recorded state of an Issue, as it stood after a change — who changed it,
 * what moved, and the issue's fields at that moment.
 */
export type ProjectIssueState = {
  __typename?: 'ProjectIssueState';
  assigneeIds: Array<Scalars['ID']['output']>;
  changeKind: IssueChangeKind;
  /**
   * Names of the Issue fields that changed, using the field names of the issue
   * itself. Empty when the issue was created. `assignees` means the assignee
   * set moved; compare `assigneeIds` with the previous state to see how.
   */
  changedFields: Array<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['DateTime']['output']>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  issueId: Scalars['ID']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
  status: IssueStatus;
  title: Scalars['String']['output'];
  /** The Issue's state after this change. */
  type: IssueType;
  /** The group member who made the change. */
  userId: Scalars['ID']['output'];
};

/** Image information and associated annotations. */
export type PromptImage = {
  __typename?: 'PromptImage';
  /** Image height */
  height: Scalars['Int']['output'];
  /** Image layers for annotations. */
  layers: Array<PromptImageLayer>;
  /** Image URL */
  url: Scalars['String']['output'];
  /** Image width */
  width: Scalars['Int']['output'];
};

/** Question Prompt Image attributes */
export type PromptImageInput = {
  /** Image height */
  height: Scalars['Int']['input'];
  /** Image layers attributes */
  layers?: InputMaybe<Array<PromptImageLayerInput>>;
  /** Image URL */
  url: Scalars['String']['input'];
  /** Image width */
  width: Scalars['Int']['input'];
};

/** Image layer information */
export type PromptImageLayer = {
  __typename?: 'PromptImageLayer';
  /** Layer coordinates */
  coords: Array<Scalars['Float']['output']>;
  /** Layer identifier */
  identifier: Scalars['String']['output'];
  /** Layer shape */
  shape: Shape;
};

/** Question Prompt Image Layer attributes */
export type PromptImageLayerInput = {
  /** Layer coordinates */
  coords: Array<Scalars['Float']['input']>;
  /** Layer identifier */
  identifier: Scalars['String']['input'];
  /** Layer shape */
  shape: Shape;
};

export type PublishImportedQuestionsInput = {
  assessmentId: Scalars['ID']['input'];
  questions: Array<QuestionAttributes>;
  sourceFile: SourceFileInput;
  subjectId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<TagInput>>;
};

/** A single Question as part of the Cadmus Assessments. */
export type Question = {
  __typename?: 'Question';
  accessGroup: Maybe<AccessGroup>;
  accessRole: Maybe<AccessRole>;
  /** Whether the question was deleted from the library. */
  archived: Scalars['Boolean']['output'];
  /** Retrieves the list of assessments where the question was used. */
  assessmentUsages: Array<QuestionAssessment>;
  /** Question body with prompt and fields. */
  body: Maybe<QuestionBody>;
  /** Preferred caching ID on the client. */
  cacheId: Scalars['ID']['output'];
  childrenQuestions: Array<Question>;
  createdAt: Scalars['PreciseDateTime']['output'];
  currentVersionId: Maybe<Scalars['ID']['output']>;
  difficulty: Maybe<QuestionDifficulty>;
  hash: Scalars['HexString']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedBy: Maybe<User>;
  libraryId: Scalars['String']['output'];
  /** Order for a child sub-question. */
  order: Maybe<Scalars['Int']['output']>;
  /** Parent question ID for sub questions. */
  parentQuestionId: Maybe<Scalars['ID']['output']>;
  /** Points alloted to this question. */
  points: Maybe<Scalars['Int']['output']>;
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Maybe<Scalars['String']['output']>;
  shuffle: Scalars['Boolean']['output'];
  sourceFile: Maybe<QuestionSourceFile>;
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
  /** Attached tags of the questions */
  tags: Array<QuestionTag>;
  /** Should be used only for task block edge. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** @deprecated Version number is not relevant now as IDs are used for versioning. */
  version: Maybe<Scalars['Int']['output']>;
  /** All the versions of the question */
  versions: Array<QuestionVersion>;
};

export type QuestionAssessment = {
  __typename?: 'QuestionAssessment';
  /** When and how the question was used in an assessment. */
  assessment: Assessment;
  points: Maybe<Scalars['Int']['output']>;
  releaseTimestamp: Scalars['PreciseDateTime']['output'];
};

export type QuestionAttributes = {
  /** Difficulty level of the question */
  difficulty?: InputMaybe<QuestionDifficulty>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<QuestionFieldInput>>;
  /** Order of the question in the parent question */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Parent question ID if this is a child of sub question */
  parentQuestionId?: InputMaybe<Scalars['ID']['input']>;
  /** Points for the question */
  points?: InputMaybe<Scalars['Int']['input']>;
  /** Question prompt prosemirror contents */
  promptDoc: Scalars['String']['input'];
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage?: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** Shuffle the choices in the question */
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Updatable attributes for a question */
export type QuestionAttributesInput = {
  currentVersionId?: InputMaybe<Scalars['ID']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  points?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBank = {
  __typename?: 'QuestionBank';
  assessmentId: Maybe<Scalars['ID']['output']>;
  category: Maybe<QuestionBankCategory>;
  createdBy: User;
  difficulty: Maybe<QuestionDifficulty>;
  fileOrigin: Maybe<QuestionBankFileOrigin>;
  id: Scalars['ID']['output'];
  points: Maybe<Scalars['Int']['output']>;
  question: Question;
  questionBankId: Scalars['ID']['output'];
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
};

export type QuestionBankCategory = {
  __typename?: 'QuestionBankCategory';
  assessmentId: Maybe<Scalars['ID']['output']>;
  createdBy: User;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
};

export type QuestionBankCategoryInput = {
  category: Scalars['String']['input'];
  scope: QuestionBankScope;
};

export type QuestionBankFileOrigin = {
  __typename?: 'QuestionBankFileOrigin';
  filename: Maybe<Scalars['String']['output']>;
  filepath: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type QuestionBankFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  questionBankIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionType?: InputMaybe<QuestionType>;
};

export type QuestionBankNodes = {
  nodeId: Scalars['ID']['input'];
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
  questionBankId: Scalars['ID']['input'];
};

export type QuestionBankScope = {
  assessmentId?: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};

/** A node (or sub-tree) in the QuestionTree */
export type QuestionBlock = {
  __typename?: 'QuestionBlock';
  /** e.g. Question 1 */
  longLabel: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the node */
  nodeId: Scalars['ID']['output'];
  /** Type of the node */
  nodeType: QuestionTreeNodeType;
  /** Order position of this node among siblings */
  order: Scalars['Int']['output'];
  /** ID of the parent node, if any */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  /** Total points below this tree node */
  points: Maybe<Scalars['Int']['output']>;
  /** Question attached to this node */
  question: Maybe<Question>;
  questionId: Maybe<Scalars['ID']['output']>;
  questionSetId: Maybe<Scalars['ID']['output']>;
  /** e.g. Q1 */
  shortLabel: Maybe<Scalars['String']['output']>;
  /** Whether to shuffle this node's children */
  shuffle: Maybe<Scalars['Boolean']['output']>;
  socraticQuestionerEnabled: Scalars['Boolean']['output'];
};

/** Saved contents of the Question. */
export type QuestionBody = {
  __typename?: 'QuestionBody';
  feedback: Maybe<Scalars['String']['output']>;
  /** Interactions and their response declaration in the question. */
  fields: Maybe<Array<QuestionField>>;
  /** Question Body ID used for caching body separately, not expected to be used. */
  id: Scalars['ID']['output'];
  /** Serialised ProseMirror document */
  promptDoc: Maybe<Scalars['String']['output']>;
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage: Maybe<PromptImage>;
  /** @deprecated Use `fields` */
  response: Maybe<QuestionResponse>;
};

export enum QuestionDifficulty {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM'
}

/** A single Question field. */
export type QuestionField = {
  __typename?: 'QuestionField';
  identifier: Scalars['String']['output'];
  /** How the student interacts with the field. */
  interaction: QuestionInteraction;
  /** How the response should be interpreted and marked. */
  response: Maybe<ResponseDeclaration>;
};

export type QuestionFieldInput = {
  choiceInteraction?: InputMaybe<ChoiceInteractionInput>;
  extendedInteraction?: InputMaybe<ExtendedInteractionInput>;
  identifier: Scalars['String']['input'];
  matchInteraction?: InputMaybe<MatchInteractionInput>;
  positionObjectInteraction?: InputMaybe<PositionObjectInteractionInput>;
  response: ResponseDeclarationInput;
  socraticInteraction?: InputMaybe<SocraticInteractionInput>;
  textEntryInteraction?: InputMaybe<TextEntryInteractionInput>;
};

/** Different kinds of interactions expected for a question. */
export type QuestionInteraction = ChoiceInteraction | ExtendedInteraction | MatchInteraction | PositionObjectInteraction | SocraticInteraction | TextEntryInteraction;

/** Outcome recorded for a single question answered by a Student. */
export type QuestionOutcome = {
  __typename?: 'QuestionOutcome';
  /** Answer snapshot submitted for marking by the student. */
  blockSnapshot: Maybe<BlockSnapshot>;
  fieldOutcomes: Array<FieldOutcome>;
  id: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  /** References snapshot submitted for marking by the student. */
  referencesBlockSnapshot: Maybe<BlockSnapshot>;
  /** Question outcome score breakdowns */
  scoreBreakdown: ScoreBreakdown;
};

/** QuestionOutcomeRelease represents a snapshot of a question outcome at release time. */
export type QuestionOutcomeRelease = {
  __typename?: 'QuestionOutcomeRelease';
  answerBlockId: Scalars['ID']['output'];
  /** Answer snapshot submitted for marking by the student. */
  blockSnapshot: Maybe<BlockSnapshot>;
  blockSnapshotId: Scalars['ID']['output'];
  fieldOutcomeReleases: Array<FieldOutcomeRelease>;
  /** The ID of the QuestionOutcome. */
  id: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  questionOutcomeId: Scalars['ID']['output'];
  referencesAnswerBlockId: Maybe<Scalars['ID']['output']>;
  /** References snapshot submitted for marking by the student. */
  referencesBlockSnapshot: Maybe<BlockSnapshot>;
  referencesBlockSnapshotId: Maybe<Scalars['ID']['output']>;
};

/** Server-computed response/success rates for a moderation question. */
export type QuestionRates = {
  __typename?: 'QuestionRates';
  averageScore: Maybe<Scalars['Float']['output']>;
  responseRate: Scalars['Int']['output'];
  successRate: Maybe<Scalars['Int']['output']>;
};

/** Different kinds of responses expected for a question. */
export type QuestionResponse = BlanksResponse | BooleanResponse | EditorResponse | MultiResponse | ShortResponse;

export type QuestionResponseCounts = {
  __typename?: 'QuestionResponseCounts';
  /** Average percentage score (0–100) across responses. Null when no responses exist. */
  averageScore: Maybe<Scalars['Float']['output']>;
  /** Count of provided responses. */
  responseCount: Scalars['Int']['output'];
  /** Count of responses that achieved 100% of the outcomes. */
  successCount: Scalars['Int']['output'];
};

/** A Question's marking rubric. */
export type QuestionRubric = {
  __typename?: 'QuestionRubric';
  /** Metrics on the responses provided to the marked question. */
  counts: QuestionResponseCounts;
  fieldRubrics: Array<FieldRubric>;
  id: Scalars['ID']['output'];
  maxScore: Scalars['Float']['output'];
  questionId: Scalars['ID']['output'];
};

/** Aggregated score for a single question within a WorkOutcome. */
export type QuestionScore = {
  __typename?: 'QuestionScore';
  questionId: Scalars['ID']['output'];
  score: Maybe<Scalars['Float']['output']>;
};

export type QuestionSelection = {
  __typename?: 'QuestionSelection';
  id: Scalars['ID']['output'];
  rules: Array<QuestionSelectionRule>;
  sets: Maybe<Array<QuestionSet>>;
  setsQuantity: Scalars['Int']['output'];
};

export type QuestionSelectionFilterInput = {
  selectedSetId: Scalars['Int']['input'];
  selectionId: Scalars['ID']['input'];
};

export type QuestionSelectionInput = {
  excludeQuestionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  overlap?: InputMaybe<Scalars['Boolean']['input']>;
  questionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionsPerSet?: InputMaybe<Scalars['Int']['input']>;
  rules: Array<QuestionSelectionRuleInput>;
  setsQuantity: Scalars['Int']['input'];
  usedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  usedTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionSelectionRule = {
  __typename?: 'QuestionSelectionRule';
  createdBy: Maybe<Scalars['ID']['output']>;
  difficulty: Maybe<QuestionDifficulty>;
  id: Scalars['ID']['output'];
  includeUsed: Maybe<Scalars['Boolean']['output']>;
  points: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  questionType: QuestionType;
  usedFrom: Maybe<Scalars['DateTime']['output']>;
  usedTo: Maybe<Scalars['DateTime']['output']>;
};

export type QuestionSelectionRuleInput = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  includeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  points: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  questionType: QuestionType;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  usedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  usedTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionSet = {
  __typename?: 'QuestionSet';
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  questions: Array<QuestionSetQuestion>;
};

export type QuestionSetQuestion = {
  __typename?: 'QuestionSetQuestion';
  id: Scalars['ID']['output'];
  /** Rubric attached to this question inside the question set */
  markerRubric: Maybe<MarkerRubric>;
  /** Tree layout node Id for the question inside question set */
  nodeId: Scalars['ID']['output'];
  /** Tree layout previous node Id for the question inside question set */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  points: Maybe<Scalars['Int']['output']>;
  /** Tree layout parent node Id for the question inside question set */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  question: Question;
  /** Id of the question version used in this question set question */
  questionVersionId: Maybe<Scalars['ID']['output']>;
  shuffle: Scalars['Boolean']['output'];
};

/** A source file for imported question in the library. */
export type QuestionSourceFile = {
  __typename?: 'QuestionSourceFile';
  filename: Maybe<Scalars['String']['output']>;
  filepath: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type QuestionTag = {
  __typename?: 'QuestionTag';
  categoryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type QuestionTagCategory = {
  __typename?: 'QuestionTagCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Type of tree-node in the QuestionTree */
export enum QuestionTreeNodeType {
  Overview = 'OVERVIEW',
  Question = 'QUESTION',
  Section = 'SECTION',
  Selection = 'SELECTION',
  Set = 'SET',
  Sub = 'SUB'
}

/** Valid Question types */
export enum QuestionType {
  Blanks = 'BLANKS',
  Extended = 'EXTENDED',
  Hotspot = 'HOTSPOT',
  Matching = 'MATCHING',
  Mcq = 'MCQ',
  Numerical = 'NUMERICAL',
  Overview = 'OVERVIEW',
  Section = 'SECTION',
  Short = 'SHORT',
  Sub = 'SUB',
  Truefalse = 'TRUEFALSE',
  Video = 'VIDEO'
}

export type QuestionVersion = {
  __typename?: 'QuestionVersion';
  /** Question body with prompt and fields. */
  body: Maybe<QuestionBody>;
  childrenQuestions: Array<QuestionVersion>;
  hash: Scalars['HexString']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  order: Maybe<Scalars['Int']['output']>;
  parentQuestionId: Maybe<Scalars['ID']['output']>;
  questionId: Scalars['ID']['output'];
  questionType: QuestionType;
  shortPrompt: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
  /** @deprecated Version number is not relevant now as IDs are used for versioning. */
  version: Maybe<Scalars['Int']['output']>;
};

export enum RecordSocraticTurnPreparationMediaError {
  /** Turn not found */
  TurnNotFound = 'TURN_NOT_FOUND'
}

export type RecordSocraticTurnPreparationMediaInput = {
  /** Duration of the recorded preparation media in seconds. */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  mediaId: Scalars['ID']['input'];
  /** URL of the recorded preparation media associated with this turn. */
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  turnId: Scalars['ID']['input'];
};

export type RecordSocraticTurnPreparationMediaPayload = {
  __typename?: 'RecordSocraticTurnPreparationMediaPayload';
  error: Maybe<RecordSocraticTurnPreparationMediaError>;
  turn: Maybe<SocraticTurn>;
};

/** Re-entry metadata for a student's exam session. */
export type ReentryStatus = {
  __typename?: 'ReentryStatus';
  /** True when re-entry prevention is enabled and the student has a prior verified session. */
  requiresReentryCode: Scalars['Boolean']['output'];
  /** Total number of re-entry events recorded for this enrollment. */
  sessionCount: Scalars['Int']['output'];
};

export type RegenerateQuestionSetInput = {
  allowOverlappingSets?: InputMaybe<Scalars['Boolean']['input']>;
  questionSetId: Scalars['ID']['input'];
  questionSetQuestionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RegenerateQuestionSetPayload = {
  __typename?: 'RegenerateQuestionSetPayload';
  /** True if the replacement set is incomplete */
  incompleteReplacement: Maybe<Scalars['Boolean']['output']>;
  /** Updated Question Set. May be nil if the replacement set is incomplete. */
  questionSet: Maybe<QuestionSet>;
};

export type RegisterQuestionSourceFileInput = {
  filename: Scalars['String']['input'];
  filepath: Scalars['String']['input'];
};

/** Return type for cancelRelease mutation. */
export type ReleaseAssessmentPayload = {
  __typename?: 'ReleaseAssessmentPayload';
  assessment: Assessment;
  sheets: Array<Sheet>;
};

export type ReleaseFeedbackForEveryonePayload = {
  __typename?: 'ReleaseFeedbackForEveryonePayload';
  feedbackReleaseRules: Array<FeedbackReleaseRule>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

/** Scope a feedback release rule applies to. */
export enum ReleaseRuleKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Joint = 'JOINT'
}

export type RemoveQuestionsUniformlyInput = {
  /** ID of the Question Selection to remove questions from */
  questionSelectionId: Scalars['ID']['input'];
  /** List of selected question set question IDs to remove. These questions will be used to determine which questions to remove from the other sets. */
  questionSetQuestionIds: Array<Scalars['ID']['input']>;
};

export type ReplaceQuestionInSetInput = {
  /** ID of the Question to use as replacement */
  questionId: Scalars['ID']['input'];
  /** ID of the Question Set to update */
  questionSetId: Scalars['ID']['input'];
  /** ID of the QuestionSetQuestion to update */
  questionSetQuestionId: Scalars['ID']['input'];
  /** ID of the specific Question Version to use as replacement (optional) */
  questionVersionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Assessment Task requirements. */
export type Requirements = {
  __typename?: 'Requirements';
  /** Allow the use of Generative AI or not. */
  allowGenerativeAi: Maybe<Scalars['Boolean']['output']>;
  /** Allow late re-submissions or not. */
  allowLateResubmission: Scalars['Boolean']['output'];
  /** If anonymous marking is selected. */
  anonymousMarking: Maybe<Scalars['Boolean']['output']>;
  assessmentType: AssessmentType;
  /** Whether submissions on this assessment are scanned by Copyleaks. */
  copyleaksEnabled: Scalars['Boolean']['output'];
  countFootnotes: Scalars['Boolean']['output'];
  countReferences: Scalars['Boolean']['output'];
  disableExamBacktrack: Maybe<Scalars['Boolean']['output']>;
  disableSpellCheck: Scalars['Boolean']['output'];
  /** Drafting due date with Institution timezone */
  draftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * Are students allowed to view draft similarity scores/reports.
   *
   * 0 - Never
   * 1 - Only After the final due date
   * 2 - Always
   */
  draftSViewReports: Scalars['Int']['output'];
  /** When true, numeric scoring of draft submissions is available in Cadmus Marker; when false, comments only. */
  draftScoringEnabled: Scalars['Boolean']['output'];
  /** Final due date with Institution timezone. */
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  enableExamAccessCode: Scalars['Boolean']['output'];
  enableExamAutoSubmission: Scalars['Boolean']['output'];
  enableExamIpFilter: Scalars['Boolean']['output'];
  enableExamLdb: Maybe<Scalars['Boolean']['output']>;
  enableExamReentryPrevention: Scalars['Boolean']['output'];
  /** Enable or disable PDF attachment in submission receipts. */
  enableSubmissionPdf: Scalars['Boolean']['output'];
  examEndDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examFeedbackDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examInactivityTimeout: Maybe<Scalars['Int']['output']>;
  examIpFilter: Maybe<Scalars['String']['output']>;
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examSchoolyearEnabled: Scalars['Boolean']['output'];
  examStartDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examTiming: ExamTiming;
  examType: Array<Scalars['String']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  /** Selected grading integration. Either `turnitin` or `speedgrader` or `moodlegrader` currently. */
  gradingService: Scalars['String']['output'];
  /**
   * Has the set of requirements been altered by a user?
   *
   * This checks whether we have saved any requirements against the assessment
   */
  hasChanged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** When true, students can see individual draft feedback before the draft due date. */
  individualDraftFeedbackAlwaysAvailable: Scalars['Boolean']['output'];
  lateSubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  /** Restrict student result view in LMS marking tool. */
  markingToolPdf: Maybe<MarkingToolPdf>;
  /** Maximum grade points. */
  maxGrade: Scalars['Int']['output'];
  noDraft: Scalars['Boolean']['output'];
  noExamFeedbackDate: Scalars['Boolean']['output'];
  noExamReadingTime: Scalars['Boolean']['output'];
  noLimit: Scalars['Boolean']['output'];
  noReferencing: Scalars['Boolean']['output'];
  /** Do students need to work in a limited time window */
  noTimeLimit: Scalars['Boolean']['output'];
  noWeight: Scalars['Boolean']['output'];
  referencingStyle: Maybe<Scalars['String']['output']>;
  /** If student result view is restricted. */
  restrictMarkingToolPdf: Scalars['Boolean']['output'];
  /** Final grade and feedback return date date with Institution timezone. */
  returnDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Show rubrics to students on sheet. */
  rubricDisplayDisabled: Scalars['Boolean']['output'];
  /**
   * Are students allowed to view final similarity scores/reports.
   *
   * 0 - Never
   * 1 - Only After the final due date
   * 2 - Always
   */
  sViewReports: Scalars['Int']['output'];
  /** Maximum number of submission attempts allowed for students. Null means unlimited attempts. */
  submitAttemptLimit: Maybe<Scalars['Int']['output']>;
  /** Allowed working time in minutes */
  timeLimit: Maybe<Scalars['Int']['output']>;
  vivaCameraRequiredDisabled: Scalars['Boolean']['output'];
  vivaReattemptWindowSeconds: Maybe<Scalars['Int']['output']>;
  /** @deprecated Whole minutes. Use `vivaReattemptWindowSeconds`. */
  vivaReattemptWindowTime: Maybe<Scalars['Int']['output']>;
  weight: Maybe<Scalars['Float']['output']>;
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type RequirementsInput = {
  allowGenerativeAi?: InputMaybe<Scalars['Boolean']['input']>;
  allowLateResubmission?: InputMaybe<Scalars['Boolean']['input']>;
  anonymousMarking?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentType?: InputMaybe<AssessmentType>;
  copyleaksEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  countFootnotes?: InputMaybe<Scalars['Boolean']['input']>;
  countReferences?: InputMaybe<Scalars['Boolean']['input']>;
  disableExamBacktrack?: InputMaybe<Scalars['Boolean']['input']>;
  disableSpellCheck?: InputMaybe<Scalars['Boolean']['input']>;
  draftDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  draftSViewReports?: InputMaybe<Scalars['Int']['input']>;
  draftScoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  enableExamAccessCode?: InputMaybe<Scalars['Boolean']['input']>;
  enableExamAutoSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  enableExamIpFilter?: InputMaybe<Scalars['Boolean']['input']>;
  enableExamLdb?: InputMaybe<Scalars['Boolean']['input']>;
  enableExamReentryPrevention?: InputMaybe<Scalars['Boolean']['input']>;
  enableSubmissionPdf?: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examFeedbackDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examInactivityTimeout?: InputMaybe<Scalars['Int']['input']>;
  examIpFilter?: InputMaybe<Scalars['String']['input']>;
  examReadingTime?: InputMaybe<Scalars['Int']['input']>;
  examSchoolyearEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examStartDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examTiming?: InputMaybe<ExamTiming>;
  examType?: InputMaybe<Array<Scalars['String']['input']>>;
  examWritingTime?: InputMaybe<Scalars['Int']['input']>;
  gradingService?: InputMaybe<Scalars['String']['input']>;
  individualDraftFeedbackAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  lateSubmissionTimeLimit?: InputMaybe<Scalars['Int']['input']>;
  markingToolPdf?: InputMaybe<MarkingToolPdf>;
  maxGrade?: InputMaybe<Scalars['Int']['input']>;
  noDraft?: InputMaybe<Scalars['Boolean']['input']>;
  noExamFeedbackDate?: InputMaybe<Scalars['Boolean']['input']>;
  noExamReadingTime?: InputMaybe<Scalars['Boolean']['input']>;
  noLimit?: InputMaybe<Scalars['Boolean']['input']>;
  noReferencing?: InputMaybe<Scalars['Boolean']['input']>;
  noTimeLimit?: InputMaybe<Scalars['Boolean']['input']>;
  noWeight?: InputMaybe<Scalars['Boolean']['input']>;
  referencingStyle?: InputMaybe<Scalars['String']['input']>;
  restrictMarkingToolPdf?: InputMaybe<Scalars['Boolean']['input']>;
  returnDate?: InputMaybe<Scalars['DateTime']['input']>;
  rubricDisplayDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  sViewReports?: InputMaybe<Scalars['Int']['input']>;
  submitAttemptLimit?: InputMaybe<Scalars['Int']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  vivaCameraRequiredDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  vivaReattemptWindowSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Whole minutes. Use `vivaReattemptWindowSeconds`. */
  vivaReattemptWindowTime?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type ResetModerationDecisionsPayload = {
  __typename?: 'ResetModerationDecisionsPayload';
  submissionOutcomes: Array<SubmissionOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type ResetQuestionModerationChangesPayload = {
  __typename?: 'ResetQuestionModerationChangesPayload';
  fieldRubrics: Array<FieldRubric>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubrics: Array<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type ResetRubricOutcomeForFieldPayload = {
  __typename?: 'ResetRubricOutcomeForFieldPayload';
  criterionOutcomesDeleted: Scalars['Int']['output'];
  fieldOutcome: FieldOutcome;
  questionOutcome: QuestionOutcome;
  studentOutcomes: Array<StudentOutcome>;
  workOutcome: WorkOutcome;
};

export type ResetRubricOutcomeForSubmissionPayload = {
  __typename?: 'ResetRubricOutcomeForSubmissionPayload';
  criterionOutcomesDeleted: Scalars['Int']['output'];
  studentOutcomes: Array<StudentOutcome>;
  submissionOutcome: SubmissionOutcome;
  workOutcome: WorkOutcome;
};

export type ResetRubricOutcomePayload = {
  __typename?: 'ResetRubricOutcomePayload';
  criteria: Array<Criterion>;
};

export type ResetScoreModerationChangesPayload = {
  __typename?: 'ResetScoreModerationChangesPayload';
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

/** A Task resource. */
export type Resource = {
  __typename?: 'Resource';
  /** File size in bytes */
  fileSize: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invalidated: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** Additional notes on this resource */
  notes: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

/** Response declaration for a question field. */
export type ResponseDeclaration = {
  __typename?: 'ResponseDeclaration';
  /** Data type of the student response */
  baseType: Maybe<BaseType>;
  /** How many correct answers expected */
  cardinality: Maybe<Cardinality>;
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  correctAreas: Array<PositionArea>;
  correctRanges: Array<NumericRange>;
  correctValues: Array<Scalars['String']['output']>;
  /** Accepted margin of error */
  errorMargin: Maybe<Scalars['Float']['output']>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
  partialScoring: Maybe<Scalars['Boolean']['output']>;
};

export type ResponseDeclarationInput = {
  baseType?: InputMaybe<BaseType>;
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  correctAreas?: InputMaybe<Array<PositionAreaInput>>;
  correctRanges?: InputMaybe<Array<NumericRangeInput>>;
  correctValues: Array<Scalars['String']['input']>;
  errorMargin?: InputMaybe<Scalars['Float']['input']>;
  matchSimilarity?: InputMaybe<Scalars['Float']['input']>;
  partialScoring?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Gradebook Result. */
export type Result = {
  __typename?: 'Result';
  /** Canvas LTI API url for a successfully recorded submission in Canvas. */
  canvasResultUrl: Maybe<Scalars['String']['output']>;
  /**
   * Copyleaks similarity score for the Result, as a percentage.
   *
   * Null until a scan has scored, and null for a student who may not see
   * similarity for this submission type.
   */
  copyleaksSimilarityScore: Maybe<Scalars['Float']['output']>;
  /**
   * Find the last access summary for launching this result with the configured
   * external grading service.
   */
  feedbackAccess: Maybe<AccessSummary>;
  /** Grade information on the Result. */
  grade: Maybe<Grade>;
  /** Connection to Hera for a successfully recorded submission in Hera and Turnitin. */
  heraResultId: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Is the hera connection complete?
   * @deprecated Use receipt edge instead.
   */
  isReady: Scalars['Boolean']['output'];
  /** Moodle LTI API url for a successfully recorded submission in Moodle. */
  moodleGraderUrl: Maybe<Scalars['String']['output']>;
  /**
   * Originality scan for the Result's current submission.
   *
   * Null when nothing has been scanned. Carries the scan's state rather than its
   * score, so a scan that has not produced one is still diagnosable.
   */
  originality: Maybe<Originality>;
  /**
   * Submission pipeline processing receipt for the latest submission made in
   * this Result.
   */
  receipt: Maybe<GradebookReceipt>;
  /** When Student grades were sent to the LMS */
  returnedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Similarity information on the Result. */
  similarity: Maybe<Similarity>;
  /** Latest submission tracked in the Result */
  submission: Maybe<Submission>;
  /** Type of the Submission that the Result belongs to. */
  submissionType: SubmissionType;
  /** ID of the Work that the Result belongs to. */
  workId: Scalars['String']['output'];
};

/** Criterion with fields for reuse */
export type ReuseCriterion = {
  __typename?: 'ReuseCriterion';
  /** Parent MarkerRubric's assessment */
  assessmentName: Scalars['String']['output'];
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** Parent MarkerRubric's kind */
  kind: MarkerRubricKind;
  maxScore: Maybe<Scalars['Int']['output']>;
  /** Parent MarkerRubric's published_at */
  publishedAt: Scalars['DateTime']['output'];
  scaleItems: Array<ScaleItem>;
  skill: LearningOutcomeSkill;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Accept the charter agreement */
  acceptStudentCharter: CharterAgreement;
  /** Add a tag to a group. */
  addGroupTag: GroupTag;
  /**
   * Import Library Questions to Task.
   *
   * Returns newly created TaskBlocks with Library Questions' data copied over.
   */
  addLibraryQuestionsToTask: Array<TaskBlock>;
  /** Add questions from question bank as TaskBlocks */
  addQuestionBanksToAssessment: Array<TaskBlock>;
  /**
   * Add QuestionSelection to Task which will allow to use QuestionSets.
   *
   * Returns created TaskBlock with QuestionSelection associated with it.
   */
  addQuestionSelectionToTask: TaskBlock;
  /** Add a tag to an enrollment */
  addTag: Tag;
  /** Append groups using group setup rules for an assessment. */
  appendGroups: Array<Group>;
  /** Append tags to the questions in given questions set, if tag's name doesn't exist in question */
  appendTagsForQuestions: Array<Question>;
  archiveQuestion: Maybe<Question>;
  /** Assign a marker to a group or groups */
  assignMarkerToGroups: Maybe<Array<Group>>;
  /** Assign markers to members. */
  assignMarkersToMembers: Array<GroupMarker>;
  /** Auto fill groups with students */
  autoAssignGroups: Maybe<Array<Group>>;
  /** Create a new MarkerRubric, or copy an existing one, into an Assessment. */
  buildMarkerRubric: BuildMarkerRubricPayload;
  /** Add a tag to multiple enrollments. */
  bulkAddTag: Array<Tag>;
  /** Remove a tag from multiple enrollments. */
  bulkRemoveTag: Scalars['Boolean']['output'];
  /** Cancel an existing Instruction Sheet release. */
  cancelRelease: CancelReleasePayload;
  /** Update user settings in a Subject context during an onboarding flow. */
  captureOnboardingInput: OnboardingPayload;
  /** Atomically switch Assessment Preset. */
  changeAssessmentPreset: ChangeAssessmentPresetResult;
  /** Clear the marker adjustment on a student's group component outcome. */
  clearMarkerAdjustment: MarkerAdjustmentPayload;
  /**
   * Finalise all submitted Criterion selection against the current student's
   * peers in the group.
   */
  completePeerOutcomes: Array<PeerOutcome>;
  /** Complete a Turn */
  completeSocraticTurn: CompleteSocraticTurnPayload;
  /** Complete marking for all submission outcomes assigned to the current marker */
  completeSubmissionOutcomes: CompleteSubmissionOutcomesPayload;
  /**
   * Copy Assessment accessories, which include resources, state and
   * settings from another assessment.
   * @deprecated Use `copy_assessment_v2` instead
   */
  copyAssessment: Task;
  /**
   * Copy Assessment accessories, which include resources, state and
   * settings from another assessment.
   *
   * The copied instruction sheet sets the destination's preset, so the result
   * carries the Assessment's settings as well as the Task the content landed in.
   */
  copyAssessmentV2: CopyAssessmentResult;
  copyQuestion: Question;
  /** Create an attachment from an answer block. */
  createBlockAttachment: BlockAttachment;
  /** Create a draft Charter Form */
  createCharterForm: CharterForm;
  /** Create a new comment under a thread. */
  createComment: Comment;
  /** Register a file imported for question bank as an origin */
  createFileOrigin: QuestionBankFileOrigin;
  /**
   * Create Marker Rubric via Cadmus Grader
   * @deprecated Use buildMarkerRubric instead.
   */
  createGraderMarkerRubric: CreateGraderMarkerRubricPayload;
  /** Create a new group. */
  createGroup: Group;
  /** Create multiple groups. */
  createGroups: Array<Group>;
  /**
   * Create a new MarkerRubric in an Assessment.
   * @deprecated Use buildMarkerRubric instead.
   */
  createMarkerRubric: MarkerRubric;
  createPrintArchive: Scalars['String']['output'];
  /**
   * Create a new question in the question library. It's possible to add an
   * array of children question for SUB question type. Returns the array of
   * questions created.
   */
  createQuestion: Question;
  /** Create a new question bank */
  createQuestionBank: QuestionBank;
  /** Create a new question bank category */
  createQuestionBankCategory: QuestionBankCategory;
  /**
   * Create a new MarkerRubric attached to a TaskBlock.
   * @deprecated Use buildMarkerRubric instead.
   */
  createQuestionMarkerRubric: CreateQuestionMarkerRubricPayload;
  /** Create a new Question Selection with pre-generated Question Sets */
  createQuestionSelection: CreateQuestionSelectionPayload;
  /** Create a new Link/Url Resource. */
  createResource: Resource;
  /** Create a one-time deep link URL to open the Schoolyear exam dashboard UI. */
  createSchoolyearDashboardUrl: Maybe<CreateSchoolyearDashboardUrlPayload>;
  /** Create a one-time deep link URL to open the Schoolyear exam settings UI. */
  createSchoolyearSettingsUrl: Maybe<CreateSchoolyearSettingsUrlPayload>;
  /** Create a new learning outcome Skill */
  createSkill: LearningOutcomeSkill;
  /** Create a new smart comment for a skill. */
  createSmartComment: SmartComment;
  /** Create a Dialogue */
  createSocraticDialogue: CreateSocraticDialoguePayload;
  /** Creates a SubmissionOutcome for the marker based on their scope. */
  createSubmissionOutcome: SubmissionOutcome;
  /** Create tag with given name */
  createTag: QuestionTag;
  /** Creating a task block */
  createTaskBlock: TaskBlock;
  /**
   * Save new Task instructions for the given Assessment.
   * @deprecated Use `create_task_save_v2` instead
   */
  createTaskSave: SaveState;
  /** Save new Task instructions. */
  createTaskSaveV2: SaveState;
  /** Create a new thread. */
  createThread: Thread;
  /** Approve or decline a group change request. */
  decideGroupChangeRequest: Message;
  /** Delete GenAI Guideline Notice for a Task, clearing custom instructions. */
  deleteGenaiGuidelineNotice: Task;
  /** Delete an existing group; returns the remaining groups for the assessment (after optional `auto_assign` redistribution) so clients can refresh their cache directly. */
  deleteGroup: Array<Group>;
  /** Delete a member from a group. */
  deleteGroupMember: Maybe<DeletedMember>;
  /** Delete multiple groups; returns the remaining groups for the assessment (after optional `auto_assign` redistribution) so clients can refresh their cache directly. */
  deleteGroups: Array<Group>;
  /** Invalidate an existing Link/Url Resource. */
  deleteResource: Resource;
  /** Delete an existing smart comment */
  deleteSmartComment: Maybe<SmartComment>;
  /** Delete a thread. */
  deleteThread: Thread;
  /** Dismiss the current teacher's satisfaction prompt for a moment. */
  dismissTeacherSatisfaction: TeacherSurvey;
  /** Generate a pre-signed download URL for the peer evaluation XLSX export. */
  downloadPeerEvaluationData: Scalars['String']['output'];
  /** Generate a pre-signed download URL for the given save */
  downloadSavePdf: Scalars['String']['output'];
  /** Generate a pre-signed download URL for the student's recorded response to a Dialogue's Turn. */
  downloadSocraticTurnMedia: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given submissions in the
   * Assessment.
   */
  downloadSubmissions: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given work artifacts ids and filenames.
   * Single artifact will download a pdf. Multiple will create a presigned url for zip.
   */
  downloadWorkArtifacts: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given work file attachments.
   * Single attachment will download the file. Multiple will create a presigned url for zip.
   */
  downloadWorkAttachments: Scalars['String']['output'];
  /** Duplicating a task block and children task blocks */
  duplicateTaskBlock: Array<TaskBlock>;
  /** Edit an existing comment. */
  editComment: Comment;
  /**
   * Change Task status to editing.
   * @deprecated Use `edit_task_v2` instead
   */
  editTask: Task;
  /** Change Task status to editing. */
  editTaskV2: Task;
  /** Edit an existing thread's title. */
  editThreadTitle: Thread;
  /**
   * Extend a Work's submit attempt limit to allow a re-submission attempt.
   * @deprecated Use updateWorkSettings or updateStudentSettings with submitAttemptLimit instead
   */
  extendWorkSubmitAttemptLimit: WorkSettings;
  /** Finalise all groups for an assessment. */
  finaliseAllGroups: Array<Group>;
  /** Finalise the student's own group in an assessment. */
  finaliseGroup: Group;
  /** Finalise specific groups for an assessment. */
  finaliseGroups: Array<Group>;
  /**
   * Select similar questions that can be used to replace the given questions
   * in the selection.
   *
   * Similar questions are selected based on question type and points. Tags can
   * be also provided to filter the questions.
   *
   * If not enough similar questions are found, the replacement is considered
   * incomplete.
   */
  findSimilarQuestions: SimilarQuestionsPayload;
  /** Flag the main submission outcomes for given work outcomes as needing attention. */
  flagAttention: SubmissionOutcomesPayload;
  /**
   * Make submissions for Student's works on their behalf.
   *
   * This mutation is used by the Teacher to batch submit student's latest save
   * if they haven't submitted their work on their own.
   */
  forceSubmissions: Array<Result>;
  /**
   * Make submissions for Student's works on their behalf.
   *
   * This mutation is used by the Teacher to batch submit student's latest save
   * if they haven't submitted their work on their own.
   */
  forceSubmissionsV2: Array<Result>;
  /** Generate Assessment and Student reports. */
  generateReport: Job;
  /**
   * Generate a Socratic question for every student in the class who is missing
   * one, and return the pool they generate into.
   *
   * `pool` carries the same `id` the `socraticQuestionerPool` query returns for
   * the same arguments, so the result lands on the query's cache entry.
   */
  generateSocraticQuestions: GenerateSocraticQuestionsPayload;
  /**
   * Generate a Socratic question for every student on the source assessment's
   * roster who is missing one, and return the task block's question as it
   * stands. Nothing waits on a generation: the new rows read `PENDING`, and each
   * is pushed over `socraticQuestionerTaskBlockUpdated` when its generation finishes.
   */
  generateSocraticStudentQuestions: GenerateSocraticStudentQuestionsPayload;
  /**
   * Generate a moderation performance CSV for an Assessment and return a
   * presigned download URL.
   *
   * Defaults to the per-student "class performance" export; pass `by_questions:
   * true` for the per-question ("success rate across questions") export.
   */
  generateWorkOutcomesCsv: Scalars['String']['output'];
  /** Grant extension settings to all active members of one or more groups. */
  grantGroupExtensions: Array<Maybe<WorkSettings>>;
  /**
   * Import selected Canvas groups as Cadmus marking groups. Reconciles the
   * incoming LMS groups against the assessment's existing groups (matching on
   * LMS external id, or by name for hand-built groups) and applies the diff in
   * one transaction. Available for any assessment — groups are the marking
   * unit regardless of whether it's a group assessment.
   */
  importCanvasGroups: ImportGroupsResult;
  /**
   * Import selected Canvas sections as Cadmus Sections (group assessments only).
   * Upserts a Section per Canvas section keyed on its LMS id and assigns members'
   * enrolments to it. Individual assessments are rejected — they use marking groups.
   */
  importCanvasSections: ImportSectionsResult;
  /**
   * Imports Library Question to existing TaskBlock. If `:question_version_id` is not provided,
   * the TaskBlock will be populated with the current versionof the Library Question.
   *
   * Returns the updated TaskBlock with Library Question references updated.
   */
  importLibraryQuestion: TaskBlock;
  /**
   * Import a MarkerRubric from an uploaded JSON file.
   *
   * Gated behind the `:rubric_import` feature flag. A fresh assessment gets a new
   * rubric; an existing rubric of the same kind (draft or published) is
   * overwritten — unless it has already been marked against, which is rejected so
   * marking data is never destroyed. The rubric is only saved if it passes
   * publish-level validation — an invalid file is turned away and nothing is
   * persisted.
   */
  importMarkerRubric: MarkerRubric;
  /** Import a roster spreadsheet assigning students to sections. */
  importSections: ImportSectionsResult;
  /** Import a list of smart comments in a single transaction. */
  importSmartComments: ImportSmartCommentsResult;
  /** Queue a RosterSyncing background job for the Assessment. */
  insertSyncRosterJob: BackgroundJob;
  /** Join an existing group as a student */
  joinGroup: Group;
  /** Leave group as a student */
  leaveGroup: Group;
  /** Link a comment thread to a marking criterion. */
  linkCommentThread: Thread;
  /** Marking a Field Outcome for Marker Rubric. */
  markFieldOutcome: MarkFieldOutcomePayload;
  /** Mark a Peer student as the current student. */
  markPeerOutcome: PeerOutcome;
  /** Mark a SubmissionOutcome connected to a MarkOutcome, optionally using a Rubric. */
  markSubmissionOutcome: MarkSubmissionOutcomePayload;
  /** Moderate score and/or feedback for multiple submission outcomes. */
  moderateMainOutcomes: SubmissionOutcomesPayload;
  /** Move groups (and their members' enrolments) into a section (null clears it). */
  moveGroupsToSection: Array<Group>;
  /** Move students' enrolments into a section (null clears it). Returns the sections. */
  moveStudentsToSection: Array<Section>;
  /** Publish a Charter Form */
  publishCharterForm: CharterForm;
  /** Import questions to the Question Library */
  publishImportedQuestions: Array<Question>;
  /**
   * Publish the draft changes on the MarkerRubric.
   * @deprecated Use saveMarkerRubric instead.
   */
  publishMarkerRubric: MarkerRubric;
  /** Push Submission Worker Job for the Result and Result's Last Submission ID. */
  pushSubmission: Result;
  /**
   * Start a submission-pipeline rerun for student submissions in an Assessment,
   * which can force a re-run of one or more stages of the pipeline in case of
   * errors or changes to the pipeline.
   *
   * Runs asynchronously in the background, while the mutation returns
   * immediately.
   */
  queueSubmissionPipeline: Maybe<Scalars['Boolean']['output']>;
  /** Recalculate a Work's marking outcomes against the released settings (impersonation only). */
  recalculateOutcomes: WorkOutcome;
  /** Record the preparation-phase video for a Turn. */
  recordSocraticTurnPreparationMedia: RecordSocraticTurnPreparationMediaPayload;
  /** Record the current teacher's satisfaction rating for a moment. */
  recordTeacherSatisfaction: TeacherSurvey;
  /**
   * Update Question Set by replacing its questions with similar ones.
   *
   * Similar questions are selected based on the rules of the original set. If
   * no rules were defined, similar questions are selected based on the
   * question type and points. Tags can be also provided to filter the questions.
   *
   * If not enough similar questions are found, the replacement is considered
   * incomplete.
   */
  regenerateQuestionSet: RegenerateQuestionSetPayload;
  /** Register the source file with the given path and name */
  registerQuestionSourceFile: QuestionSourceFile;
  /** Release the Assessment, releasing all Tasks and publishing draft MarkerRubrics. */
  releaseAssessment: ReleaseAssessmentPayload;
  releaseFeedbackForEveryone: ReleaseFeedbackForEveryonePayload;
  /** Release the given Task, returning a new latest Instruction Sheet. */
  releaseTask: Sheet;
  /** Remove an attachment from an AnswerBlock. */
  removeBlockAttachment: BlockAttachment;
  /** Remove a tag from a group. */
  removeGroupTag: Scalars['Boolean']['output'];
  /** Delete an existing MarkerRubric. */
  removeMarkerRubric: MarkerRubric;
  /**
   * Remove outcomes for marker rubric
   * @deprecated Use resetRubricOutcome instead
   */
  removeMarkerRubricOutcomes: OutcomesDeletedPayload;
  /** remove a question bank category */
  removeQuestionBankCategory: Maybe<Scalars['Boolean']['output']>;
  /**
   * Remove questions uniformly across all sets in a Question Selection.
   *
   * This mutation removes the same number of questions from each set based on
   * the similarity rules derived from the provided Question Set Questions. If
   * no explicit Question Selection Rule rules are defined, the removal is
   * guided by matching question type and points.
   */
  removeQuestionsUniformly: QuestionSelection;
  /** Remove a tag from an enrollment */
  removeTag: Scalars['Boolean']['output'];
  /** Replace a question in a Question Set with another question. */
  replaceQuestionInSet: QuestionSet;
  /** Reset all the student's given peer evaluation outcomes. */
  resetCriterionOutcomes: Scalars['Int']['output'];
  /** Reset a student's writing time on a windowed exam (impersonation only). */
  resetExamWritingTime: Work;
  /** Remove all unexecuted feedback release rules for an assessment. */
  resetFeedbackReleaseRules: Array<FeedbackReleaseRule>;
  /** Delete all groups in an assessment. */
  resetGroups: Scalars['Boolean']['output'];
  /**
   * Reset any un-published changes on the Marker Rubric.
   * @deprecated Use resetRubricOutcome instead.
   */
  resetMarkerRubric: MarkerRubric;
  resetModerationDecisions: ResetModerationDecisionsPayload;
  resetModerationPenaltyRules: Array<ModerationPenaltyRule>;
  /** Reset all moderation changes made against marking rubrics for all questions. */
  resetQuestionModerationChanges: ResetQuestionModerationChangesPayload;
  /** Delete criterion outcomes, submission and field scores for criteria */
  resetRubricOutcome: ResetRubricOutcomePayload;
  /** Reset rubric outcome and related field outcomes from marker rubric */
  resetRubricOutcomeForField: ResetRubricOutcomeForFieldPayload;
  /** Reset rubric outcome and related submission outcomes from marker rubric */
  resetRubricOutcomeForSubmission: ResetRubricOutcomeForSubmissionPayload;
  /** Reset all moderation changes made against the scores of the work outcomes. */
  resetScoreModerationChanges: ResetScoreModerationChangesPayload;
  /**
   * Resolve messages by their IDs.
   * @deprecated Use decideGroupChangeRequest
   */
  resolveMessages: Array<Message>;
  /** Discard the draft changes, restoring the published version. */
  restoreMarkerRubric: MarkerRubric;
  /** Cloud save for a Work. */
  save: Save;
  /** Save a new block snapshot against an answer block. */
  saveBlockSnapshot: SaveBlockSnapshotResponse;
  /**
   * Save the editor state by updating the `snapshot_doc`
   *     and `snapshot_version`
   */
  saveCharterEditor: CharterEditor;
  /** Save GenAI Guideline Notice content for a Task. */
  saveGenaiGuidelineNotice: TaskNotice;
  /** Save Institution wide settings for the current user. */
  saveGlobalUserSettings: SaveGlobalUserSettingsPayload;
  /** Save changes to a draft or published MarkerRubric. */
  saveMarkerRubric: MarkerRubric;
  /** Append new state to the question in a task block */
  saveQuestionState: Question;
  /** Save a teacher's reaction (and optional comment) on a Socratic questioner pool. */
  saveSocraticFeedbackEvent: SaveSocraticFeedbackEventPayload;
  /**
   * Save a teacher's reaction (and optional comment) on one Base question of one
   * task block. The source task is read from the viva assessment's settings.
   */
  saveSocraticQuestionerFeedback: SaveSocraticFeedbackEventPayload;
  /**
   * Send emails to students in class with a work artifact.
   *
   * This mutation is used by the teacher to batch send Automarked PDF (`complete_pdf`s)
   * to students in their class. The submission ids are provided by the client.
   */
  sendEmailsToClass: Scalars['String']['output'];
  /** Create a new pending message in the Assessment. */
  sendMessage: Message;
  /** Record the student's email-sharing consent for a group assessment. */
  setAssessmentEmailConsent: AssessmentEmailConsent;
  /** Set a marker adjustment on a student's group component outcome. */
  setMarkerAdjustment: MarkerAdjustmentPayload;
  /** Create or update a Access code */
  setupAccessCode: AccessCode;
  /** Create or access the latest student Group Charter. */
  setupCharter: Charter;
  /** Setup Work document for a finalised Student group. */
  setupGroupWork: WorkGroup;
  /** Initial wizard flow setup for groups in an assessment. */
  setupGroups: Array<Group>;
  /** Create a new Task for the given Assessment. */
  setupTask: Task;
  /** Manually setup a Work for a given Task explicitly */
  setupWork: Work;
  snapshotFieldOutcome: FieldOutcome;
  /** Save new snapshot for a SubmissionOutcome feedback. */
  snapshotSubmissionOutcome: SubmissionOutcome;
  /** Mark start of a work with time limit. */
  start: Work;
  /** Start a Dialogue */
  startSocraticDialogue: StartSocraticDialoguePayload;
  /** Start a Turn */
  startSocraticTurn: StartSocraticTurnPayload;
  /** Draft or final Submission. */
  submit: Submission;
  /**
   * Make a server-side submission attempt.
   * @deprecated Use `submitAttemptV2` instead
   */
  submitAttempt: Result;
  /**
   * Make a Submission attempt with a fixed attempt number.
   *
   * The latest server-recorded state of the Work is submitted if allowed.
   */
  submitAttemptV2: SubmitAttemptPayload;
  /** Submit a new sentiment check */
  submitSentimentCheck: SentimentCheck;
  /** Draft or final Submission (v2) */
  submitV2: Submission;
  /** Swap the order of two Resources. */
  swapResource: Scalars['Boolean']['output'];
  /**
   * Pass all existing final grades to the source LMS of an Assessment.
   *
   * This process happens asynchronously in the background, while the mutation
   * returns immediately.
   */
  syncGrades: Maybe<Scalars['Boolean']['output']>;
  /**
   * Perform a Roster Sync with the source LMS of an Assessment.
   *
   * Returns the list of new enrollments created, if any. The roster sync will
   * fail if the source LMS does not support it or has not provided service
   * params to sync with.
   */
  syncRoster: Array<Maybe<Enrollment>>;
  /** Unassign assessment markers. */
  unassignMarkers: Scalars['Boolean']['output'];
  /** Unlink a comment thread from its current marking criterion. */
  unlinkCommentThread: Thread;
  /** Unlink Library Question references from the TaskBlock. */
  unlinkLibraryQuestion: TaskBlock;
  /** Unlock the charter agreement */
  unlockStudentCharter: CharterAgreement;
  /** Unsubmission, which is really to allow Re-submissions. */
  unsubmit: Submission;
  /** Update a existing answer block. */
  updateAnswerBlock: AnswerBlock;
  /** Update an Assessment name. */
  updateAssessmentName: Assessment;
  updateAssessmentSettings: Assessment;
  /** Update an existing Charter Form and its fields */
  updateCharterForm: CharterForm;
  /**
   * Update enrollment status(deleted/withdrawn) of a list of enrollment ids on an assessment.
   *
   * This mutation is used by the Teacher to batch withdrawn/un-withdrawn students from the classlist
   * due to the fact that NRPS is not returning the right list of students on some LMS
   */
  updateEnrollmentsStatus: Array<Enrollment>;
  /** Update the cadmus experience survey score. */
  updateExperience: Survey;
  /** Update assessment's feedback release rules as a whole. */
  updateFeedbackReleaseRules: Array<FeedbackReleaseRule>;
  updateFeedbackVisibility: FeedbackVisibility;
  /** Update the marking rubric user for a single field. */
  updateFieldRubricResponse: UpdateFieldRubricPayload;
  /** Update a file origin name */
  updateFileOrigin: QuestionBankFileOrigin;
  /**
   * Update an existing group's memberships / marker assignments / name
   * @deprecated Use update_group_memberships / assign_marker_to_groups / update_group_name (to be created) instead
   */
  updateGroup: Group;
  /** Update the reason of the current user's own pending group change request. */
  updateGroupChangeRequest: Message;
  /**
   * Bulk update user memberships across multiple existing groups.
   *
   * Returns the new complete list of an Assessment's marking groups.
   */
  updateGroupMemberships: Array<Group>;
  /** Updates the existing Insights Mailing List for the given assessment. */
  updateInsightsMailingList: MailingList;
  /**
   * Update existing MarkerRubric.
   * @deprecated Use saveMarkerRubric instead.
   */
  updateMarkerRubric: MarkerRubric;
  /** Upsert the milestones of a charter */
  updateMilestones: Charter;
  updateModerationPenaltyRules: Array<ModerationPenaltyRule>;
  /** Set the assessments preferred as Smart Comment sources while grading assessmentId. */
  updatePreferredAssessmentSources: Array<Assessment>;
  /** Update all project issues for a Student Group to reflect the latest input state. */
  updateProjectIssue: Array<ProjectIssue>;
  updateQuestion: Question;
  /** Bulk edit attributes questions without creating a new version. */
  updateQuestionAttributes: Array<Question>;
  /** Update a question bank */
  updateQuestionBank: QuestionBank;
  /** Update (set or remove) category of a list of question banks */
  updateQuestionBanksCategory: Array<QuestionBank>;
  /**
   * Update automarking conditions for a question.
   *
   * This mutation updates automark settings at the question level, which are applied
   * to all field rubrics within the given question rubric.
   *
   * Changes trigger recalculation of student outcomes.
   */
  updateQuestionRubric: UpdateQuestionRubricPayload;
  /** Update a source file name */
  updateQuestionSourceFile: QuestionSourceFile;
  /** Update a question to save a new version */
  updateQuestionVersion: Question;
  /** Partial Requirements update. */
  updateRequirements: Requirements;
  /** Update an existing Link/Url Resource. */
  updateResource: Resource;
  /**
   * Record a lecturer's verdict on one generated question: dismiss it, so that
   * student is asked the base question instead, or replace its wording with the
   * lecturer's. Both are per-student and reversible, and neither can change a
   * question a student has already been asked.
   *
   * Returns the pool row the write landed on, carrying the same
   * `{poolId}:{studentId}` id the pool query returns for that student. A write to
   * a question a newer attempt has superseded lands on the superseded question and
   * the row comes back unchanged.
   */
  updateSocraticQuestion: UpdateSocraticQuestionPayload;
  /**
   * Record a lecturer's verdict on one student question: dismiss it, so the
   * student is asked the base question instead, or write the wording they are
   * asked. Both are reversible.
   *
   * Note that it doesn't change a question a student has already been asked.
   * But only affect the future socratic dialogues.
   */
  updateSocraticStudentQuestion: UpdateSocraticStudentQuestionPayload;
  /** Update the moderator modifier score on a student outcome. */
  updateStudentOutcomeScore: UpdateStudentOutcomeScorePayload;
  /** Batch update student settings. */
  updateStudentSettings: Array<Maybe<WorkSettings>>;
  /**
   * Set or clear a marker's modifier on a SubmissionOutcome.
   *
   * When `awarded_points` is given, derives the additive modifier from the
   * marker's target total, clamps it so the awarded total stays within
   * `[0, max_score]` (the modifier may be negative), and recomputes the
   * SubmissionOutcome score. When `awarded_points` is null, clears the modifier
   * and recomputes the score from the rubric alone.
   */
  updateSubmissionMarkerModifier: SubmissionMarkerModifierPayload;
  /** Update all tags for a question */
  updateTagsForQuestion: Question;
  /** Update TaskBlock attributes */
  updateTaskBlock: TaskBlock;
  /** Update TaskBlocks ordering/deleted flag. Returns the updated TaskBlock */
  updateTaskBlocks: Array<TaskBlock>;
  /**
   * Update Task Format.
   * @deprecated Use `change_assessment_preset` instead
   */
  updateTaskFormat: Task;
  /** Update thread resolution status. */
  updateThreadResolution: Thread;
  /** Update the moderator modifier score on a work outcome. */
  updateWorkOutcomeScore: UpdateWorkOutcomeScorePayload;
  /** Update a Work's settings. */
  updateWorkSettings: WorkSettings;
  /**
   * Verify a student-supplied access code for the assessment.
   *
   * Deprecated, use v2
   * @deprecated Use verifyAccessCodeV2
   */
  verifyAccessCode: Session;
  /** Verify a student-supplied access code for the assessment. */
  verifyAccessCodeV2: VerifyAccessCodePayload;
  /**
   * Withdraw feedback for the Students.
   *
   * Withdraws all `final` WorkOutcomeReleases for the Student and Student's
   * Group (if applicable). Removes grades from the Gradebook.Result for the
   * Students.
   */
  withdrawFeedback: Array<StudentOutcome>;
  /** Withdraw the current user's own pending group change request. */
  withdrawGroupChangeRequest: Message;
};


export type RootMutationTypeAcceptStudentCharterArgs = {
  input: CharterAgreementInput;
};


export type RootMutationTypeAddGroupTagArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type RootMutationTypeAddLibraryQuestionsToTaskArgs = {
  questionIds: Array<Scalars['ID']['input']>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddQuestionBanksToAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
  input: Array<AddQuestionBanksToAssessmentInput>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddQuestionSelectionToTaskArgs = {
  questionSelectionId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddTagArgs = {
  column: InputMaybe<Scalars['Int']['input']>;
  enrollmentId: Scalars['ID']['input'];
  tab: InputMaybe<ClassTab>;
  text: Scalars['String']['input'];
};


export type RootMutationTypeAppendGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SetupGroupInput;
  userIds: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootMutationTypeAppendTagsForQuestionsArgs = {
  input: Array<TagInput>;
  questionIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeArchiveQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeAssignMarkerToGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: InputMaybe<Array<Scalars['ID']['input']>>;
  markerId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeAssignMarkersToMembersArgs = {
  assessmentId: Scalars['ID']['input'];
  inputs: Array<MarkerForMembersInput>;
};


export type RootMutationTypeAutoAssignGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeBuildMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: BuildMarkerRubricInput;
};


export type RootMutationTypeBulkAddTagArgs = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tab: ClassTab;
  text: Scalars['String']['input'];
};


export type RootMutationTypeBulkRemoveTagArgs = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tab: ClassTab;
  text: Scalars['String']['input'];
};


export type RootMutationTypeCancelReleaseArgs = {
  assessmentId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type RootMutationTypeCaptureOnboardingInputArgs = {
  discipline: InputMaybe<Discipline>;
  subjectId: Scalars['ID']['input'];
  subjectRole: InputMaybe<SubjectRole>;
};


export type RootMutationTypeChangeAssessmentPresetArgs = {
  assessmentId: Scalars['ID']['input'];
  preset: AssessmentPreset;
};


export type RootMutationTypeClearMarkerAdjustmentArgs = {
  studentId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeCompletePeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCompleteSocraticTurnArgs = {
  input: CompleteSocraticTurnInput;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeCompleteSubmissionOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCopyAssessmentArgs = {
  destinationAssessmentId: Scalars['ID']['input'];
  destinationTaskId: InputMaybe<Scalars['ID']['input']>;
  sourceInstructionSheetId: Scalars['ID']['input'];
};


export type RootMutationTypeCopyAssessmentV2Args = {
  destinationAssessmentId: Scalars['ID']['input'];
  destinationTaskId: InputMaybe<Scalars['ID']['input']>;
  sourceInstructionSheetId: Scalars['ID']['input'];
};


export type RootMutationTypeCopyQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateBlockAttachmentArgs = {
  answerBlockId: Scalars['ID']['input'];
  mediaId: Scalars['ID']['input'];
  mediaUrl: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateCharterFormArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateCommentArgs = {
  content: Scalars['String']['input'];
  smartCommentId: InputMaybe<Scalars['ID']['input']>;
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateFileOriginArgs = {
  input: CreateQuestionBankFileOriginInput;
};


export type RootMutationTypeCreateGraderMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateGraderMarkerRubricInput;
};


export type RootMutationTypeCreateGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  group: GroupInput;
};


export type RootMutationTypeCreateGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groups: Array<GroupInput>;
};


export type RootMutationTypeCreateMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateMarkerRubricInput;
};


export type RootMutationTypeCreatePrintArchiveArgs = {
  input: PrintArchiveInput;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateQuestionArgs = {
  assessmentId: Scalars['ID']['input'];
  childrenQuestions: InputMaybe<Array<QuestionAttributes>>;
  input: QuestionAttributes;
  subjectId: Scalars['ID']['input'];
  tags: InputMaybe<Array<TagInput>>;
};


export type RootMutationTypeCreateQuestionBankArgs = {
  questionBank: CreateQuestionBankInput;
};


export type RootMutationTypeCreateQuestionBankCategoryArgs = {
  input: QuestionBankCategoryInput;
};


export type RootMutationTypeCreateQuestionMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateQuestionMarkerRubricInput;
};


export type RootMutationTypeCreateQuestionSelectionArgs = {
  input: QuestionSelectionInput;
};


export type RootMutationTypeCreateResourceArgs = {
  assessmentId: Scalars['ID']['input'];
  fileSize: InputMaybe<Scalars['Int']['input']>;
  mediaId: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  notes: InputMaybe<Scalars['String']['input']>;
  taskId: InputMaybe<Scalars['ID']['input']>;
  url: Scalars['String']['input'];
};


export type RootMutationTypeCreateSchoolyearDashboardUrlArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateSchoolyearSettingsUrlArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateSkillArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateSkillInput;
};


export type RootMutationTypeCreateSmartCommentArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateSmartCommentInput;
};


export type RootMutationTypeCreateSocraticDialogueArgs = {
  attemptNumber: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateSubmissionOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  markerScope: MarkerScopeInput;
  workOutcomeId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateTagArgs = {
  name: Scalars['String']['input'];
};


export type RootMutationTypeCreateTaskBlockArgs = {
  input: InputMaybe<CreateTaskBlockInput>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateTaskSaveArgs = {
  assessmentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  editor: InputMaybe<EditorType>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeCreateTaskSaveV2Args = {
  content: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateThreadArgs = {
  input: ThreadInput;
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeDecideGroupChangeRequestArgs = {
  assessmentId: Scalars['ID']['input'];
  decision: GroupChangeDecision;
  messageId: Scalars['ID']['input'];
  note: InputMaybe<Scalars['String']['input']>;
  targetGroupId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeDeleteGenaiGuidelineNoticeArgs = {
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  autoAssign?: InputMaybe<Scalars['Boolean']['input']>;
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupMemberArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  autoAssign?: InputMaybe<Scalars['Boolean']['input']>;
  groupIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeDeleteResourceArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteSmartCommentArgs = {
  assessmentId: Scalars['ID']['input'];
  smartCommentId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeDismissTeacherSatisfactionArgs = {
  assessmentId: Scalars['ID']['input'];
  moment: Moment;
};


export type RootMutationTypeDownloadPeerEvaluationDataArgs = {
  assessmentId: Scalars['ID']['input'];
  enrollmentId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadSavePdfArgs = {
  saveId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadSocraticTurnMediaArgs = {
  assessmentId: Scalars['ID']['input'];
  dialogueId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadSubmissionsArgs = {
  assessmentId: Scalars['ID']['input'];
  preferPdf: InputMaybe<Scalars['Boolean']['input']>;
  submissions: Array<SubmissionDetailInput>;
};


export type RootMutationTypeDownloadWorkArtifactsArgs = {
  assessmentId: Scalars['ID']['input'];
  workArtifacts: Array<WorkArtifactDetailInput>;
};


export type RootMutationTypeDownloadWorkAttachmentsArgs = {
  answerBlockId: Scalars['ID']['input'];
  blockAttachmentIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeDuplicateTaskBlockArgs = {
  taskBlockId: Scalars['ID']['input'];
};


export type RootMutationTypeEditCommentArgs = {
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};


export type RootMutationTypeEditTaskArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeEditTaskV2Args = {
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeEditThreadTitleArgs = {
  threadId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeExtendWorkSubmitAttemptLimitArgs = {
  assessmentId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeFinaliseAllGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeFinaliseGroupArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeFinaliseGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeFindSimilarQuestionsArgs = {
  input: FindSimilarQuestionsInput;
};


export type RootMutationTypeFlagAttentionArgs = {
  assessmentId: Scalars['ID']['input'];
  flagReason: InputMaybe<Scalars['String']['input']>;
  workOutcomeIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeForceSubmissionsArgs = {
  assessmentId: Scalars['ID']['input'];
  submittedAt: Scalars['DateTime']['input'];
  type: SubmissionType;
  workIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type RootMutationTypeForceSubmissionsV2Args = {
  assessmentId: Scalars['ID']['input'];
  submittedAt: Scalars['DateTime']['input'];
  type: SubmissionType;
  workIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type RootMutationTypeGenerateReportArgs = {
  anonymousName: InputMaybe<Scalars['String']['input']>;
  assessmentId: Scalars['ID']['input'];
  kind: Scalars['String']['input'];
  studentId: InputMaybe<Scalars['ID']['input']>;
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeGenerateSocraticQuestionsArgs = {
  input: SocraticQuestionerPoolInput;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeGenerateSocraticStudentQuestionsArgs = {
  input: SocraticQuestionerTaskBlockInput;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeGenerateWorkOutcomesCsvArgs = {
  assessmentId: Scalars['ID']['input'];
  byQuestions: InputMaybe<Scalars['Boolean']['input']>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeGrantGroupExtensionsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']>;
  input: GroupExtensionInput;
};


export type RootMutationTypeImportCanvasGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: ImportCanvasGroupsInput;
};


export type RootMutationTypeImportCanvasSectionsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: ImportCanvasSectionsInput;
};


export type RootMutationTypeImportLibraryQuestionArgs = {
  input: ImportLibraryQuestionInput;
};


export type RootMutationTypeImportMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: ImportMarkerRubricInput;
};


export type RootMutationTypeImportSectionsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: ImportSectionsInput;
};


export type RootMutationTypeImportSmartCommentsArgs = {
  assessmentId: Scalars['ID']['input'];
  comments: Array<ImportSmartCommentInput>;
};


export type RootMutationTypeInsertSyncRosterJobArgs = {
  assessmentId: Scalars['ID']['input'];
  extensionConflictAction?: InputMaybe<ExtensionConflictActionType>;
  withExtensions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeJoinGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeLeaveGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeLinkCommentThreadArgs = {
  assessmentId: Scalars['ID']['input'];
  criterionId: Scalars['Int']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeMarkFieldOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkFieldOutcomeInput;
};


export type RootMutationTypeMarkPeerOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkPeerOutcomeInput;
};


export type RootMutationTypeMarkSubmissionOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkSubmissionOutcomeInput;
};


export type RootMutationTypeModerateMainOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
  exceptions: InputMaybe<Array<ExceptionInput>>;
  feedbackModeration: InputMaybe<FeedbackModerationDecisionInput>;
  scoreModeration: InputMaybe<ScoreModerationDecisionInput>;
  workOutcomeIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeMoveGroupsToSectionArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']>;
  sectionId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeMoveStudentsToSectionArgs = {
  assessmentId: Scalars['ID']['input'];
  sectionId: InputMaybe<Scalars['ID']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypePublishCharterFormArgs = {
  charterFormId: Scalars['ID']['input'];
};


export type RootMutationTypePublishImportedQuestionsArgs = {
  input: PublishImportedQuestionsInput;
};


export type RootMutationTypePublishMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypePushSubmissionArgs = {
  assessmentId: Scalars['ID']['input'];
  resultId: Scalars['ID']['input'];
};


export type RootMutationTypeQueueSubmissionPipelineArgs = {
  assessmentId: Scalars['ID']['input'];
  payload: SubmissionPipelineInput;
};


export type RootMutationTypeRecalculateOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeRecordSocraticTurnPreparationMediaArgs = {
  input: RecordSocraticTurnPreparationMediaInput;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeRecordTeacherSatisfactionArgs = {
  assessmentId: Scalars['ID']['input'];
  moment: Moment;
  score: Scalars['Int']['input'];
};


export type RootMutationTypeRegenerateQuestionSetArgs = {
  input: RegenerateQuestionSetInput;
};


export type RootMutationTypeRegisterQuestionSourceFileArgs = {
  input: RegisterQuestionSourceFileInput;
};


export type RootMutationTypeReleaseAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
  scheduleTimestamp: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootMutationTypeReleaseFeedbackForEveryoneArgs = {
  assessmentId: Scalars['ID']['input'];
  feedbackVisibility: InputMaybe<FeedbackVisibilityInput>;
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeReleaseTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<Scalars['ReleaseType']['input']>;
  saveId: Scalars['ID']['input'];
  scheduleTimestamp: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootMutationTypeRemoveBlockAttachmentArgs = {
  blockAttachmentId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveGroupTagArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type RootMutationTypeRemoveMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveMarkerRubricOutcomesArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveQuestionBankCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveQuestionsUniformlyArgs = {
  input: RemoveQuestionsUniformlyInput;
};


export type RootMutationTypeRemoveTagArgs = {
  column: InputMaybe<Scalars['Int']['input']>;
  enrollmentId: Scalars['ID']['input'];
  tab: InputMaybe<ClassTab>;
  text: Scalars['String']['input'];
};


export type RootMutationTypeReplaceQuestionInSetArgs = {
  input: ReplaceQuestionInSetInput;
};


export type RootMutationTypeResetCriterionOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetExamWritingTimeArgs = {
  assessmentId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeResetGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeResetModerationDecisionsArgs = {
  assessmentId: Scalars['ID']['input'];
  workOutcomeIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeResetModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetQuestionModerationChangesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetRubricOutcomeArgs = {
  criteriaId: InputMaybe<Scalars['ID']['input']>;
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeResetRubricOutcomeForFieldArgs = {
  assessmentId: Scalars['ID']['input'];
  fieldOutcomeId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeResetRubricOutcomeForSubmissionArgs = {
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  submissionOutcomeId: Scalars['ID']['input'];
};


export type RootMutationTypeResetScoreModerationChangesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResolveMessagesArgs = {
  assessmentId: Scalars['ID']['input'];
  messageIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeRestoreMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveArgs = {
  content: Scalars['String']['input'];
  dispatchedAt: Scalars['DateTime']['input'];
  editor: InputMaybe<EditorType>;
  metadata: InputMaybe<SaveMetadataInput>;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveBlockSnapshotArgs = {
  answerBlockId: Scalars['ID']['input'];
  previousBlockSnapshotId: InputMaybe<Scalars['ID']['input']>;
  snapshotContent: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  wordCountChange: InputMaybe<Scalars['String']['input']>;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveCharterEditorArgs = {
  input: CharterEditorInput;
};


export type RootMutationTypeSaveGenaiGuidelineNoticeArgs = {
  content: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type RootMutationTypeSaveGlobalUserSettingsArgs = {
  userSettingsInput: GlobalUserSettingsInput;
};


export type RootMutationTypeSaveMarkerRubricArgs = {
  input: MarkerRubricInput;
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveQuestionStateArgs = {
  input: SaveQuestionStateInput;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveSocraticFeedbackEventArgs = {
  input: SocraticFeedbackEventInput;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveSocraticQuestionerFeedbackArgs = {
  input: SocraticQuestionerFeedbackInput;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeSendEmailsToClassArgs = {
  assessmentId: Scalars['ID']['input'];
  submissionIds: Array<InputMaybe<Scalars['ID']['input']>>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeSendMessageArgs = {
  assessmentId: Scalars['ID']['input'];
  message: MessageInput;
};


export type RootMutationTypeSetAssessmentEmailConsentArgs = {
  assessmentId: Scalars['ID']['input'];
  consent: Scalars['Boolean']['input'];
};


export type RootMutationTypeSetMarkerAdjustmentArgs = {
  note: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['ID']['input'];
  value: Scalars['Decimal']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSetupAccessCodeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: AccessCodeInput;
};


export type RootMutationTypeSetupCharterArgs = {
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeSetupGroupWorkArgs = {
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeSetupGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SetupGroupInput;
  settingsInput: InputMaybe<GroupSettingsInput>;
};


export type RootMutationTypeSetupTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: TaskKind;
};


export type RootMutationTypeSetupWorkArgs = {
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeSnapshotFieldOutcomeArgs = {
  fieldOutcomeId: Scalars['ID']['input'];
  input: SnapshotFieldOutcomeInput;
};


export type RootMutationTypeSnapshotSubmissionOutcomeArgs = {
  input: SnapshotSubmissionOutcomeInput;
  submissionOutcomeId: Scalars['ID']['input'];
};


export type RootMutationTypeStartArgs = {
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeStartSocraticDialogueArgs = {
  dialogueId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeStartSocraticTurnArgs = {
  recordingStartedAt: InputMaybe<Scalars['PreciseDateTime']['input']>;
  turnId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitArgs = {
  acceptedDeclaration: Scalars['Boolean']['input'];
  editor: InputMaybe<EditorType>;
  saveId: Scalars['ID']['input'];
  sessionId: InputMaybe<Scalars['String']['input']>;
  submissionTrigger: InputMaybe<SubmissionTrigger>;
  submittedAt: InputMaybe<Scalars['DateTime']['input']>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitAttemptArgs = {
  attemptNumber: Scalars['Int']['input'];
  submissionDate: InputMaybe<Scalars['DateTime']['input']>;
  submissionTrigger: InputMaybe<SubmissionTrigger>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitAttemptV2Args = {
  attemptNumber: Scalars['Int']['input'];
  submissionDate: InputMaybe<Scalars['DateTime']['input']>;
  submissionTrigger: InputMaybe<SubmissionTrigger>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitSentimentCheckArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SentimentCheckInput;
};


export type RootMutationTypeSubmitV2Args = {
  blockSnapshotIds: Array<Scalars['ID']['input']>;
  forceSubmitted: InputMaybe<Scalars['Boolean']['input']>;
  submissionTrigger: InputMaybe<SubmissionTrigger>;
  submittedAt: InputMaybe<Scalars['DateTime']['input']>;
  submittedBy: InputMaybe<Scalars['String']['input']>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSwapResourceArgs = {
  firstId: Scalars['ID']['input'];
  secondId: Scalars['ID']['input'];
};


export type RootMutationTypeSyncGradesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeSyncRosterArgs = {
  assessmentId: Scalars['ID']['input'];
  extensionConflictAction?: InputMaybe<ExtensionConflictActionType>;
  withExtensions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeUnassignMarkersArgs = {
  assessmentId: Scalars['ID']['input'];
  groupMarkerIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeUnlinkCommentThreadArgs = {
  assessmentId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeUnlinkLibraryQuestionArgs = {
  input: UnlinkLibraryQuestionInput;
};


export type RootMutationTypeUnlockStudentCharterArgs = {
  input: CharterAgreementInput;
};


export type RootMutationTypeUnsubmitArgs = {
  submissionId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateAnswerBlockArgs = {
  answerBlockId: Scalars['ID']['input'];
  input: UpdateAnswerBlockInput;
};


export type RootMutationTypeUpdateAssessmentNameArgs = {
  assessmentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type RootMutationTypeUpdateAssessmentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: AssessmentSettingsInput;
};


export type RootMutationTypeUpdateCharterFormArgs = {
  input: CharterFormInput;
};


export type RootMutationTypeUpdateEnrollmentsStatusArgs = {
  assessmentId: Scalars['ID']['input'];
  enrollmentIds: Array<Scalars['ID']['input']>;
  withdrawn: Scalars['Boolean']['input'];
};


export type RootMutationTypeUpdateExperienceArgs = {
  score: Scalars['Int']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<FeedbackReleaseType>;
  rules: Array<FeedbackReleaseRuleInput>;
};


export type RootMutationTypeUpdateFeedbackVisibilityArgs = {
  assessmentId: Scalars['ID']['input'];
  input: FeedbackVisibilityInput;
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeUpdateFieldRubricResponseArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateFieldRubricInput;
};


export type RootMutationTypeUpdateFileOriginArgs = {
  input: UpdateQuestionBankFileOriginInput;
};


export type RootMutationTypeUpdateGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  group: GroupUpdateInput;
};


export type RootMutationTypeUpdateGroupChangeRequestArgs = {
  assessmentId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type RootMutationTypeUpdateGroupMembershipsArgs = {
  assessmentId: Scalars['ID']['input'];
  memberships: Array<GroupMembershipInput>;
};


export type RootMutationTypeUpdateInsightsMailingListArgs = {
  assessmentId: Scalars['ID']['input'];
  members: Array<Scalars['String']['input']>;
  subscribed: Scalars['Boolean']['input'];
};


export type RootMutationTypeUpdateMarkerRubricArgs = {
  input: MarkerRubricInput;
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateMilestonesArgs = {
  input: UpdateMilestonesInput;
};


export type RootMutationTypeUpdateModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  rules: Array<ModerationPenaltyRuleInput>;
};


export type RootMutationTypeUpdatePreferredAssessmentSourcesArgs = {
  assessmentId: Scalars['ID']['input'];
  sourceAssessmentIds: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootMutationTypeUpdateProjectIssueArgs = {
  input: UpdateProjectIssueInput;
};


export type RootMutationTypeUpdateQuestionArgs = {
  input: QuestionAttributesInput;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateQuestionAttributesArgs = {
  input: QuestionAttributesInput;
  questionIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeUpdateQuestionBankArgs = {
  questionBank: UpdateQuestionBankInput;
};


export type RootMutationTypeUpdateQuestionBanksCategoryArgs = {
  input: UpdateQuestionBanksCategoryInput;
};


export type RootMutationTypeUpdateQuestionRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateQuestionRubricInput;
};


export type RootMutationTypeUpdateQuestionSourceFileArgs = {
  input: UpdateQuestionSourceFileInput;
};


export type RootMutationTypeUpdateQuestionVersionArgs = {
  childrenQuestions: InputMaybe<Array<UpdateQuestionVersionInput>>;
  input: UpdateQuestionVersionInput;
};


export type RootMutationTypeUpdateRequirementsArgs = {
  assessmentId: Scalars['ID']['input'];
  requirements: RequirementsInput;
};


export type RootMutationTypeUpdateResourceArgs = {
  id: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  notes: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateSocraticQuestionArgs = {
  input: UpdateSocraticQuestionInput;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateSocraticStudentQuestionArgs = {
  input: UpdateSocraticStudentQuestionInput;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateStudentOutcomeScoreArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateStudentOutcomeScoreInput;
  studentId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateStudentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  settings: Array<InputMaybe<StudentSettingsInput>>;
};


export type RootMutationTypeUpdateSubmissionMarkerModifierArgs = {
  assessmentId: Scalars['ID']['input'];
  awardedPoints: InputMaybe<Scalars['Float']['input']>;
  submissionOutcomeId: Scalars['Int']['input'];
};


export type RootMutationTypeUpdateTagsForQuestionArgs = {
  input: Array<TagInput>;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateTaskBlockArgs = {
  input: UpdateTaskBlockInput;
  taskBlockId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateTaskBlocksArgs = {
  taskBlockList: Array<UpdateTaskBlocksInput>;
};


export type RootMutationTypeUpdateTaskFormatArgs = {
  format: TaskFormat;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateThreadResolutionArgs = {
  resolved: Scalars['Boolean']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateWorkOutcomeScoreArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateWorkOutcomeScoreInput;
};


export type RootMutationTypeUpdateWorkSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  draftExamEndDate: InputMaybe<Scalars['String']['input']>;
  draftExamStartDate: InputMaybe<Scalars['String']['input']>;
  dueDate: InputMaybe<Scalars['DateTime']['input']>;
  enrollmentId: Scalars['ID']['input'];
  examDeferred: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate: InputMaybe<Scalars['DateTime']['input']>;
  examReadingTime: InputMaybe<Scalars['Int']['input']>;
  examStartDate: InputMaybe<Scalars['DateTime']['input']>;
  examWritingTime: InputMaybe<Scalars['Int']['input']>;
  submitAttemptLimit: InputMaybe<Scalars['Int']['input']>;
  taskKind?: InputMaybe<TaskKind>;
  timeLimit: InputMaybe<Scalars['Int']['input']>;
  updateReason: InputMaybe<Scalars['String']['input']>;
  vivaExtraAttempts: InputMaybe<Scalars['Int']['input']>;
  vivaExtraPrepSeconds: InputMaybe<Scalars['Int']['input']>;
  vivaExtraResponseSeconds: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTypeVerifyAccessCodeArgs = {
  assessmentId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};


export type RootMutationTypeVerifyAccessCodeV2Args = {
  assessmentId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};


export type RootMutationTypeWithdrawFeedbackArgs = {
  assessmentId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeWithdrawGroupChangeRequestArgs = {
  assessmentId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Token to use for making API calls to all Cadmus services */
  apiToken: Scalars['String']['output'];
  /** A single assessment. */
  assessment: Assessment;
  /** Returns all active AccessCodes in an Assessment. */
  assessmentAccessCodes: Maybe<Array<AccessCode>>;
  /** All Student Group Charter documents in the Assessment. */
  assessmentCharters: Array<Charter>;
  /** Current student's email-sharing consent state in the Assessment. */
  assessmentEmailConsent: AssessmentEmailConsent;
  /** List of all published marker rubrics for an Assessment. */
  assessmentMarkerRubrics: Array<MarkerRubric>;
  assessmentProgress: AssessmentProgressResponse;
  assessmentProjectIssues: Array<ProjectIssue>;
  /** Per-question scores for every WorkOutcome in an Assessment. */
  assessmentQuestionScores: Array<WorkOutcomeQuestionScores>;
  /** List all Sentiment Checks submitted by students in an Assessment. */
  assessmentSentimentChecks: Array<SentimentCheck>;
  /** Lookup existing background job. */
  backgroundJob: Maybe<BackgroundJob>;
  /** Access the Brightspace REST API as the current user via OAuth2 interface. */
  brightspaceApi: BrightspaceApi;
  /** Access the Canvas REST API as the current user via OAuth2 interface. */
  canvasApi: CanvasApi;
  /** Student group charter document */
  charter: Charter;
  /** Assessment's Group Charter form (draft or published) */
  charterForm: Maybe<CharterForm>;
  /** Complete Class information for an Assessment's cohort. */
  class: Class;
  /**
   * A full Class list for the given Assessment.
   * @deprecated Use `class` query field instead
   */
  classList: ClassList;
  /** All Peer Outcomes in a Class, for teacher eyes only. */
  classPeerOutcomes: Array<PeerOutcome>;
  /** All Work Groups in a Group Assessment. */
  classWorkGroups: Array<WorkGroup>;
  /**
   * Authorship overlay for an answer block (`answer_block_id` is the stream id):
   * which author wrote each surviving range, plus deleted text/media on request.
   *
   * `from`/`to` (1-based PM positions, `to` exclusive) window the result to a
   * viewport — only the ranges and deletions overlapping it are returned, and the
   * rest of the document is never materialised. Give both or neither.
   * `include_deletions` adds the (larger) deletions list; off by default.
   * `as_of_version` time-travels for the timeline scrubber; omit for the latest.
   */
  contribution: Contribution;
  /**
   * Contribution overlays at several versions in one progressive fold — the batch
   * counterpart to `contribution(as_of_version:)`. Steps are folded once across
   * all versions rather than re-folded per version. Results are ascending by
   * version and deduplicated (re-key by `as_of_version`), not in input order.
   *
   * A lecturer sees every member of the group, or every author unscoped on
   * individual work. Anyone else sees only the spans they authored themselves.
   * Deletions are never folded here, so the overlay is surviving text only.
   * `versions` is capped at 200 entries server-side.
   */
  contributionsAt: Array<Contribution>;
  /** Reusing Scale Items by Skill */
  criteriaBySkill: Array<ReuseCriterion>;
  /** Recover a deleted extended answer block for a question. */
  deletedAnswerBlock: Maybe<AnswerBlock>;
  /**
   * The version-0 base document for an answer block. The client replays
   * `document_steps` over `base_doc` to reconstruct any version locally without
   * per-version snapshots or S3 reads.
   */
  documentBase: DocumentBase;
  /**
   * ProseMirror steps in the inclusive `from_version..to_version` range, ascending.
   * A buffered scrubber fetches the window it needs and applies the steps over
   * `document_base` to render frames.
   */
  documentSteps: Array<DocumentStep>;
  /**
   * Seek window for the timeline scrubber. Returns the nearest snapshot at or
   * before `target_version` (as `base_version`) plus steps
   * `base_version+1 .. target_version+buffer`, so the client seeds the snapshot,
   * applies the few steps to land on the target, and keeps the buffer to scrub
   * forward without a refetch.
   *
   * Pass `have_snapshot_version` with the snapshot the client already holds:
   * when it matches `base_version`, `document` is null and only steps ship.
   * `base_version` is 0 when no snapshot precedes the target. `buffer` must be
   * between 0 and 20000; the ceiling is enforced server-side.
   */
  documentWindow: DocumentWindow;
  /**
   * The feature flags currently enabled for the requesting user,
   * institution, and (optionally) assessment. Only flags evaluated to
   * `true` are returned; the full flag registry is intentionally not
   * exposed.
   *
   * Pass `assessmentId` from any UI that knows which assessment it is
   * showing — flags scoped to a specific assessment (or to a group that
   * includes the assessment's institution) can then evaluate correctly.
   */
  enabledFlags: Array<FeatureFlag>;
  /** Fetch threads by entity ID and type. */
  entityThreads: Array<Thread>;
  /** MarkerRubric lookup by ID and document status. */
  extendedRubric: Maybe<MarkerRubric>;
  /** Feature flags enabled in the user's context. */
  featureFlags: InstitutionFeatures;
  /** Feedback Release Rule: schedule feedback release based on filters. */
  feedbackReleaseRules: Array<FeedbackReleaseRule>;
  /**
   * feedback visibility for assessment
   * @deprecated Use `feedback_visibility_for_type` instead
   */
  feedbackVisibility: FeedbackVisibility;
  /** feedback visibility for assessment */
  feedbackVisibilityForType: FeedbackVisibility;
  /**
   * Future scheduled Instruction sheet, if any
   * @deprecated Use tasks.futureSheet instead
   */
  futureSheet: Maybe<Sheet>;
  /** List group change requests in the Assessment: pending and expired, undecided, oldest first. */
  groupChangeRequests: Array<Message>;
  groupList: Array<Group>;
  /** Peer Outcomes for members of a Student Group. */
  groupPeerOutcomes: Array<PeerOutcome>;
  /** List Sentiment Checks submitted by students in a group. */
  groupSentimentChecks: Array<SentimentCheck>;
  /** Work Outcome for a Student Group in an assessment. */
  groupWorkOutcome: Maybe<WorkOutcome>;
  /**
   * Groups for assessment.
   * @deprecated Use `class` query field instead
   */
  groups: Array<Group>;
  /**
   * Assessment's latest Insights mailing list consisting of teacher emails who
   * want to receive Insight updates via email.
   */
  insightsMailingList: MailingList;
  /** Current user Institution. */
  institution: Institution;
  /**
   * InstructionSheet within an Assessment defaulting to the latest.
   * @deprecated Use tasks.instructionSheet instead
   */
  instructionSheet: Maybe<Sheet>;
  /**
   * Recorded state history for every issue on a Group's board, oldest first.
   * Includes states of soft-deleted issues; history outlives the task.
   */
  issueStates: Array<ProjectIssueState>;
  /**
   * Latest Gradebook result for a particular submission type.
   *
   * This field always tries to resolve to the most up to date information, and
   * can also query Hera (and in turn Turnitin) to get it.
   */
  latestResult: Result;
  /** List of lecturers for an assessment */
  lecturers: Array<User>;
  /** Lists all library questions viewable by the current user. */
  libraryQuestions: Array<Question>;
  /** Distinct students and groups with marking on the given Criteria. */
  markedCounts: MarkedCounts;
  /** MarkerRubric lookup in an Assessment for a given kind and document status. */
  markerRubric: Maybe<MarkerRubric>;
  /** Lookup marker rubric by ID for lecturers. */
  markerRubricById: MarkerRubric;
  /** Current logged in User profile */
  me: User;
  /** List messages receivable by current user. */
  messageInbox: Array<Message>;
  /** Moderation Penalty Rule: penalties to apply on feedback release. */
  moderationPenaltyRules: Maybe<Array<ModerationPenaltyRule>>;
  /**
   * Question read-model for Moderation in Cadmus Marker for particular Task in an Assessment.
   * If task kind is not provided, defaults to `:individual`.
   */
  moderationQuestions: Array<ModerationQuestion>;
  /** Past instruction sheets that the user has been involved in. */
  pastInstructionSheets: Array<PastInstructionSheet>;
  /** Past Marker Rubric by ID, as its latest valid version. */
  pastMarkerRubric: MarkerRubric;
  /** List all MarkerRubrics accessibly to the current lecturer. */
  pastMarkerRubrics: Array<MarkerRubric>;
  /** Peer Rubric for Students */
  peerRubric: Maybe<MarkerRubric>;
  /** The assessments the current user has preferred as Smart Comment sources while grading assessmentId. */
  preferredAssessmentSources: Array<Assessment>;
  /** URL for a expected PrintInstruction archive, if it is ready. */
  printArchiveUrl: Maybe<Scalars['String']['output']>;
  /** List of issues in a student Group's project board. */
  projectIssues: Array<ProjectIssue>;
  /** Single library published question */
  question: Maybe<Question>;
  questionBankCategories: Array<QuestionBankCategory>;
  questionBanks: Array<QuestionBank>;
  /** Single question rubric. */
  questionRubric: QuestionRubric;
  questionSelection: Maybe<QuestionSelection>;
  /** All Tag categories in the Question Library for the current Tenant */
  questionTagCategories: Array<QuestionTagCategory>;
  /** List of all selected question blocks in the Task. */
  questionTree: Array<QuestionBlock>;
  /** Select a known past Question version */
  questionVersion: Maybe<QuestionVersion>;
  /**
   * Re-entry metadata for the student's current exam session. Returns whether a
   * re-entry code is required and how many re-entry events have occurred, so
   * aphrodite can render the correct access code modal variant and attempt number.
   */
  reentryStatus: ReentryStatus;
  /** Assessment's marking rubrics. */
  rubric: Maybe<Rubric>;
  /**
   * Search assessments by assessment or subject name.
   * Scoped to assessments the current user lectures.
   */
  searchAssessments: Array<AssessmentOption>;
  /** List an assessment's group-formation sections, ordered by position. */
  sections: Array<Section>;
  /** @deprecated Please use :api_token instead, which is more scoped */
  serviceToken: Scalars['String']['output'];
  /** User's session information. */
  session: Session;
  /**
   * Current Session ID tied to the user's authenticated session.
   * @deprecated Please use the `session` field instead.
   */
  sessionId: Scalars['String']['output'];
  /** Learning Outcome Skills for the Tenant. */
  skills: Array<LearningOutcomeSkill>;
  /** Learning Outcome Skills used in the Assessment. */
  skillsByAssessment: Array<LearningOutcomeSkill>;
  smartCommentsBySkills: Array<SmartComment>;
  /**
   * Document and contribution overlay at one point on the timeline, folded to
   * `version` and scoped to the group's active members.
   */
  snapshot: Snapshot;
  /**
   * Timeline ticks for an answer block, oldest first — one per adaptive time
   * bucket (per-save would flood the scrubber). The bucket scales with the
   * snapshot count, from every snapshot down to one per day. A streamless
   * answer block (no collaborative session) keeps every snapshot instead, up
   * to 5,000, past which it falls back to the same bucketing. Pair each
   * `version` with `snapshot` to load the document and contribution there.
   *
   * `max_snapshot_id` caps the timeline at that snapshot's version, so a draft
   * scrubber ends on the draft.
   */
  snapshotTicks: Array<SnapshotTick>;
  /**
   * Batched `snapshot` for buffering the scrubber. Versions with no snapshot
   * or a failed doc fetch are omitted; the caller keeps whatever loaded.
   * `versions` is capped at 200 entries server-side.
   */
  snapshots: Array<Snapshot>;
  /** Fetch a specific Socratic Dialogue by ID. */
  socraticDialogue: Maybe<SocraticDialogue>;
  /** Fetch multiple Socratic Dialogues by IDs. Restricted to lecturers. */
  socraticDialogues: Array<SocraticDialogue>;
  /**
   * Fetch the pool of generated questions for a viva task block, projected
   * against the class roster.
   *
   * Null when the arguments name no pool against real data: the task is not a
   * viva, its assessment names no source task, or the block's question resolves
   * to empty text.
   */
  socraticQuestionerPool: Maybe<SocraticQuestionerPool>;
  /**
   * Fetch what every student on the source assessment's roster will be asked for
   * one question on one task block.
   *
   * Null when the arguments name nothing against real data: the task is not a
   * viva, its assessment names no source task, or the block's question resolves
   * to empty text.
   */
  socraticQuestionerTaskBlock: Maybe<SocraticQuestionerTaskBlock>;
  /** Fetch a Socratic Session for a student and answer block, creating it if it does not exist. */
  socraticSession: SocraticSession;
  /** Fetch the transcription outcome for a Socratic Dialogue's turn. */
  socraticTranscript: Maybe<SocraticTranscription>;
  /**
   * The current student's "Your actions" card for a group assessment.
   * Returns `null` when the card does not apply or the assessment has not opened
   * for the student: not a group assessment, no due date set, or an open date
   * still in the future (`Facts.load/4`'s `{:no_stage, _}`). Once open it
   * resolves to a stage; unlike the lecturer digest, the post-due marking gap is
   * a stage rather than a null feed.
   */
  studentActionFeed: Maybe<StudentActionFeed>;
  studentEnrollments: Array<Enrollment>;
  /** Student Outcome in an Assessment */
  studentOutcome: StudentOutcome;
  /** Student Outcomes in an Assessment */
  studentOutcomes: Array<StudentOutcome>;
  /**
   * Completion status for the current student's peer evaluation in this
   * assessment. Returns `null` when no peer rubric is published, or when
   * the student is not in a group for the assessment.
   */
  studentPeerEvalProgress: Maybe<StudentPeerEvalProgress>;
  /** The current student's Peer Outcome in the Assessment. */
  studentPeerOutcome: Maybe<PeerOutcome>;
  /** List all sentiment check intervals for the current student in an assessment. */
  studentSentimentChecks: Array<SentimentCheckInterval>;
  /** Current student users' Work Group in the Assessment. */
  studentWorkGroup: Maybe<WorkGroup>;
  /** Work Outcome for a Student in an assessment. */
  studentWorkOutcome: Maybe<WorkOutcome>;
  /**
   * A subject and its assessments for the teacher subject page.
   *
   * Feature-flagged (`subject_assessments_page`) and scoped to a teacher enrolled
   * in the subject — see `VerifySubjectEnrollment`. Returns every assessment in
   * the subject, each flagged accessible or locked for the requesting teacher.
   */
  subject: Maybe<Subject>;
  /** A single assessment task of a specific kind. */
  task: Maybe<Task>;
  /** Fetch a thread by ID. */
  thread: Thread;
  /** Fetch multiple threads by IDs. */
  threads: Array<Thread>;
  /** Token for Current User token authentication with Phoenix channels. */
  token: Scalars['String']['output'];
  /** Lookup complete user settings for an asseessment */
  userSettings: Maybe<UserSettings>;
  /** A single Work. */
  work: Work;
  /** Outcome recorded for a student's work. */
  workOutcome: Maybe<WorkOutcome>;
  /** Work Outcomes in an Assessment that the user can access. */
  workOutcomes: Array<WorkOutcome>;
  /**
   * Version history across a work's answer blocks (for example body and
   * references), newest first, every saved snapshot, unlike `snapshotTicks`'s
   * sampled marks. Feeds the version-history sidebar.
   *
   * `answerBlockIds` names every block the sidebar should merge into one
   * list, ordered by save time rather than `version`. Separate blocks number
   * versions independently, so each node names its own `answerBlockId`.
   * `after` is an opaque cursor: pass the previous page's `pageInfo.endCursor`
   * to continue. `first` defaults to 50, must be positive,
   * and is hard-capped server-side (see `WorkTimeline.versions/3`) regardless
   * of what is requested.
   */
  workVersions: WorkVersionConnection;
};


export type RootQueryTypeApiTokenArgs = {
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentAccessCodesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentChartersArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentEmailConsentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentMarkerRubricsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentProgressArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentProjectIssuesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentQuestionScoresArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentSentimentChecksArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeBackgroundJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type RootQueryTypeBrightspaceApiArgs = {
  assessmentId: Scalars['ID']['input'];
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
};


export type RootQueryTypeCanvasApiArgs = {
  assessmentId: Scalars['ID']['input'];
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
};


export type RootQueryTypeCharterArgs = {
  charterId: Scalars['ID']['input'];
};


export type RootQueryTypeCharterFormArgs = {
  assessmentId: Scalars['ID']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeClassArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassPeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassWorkGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeContributionArgs = {
  answerBlockId: Scalars['ID']['input'];
  asOfVersion: InputMaybe<Scalars['Int']['input']>;
  assessmentId: Scalars['ID']['input'];
  from: InputMaybe<Scalars['Int']['input']>;
  includeDeletions?: InputMaybe<Scalars['Boolean']['input']>;
  to: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeContributionsAtArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  versions: Array<Scalars['Int']['input']>;
};


export type RootQueryTypeCriteriaBySkillArgs = {
  assessmentId: Scalars['ID']['input'];
  skillId: Scalars['ID']['input'];
};


export type RootQueryTypeDeletedAnswerBlockArgs = {
  answerBlockId: Scalars['ID']['input'];
};


export type RootQueryTypeDocumentBaseArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeDocumentStepsArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  fromVersion: Scalars['Int']['input'];
  toVersion: Scalars['Int']['input'];
};


export type RootQueryTypeDocumentWindowArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  buffer?: InputMaybe<Scalars['Int']['input']>;
  haveSnapshotVersion: InputMaybe<Scalars['Int']['input']>;
  targetVersion: Scalars['Int']['input'];
};


export type RootQueryTypeEnabledFlagsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeEntityThreadsArgs = {
  entityId: InputMaybe<Scalars['ID']['input']>;
  entityIds: InputMaybe<Array<Scalars['ID']['input']>>;
  entityType: EntityType;
};


export type RootQueryTypeExtendedRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  status: MarkerRubricStatus;
};


export type RootQueryTypeFeatureFlagsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeFeedbackVisibilityArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeFeedbackVisibilityForTypeArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: FeedbackReleaseType;
};


export type RootQueryTypeFutureSheetArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
};


export type RootQueryTypeGroupChangeRequestsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeGroupListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeGroupPeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeGroupSentimentChecksArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootQueryTypeGroupWorkOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  studentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeInsightsMailingListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeInstructionSheetArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
  sheetId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeIssueStatesArgs = {
  groupId: Scalars['ID']['input'];
  issueId: InputMaybe<Scalars['ID']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  since: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeLatestResultArgs = {
  submissionType: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeLecturersArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeMarkedCountsArgs = {
  assessmentId: Scalars['ID']['input'];
  criteriaIds: Array<Scalars['ID']['input']>;
};


export type RootQueryTypeMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: MarkerRubricKind;
  status: MarkerRubricStatus;
};


export type RootQueryTypeMarkerRubricByIdArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootQueryTypeMessageInboxArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeModerationQuestionsArgs = {
  assessmentId: Scalars['ID']['input'];
  taskKind: InputMaybe<TaskKind>;
};


export type RootQueryTypePastInstructionSheetsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypePastMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootQueryTypePastMarkerRubricsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePeerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePreferredAssessmentSourcesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePrintArchiveUrlArgs = {
  archiveId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootQueryTypeProjectIssuesArgs = {
  groupId: Scalars['ID']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionBankCategoriesArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId: InputMaybe<Scalars['ID']['input']>;
  subjectId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeQuestionBanksArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId: InputMaybe<Scalars['ID']['input']>;
  subjectId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeQuestionRubricArgs = {
  questionRubricId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionSelectionArgs = {
  questionSelectionId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionTreeArgs = {
  selectionInput: Array<QuestionSelectionFilterInput>;
  taskId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionVersionArgs = {
  questionId: InputMaybe<Scalars['ID']['input']>;
  version: InputMaybe<Scalars['Int']['input']>;
  versionId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeReentryStatusArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeRubricArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeSearchAssessmentsArgs = {
  search: Scalars['String']['input'];
};


export type RootQueryTypeSectionsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeSkillsByAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeSmartCommentsBySkillsArgs = {
  assessmentIds: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  maxScore: InputMaybe<Scalars['Int']['input']>;
  rangeFrom: InputMaybe<Scalars['Int']['input']>;
  rangeTo: InputMaybe<Scalars['Int']['input']>;
  skillIds: Array<Scalars['ID']['input']>;
};


export type RootQueryTypeSnapshotArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type RootQueryTypeSnapshotTicksArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  maxSnapshotId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeSnapshotsArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  versions: Array<Scalars['Int']['input']>;
};


export type RootQueryTypeSocraticDialogueArgs = {
  assessmentId: Scalars['ID']['input'];
  dialogueId: Scalars['ID']['input'];
};


export type RootQueryTypeSocraticDialoguesArgs = {
  assessmentId: Scalars['ID']['input'];
  dialogueIds: Array<Scalars['ID']['input']>;
};


export type RootQueryTypeSocraticQuestionerPoolArgs = {
  input: SocraticQuestionerPoolInput;
  taskId: Scalars['ID']['input'];
};


export type RootQueryTypeSocraticQuestionerTaskBlockArgs = {
  input: SocraticQuestionerTaskBlockInput;
  taskId: Scalars['ID']['input'];
};


export type RootQueryTypeSocraticSessionArgs = {
  answerBlockId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeSocraticTranscriptArgs = {
  assessmentId: Scalars['ID']['input'];
  dialogueId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentActionFeedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentEnrollmentsArgs = {
  assessmentId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
  withDeleted: Scalars['Boolean']['input'];
};


export type RootQueryTypeStudentOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentPeerEvalProgressArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentPeerOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentSentimentChecksArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentWorkGroupArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentWorkOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  studentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeSubjectArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootQueryTypeThreadsArgs = {
  threadIds: Array<Scalars['ID']['input']>;
};


export type RootQueryTypeUserSettingsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeWorkArgs = {
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeWorkOutcomeArgs = {
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeWorkOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeWorkVersionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  answerBlockIds: Array<Scalars['ID']['input']>;
  assessmentId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** Deprecated: use assessmentSettingsUpdated instead. Subscribe to updates for AssessmentSettings */
  assessmentSettings: AssessmentSettings;
  /** Subscribe to updates for AssessmentSettings. Prefer this over the deprecated assessmentSettings subscription. */
  assessmentSettingsUpdated: AssessmentSettings;
  /** Notification on number of enrollments updated */
  enrollmentsUpdated: Scalars['Int']['output'];
  /** Subscribe to thread updates for a specific entity (e.g., answer block). Receives lightweight thread lifecycle events. */
  entityThreadsUpdated: EntityThreadEvent;
  /** Subscription for field outcome batch updates. */
  fieldOutcomesUpdated: Maybe<Array<Maybe<FieldOutcome>>>;
  /** Subscription for field_rubric updates. */
  fieldRubricsUpdated: Array<FieldRubric>;
  /** Future sheet release schedule timestamp */
  futureReleaseSchedule: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Subscription for when a group is updated by self enrollment. */
  groupUpdated: Group;
  /** At least one submission has been made in the Assessment. */
  hasSubmission: Scalars['Boolean']['output'];
  /**
   * A Gradebook Result update in an Assessment.
   * @deprecated Use `results_updated` instead
   */
  resultUpdated: Result;
  /** Multiple Gradebook Results updated in an Assessment. */
  resultsUpdated: Array<Result>;
  /** Subscribe to updates for a Schoolyear exam. */
  schoolyearExamUpdated: SchoolyearExam;
  /** New Instruction Sheet release. */
  sheetReleased: Sheet;
  /** A question in a pool reached a terminal state (completed or failed). */
  socraticQuestionerPoolUpdated: SocraticQuestion;
  /**
   * A generation attempt was recorded for a student question on the task block.
   * The row carries the id `socraticQuestionerTaskBlock` gave it.
   */
  socraticQuestionerTaskBlockUpdated: SocraticStudentQuestion;
  /** Pushed when a Socratic turn's transcription attempt finishes. */
  socraticTranscriptionUpdated: SocraticTranscriptionOutcome;
  /**
   * Lightweight notification that one or more student outcomes changed for an
   * assessment.
   *
   * Unlike `student_outcomes_updated`, this does not resolve the (expensive)
   * score breakdowns — it only reports how many, and which, students changed,
   * so it is safe to fan out to every connected lecturer even for large
   * cohorts. Clients use it to surface an "out of sync" indicator and refetch
   * on demand.
   */
  studentOutcomesInvalidated: OutcomeSyncSignal;
  /** Subscription for student outcomes updates for an assessment */
  studentOutcomesUpdated: Array<StudentOutcome>;
  /** Subscribe to conversation updates for a specific thread. Receives comment additions, edits, and title changes. */
  threadConversationUpdated: ConversationEvent;
  /** [DEPRECATED] Subscribe to thread updates. Use entity_threads_updated for thread lifecycle events or thread_conversation_updated for comment events. */
  threadUpdated: Thread;
  /**
   * Subscription for work outcome batch updates.
   * @deprecated use `student_outcomes_updated`
   */
  workOutcomesUpdated: Array<WorkOutcome>;
  /** Pdf Artifact created in an assessment. */
  workPdfCreated: WorkArtifact;
  /** Update for a Gradebook result for a particular Work only. */
  workResultUpdated: Result;
  /** Update for a Work Settings. */
  workSettingsUpdated: WorkSettings;
  /** Update for work started */
  workStarted: Work;
  /** A Work has a new submission. */
  workSubmitted: Submission;
  /** A Work has been updated. Usually it's the settings that update for a work. */
  workUpdated: Work;
  /** A list of works' settings has been updated */
  worksSettingsUpdated: Array<Maybe<WorkSettings>>;
  /**
   * Multiple Works were submitted in the assessment.
   * @deprecated Use `results_updated` instead for updates on multiple submissions.
   */
  worksSubmitted: Array<Submission>;
};


export type RootSubscriptionTypeAssessmentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeAssessmentSettingsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEnrollmentsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEntityThreadsUpdatedArgs = {
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
};


export type RootSubscriptionTypeFieldOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeFieldRubricsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeFutureReleaseScheduleArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeGroupUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeHasSubmissionArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeResultUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeResultsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeSchoolyearExamUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeSheetReleasedArgs = {
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootSubscriptionTypeSocraticQuestionerPoolUpdatedArgs = {
  poolId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeSocraticQuestionerTaskBlockUpdatedArgs = {
  taskBlockId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeSocraticTranscriptionUpdatedArgs = {
  dialogueId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeStudentOutcomesInvalidatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeStudentOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeThreadConversationUpdatedArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeThreadUpdatedArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkPdfCreatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkResultUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkSettingsUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkStartedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkSubmittedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorksSettingsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorksSubmittedArgs = {
  assessmentId: Scalars['ID']['input'];
};

/** An Assessment's marking rubrics. */
export type Rubric = {
  __typename?: 'Rubric';
  id: Scalars['ID']['output'];
  questions: Array<QuestionRubric>;
};

/** Marking outcome from using a MarkerRubric to score the parent Outcome. */
export type RubricOutcome = {
  __typename?: 'RubricOutcome';
  criterionOutcomes: Array<CriterionOutcome>;
  score: Maybe<Scalars['Float']['output']>;
};

/** A Save for a work. */
export type Save = {
  __typename?: 'Save';
  /** Fetched contents of the embedded S3 Store reference. */
  content: Scalars['String']['output'];
  dispatchedAt: Scalars['PreciseDateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Database ID of the persisted save.
   *
   * This always reflects the actual table primary key of the Save, even when the
   * the `:id` value is some constant string. Sometimes the `:id` field has to
   * resolve to a constant string to make the client side cache always hit.
   */
  serverId: Scalars['ID']['output'];
  /** S3 object version ID. */
  version: Scalars['String']['output'];
};

/** Response for saving a block snapshot */
export type SaveBlockSnapshotResponse = {
  __typename?: 'SaveBlockSnapshotResponse';
  blockSnapshot: BlockSnapshot;
};

/** Mutation return for `saveGlobalUserSettings`. */
export type SaveGlobalUserSettingsPayload = {
  __typename?: 'SaveGlobalUserSettingsPayload';
  userSettings: Maybe<UserSettings>;
};

export type SaveMetadataInput = {
  assessmentId: Scalars['String']['input'];
  prevSaveId?: InputMaybe<Scalars['String']['input']>;
  prevVersionId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated will be automatically added from session */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  workId: Scalars['String']['input'];
};

/** Question state append attributes */
export type SaveQuestionStateInput = {
  feedback: Scalars['String']['input'];
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<QuestionFieldInput>>;
  /** Question prompt prosemirror contents */
  promptDoc?: InputMaybe<Scalars['String']['input']>;
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage?: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
};

export type SaveSocraticFeedbackEventPayload = {
  __typename?: 'SaveSocraticFeedbackEventPayload';
  feedbackEvent: Maybe<SocraticFeedbackEvent>;
};

/** Latest Task content save. */
export type SaveState = {
  __typename?: 'SaveState';
  /** Latest Task save ID. */
  id: Scalars['ID']['output'];
  /** JSON serialised raw content in this save. */
  rawContent: Maybe<Scalars['String']['output']>;
  /** The persisted TaskState server ID */
  serverId: Scalars['ID']['output'];
  updatedAt: Scalars['PreciseDateTime']['output'];
  version: Scalars['Int']['output'];
};

export type ScaleItem = {
  __typename?: 'ScaleItem';
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  order: Scalars['Int']['output'];
  rangeFrom: Maybe<Scalars['Float']['output']>;
  rangeTo: Maybe<Scalars['Float']['output']>;
  scaleLabel: Maybe<Scalars['String']['output']>;
};

export type ScaleItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
  rangeFrom?: InputMaybe<Scalars['Float']['input']>;
  rangeTo?: InputMaybe<Scalars['Float']['input']>;
  scaleLabel?: InputMaybe<Scalars['String']['input']>;
};

/** A Schoolyear exam linked to a Cadmus assessment. */
export type SchoolyearExam = {
  __typename?: 'SchoolyearExam';
  id: Scalars['ID']['output'];
  /** The push status of the Schoolyear exam. */
  pushStatus: SchoolyearExamPushStatus;
  /** The Schoolyear exam ID. Present only when push_status is ready. */
  schoolyearExamId: Maybe<Scalars['String']['output']>;
};

/** The push status of a Schoolyear exam. */
export enum SchoolyearExamPushStatus {
  /** The exam could not be created in Schoolyear. */
  Error = 'ERROR',
  /** The exam is being created in Schoolyear. */
  Pending = 'PENDING',
  /** The exam has been created in Schoolyear. */
  Ready = 'READY'
}

/** Score Breakdown */
export type ScoreBreakdown = {
  __typename?: 'ScoreBreakdown';
  automark: Maybe<Scalars['Float']['output']>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  marker: Maybe<Scalars['Float']['output']>;
  markerModifier: Maybe<Scalars['Float']['output']>;
  markerScore: Maybe<Scalars['Float']['output']>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  score: Maybe<Scalars['Float']['output']>;
};

/** Moderation decisions for score of a submission outcome. */
export enum ScoreModerationDecision {
  Average = 'AVERAGE',
  Custom = 'CUSTOM',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Input for score moderation decision. :highest and :lowest resolve per-outcome to :primary or :secondary. */
export enum ScoreModerationDecisionInput {
  Average = 'AVERAGE',
  Custom = 'CUSTOM',
  Highest = 'HIGHEST',
  Lowest = 'LOWEST',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** A roster sub-division of an assessment (e.g. a tutorial cohort) */
export type Section = {
  __typename?: 'Section';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  /** Number of (non-withdrawn) students assigned to this section */
  studentCount: Scalars['Int']['output'];
};

/** One row of a section roster import: a student and the section they belong to. */
export type SectionAssignmentInput = {
  sectionName: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** How self evaluation affects the final grade. :component adds the self score as a grade component; :peer_scaling includes the student's own self evaluation alongside their peers in the peer group-report multiplier. */
export enum SelfEvaluationMode {
  Component = 'COMPONENT',
  PeerScaling = 'PEER_SCALING'
}

/** A sentiment check */
export type SentimentCheck = {
  __typename?: 'SentimentCheck';
  comment: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  level: Maybe<SentimentCheckLevel>;
  order: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
  user: User;
};

export type SentimentCheckInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<SentimentCheckLevel>;
  skipped: Scalars['Boolean']['input'];
};

/** A sentiment check interval representing a time window for submitting a check */
export type SentimentCheckInterval = {
  __typename?: 'SentimentCheckInterval';
  endTime: Scalars['PreciseDateTime']['output'];
  order: Scalars['Int']['output'];
  sentimentCheck: Maybe<SentimentCheck>;
  startTime: Scalars['PreciseDateTime']['output'];
};

/** Enum of sentiment check levels */
export enum SentimentCheckLevel {
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED'
}

/** A custom sentiment check schedule entry */
export type SentimentCheckSchedule = {
  __typename?: 'SentimentCheckSchedule';
  id: Scalars['ID']['output'];
  scheduledAt: Scalars['PreciseDateTime']['output'];
};

/** Input for a custom sentiment check schedule entry */
export type SentimentCheckScheduleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  scheduledAt: Scalars['PreciseDateTime']['input'];
};

/** Schedule type for sentiment checks */
export enum SentimentCheckScheduleType {
  Custom = 'CUSTOM',
  Frequency = 'FREQUENCY'
}

/** Session information */
export type Session = {
  __typename?: 'Session';
  /** Session ID */
  id: Scalars['ID']['output'];
  /** Verification status for a session tied to an enrollment. */
  verified: Scalars['Boolean']['output'];
};


/** Session information */
export type SessionVerifiedArgs = {
  assessmentId: Scalars['ID']['input'];
};

export type SetupGroupInput = {
  bulkMarkerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  divideEqually?: InputMaybe<Scalars['Boolean']['input']>;
  excludedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  groupAssessmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupRules?: InputMaybe<Array<GroupRule>>;
  groupSelfEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  groupSelfEnrollmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  groupType: GroupType;
  maxLimit?: InputMaybe<Scalars['Int']['input']>;
  minLimit?: InputMaybe<Scalars['Int']['input']>;
};

export enum Shape {
  Ellipse = 'ellipse',
  Point = 'point',
  Polygon = 'polygon',
  Rectangle = 'rectangle'
}

/** Latest Instruction sheet for an Assessment. */
export type Sheet = {
  __typename?: 'Sheet';
  /**
   * List of released TaskBlocks in the Sheet
   * @deprecated Use the `question_blocks` field instead
   */
  blocks: Array<TaskBlock>;
  /** Released task format */
  format: TaskFormat;
  /** Settings to be used in the future, if this is a future sheet. */
  futureSettings: Maybe<AssessmentSettings>;
  /** GenAI Guideline notice released to students. */
  genaiGuidelineNotice: Maybe<TaskNotice>;
  /**
   * Task ID for which this sheet is released.
   *
   * NOTE: this is the Task ID and not the actual sheet ID which changes from
   * sheet to sheet. Use `serverId` for the actual sheet ID. This was done for
   * automatic cache replacement in apollo client for new sheets.
   */
  id: Scalars['String']['output'];
  kind: TaskKind;
  /** When the next sheet, if any, will be released. */
  nextReleaseTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Flattened Question Tree */
  questionBlocks: Array<QuestionBlock>;
  /** Serialised Editor contents of the Task body with other embedded metadata */
  rawContent: Maybe<Scalars['String']['output']>;
  /** When the sheet was released. */
  releaseTimestamp: Scalars['PreciseDateTime']['output'];
  /** List of released resources. */
  resources: Array<Resource>;
  /** Actual TaskHistory primary ID. */
  serverId: Scalars['ID']['output'];
  /** Settings for this assessment */
  settings: Maybe<AssessmentSettings>;
  /** Source Task ID for the Sheet */
  taskId: Scalars['ID']['output'];
  /** Task save version number from which the Sheet was created. */
  version: Scalars['Int']['output'];
};

/** Response as a plain text short phrase. */
export type ShortResponse = {
  __typename?: 'ShortResponse';
  /** Whether the matching is case sensitive */
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  /** Expected answer matches */
  matchPhrases: Maybe<Array<Scalars['String']['output']>>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
};

export type ShortResponseInput = {
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  matchPhrases?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Between 0.0 and 1.0 inclusive. */
  matchSimilarity?: InputMaybe<Scalars['Float']['input']>;
};

export type SimilarQuestionsPayload = {
  __typename?: 'SimilarQuestionsPayload';
  /** True if the replacement set is incomplete */
  incompleteReplacement: Maybe<Scalars['Boolean']['output']>;
  /** List of similar questions found */
  questions: Maybe<Array<Question>>;
};

/**
 * Similarity information for a Result.
 *
 * Currently a Turnitin similarity score is available in the gradebook. This
 * score is a floating point percentage value.
 */
export type Similarity = {
  __typename?: 'Similarity';
  /** Human formatted representation */
  display: Scalars['String']['output'];
  /** Label color for the similarity score */
  label: Scalars['String']['output'];
  /** Actual similarity score value between 0-100 */
  value: Scalars['Float']['output'];
};

export type SimpleChoice = {
  __typename?: 'SimpleChoice';
  content: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
};

export type SimpleChoiceInput = {
  content: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type SmartComment = {
  __typename?: 'SmartComment';
  assessmentId: Maybe<Scalars['ID']['output']>;
  /** The name of the assessment under which the smart comment was created. */
  assessmentName: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  lastUsed: Maybe<Scalars['PreciseDateTime']['output']>;
  score: Scalars['Int']['output'];
  skillId: Scalars['ID']['output'];
  updatedAt: Scalars['PreciseDateTime']['output'];
  usageCount: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
  userName: Maybe<Scalars['String']['output']>;
};

export type Snapshot = {
  __typename?: 'Snapshot';
  asOfVersion: Scalars['Int']['output'];
  contributions: Maybe<Contribution>;
  document: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type SnapshotFieldOutcomeInput = {
  blockName: AnswerBlockName;
  /** JSON ProseMirror Document */
  doc: Scalars['String']['input'];
  /** Version of the document */
  version: Scalars['Int']['input'];
};

export type SnapshotSubmissionOutcomeInput = {
  blockName: AnswerBlockName;
  /** JSON ProseMirror Document */
  doc: Scalars['String']['input'];
  /** Version of the document */
  version: Scalars['Int']['input'];
};

export type SnapshotTick = {
  __typename?: 'SnapshotTick';
  id: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** The question a lecturer wrote, which a student is shown when generation produces nothing. */
export type SocraticBaseQuestion = {
  __typename?: 'SocraticBaseQuestion';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** A Socratic Dialogue represents a full conversation between a student and the socratic challenger. */
export type SocraticDialogue = {
  __typename?: 'SocraticDialogue';
  attemptNumber: Scalars['Int']['output'];
  /** Started at + duration */
  expiredAt: Maybe<Scalars['PreciseDateTime']['output']>;
  id: Scalars['ID']['output'];
  maxTurns: Scalars['Int']['output'];
  readingTimeSeconds: Scalars['Int']['output'];
  responseTimeSeconds: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** All turns in this Dialogue */
  turns: Array<SocraticTurn>;
};

/**
 * A teacher's reaction (and optional comment) on a Socratic
 * questioner pool.
 */
export type SocraticFeedbackEvent = {
  __typename?: 'SocraticFeedbackEvent';
  baseQuestionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  reaction: SocraticFeedbackReaction;
  sourceTaskId: Scalars['ID']['output'];
  targetTaskId: Scalars['ID']['output'];
  /** The task block the reaction was left on. Null on rows written before it was recorded. */
  taskBlockId: Maybe<Scalars['ID']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

/** Reaction to a Socratic questioner pool (with optional comment). */
export type SocraticFeedbackEventInput = {
  /**
   * The base question text the pool was generated for — e.g. `SocraticQuestionerPool.baseQuestion`.
   * Resolved server-side to the existing `BaseQuestion` row for that text, or a new one, same as
   * question generation does; the client never handles a `base_question_id`.
   */
  baseQuestion: Scalars['String']['input'];
  /** The teacher's reaction to the pool. */
  reaction: SocraticFeedbackReaction;
  /** The task whose submissions were probed. */
  sourceTaskId: Scalars['ID']['input'];
  /** An optional free-text comment alongside the reaction. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** A teacher's reaction to a Socratic questioner pool. */
export enum SocraticFeedbackReaction {
  Down = 'DOWN',
  Up = 'UP'
}

export type SocraticInteraction = {
  __typename?: 'SocraticInteraction';
  kind: Maybe<Scalars['String']['output']>;
  maxAttempts: Maybe<Scalars['Int']['output']>;
  readingTime: Maybe<Scalars['Int']['output']>;
  responseTime: Maybe<Scalars['Int']['output']>;
};

export type SocraticInteractionInput = {
  /**
   * Maximum number of attempts the student has to submit finished dialogue.
   *         Must be at least 1.
   */
  maxAttempts: Scalars['Int']['input'];
  /** Time in seconds the student has to read the prompt before responding. */
  readingTime: Scalars['Int']['input'];
  /** Time in seconds the student has to respond. */
  responseTime: Scalars['Int']['input'];
};

/** A single Socratic follow-up question generated from one submission. */
export type SocraticQuestion = {
  __typename?: 'SocraticQuestion';
  /**
   * The wording this student is asked: the lecturer's when they edited it,
   * otherwise the model's.
   */
  content: Maybe<Scalars['String']['output']>;
  /** Whether a lecturer dismissed this question. */
  dismissed: Scalars['Boolean']['output'];
  /** Whether a lecturer replaced the model's wording, which `content` then carries. */
  edited: Scalars['Boolean']['output'];
  /** Failure detail when generation failed. */
  error: Maybe<Scalars['String']['output']>;
  /**
   * The generated question `updateSocraticQuestion` writes to. Null when no
   * generated question exists for this student
   */
  generatedQuestionId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  status: SocraticQuestionStatus;
  /** The submission's author; absent for group work and legacy runs. */
  student: Maybe<User>;
  /** The submission this question is grounded in; null when the student has none. */
  submissionId: Maybe<Scalars['ID']['output']>;
};

/** The generation state of a Socratic question. */
export enum SocraticQuestionStatus {
  /** A question was generated successfully. */
  Completed = 'COMPLETED',
  /** Generation errored, from the LLM or resolving the submission. */
  Failed = 'FAILED',
  /** A submission exists, but no question was generated for it in this pool. */
  NotAttempted = 'NOT_ATTEMPTED',
  /** The enrolled student made no final submission. */
  NoSubmission = 'NO_SUBMISSION',
  /** Generation is queued or in-flight; no result yet. */
  Pending = 'PENDING'
}

/** Reaction to one Base question on one task block (with optional comment). */
export type SocraticQuestionerFeedbackInput = {
  /** `SocraticQuestionerTaskBlock.baseQuestion.id`. */
  baseQuestionId: Scalars['ID']['input'];
  /** The teacher's reaction to the question. */
  reaction: SocraticFeedbackReaction;
  /** A block on the viva task. */
  taskBlockId: Scalars['ID']['input'];
  /** An optional free-text comment alongside the reaction. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The pool of Socratic questions for one base question, projected against the
 * class roster: one row per enrolled student, across every run in the pool.
 */
export type SocraticQuestionerPool = {
  __typename?: 'SocraticQuestionerPool';
  /** The teacher-authored question stating what to probe. */
  baseQuestion: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** One attempted socratic question per enrolled student */
  socraticQuestions: Maybe<Array<Maybe<SocraticQuestion>>>;
  /** The task whose submissions are being probed. */
  sourceTaskId: Scalars['String']['output'];
};

/** Names the pool of generated questions for one viva task block. */
export type SocraticQuestionerPoolInput = {
  /**
   * Question prompt ProseMirror contents (JSON). Replaces the block's saved
   * question, both for naming the pool and for generating into it. When absent
   * the block's latest saved question state is used.
   */
  promptDocOverrides?: InputMaybe<Scalars['String']['input']>;
  /** The viva task block naming the pool. */
  taskBlockId: Scalars['ID']['input'];
};

/**
 * One task block's question, and what every student on the source assessment's
 * roster will be asked for it.
 */
export type SocraticQuestionerTaskBlock = {
  __typename?: 'SocraticQuestionerTaskBlock';
  baseQuestion: SocraticBaseQuestion;
  id: Scalars['ID']['output'];
  /** The task whose submissions are being probed. */
  sourceTaskId: Scalars['String']['output'];
  /** One row per student on the source assessment's roster. */
  studentQuestions: Maybe<Array<Maybe<SocraticStudentQuestion>>>;
  /** The viva task block the question is asked on. */
  taskBlockId: Scalars['ID']['output'];
};

/**
 * Names one task block's question: the block, and the wording its students are
 * asked.
 */
export type SocraticQuestionerTaskBlockInput = {
  /**
   * Question prompt ProseMirror contents (JSON). Replaces the block's saved
   * question, both for naming the question and for generating into it. When
   * absent the block's latest saved question state is used.
   */
  promptDocOverrides?: InputMaybe<Scalars['String']['input']>;
  /** The viva task block holding the question. */
  taskBlockId: Scalars['ID']['input'];
};

/** A Socratic Session represents a single session of socratic interaction for a student. */
export type SocraticSession = {
  __typename?: 'SocraticSession';
  answerBlock: AnswerBlock;
  /** All Dialogues in this Session. */
  dialogues: Array<SocraticDialogue>;
  id: Scalars['ID']['output'];
  /** The latest Dialogue in this Session, or null if no Dialogues have been created yet. */
  latestDialogue: Maybe<SocraticDialogue>;
  maxAttempts: Scalars['Int']['output'];
  /** Prep time in seconds, including special consideration extra time. */
  readingTimeSeconds: Maybe<Scalars['Int']['output']>;
  /** When the student can reattempt, or null if they haven't started their first attempt yet, or reattempts never expire. */
  reattemptWindowEndsAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * How long the reattempt window is, in seconds, as it applies to this
   * student. Null when no window applies, whether the setting is off or the
   * student has been granted extra attempts. A zero is a window of zero
   * length, not the absence of one.
   */
  reattemptWindowSeconds: Maybe<Scalars['Int']['output']>;
  /** Response time in seconds, including special consideration extra time. */
  responseTimeSeconds: Maybe<Scalars['Int']['output']>;
};

/** What one student will be asked, for one base question on one task block. */
export type SocraticStudentQuestion = {
  __typename?: 'SocraticStudentQuestion';
  /**
   * Whether a lecturer dismissed this question, so the student is asked the
   * base question instead.
   */
  dismissed: Scalars['Boolean']['output'];
  /**
   * Why this student has no question, from the newest failed generation call.
   * Null once they have one.
   */
  error: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: SocraticStudentQuestionStatus;
  /** The student who will be asked. */
  student: Maybe<User>;
  studentQuestionId: Maybe<Scalars['ID']['output']>;
  /**
   * The submission the question was generated from, kept after a resubmission.
   * A lecturer's wording keeps the submission of the generated one it
   * replaced. Before any generation, the student's latest submission; null
   * when they have none.
   */
  submissionId: Maybe<Scalars['ID']['output']>;
  wording: Maybe<SocraticWording>;
};

/** The generation state of one student's question. */
export enum SocraticStudentQuestionStatus {
  /** The student has a question. */
  Completed = 'COMPLETED',
  /** Generation gave up after failing every call it was allowed. */
  Failed = 'FAILED',
  /** Something to generate from exists, but no generation has been run for it. */
  NotAttempted = 'NOT_ATTEMPTED',
  /** The student has nothing to generate a question from. */
  NoSubmission = 'NO_SUBMISSION',
  /** Generation is queued or in flight; no result yet. */
  Pending = 'PENDING'
}

/** A single timestamped segment of a Socratic transcript. */
export type SocraticTranscriptSegment = {
  __typename?: 'SocraticTranscriptSegment';
  endTime: Scalars['Float']['output'];
  startTime: Scalars['Float']['output'];
  text: Scalars['String']['output'];
};

/** Outcome of a finished transcription attempt for a Socratic Turn. */
export type SocraticTranscription = {
  __typename?: 'SocraticTranscription';
  dialogueId: Scalars['ID']['output'];
  /** The failure reason, present only when status is FAILED. */
  error: Maybe<Scalars['String']['output']>;
  /** Timestamped transcript segments, present only when status is SUCCEEDED. */
  segments: Maybe<Array<SocraticTranscriptSegment>>;
  status: SocraticTranscriptionStatus;
  /** The transcript text, present only when status is SUCCEEDED. */
  text: Maybe<Scalars['String']['output']>;
  turnId: Scalars['ID']['output'];
};

/** Outcome of a finished transcription attempt for a Socratic Turn. */
export type SocraticTranscriptionOutcome = {
  __typename?: 'SocraticTranscriptionOutcome';
  dialogueId: Scalars['ID']['output'];
  /** The failure reason, present only when status is FAILED. */
  error: Maybe<Scalars['String']['output']>;
  status: SocraticTranscriptionStatus;
  turnId: Scalars['ID']['output'];
};

export enum SocraticTranscriptionStatus {
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED'
}

/** A Socratic Turn represents a single exchange in a Socratic Dialogue. */
export type SocraticTurn = {
  __typename?: 'SocraticTurn';
  /** Whether this turn's prompt was generated by the Socratic Questioner for the student, rather than the base authored prompt. */
  generated: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  /** The student's preparation-phase video for this turn, if recorded. */
  preparationMedia: Maybe<TurnResponse>;
  /** The question prompt text for this turn. */
  questionPrompt: Maybe<Scalars['String']['output']>;
  /** When the recording was completed. */
  recordingCompletedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** When the recording was started. */
  recordingStartedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** The student's video response for this turn, if submitted. */
  response: Maybe<TurnResponse>;
};

/** One phrasing of a student's question. */
export type SocraticWording = {
  __typename?: 'SocraticWording';
  content: Scalars['String']['output'];
  /** Whether a person wrote this wording rather than a generation. */
  edited: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type SourceFileInput = {
  /** Imported file name set by the user */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** File path of imported file */
  filepath?: InputMaybe<Scalars['String']['input']>;
  /** ID of the file source */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum StartSocraticDialogueError {
  /** Outside reattempt window */
  OutsideReattemptWindow = 'OUTSIDE_REATTEMPT_WINDOW'
}

export type StartSocraticDialoguePayload = {
  __typename?: 'StartSocraticDialoguePayload';
  dialogue: Maybe<SocraticDialogue>;
  error: Maybe<StartSocraticDialogueError>;
  session: Maybe<SocraticSession>;
};

export enum StartSocraticTurnError {
  /** @deprecated Never returned; a repeated start returns the dialogue as it stands. */
  AlreadyStarted = 'ALREADY_STARTED',
  /** @deprecated Never returned; a start on a finished dialogue returns the dialogue. */
  DialogueAlreadyFinished = 'DIALOGUE_ALREADY_FINISHED'
}

export type StartSocraticTurnPayload = {
  __typename?: 'StartSocraticTurnPayload';
  dialogue: Maybe<SocraticDialogue>;
  error: Maybe<StartSocraticTurnError>;
};

/** All possible Task release states. */
export enum Status {
  Editing = 'EDITING',
  Released = 'RELEASED'
}

/**
 * The student home page's "Your actions" card: ranked notifications the
 * student can act on, plus notifications waiting on someone else, for one
 * student on a group assessment.
 */
export type StudentActionFeed = {
  __typename?: 'StudentActionFeed';
  /** Every notification the student can act on, already ranked; the client decides how many to show. */
  actions: Array<Notification>;
  /** Count of actions the student can clear themselves; waiting notes are not included. */
  badgeCount: Scalars['Int']['output'];
  /** Whether the student has opened the group work. Null if the student has no group work to speak of: not in a group, the group isn't finalised, feedback has already released, or the writing facts failed to load. False covers both a real unopened work and a group that hasn't launched one yet. */
  groupWorkViewed: Maybe<Scalars['Boolean']['output']>;
  /** Whether the student has opened their individual work. Null if the student has no individual work (for example, individual reports are disabled for this assessment). */
  individualWorkViewed: Maybe<Scalars['Boolean']['output']>;
  /** Whether the student has opened the peer evaluation for their group. */
  peerEvaluationViewed: Maybe<Scalars['Boolean']['output']>;
  /** The assessment's current lifecycle stage (1-6), from `Cadmus.Digest.lifecycle_stage/2`. The same timeline as the lecturer digest, but not gated by its send schedule. */
  stage: Scalars['Int']['output'];
  /** Whether the student has actions to take, is up to date, or the card's status is unknown. */
  state: StudentActionFeedState;
  /** Notifications the student is waiting on someone else to resolve; never counted in badgeCount. */
  waitingOnOthers: Array<Notification>;
};

/** Whether the student has actions to take, is fully up to date, or the card's status is unknown because a fact family failed to load. */
export enum StudentActionFeedState {
  Actions = 'ACTIONS',
  Unknown = 'UNKNOWN',
  UpToDate = 'UP_TO_DATE'
}

/** Marking outcome targetting a single student in the assessment. */
export type StudentOutcome = {
  __typename?: 'StudentOutcome';
  /**
   * The `base` field calculates a ComponentBreakdown for each component using the up-to-date
   * data sources such as WorkOutcome, SubmissionOutcome, or FieldOutcome as the source of scores.
   *
   * Any marking or moderation action such as `markFieldOutcome`, `markSubmissionOutcome`,
   * or `updateWorkOutcomeScore` will alter the underlying outcome and there the `base` scores.
   */
  base: ComponentBreakdown;
  /**
   * The `:final` edge calculates a ComponentBreakdown of each component using only released
   * data sources such as WorkOutcomeRelease as the source of scores.
   *
   * The only way to alter any final score is to withdraw feedback and then subsequently make
   * a new final release to the student with some marking or moderation actions being taken.
   */
  final: ComponentBreakdown;
  groupWorkOutcome: Maybe<WorkOutcome>;
  id: Scalars['ID']['output'];
  individualWorkOutcome: Maybe<WorkOutcome>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  /** Per-student additive score modifiers (e.g. marker adjustments). */
  modifiers: Array<StudentOutcomeModifier>;
  peerOutcome: Maybe<PeerOutcome>;
  /**
   * The `:provisional` edge calculates a ComponentBreakdown of each component using only released
   * data sources such as WorkOutcomeRelease as the source of scores.
   *
   * The only way to alter any provisional score is to a new provisional release to the student
   * with some new marking or moderation actions being taken.
   *
   * One notable exception: changes to student_outcome_moderator_modifier will alter
   * the total score immediately (not a component's score such as individual or group).
   */
  provisional: ComponentBreakdown;
  studentId: Scalars['ID']['output'];
};

/** Per-student additive score modifier. Generic over `type`/`origin`/`component`. */
export type StudentOutcomeModifier = {
  __typename?: 'StudentOutcomeModifier';
  addedAt: Scalars['DateTime']['output'];
  addedByUserId: Maybe<Scalars['ID']['output']>;
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note: Maybe<Scalars['String']['output']>;
  origin: StudentOutcomeModifierOrigin;
  sourceOutcomeId: Maybe<Scalars['ID']['output']>;
  type: StudentOutcomeModifierType;
  value: Scalars['Decimal']['output'];
};

/** Origins that can create per-student additive score modifiers. */
export enum StudentOutcomeModifierOrigin {
  Marker = 'MARKER',
  Moderator = 'MODERATOR'
}

/** Types of per-student additive score modifiers. */
export enum StudentOutcomeModifierType {
  Contribution = 'CONTRIBUTION'
}

/**
 * Completion booleans describing whether the current student has finished
 * their peer evaluation for an assessment. Replaces the per-row
 * `has_evaluated_all_peers` / `has_completed_self_evaluation` flags on
 * `peer_outcome` for callers that need the viewing student's own status,
 * which may not exist as a row when no peer has evaluated them yet.
 */
export type StudentPeerEvalProgress = {
  __typename?: 'StudentPeerEvalProgress';
  /** Whether the current student has submitted their self evaluation. `true` when self evaluation is disabled. */
  hasCompletedSelfEvaluation: Scalars['Boolean']['output'];
  /** Whether the current student has evaluated every assigned peer (pre-due requires published; post-due drafts count). */
  hasEvaluatedAllPeers: Scalars['Boolean']['output'];
};

/** Input object for updating a student's settings within an assessment context. */
export type StudentSettingsInput = {
  draftExamEndDate?: InputMaybe<Scalars['String']['input']>;
  draftExamStartDate?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  examDeferred?: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  examReadingTime?: InputMaybe<Scalars['Int']['input']>;
  examStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  examWritingTime?: InputMaybe<Scalars['Int']['input']>;
  studentId: Scalars['ID']['input'];
  submitAttemptLimit?: InputMaybe<Scalars['Int']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  updateReason?: InputMaybe<Scalars['String']['input']>;
  vivaExtraAttempts?: InputMaybe<Scalars['Int']['input']>;
  vivaExtraPrepSeconds?: InputMaybe<Scalars['Int']['input']>;
  vivaExtraResponseSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** A Cadmus Subject. */
export type Subject = {
  __typename?: 'Subject';
  /**
   * Every assessment in this subject, oldest-due first, for the teacher subject
   * page. Each carries an `accessible` flag: true when the requesting teacher is
   * enrolled in that assessment, false when it belongs to the subject but not to
   * them (shown as a locked row). Reached only through the flag-gated,
   * enrolment-scoped `subject` query.
   */
  assessments: Array<SubjectAssessment>;
  discipline: Maybe<Discipline>;
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /**
   * Subject groups this subject belongs to.
   *
   * A subject can belong to more than one group. Exposed so a list of
   * assessments (e.g. past assessments) can be filtered by subject group: the
   * distinct set across the listed subjects is the available filter, and each
   * subject carries the groups it belongs to. Empty when the subject is in no
   * groups. Batched per tenant.
   */
  subjectGroups: Array<SubjectGroup>;
};

/**
 * An assessment as it appears on the teacher subject-page timeline.
 *
 * Carries only the basic attributes the timeline renders. `accessible` is false
 * for assessments that belong to the subject but not to the requesting teacher —
 * shown as locked rows they cannot open. Funnel, marking and grade analytics are
 * deliberately not part of this first phase, so there is nothing sensitive to
 * leak on a locked row.
 */
export type SubjectAssessment = {
  __typename?: 'SubjectAssessment';
  /** True when the requesting teacher is enrolled in this assessment and may open it. */
  accessible: Scalars['Boolean']['output'];
  /** Coarse assessment type. */
  assessmentType: Maybe<AssessmentType>;
  /** Submission due date. */
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Assessment cut-off date, set in the LMS. */
  endDate: Maybe<Scalars['PreciseDateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Assessment open/start date. For exams this is the scheduled exam start. */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * Where the assessment sits in its teacher lifecycle:
   * `draft` (instructions not released), `released` (live), `marking` (released
   * and past due), or `feedback` (marks/feedback released).
   */
  status: SubjectAssessmentStatus;
  /** Weight as a percentage of the subject grade; null when weighting is disabled. */
  weight: Maybe<Scalars['Float']['output']>;
  /** Configured word limit; null when the word limit is disabled. */
  wordLimit: Maybe<Scalars['Int']['output']>;
};

/** Where an assessment sits in its lifecycle on the subject timeline. */
export enum SubjectAssessmentStatus {
  Draft = 'DRAFT',
  Feedback = 'FEEDBACK',
  Marking = 'MARKING',
  Released = 'RELEASED'
}

/**
 * A group of related subjects. Used to filter assessments across subjects that
 * belong to the same group.
 */
export type SubjectGroup = {
  __typename?: 'SubjectGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum SubjectRole {
  ExternalExaminer = 'EXTERNAL_EXAMINER',
  FacultyLeader = 'FACULTY_LEADER',
  LearningDesigner = 'LEARNING_DESIGNER',
  LearningTechnologist = 'LEARNING_TECHNOLOGIST',
  Lecturer = 'LECTURER',
  Marker = 'MARKER',
  Other = 'OTHER',
  SubjectCoordinator = 'SUBJECT_COORDINATOR',
  Tutor = 'TUTOR',
  UniversityLeader = 'UNIVERSITY_LEADER'
}

/** A Final or Draft Submission. */
export type Submission = {
  __typename?: 'Submission';
  /** Attempt number if provided during submission. */
  attemptNumber: Maybe<Scalars['Int']['output']>;
  /** A representation of an answer to a question block */
  blockSnapshots: Array<BlockSnapshot>;
  /**
   * If the submission was forcefully submitted on behalf of the student.
   *
   * Use the `submittedBy` field to know who submitted the submission.
   */
  forceSubmitted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Gradebook result on the submission.
   * @deprecated Use Work.result directly instead. Result should be the parent of Submission.
   */
  result: Result;
  /** Save attached to the submission. */
  save: Maybe<Save>;
  /**
   * What triggered this Submission: the student manually submitting, or the
   * client auto-submitting (e.g. writing time expiring). Use `forceSubmitted`
   * to check whether a lecturer force-submitted on the student's behalf. Null
   * if unknown, e.g. for submissions made before this field existed.
   */
  submissionTrigger: Maybe<SubmissionTrigger>;
  submittedAt: Scalars['PreciseDateTime']['output'];
  /**
   * The User who made the submission.
   *
   * If the value is null, the user should be assumed to be the student who owns
   * the Work.
   */
  submittedBy: Maybe<User>;
  /** Type of Submission. */
  type: SubmissionType;
  unsubmittedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  workId: Scalars['ID']['output'];
};

/**
 * Input to downloadSubmissions mutation to add a submission's PDF to the
 * archive.
 */
export type SubmissionDetailInput = {
  /** Submission ID */
  id: Scalars['ID']['input'];
  /** Filename inside the archive */
  name: Scalars['String']['input'];
};

export type SubmissionMarkerModifierPayload = {
  __typename?: 'SubmissionMarkerModifierPayload';
  studentOutcomes: Array<StudentOutcome>;
  submissionOutcome: SubmissionOutcome;
  workOutcome: WorkOutcome;
};

/** Outcome recorded for a student's submission. */
export type SubmissionOutcome = {
  __typename?: 'SubmissionOutcome';
  bodyBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  bodyDoc: Maybe<Scalars['String']['output']>;
  bodyDocStreamUuid: Maybe<Scalars['ID']['output']>;
  bodyDocVersion: Scalars['Int']['output'];
  completedAt: Maybe<Scalars['DateTime']['output']>;
  feedbackModeration: Maybe<FeedbackModerationDecision>;
  flagReason: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Indicated whether the SubmissionOutcome is the latest for FINAL or DRAFT */
  latestForType: Scalars['Boolean']['output'];
  /** The marker's additive adjustment on top of the rubric outcome score. */
  markerModifier: Maybe<Scalars['Float']['output']>;
  markerScope: MarkerScope;
  markerUserId: Maybe<Scalars['ID']['output']>;
  moderationOutcome: Maybe<ModerationOutcome>;
  referencesBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  referencesDoc: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Scalars['Int']['output'];
  /** Marking outcome from using a MarkerRubric to score the parent Outcome. */
  rubricOutcome: RubricOutcome;
  score: Maybe<Scalars['Float']['output']>;
  scoreModeration: Maybe<ScoreModerationDecision>;
  submissionId: Scalars['ID']['output'];
  submissionType: SubmissionType;
  submittedAt: Scalars['PreciseDateTime']['output'];
};

/**
 * SubmissionOutcomeRelease represents a snapshot of a submission outcome at release time.
 * Contains the overall submission marking and documentation.
 */
export type SubmissionOutcomeRelease = {
  __typename?: 'SubmissionOutcomeRelease';
  bodyBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  bodyDoc: Maybe<Scalars['String']['output']>;
  bodyDocStreamUuid: Scalars['ID']['output'];
  bodyDocVersion: Scalars['Int']['output'];
  criterionOutcomeReleases: Array<CriterionOutcomeRelease>;
  id: Scalars['ID']['output'];
  referencesBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  referencesDoc: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  submissionId: Scalars['ID']['output'];
  threadReleases: Array<ThreadRelease>;
};

export type SubmissionOutcomesPayload = {
  __typename?: 'SubmissionOutcomesPayload';
  submissionOutcomes: Array<SubmissionOutcome>;
};

/** Options for queueSubmissionPipeline. Mirrors the SubmissionWorker force_* options. */
export type SubmissionPipelineInput = {
  forceCopyleaks?: InputMaybe<Scalars['Boolean']['input']>;
  forceLms?: InputMaybe<Scalars['Boolean']['input']>;
  forceManifest?: InputMaybe<Scalars['Boolean']['input']>;
  forcePdf?: InputMaybe<Scalars['Boolean']['input']>;
  forceTurnitin?: InputMaybe<Scalars['Boolean']['input']>;
  resultIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  submissionType?: InputMaybe<SubmissionType>;
};

/** What triggered a Submission. */
export enum SubmissionTrigger {
  /** The client auto-submitted, e.g. writing time expired. */
  Auto = 'AUTO',
  /** The student manually submitted. */
  Manual = 'MANUAL'
}

/** Types of submissions the client can make. */
export enum SubmissionType {
  Draft = 'DRAFT',
  Final = 'FINAL'
}

export type SubmitAttemptPayload = {
  __typename?: 'SubmitAttemptPayload';
  /** Next acceptable submission attempt number */
  nextAttemptNumber: Scalars['Int']['output'];
  result: Result;
};

/** A recorded Survey response. */
export type Survey = {
  __typename?: 'Survey';
  /** Is the survey open for accepting new answers? */
  active: Scalars['Boolean']['output'];
  answer: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  score: Maybe<Scalars['Int']['output']>;
};

/** A Tag attached to an Enrollment */
export type Tag = {
  __typename?: 'Tag';
  /** @deprecated Use an explicit `tab` instead of column */
  column: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  tab: ClassTab;
  text: Scalars['String']['output'];
};

export type TagInput = {
  /** Link tag to a category */
  categoryId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/**
 * An Assessment's Task.
 *
 * A single `Task` document is edited by a teacher and released as `Sheet` to
 * their Assessment. An Assessment can have multiple Tasks, one of each
 * `TaskKind`. The `INDIVIDUAL` kinded Task is the default and always-present
 * Task.
 *
 * A Task has a latest `SaveState` which is the latest content saved by the
 * teacher.
 *
 * A Task has attached `Resources`.
 *
 * DEPRECATED A Task has settings in the form of `Requirements`. Use `settings`
 * edge on `Assessment` instead.
 */
export type Task = {
  __typename?: 'Task';
  /** One Task block by id. */
  block: Maybe<TaskBlock>;
  /** List of all multi-format Task blocks. */
  blocks: Array<TaskBlock>;
  format: Maybe<TaskFormat>;
  /**
   * Future scheduled instruction sheet for this task.
   *
   * Returns null if no future release is scheduled.
   * Uses batching to prevent N+1 queries when resolving multiple tasks.
   */
  futureSheet: Maybe<Sheet>;
  /** Latest GenAI Guideline notice attached to this Task, if any. */
  genaiGuidelineNotice: Maybe<TaskNotice>;
  /** Task has a linked Marker Rubric. */
  hasMarkerRubric: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Current released instruction sheet for this task.
   *
   * Returns null if task has never been released.
   * Uses batching to prevent N+1 queries when resolving multiple tasks.
   */
  instructionSheet: Maybe<Sheet>;
  kind: TaskKind;
  /** Latest Task requirement values. */
  requirements: Requirements;
  /** Latest Task resources. */
  resources: Array<Resource>;
  /** Latest Task save state. */
  saveState: SaveState;
  /** Task is in a released state or not. */
  status: Status;
};


/**
 * An Assessment's Task.
 *
 * A single `Task` document is edited by a teacher and released as `Sheet` to
 * their Assessment. An Assessment can have multiple Tasks, one of each
 * `TaskKind`. The `INDIVIDUAL` kinded Task is the default and always-present
 * Task.
 *
 * A Task has a latest `SaveState` which is the latest content saved by the
 * teacher.
 *
 * A Task has attached `Resources`.
 *
 * DEPRECATED A Task has settings in the form of `Requirements`. Use `settings`
 * edge on `Assessment` instead.
 */
export type TaskBlockArgs = {
  id: Scalars['ID']['input'];
};

/**
 * A block inside a Task or TaskHistory.
 *
 * Task blocks convey a question or bunch of questions within a Task. A list of
 * blocks within a Task have a Tree structure with nesting. This Tree structure
 * is constructed using the 3 fields:
 *
 *   1. `nodeId` required
 *   2. `parentNodeId` optional
 *   3. `previousNodeId` optional
 *
 * Task blocks can also be flattened and given a fixed ordering using the `order`
 * field. The flattened tree numbering is preserved in `orderLabel` field.
 */
export type TaskBlock = {
  __typename?: 'TaskBlock';
  deleted: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Library Question ID linked to this block */
  libraryQuestionId: Maybe<Scalars['ID']['output']>;
  /** Library Question Version ID linked to this block */
  libraryQuestionVersionId: Maybe<Scalars['ID']['output']>;
  markerRubric: Maybe<MarkerRubric>;
  /** Tree layout node ID for the block. */
  nodeId: Scalars['ID']['output'];
  order: Maybe<Scalars['Int']['output']>;
  orderLabel: Maybe<Scalars['String']['output']>;
  /** @deprecated Use parentNodeId */
  parentId: Maybe<Scalars['ID']['output']>;
  /** Tree layout parent node ID for this block. */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  points: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use previousNodeId */
  previousId: Maybe<Scalars['ID']['output']>;
  /** Tree layout previous node ID for this block. */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  /** Number of questions referenced by the TaskBlock */
  quantity: Maybe<Scalars['Int']['output']>;
  /** Question attached to a Task block. */
  question: Maybe<Question>;
  /** QuestionSelection with sets attached this block */
  questionSelection: Maybe<QuestionSelection>;
  shuffle: Scalars['Boolean']['output'];
  /** Whether Socratic AI Questioner is enabled for this block */
  socraticQuestionerEnabled: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Enum of format of task */
export enum TaskFormat {
  Classic = 'CLASSIC',
  Multiformat = 'MULTIFORMAT'
}

/** Kinds of Tasks created in an Assessment. */
export enum TaskKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Peer = 'PEER',
  Viva = 'VIVA'
}

/** A Task Notice. */
export type TaskNotice = {
  __typename?: 'TaskNotice';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

/** A teacher's satisfaction survey response. */
export type TeacherSurvey = {
  __typename?: 'TeacherSurvey';
  /**
   * Is the survey open — should the rating card be shown? True only when the
   * `teacher_satisfaction_survey` feature flag is enabled, the session is not
   * impersonated, and the teacher has neither rated nor dismissed it.
   */
  active: Scalars['Boolean']['output'];
  score: Maybe<Scalars['Int']['output']>;
};

export type TextEntryInteraction = {
  __typename?: 'TextEntryInteraction';
  /** Allow file attachments */
  attachmentEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Base type of the student's answer */
  baseType: Maybe<BaseType>;
  /** Expected length of the text entry */
  expectedLength: Maybe<Scalars['Int']['output']>;
};

export type TextEntryInteractionInput = {
  attachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  expectedLength?: InputMaybe<Scalars['Int']['input']>;
};

export type Thread = {
  __typename?: 'Thread';
  comments: Array<Comment>;
  createdBy: User;
  criterion: Maybe<Criterion>;
  /** Linked rubric Criterion */
  criterionId: Maybe<Scalars['ID']['output']>;
  entityId: Maybe<Scalars['ID']['output']>;
  entityType: Maybe<EntityType>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  metadata: Maybe<Metadata>;
  resolvedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  resolvedBy: Maybe<User>;
  status: ThreadStatus;
  title: Maybe<Scalars['String']['output']>;
};

export type ThreadInput = {
  /** Initial comment content as HTML string */
  comment?: InputMaybe<Scalars['String']['input']>;
  criterionId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the associated entity. */
  entityId: Scalars['ID']['input'];
  /** Type of the associated entity. */
  entityType: EntityType;
  /** ID of the group the thread belongs to. */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<ThreadMetadataInput>;
  /** ID of the associated smart comment, if any. */
  smartCommentId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ThreadMetadataInput = {
  /** ID of the BlockAttachment this thread is about */
  blockAttachmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Display name of the file */
  blockAttachmentName?: InputMaybe<Scalars['String']['input']>;
  charterEditorId?: InputMaybe<Scalars['ID']['input']>;
  charterSectionType?: InputMaybe<CharterSectionType>;
};

/**
 * ThreadRelease represents a snapshot of a thread at the time of feedback release.
 * Contains the thread information and its comments at release time.
 */
export type ThreadRelease = {
  __typename?: 'ThreadRelease';
  commentReleases: Array<CommentRelease>;
  /** Linked rubric Criterion */
  criterionId: Maybe<Scalars['ID']['output']>;
  /** The ID of the Thread. */
  id: Scalars['ID']['output'];
  metadata: Maybe<Metadata>;
  threadInsertedAt: Scalars['PreciseDateTime']['output'];
  title: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** Thread states. */
export enum ThreadStatus {
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Editing = 'EDITING'
}

/** The student's video response to a Socratic Turn. */
export type TurnResponse = {
  __typename?: 'TurnResponse';
  /** Duration of the student's recorded response media in seconds. */
  durationSeconds: Maybe<Scalars['Int']['output']>;
  /** The URL where the student's recorded response media can be accessed. */
  mediaUrl: Maybe<Scalars['String']['output']>;
};

/** Input for unlinking library question references */
export type UnlinkLibraryQuestionInput = {
  taskBlockId: Scalars['ID']['input'];
  unlinkVersionOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAnswerBlockInput = {
  bookmark?: InputMaybe<Scalars['Boolean']['input']>;
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFieldRubricInput = {
  fieldRubricId: Scalars['ID']['input'];
  role: MarkingRole;
  valuesAdded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valuesRemoved?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateFieldRubricPayload = {
  __typename?: 'UpdateFieldRubricPayload';
  fieldOutcomes: Array<FieldOutcome>;
  fieldRubric: Maybe<FieldRubric>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubric: Maybe<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

/**
 * Input to update the milestones of a charter by passing
 *   the `charter_id` and the list of `milestones`
 */
export type UpdateMilestonesInput = {
  charterId: Scalars['ID']['input'];
  milestones?: InputMaybe<Array<MilestoneInput>>;
};

export type UpdateProjectIssueInput = {
  groupId: Scalars['ID']['input'];
  issues?: InputMaybe<Array<ProjectIssueInput>>;
};

export type UpdateQuestionBankFileOriginInput = {
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateQuestionBankInput = {
  /** @deprecated Deprecated. Use fields instead */
  blanksResponse?: InputMaybe<BlanksResponseInput>;
  /** @deprecated Deprecated. Use fields instead */
  booleanResponse?: InputMaybe<BooleanResponseInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  /** @deprecated Deprecated. Use fields instead */
  editorResponse?: InputMaybe<EditorResponseInput>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<InputMaybe<QuestionFieldInput>>>;
  /** @deprecated Deprecated. Use fields instead */
  multiResponse?: InputMaybe<MultiResponseInput>;
  points?: InputMaybe<Scalars['Int']['input']>;
  promptDoc: Scalars['String']['input'];
  questionBankId: Scalars['ID']['input'];
  /** Question type */
  questionType: QuestionType;
  scope: QuestionBankScope;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** @deprecated Deprecated. Use fields instead */
  shortResponse?: InputMaybe<ShortResponseInput>;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateQuestionBanksCategoryInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  questionBankIds: Array<Scalars['ID']['input']>;
  scope: QuestionBankScope;
};

export type UpdateQuestionRubricInput = {
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  errorMargin?: InputMaybe<Scalars['Float']['input']>;
  partialScoring?: InputMaybe<Scalars['Boolean']['input']>;
  questionRubricId: Scalars['ID']['input'];
  role: MarkingRole;
  similarity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateQuestionRubricPayload = {
  __typename?: 'UpdateQuestionRubricPayload';
  fieldOutcomes: Array<FieldOutcome>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubric: Maybe<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type UpdateQuestionSourceFileInput = {
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateQuestionVersionInput = {
  /** The attributes to update the question with */
  attributes: QuestionAttributes;
  /** The ID of the question to be updated */
  id: Scalars['ID']['input'];
  /** The version of the question to be updated */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** A lecturer's verdict on one generated question. */
export type UpdateSocraticQuestionInput = {
  /**
   * `true` records that this student is asked the pool's base question instead.
   * `false` un-dismisses, so they are asked this question's wording again.
   */
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The lecturer's wording, which the student is asked in place of the model's.
   * `null` clears the edit, restoring the model's question.
   */
  editedContent?: InputMaybe<Scalars['String']['input']>;
  /** The question to write to, from `SocraticQuestion.generatedQuestionId`. */
  generatedQuestionId: Scalars['ID']['input'];
};

export type UpdateSocraticQuestionPayload = {
  __typename?: 'UpdateSocraticQuestionPayload';
  socraticQuestion: Maybe<SocraticQuestion>;
};

/** A lecturer's verdict on one student question. */
export type UpdateSocraticStudentQuestionInput = {
  /**
   * `true` records that this student is asked the base question instead.
   * `false` un-dismisses, so they are asked the question's newest wording again.
   */
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The lecturer's wording, which becomes the one the student is asked and
   * clears a dismissal unless `dismissed` is also sent. `null` goes back to the
   * newest generated wording, and clears a dismissal the same way.
   */
  editedContent?: InputMaybe<Scalars['String']['input']>;
  /** The student question to write to */
  studentQuestionId: Scalars['ID']['input'];
};

export type UpdateSocraticStudentQuestionPayload = {
  __typename?: 'UpdateSocraticStudentQuestionPayload';
  studentQuestion: Maybe<SocraticStudentQuestion>;
};

export type UpdateStudentOutcomeScoreInput = {
  moderatorModifier?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateStudentOutcomeScorePayload = {
  __typename?: 'UpdateStudentOutcomeScorePayload';
  studentOutcome: StudentOutcome;
};

/** Updatable attributes for a TaskBlock */
export type UpdateTaskBlockInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
  socraticQuestionerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Updatable attributes for a TaskBlock for UpdateTaskBlocks */
export type UpdateTaskBlocksInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkOutcomeScoreInput = {
  moderatorModifier: Scalars['Float']['input'];
  workOutcomeId: Scalars['ID']['input'];
};

export type UpdateWorkOutcomeScorePayload = {
  __typename?: 'UpdateWorkOutcomeScorePayload';
  fieldOutcome: Maybe<FieldOutcome>;
  fieldRubric: Maybe<FieldRubric>;
  questionOutcome: Maybe<QuestionOutcome>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcome: Maybe<WorkOutcome>;
};

/** Cadmus User profile */
export type User = {
  __typename?: 'User';
  /** Optional user colourset index for group context. */
  colourset: Maybe<Scalars['Int']['output']>;
  email: Maybe<Scalars['String']['output']>;
  /** User family name to be used for sorting. */
  familyName: Scalars['String']['output'];
  /** User given name to be used as a short display name. */
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Full name, parsed from the LMS request which created the user. */
  name: Scalars['String']['output'];
  /** Has the user seen the latest onboarding manual screens? */
  onboardingSeen: Scalars['Boolean']['output'];
};

/** Personal settings of a user. */
export type UserSettings = {
  __typename?: 'UserSettings';
  id: Scalars['ID']['output'];
  /** Integrity Assuranceonboarding flag */
  showIaOnboarding: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No more UserPilot */
  showUserpilotOnboarding: Maybe<Scalars['Boolean']['output']>;
  /** User provided role in the subject */
  subjectRole: Maybe<SubjectRole>;
};

export type VerifiedCode = {
  __typename?: 'VerifiedCode';
  code: Scalars['String']['output'];
  insertedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type VerifyAccessCodePayload = {
  __typename?: 'VerifyAccessCodePayload';
  failureReason: Maybe<AccessCodeFailureReason>;
  session: Session;
  success: Scalars['Boolean']['output'];
};

export type VivaSourceTask = {
  __typename?: 'VivaSourceTask';
  assessmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Aggregated weighted scoring data across all components and outcome-level modifiers. */
export type WeightedScore = {
  __typename?: 'WeightedScore';
  /**
   * Summed applied raw (pre-weight) marker adjustment across components after
   * clamping. Reported for transparency only — already folded into `score`,
   * never re-added on top.
   */
  adjustment: Scalars['Float']['output'];
  /** The maximum possible grade for the score. */
  maxScore: Scalars['Float']['output'];
  /** Total weighted moderation adjustment from all components. */
  moderatorModifierComponents: Scalars['Float']['output'];
  /** A modifier applied directly to the student's final weighted score with 100% weightage. */
  moderatorModifierStudent: Scalars['Float']['output'];
  /** Total weighted penalty deduction (positive float or 0.0). */
  penaltyScore: Scalars['Float']['output'];
  /**
   * The student's running weighted total score.
   * * `base`: Exists as soon as any score is recorded.
   * * `final`/`provisional`: Exists only when all components are released.
   *
   * Formula: Sum of component weighted scores, penalties, and modifiers + `student_outcome_moderator_modifier`.
   */
  score: Maybe<Scalars['Float']['output']>;
};

/** A Student's Work with submissions and saves. */
export type Work = {
  __typename?: 'Work';
  /** Answer blocks linked to a Work */
  answerBlocks: Array<AnswerBlock>;
  /** Current attempt count: not 1 to 1 for Submissions */
  attemptCount: Scalars['Int']['output'];
  /** Student's Cadmus experience survey response related to this work */
  experience: Survey;
  /** Feature flags enabled on a Work */
  features: WorkFeatures;
  /** Group that owns the work in group assessments. */
  group: Maybe<Group>;
  /**
   * Is there a save (either Save or BlockSnapshot for this work?).
   *
   * Note: this field is an optimized version of `:last_save_time`
   * since the client never uses the actual date but `existence` of
   * a save.
   */
  hasSave: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Last save timestamp if there is a last save.
   *
   * For work-authority (snapshots) works this reads the denormalised
   * `works.last_snapshot_at` column.
   */
  lastSaveTime: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * Latest save for the Work, if any.
   *
   * NOTE: This field is not optimised for batch loading on multiple works.
   */
  latestSave: Maybe<Save>;
  /** Latest sentiment check for a work */
  latestSentimentCheck: Maybe<SentimentCheck>;
  /** Latest Gradebook result for the Work. */
  result: Maybe<Result>;
  /** Settings specific to the Work that override the Assessment's released sheet. */
  settings: Maybe<WorkSettings>;
  /** Instruction Sheet released to the Student. */
  sheet: Maybe<Sheet>;
  /** Start date for a timed Work that the student has to manually trigger. */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Student with access to the work. */
  student: User;
  /** ID of the Task this Work belongs to, if any. */
  taskId: Maybe<Scalars['ID']['output']>;
  /** Kind of Task this Work belongs to (individual, group, peer, viva). */
  taskKind: Maybe<TaskKind>;
  /** Last update timestamp. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
};


/** A Student's Work with submissions and saves. */
export type WorkResultArgs = {
  submissionType: SubmissionType;
};

/** Work Artifacts Associated with this Work. */
export type WorkArtifact = {
  __typename?: 'WorkArtifact';
  /** Marking service or AGS receipt date */
  agsSentAt: Maybe<Scalars['PreciseDateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Email receipt date */
  studentSentAt: Maybe<Scalars['PreciseDateTime']['output']>;
  submissionId: Scalars['ID']['output'];
  taskHistoryId: Scalars['ID']['output'];
  workId: Scalars['ID']['output'];
};

/**
 * Input to downloadWorkArtifacts mutation to add an artifact's PDF to the
 * archive.
 */
export type WorkArtifactDetailInput = {
  /** Filename inside the archive */
  filename: Scalars['String']['input'];
  /** Work Artifact ID */
  id: Scalars['ID']['input'];
  /** Force regenerate the WorkArtifact */
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Feature flags enabled on a Work */
export type WorkFeatures = {
  __typename?: 'WorkFeatures';
  /** Font family/size controls (the FontMarks editor extension) */
  enableFontControls: Scalars['Boolean']['output'];
  /** Use the collaborative editor for this individual Work */
  enableIndividualCollab: Scalars['Boolean']['output'];
  /** Offline persistence for streams in the Work */
  enableOfflinePersistence: Scalars['Boolean']['output'];
  /** This Work's Authority stream lives in the per-tenant schema */
  enableTenantStreams: Scalars['Boolean']['output'];
  /** Enable usage of Work Authority API */
  enableWorkAuthority: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};


/** Feature flags enabled on a Work */
export type WorkFeaturesEnableFontControlsArgs = {
  assessmentId: Scalars['ID']['input'];
};

/** A Working Group of students in a group assessment. */
export type WorkGroup = {
  __typename?: 'WorkGroup';
  /** Group's charter, if created */
  charter: Maybe<Charter>;
  /** Finalised status of the current group. */
  finalised: Scalars['Boolean']['output'];
  /** Student's current group in the Assessment. */
  group: Group;
  id: Scalars['ID']['output'];
  /** Student's individual Work, if created. */
  individualWork: Maybe<Work>;
  /**
   * ID for Individual work report if enabled for the group assessment.
   * @deprecated Use `individual_work` edge.
   */
  individualWorkId: Maybe<Scalars['ID']['output']>;
  /** Latest group change request of the current user. */
  latestGroupChangeRequest: Maybe<Message>;
  /** Group's Work document, if created. */
  work: Maybe<Work>;
};


/** A Working Group of students in a group assessment. */
export type WorkGroupLatestGroupChangeRequestArgs = {
  assessmentId: Scalars['ID']['input'];
};

export enum WorkItemKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL'
}

/** Outcome recorded for a student's work. */
export type WorkOutcome = {
  __typename?: 'WorkOutcome';
  /** Answer blocks seen by the connected Work. */
  answerBlocks: Array<AnswerBlock>;
  assessmentId: Scalars['ID']['output'];
  /** If there are FieldOutcomes still being automarked. */
  automarkPending: Maybe<Scalars['Boolean']['output']>;
  /** Current SubmissionOutcome for the DRAFT submission. */
  draftSubmissionOutcome: Maybe<SubmissionOutcome>;
  /** Released SubmissionOutcome for the draft Submission. */
  draftSubmissionOutcomeRelease: Maybe<SubmissionOutcomeRelease>;
  /** Indicates whether final feedback has been released for the work outcome. */
  feedbackReleased: Scalars['Boolean']['output'];
  feedbackReleasedTimestamp: Maybe<Scalars['DateTime']['output']>;
  finalRelease: Maybe<WorkOutcomeRelease>;
  /** The final score of the most recent final feedback. */
  finalScore: Maybe<Scalars['Float']['output']>;
  /** The final score penalty of the most recent final feedback. */
  finalScorePenalty: Maybe<Scalars['Float']['output']>;
  /** Current SubmissionOutcome for the FINAL submission. */
  finalSubmissionOutcome: Maybe<SubmissionOutcome>;
  groupId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** SubmissionOutcome for the FINAL submission for the assigned marker. */
  markingSubmissionOutcome: Maybe<SubmissionOutcome>;
  maxScore: Scalars['Int']['output'];
  moderationPenaltyRules: Array<ModerationPenaltyRule>;
  /**
   * SubmissionOutcomes for the FINAL submission used during moderation.
   * Only available when double-blind marking is enabled.
   *
   * ## Visibility rules:
   * - `:primary` and `:secondary` outcomes are only returned once both markers have fully
   *   submitted their marking (both `score` and `completed_at` must be set).
   *
   * - Other scopes (`:main`, `:average`, `:custom`) are always returned if existing.
   */
  moderationSubmissionOutcomes: Array<SubmissionOutcome>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  /**
   * SubmissionOutcomes for the FINAL submission used in progress table.
   * Used in double marking.
   */
  progressSubmissionOutcomes: Array<ProgressSubmissionOutcome>;
  provisionalRelease: Maybe<WorkOutcomeRelease>;
  questionOutcomes: Array<QuestionOutcome>;
  /**
   * Whether every active QuestionOutcome's FieldOutcome has a score.
   * If there are no QuestionOutcomes, returns `true`.
   */
  questionOutcomesScored: Scalars['Boolean']['output'];
  /** Score breakdown for the SubmissionOutcome for the final Submission. */
  scoreBreakdown: ScoreBreakdown;
  /** The student whose work this outcome belongs to. `nil` for group outcomes. */
  student: Maybe<User>;
  studentId: Maybe<Scalars['ID']['output']>;
  /** The past 5 SubmissionOutcomes with MAIN marker scope including latest. */
  submissionOutcomes: Array<SubmissionOutcome>;
  workId: Scalars['ID']['output'];
  /** Released WorkOutcome for the final Submission. */
  workOutcomeRelease: Maybe<WorkOutcomeRelease>;
};

/**
 * Per-question scores for a single WorkOutcome, used to compute question
 * performance metrics in moderation.
 */
export type WorkOutcomeQuestionScores = {
  __typename?: 'WorkOutcomeQuestionScores';
  id: Scalars['ID']['output'];
  questionScores: Array<QuestionScore>;
  workOutcomeId: Scalars['ID']['output'];
};

/**
 * WorkOutcomeRelease represents a snapshot of a WorkOutcome at the time of feedback release.
 * Each release event (provisional or final) creates a new WorkOutcomeRelease record.
 *
 * This edge can also be resolve by any `WorkOutcomeRelease.t()`.
 */
export type WorkOutcomeRelease = {
  __typename?: 'WorkOutcomeRelease';
  feedbackVisibility: FeedbackVisibility;
  finalScore: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  moderationPenaltyRules: Array<ModerationPenaltyRule>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  penaltyScore: Scalars['Float']['output'];
  questionOutcomeReleases: Array<QuestionOutcomeRelease>;
  releaseType: FeedbackReleaseType;
  releasedAt: Scalars['DateTime']['output'];
  submissionOutcomeRelease: Maybe<SubmissionOutcomeRelease>;
};

export type WorkProgress = {
  __typename?: 'WorkProgress';
  groupStatistics: ProgressStatistics;
  individualStatistics: ProgressStatistics;
  items: Array<WorkProgressItem>;
};

export type WorkProgressItem = {
  __typename?: 'WorkProgressItem';
  entityId: Scalars['ID']['output'];
  kind: WorkItemKind;
  lastEventTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  members: Array<MemberProgress>;
  overallStatus: ProgressStatus;
};

/** Settings for a work */
export type WorkSettings = {
  __typename?: 'WorkSettings';
  assessmentId: Scalars['ID']['output'];
  draftExamEndDate: Maybe<Scalars['String']['output']>;
  draftExamStartDate: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examDeferred: Maybe<Scalars['Boolean']['output']>;
  examEndDate: Maybe<Scalars['DateTime']['output']>;
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examStartDate: Maybe<Scalars['DateTime']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  groupId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  lastUpdatedBy: Maybe<User>;
  studentId: Maybe<Scalars['ID']['output']>;
  submitAttemptLimit: Maybe<Scalars['Int']['output']>;
  timeLimit: Maybe<Scalars['Int']['output']>;
  updateReason: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  vivaExtraAttempts: Maybe<Scalars['Int']['output']>;
  vivaExtraPrepSeconds: Maybe<Scalars['Int']['output']>;
  vivaExtraResponseSeconds: Maybe<Scalars['Int']['output']>;
};

export type WorkVersion = {
  __typename?: 'WorkVersion';
  answerBlockId: Scalars['ID']['output'];
  author: Maybe<WorkVersionAuthor>;
  id: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type WorkVersionAuthor = {
  __typename?: 'WorkVersionAuthor';
  name: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type WorkVersionConnection = {
  __typename?: 'WorkVersionConnection';
  nodes: Array<WorkVersion>;
  pageInfo: PageInfo;
};

export type FeatureFlagsFragment = { __typename?: 'InstitutionFeatures', id: string, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, turnitin: boolean, groupAssessment: boolean, extensionSyncing: boolean };

export type InstitutionFragment = { __typename?: 'Institution', id: string, customDeclarationText: string | null };

export type SessionFragment = { __typename?: 'Session', id: string, verified: boolean };

export type UserFragment = { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null };

export type ApiTokenQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
}>;


export type ApiTokenQuery = { __typename?: 'RootQueryType', apiToken: string };

export type AssessmentFragment = { __typename?: 'Assessment', id: string, name: string, subjectName: string, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, groupDraftEnabled: boolean, groupDraftDueDate: string | null, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, rubricDisplayDisabled: boolean, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examSchoolyearEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupChangeRequestsEnabled: boolean, groupChangeRequestCutoff: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckScheduleType: SentimentCheckScheduleType, sentimentCheckFirstCheckAt: string | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, groupCharterEnabled: boolean, groupCharterAvailable: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null } | null };

export type AssessmentMarkerRubricsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentMarkerRubricsQuery = { __typename?: 'RootQueryType', assessmentMarkerRubrics: Array<{ __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, location: { __typename?: 'MarkerRubricLocation', questionId: string | null } }> };

export type AssessmentQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', id: string, verified: boolean }, institution: { __typename?: 'Institution', id: string, customDeclarationText: string | null }, me: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, groupDraftEnabled: boolean, groupDraftDueDate: string | null, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, rubricDisplayDisabled: boolean, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examSchoolyearEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupChangeRequestsEnabled: boolean, groupChangeRequestCutoff: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckScheduleType: SentimentCheckScheduleType, sentimentCheckFirstCheckAt: string | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, groupCharterEnabled: boolean, groupCharterAvailable: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null } | null } };

export type AssessmentSettingsFragment = { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, groupDraftEnabled: boolean, groupDraftDueDate: string | null, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, rubricDisplayDisabled: boolean, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examSchoolyearEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupChangeRequestsEnabled: boolean, groupChangeRequestCutoff: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckScheduleType: SentimentCheckScheduleType, sentimentCheckFirstCheckAt: string | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, groupCharterEnabled: boolean, groupCharterAvailable: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null };

export type AssessmentSettingsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentSettingsQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, groupDraftEnabled: boolean, groupDraftDueDate: string | null, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, rubricDisplayDisabled: boolean, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examSchoolyearEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupChangeRequestsEnabled: boolean, groupChangeRequestCutoff: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckScheduleType: SentimentCheckScheduleType, sentimentCheckFirstCheckAt: string | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, groupCharterEnabled: boolean, groupCharterAvailable: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null } | null } };

export type OnAssessmentSettingsUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type OnAssessmentSettingsUpdatedSubscription = { __typename?: 'RootSubscriptionType', assessmentSettingsUpdated: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, groupDraftEnabled: boolean, groupDraftDueDate: string | null, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, rubricDisplayDisabled: boolean, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examSchoolyearEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupChangeRequestsEnabled: boolean, groupChangeRequestCutoff: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckScheduleType: SentimentCheckScheduleType, sentimentCheckFirstCheckAt: string | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, groupCharterEnabled: boolean, groupCharterAvailable: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null } };

export type OnFutureReleaseScheduleSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type OnFutureReleaseScheduleSubscription = { __typename?: 'RootSubscriptionType', futureReleaseSchedule: string | null };

export type InstructionSheetQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  taskKind: InputMaybe<TaskKind>;
}>;


export type InstructionSheetQuery = { __typename?: 'RootQueryType', instructionSheet: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, content: string, version: number } | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } | null };

export type MarkerRubricQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  kind: MarkerRubricKind;
}>;


export type MarkerRubricQuery = { __typename?: 'RootQueryType', markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, hideScores: boolean, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }>, location: { __typename?: 'MarkerRubricLocation', path: string, questionId: string | null } } | null };

export type PublishedMarkerRubricQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
}>;


export type PublishedMarkerRubricQuery = { __typename?: 'RootQueryType', publishedMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, hideScores: boolean, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }>, location: { __typename?: 'MarkerRubricLocation', path: string, questionId: string | null } } | null };

export type ResourceFragment = { __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null };

export type SheetFragment = { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, content: string, version: number } | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> };

export type SheetQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type SheetQuery = { __typename?: 'RootQueryType', work: { __typename?: 'Work', id: string, attemptCount: number, startDate: string | null, group: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, minLimit: number | null, finalised: boolean, groupMembers: Array<{ __typename?: 'GroupMember', id: string, isActive: boolean, user: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null } | null }> } | null, settings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examWritingTime: number | null, examDeferred: boolean | null, submitAttemptLimit: number | null } | null, student: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }, sheet: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, content: string, version: number } | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } | null } };

export type OnSheetReleasedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
}>;


export type OnSheetReleasedSubscription = { __typename?: 'RootSubscriptionType', sheetReleased: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, content: string, version: number } | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } };

export type TaskBlockFragment = { __typename?: 'TaskBlock', id: string, order: number | null, orderLabel: string | null, points: number | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null };

export type TaskNoticeFragment = { __typename?: 'TaskNotice', id: string, content: string, version: number };

export type WorkGenaiGuidelineNoticeFragment = { __typename?: 'Work', sheet: { __typename?: 'Sheet', genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, content: string, version: number } | null } | null };

export type CommentReleaseFragment = { __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } };

export type ComponentBreakdownFragment = { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null };

export type CriterionOutcomeReleaseFragment = { __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string };

export type DownloadWorkAttachmentsMutationVariables = Exact<{
  answerBlockId: Scalars['ID']['input'];
  blockAttachmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DownloadWorkAttachmentsMutation = { __typename?: 'RootMutationType', downloadWorkAttachments: string };

export type FeedbackCriterionFragment = { __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> };

export type FeedbackQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type FeedbackQuery = { __typename?: 'RootQueryType', token: string, session: { __typename?: 'Session', id: string }, me: { __typename?: 'User', id: string }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, tasks: Array<{ __typename?: 'Task', id: string, kind: TaskKind, instructionSheet: { __typename?: 'Sheet', id: string, format: TaskFormat } | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, groupDraftEnabled: boolean, groupDraftDueDate: string | null, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, rubricDisplayDisabled: boolean, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examSchoolyearEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupChangeRequestsEnabled: boolean, groupChangeRequestCutoff: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckScheduleType: SentimentCheckScheduleType, sentimentCheckFirstCheckAt: string | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, groupCharterEnabled: boolean, groupCharterAvailable: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null } | null } };

export type FeedbackSummaryQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type FeedbackSummaryQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, groupDraftEnabled: boolean, groupDraftDueDate: string | null, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, rubricDisplayDisabled: boolean, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examSchoolyearEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupChangeRequestsEnabled: boolean, groupChangeRequestCutoff: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckScheduleType: SentimentCheckScheduleType, sentimentCheckFirstCheckAt: string | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, groupCharterEnabled: boolean, groupCharterAvailable: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null } | null }, finalFeedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, provisionalFeedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, turnitin: boolean, groupAssessment: boolean, extensionSyncing: boolean }, studentOutcome: { __typename?: 'StudentOutcome', id: string, studentId: string, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, draftSubmissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, finalScore: number | null, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, draftSubmissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string } | null } | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, isComplete: boolean | null, peerMaxScore: number | null, selfMaxScore: number | null, peerScore: number | null, selfScore: number | null, groupReportScaleFactor: number | null } | null, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, modifiersTotal: number, moderatorModifier: number, penaltyScore: number } | null } } };

export type FeedbackVisibilityFragment = { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType };

export type FieldOutcomeReleaseFragment = { __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> };

export type GroupFeedbackQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupFeedbackQuery = { __typename?: 'RootQueryType', individualMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, hideScores: boolean, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }>, location: { __typename?: 'MarkerRubricLocation', path: string, questionId: string | null } } | null, groupMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, hideScores: boolean, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }>, location: { __typename?: 'MarkerRubricLocation', path: string, questionId: string | null } } | null, peerMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, hideScores: boolean, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }>, location: { __typename?: 'MarkerRubricLocation', path: string, questionId: string | null } } | null, studentWorkGroup: { __typename?: 'WorkGroup', id: string, group: { __typename?: 'Group', id: string, activeGroupMembers: Array<{ __typename?: 'GroupMember', id: string, user: { __typename?: 'User', id: string, name: string } | null }> } } | null, studentOutcome: { __typename?: 'StudentOutcome', id: string, studentId: string, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, assessmentId: string, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, draftSubmissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, points: number | null, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, assessmentId: string, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, draftSubmissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, points: number | null, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, peerMaxScore: number | null, selfMaxScore: number | null, peerScore: number | null, selfScore: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> } | null }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, turnitin: boolean, groupAssessment: boolean, extensionSyncing: boolean } };

export type IndividualFeedbackQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type IndividualFeedbackQuery = { __typename?: 'RootQueryType', individualMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, hideScores: boolean, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }>, location: { __typename?: 'MarkerRubricLocation', path: string, questionId: string | null } } | null, studentWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, assessmentId: string, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, draftSubmissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, points: number | null, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, featureFlags: { __typename?: 'InstitutionFeatures', id: string, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, turnitin: boolean, groupAssessment: boolean, extensionSyncing: boolean } };

export type MarkerRubricFragment = { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, hideScores: boolean, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }>, location: { __typename?: 'MarkerRubricLocation', path: string, questionId: string | null } };

export type MfaFeedbackQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type MfaFeedbackQuery = { __typename?: 'RootQueryType', assessmentMarkerRubrics: Array<{ __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, hideScores: boolean, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }>, location: { __typename?: 'MarkerRubricLocation', path: string, questionId: string | null } }>, studentWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, assessmentId: string, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, draftSubmissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, points: number | null, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, featureFlags: { __typename?: 'InstitutionFeatures', id: string, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, turnitin: boolean, groupAssessment: boolean, extensionSyncing: boolean } };

export type QuestionOutcomeReleaseFragment = { __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null };

export type ReceivedPeerOutcomeFragment = { __typename?: 'PeerOutcome', id: string, targetUserId: string, peerMaxScore: number | null, selfMaxScore: number | null, peerScore: number | null, selfScore: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> };

export type SimilarityQueryVariables = Exact<{
  submissionType: SubmissionType;
  workId: Scalars['ID']['input'];
}>;


export type SimilarityQuery = { __typename?: 'RootQueryType', latestResult: { __typename?: 'Result', id: string, workId: string, heraResultId: number | null, returnedAt: string | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null } };

export type StudentOutcomeFragment = { __typename?: 'StudentOutcome', id: string, studentId: string, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, assessmentId: string, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, draftSubmissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, points: number | null, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, assessmentId: string, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, draftSubmissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, points: number | null, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, peerMaxScore: number | null, selfMaxScore: number | null, peerScore: number | null, selfScore: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> } | null };

export type SubmissionOutcomeReleaseFragment = { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> };

export type ThreadReleaseFragment = { __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> };

export type WorkOutcomeFragment = { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, assessmentId: string, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, draftSubmissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, points: number | null, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> };

export type WorkOutcomeReleaseFragment = { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number | null, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null };

export type AcceptStudentCharterMutationVariables = Exact<{
  input: CharterAgreementInput;
}>;


export type AcceptStudentCharterMutation = { __typename?: 'RootMutationType', acceptStudentCharter: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } };

export type CharterAgreementFragment = { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null };

export type CharterEditorFragment = { __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string };

export type CharterFormFragment = { __typename?: 'CharterForm', id: string, published: boolean, publishTimestamp: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, type: CharterFormSectionType, deleted: boolean, enabled: boolean, promptDoc: string | null, rank: number | null, title: string | null, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', id: string, description: string | null, dueDate: string | null, title: string | null }> | null }> };

export type CharterFragment = { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, latestAgreement: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } | null, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null }> };

export type CharterMilestoneFragment = { __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean };

export type CharterQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  charterId: Scalars['ID']['input'];
}>;


export type CharterQuery = { __typename?: 'RootQueryType', token: string, charter: { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, latestAgreement: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } | null, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null }> }, charterForm: { __typename?: 'CharterForm', id: string, published: boolean, publishTimestamp: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, type: CharterFormSectionType, deleted: boolean, enabled: boolean, promptDoc: string | null, rank: number | null, title: string | null, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', id: string, description: string | null, dueDate: string | null, title: string | null }> | null }> } | null };

export type CharterStatusQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type CharterStatusQuery = { __typename?: 'RootQueryType', studentWorkGroup: { __typename?: 'WorkGroup', charter: { __typename?: 'Charter', allMembersAccepted: boolean } | null } | null };

export type SaveCharterEditorMutationVariables = Exact<{
  input: CharterEditorInput;
}>;


export type SaveCharterEditorMutation = { __typename?: 'RootMutationType', saveCharterEditor: { __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string } };

export type SetupCharterMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;


export type SetupCharterMutation = { __typename?: 'RootMutationType', setupCharter: { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, latestAgreement: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } | null, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null }> } };

export type UnlockStudentCharterMutationVariables = Exact<{
  input: CharterAgreementInput;
}>;


export type UnlockStudentCharterMutation = { __typename?: 'RootMutationType', unlockStudentCharter: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } };

export type UpdateMilestonesMutationVariables = Exact<{
  input: UpdateMilestonesInput;
}>;


export type UpdateMilestonesMutation = { __typename?: 'RootMutationType', updateMilestones: { __typename?: 'Charter', id: string, milestones: Array<{ __typename?: 'CharterMilestone', deleted: boolean, description: string | null, dueDate: string, id: string | null, title: string }> } };

export type AssessmentEmailConsentQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentEmailConsentQuery = { __typename?: 'RootQueryType', assessmentEmailConsent: { __typename?: 'AssessmentEmailConsent', enabled: boolean, consent: boolean | null } };

export type FinaliseGroupMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type FinaliseGroupMutation = { __typename?: 'RootMutationType', finaliseGroup: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, minLimit: number | null, finalised: boolean, groupMembers: Array<{ __typename?: 'GroupMember', id: string, isActive: boolean, user: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null } | null }> } };

export type GroupFragment = { __typename?: 'Group', id: string, name: string, maxLimit: number | null, minLimit: number | null, finalised: boolean, groupMembers: Array<{ __typename?: 'GroupMember', id: string, isActive: boolean, user: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null } | null }> };

export type GroupUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupUpdatedSubscription = { __typename?: 'RootSubscriptionType', groupUpdated: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, minLimit: number | null, finalised: boolean, groupMembers: Array<{ __typename?: 'GroupMember', id: string, isActive: boolean, user: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null } | null }> } };

export type ListGroupsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ListGroupsQuery = { __typename?: 'RootQueryType', token: string, groupList: Array<{ __typename?: 'Group', id: string, name: string, maxLimit: number | null, minLimit: number | null, finalised: boolean, groupMembers: Array<{ __typename?: 'GroupMember', id: string, isActive: boolean, user: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null } | null }> }>, me: { __typename?: 'User', id: string, name: string }, assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean } | null } };

export type JoinGroupMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type JoinGroupMutation = { __typename?: 'RootMutationType', joinGroup: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, minLimit: number | null, finalised: boolean, groupMembers: Array<{ __typename?: 'GroupMember', id: string, isActive: boolean, user: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null } | null }> } };

export type LeaveGroupMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type LeaveGroupMutation = { __typename?: 'RootMutationType', leaveGroup: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, minLimit: number | null, finalised: boolean, groupMembers: Array<{ __typename?: 'GroupMember', id: string, isActive: boolean, user: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null } | null }> } };

export type SetAssessmentEmailConsentMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  consent: Scalars['Boolean']['input'];
}>;


export type SetAssessmentEmailConsentMutation = { __typename?: 'RootMutationType', setAssessmentEmailConsent: { __typename?: 'AssessmentEmailConsent', enabled: boolean, consent: boolean | null } };

export type MessageFragment = { __typename?: 'Message', id: string, messageType: MessageRequestType, reason: string | null, status: GroupChangeRequestStatus, decision: GroupChangeDecision | null, decisionNote: string | null, decidedAt: string | null, expiresAt: string | null, insertedAt: string };

export type PeerOverviewQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type PeerOverviewQuery = { __typename?: 'RootQueryType', me: { __typename?: 'User', id: string, name: string }, assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', selfEvaluationEnabled: boolean, groupCharterEnabled: boolean, groupCharterAvailable: boolean, groupCharterAcceptanceRequired: boolean, peerEvaluationDueDate: string | null, dueDate: string | null } | null }, peerRubric: { __typename?: 'MarkerRubric', id: string, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, studentWorkGroup: { __typename?: 'WorkGroup', id: string, work: { __typename?: 'Work', id: string, settings: { __typename?: 'WorkSettings', id: string, dueDate: string | null } | null } | null, charter: { __typename?: 'Charter', latestAgreement: { __typename?: 'CharterAgreement', id: string, acceptedAt: string } | null } | null, group: { __typename?: 'Group', id: string, activeGroupMembers: Array<{ __typename?: 'GroupMember', id: string, user: { __typename?: 'User', id: string, name: string } | null }> } } | null, groupPeerOutcomes: Array<{ __typename?: 'PeerOutcome', id: string, targetUserId: string, feedbackReleasedTimestamp: string | null, givenCriterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> }>, studentPeerEvalProgress: { __typename?: 'StudentPeerEvalProgress', hasEvaluatedAllPeers: boolean, hasCompletedSelfEvaluation: boolean } | null };

export type ProjectIssueFragment = { __typename?: 'ProjectIssue', id: string, groupId: string, title: string, type: IssueType, status: IssueStatus, deleted: boolean, description: string | null, dueDate: string | null, parentId: string | null, assignees: Array<string> };

export type ProjectIssuesQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;


export type ProjectIssuesQuery = { __typename?: 'RootQueryType', projectIssues: Array<{ __typename?: 'ProjectIssue', id: string, title: string, type: IssueType, status: IssueStatus, groupId: string, deleted: boolean, description: string | null, dueDate: string | null, parentId: string | null, assignees: Array<string> }> };

export type UpdateProjectIssueMutationVariables = Exact<{
  input: UpdateProjectIssueInput;
}>;


export type UpdateProjectIssueMutation = { __typename?: 'RootMutationType', updateProjectIssue: Array<{ __typename?: 'ProjectIssue', id: string, title: string, type: IssueType, status: IssueStatus, deleted: boolean, description: string | null, dueDate: string | null, assignees: Array<string>, parentId: string | null }> };

export type SendMessageMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  message: MessageInput;
}>;


export type SendMessageMutation = { __typename?: 'RootMutationType', sendMessage: { __typename?: 'Message', id: string, messageType: MessageRequestType, reason: string | null, status: GroupChangeRequestStatus, decision: GroupChangeDecision | null, decisionNote: string | null, decidedAt: string | null, expiresAt: string | null, insertedAt: string } };

export type SetupGroupWorkMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;


export type SetupGroupWorkMutation = { __typename?: 'RootMutationType', setupGroupWork: { __typename?: 'WorkGroup', id: string, work: { __typename?: 'Work', id: string } | null } };

export type StudentActionFeedQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type StudentActionFeedQuery = { __typename?: 'RootQueryType', studentActionFeed: { __typename?: 'StudentActionFeed', state: StudentActionFeedState, badgeCount: number, groupWorkViewed: boolean | null, individualWorkViewed: boolean | null, peerEvaluationViewed: boolean | null, actions: Array<{ __typename?: 'Notification', type: string, tier: number | null, tone: NotificationTone | null, title: string, detail: string, action: { __typename?: 'NotificationAction', label: string, targetKind: NotificationTargetKind | null } | null }>, waitingOnOthers: Array<{ __typename?: 'Notification', type: string, title: string, detail: string }> } | null };

export type UpdateGroupChangeRequestMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type UpdateGroupChangeRequestMutation = { __typename?: 'RootMutationType', updateGroupChangeRequest: { __typename?: 'Message', id: string, messageType: MessageRequestType, reason: string | null, status: GroupChangeRequestStatus, decision: GroupChangeDecision | null, decisionNote: string | null, decidedAt: string | null, expiresAt: string | null, insertedAt: string } };

export type WithdrawGroupChangeRequestMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
}>;


export type WithdrawGroupChangeRequestMutation = { __typename?: 'RootMutationType', withdrawGroupChangeRequest: { __typename?: 'Message', id: string, messageType: MessageRequestType, reason: string | null, status: GroupChangeRequestStatus, decision: GroupChangeDecision | null, decisionNote: string | null, decidedAt: string | null, expiresAt: string | null, insertedAt: string } };

export type WorkGroupQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type WorkGroupQuery = { __typename?: 'RootQueryType', studentWorkGroup: { __typename?: 'WorkGroup', id: string, finalised: boolean, latestGroupChangeRequest: { __typename?: 'Message', id: string, messageType: MessageRequestType, reason: string | null, status: GroupChangeRequestStatus, decision: GroupChangeDecision | null, decisionNote: string | null, decidedAt: string | null, expiresAt: string | null, insertedAt: string } | null, charter: { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, latestAgreement: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } | null, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null }> } | null, group: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, minLimit: number | null, finalised: boolean, groupMembers: Array<{ __typename?: 'GroupMember', id: string, isActive: boolean, user: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null } | null }> }, work: { __typename?: 'Work', id: string, result: { __typename?: 'Result', id: string, heraResultId: number | null, workId: string, canvasResultUrl: string | null, moodleGraderUrl: string | null, submissionType: SubmissionType, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null, receipt: { __typename?: 'GradebookReceipt', lmsComplete: boolean } | null } | null, settings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examWritingTime: number | null, examDeferred: boolean | null, submitAttemptLimit: number | null } | null } | null, individualWork: { __typename?: 'Work', id: string, result: { __typename?: 'Result', id: string, heraResultId: number | null, workId: string, canvasResultUrl: string | null, moodleGraderUrl: string | null, submissionType: SubmissionType, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null, receipt: { __typename?: 'GradebookReceipt', lmsComplete: boolean } | null } | null, settings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examWritingTime: number | null, examDeferred: boolean | null, submitAttemptLimit: number | null } | null } | null } | null };

export type CompletePeerOutcomesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type CompletePeerOutcomesMutation = { __typename?: 'RootMutationType', completePeerOutcomes: Array<{ __typename?: 'PeerOutcome', id: string, targetUserId: string, feedbackReleasedTimestamp: string | null, givenCriterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> }> };

export type CriterionFragment = { __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> };

export type CriterionOutcomeFragment = { __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null };

export type FeedbackThreadFragment = { __typename?: 'Thread', id: string, entityId: string | null, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> };

export type GroupPeerOutcomeFragment = { __typename?: 'PeerOutcome', id: string, targetUserId: string, feedbackReleasedTimestamp: string | null, givenCriterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> };

export type LearningOutcomeSkillFragment = { __typename?: 'LearningOutcomeSkill', id: string, skill: string };

export type MarkPeerOutcomeMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: MarkPeerOutcomeInput;
}>;


export type MarkPeerOutcomeMutation = { __typename?: 'RootMutationType', markPeerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, feedbackReleasedTimestamp: string | null, givenCriterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> } };

export type PeerAssessmentQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type PeerAssessmentQuery = { __typename?: 'RootQueryType', me: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }, studentWorkGroup: { __typename?: 'WorkGroup', id: string, group: { __typename?: 'Group', id: string, activeGroupMembers: Array<{ __typename?: 'GroupMember', id: string, user: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null } | null }> } } | null, peerRubric: { __typename?: 'MarkerRubric', id: string, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, groupPeerOutcomes: Array<{ __typename?: 'PeerOutcome', id: string, targetUserId: string, feedbackReleasedTimestamp: string | null, givenCriterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> }>, instructionSheet: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, content: string, version: number } | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } | null };

export type ResetGivenEvaluationsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ResetGivenEvaluationsMutation = { __typename?: 'RootMutationType', resetCriterionOutcomes: number };

export type ScaleItemFragment = { __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null };

export type SentimentCheckFragment = { __typename?: 'SentimentCheck', id: string, comment: string | null, skipped: boolean, level: SentimentCheckLevel | null, sessionId: string, insertedAt: string | null };

export type StudentSentimentChecksQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type StudentSentimentChecksQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', sentimentCheckSkipEnabled: boolean } | null }, studentSentimentChecks: Array<{ __typename?: 'SentimentCheckInterval', order: number, startTime: string, endTime: string, sentimentCheck: { __typename?: 'SentimentCheck', id: string, comment: string | null, skipped: boolean, level: SentimentCheckLevel | null, sessionId: string, insertedAt: string | null } | null }> };

export type SubmitSentimentCheckMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: SentimentCheckInput;
}>;


export type SubmitSentimentCheckMutation = { __typename?: 'RootMutationType', submitSentimentCheck: { __typename?: 'SentimentCheck', id: string, comment: string | null, skipped: boolean, level: SentimentCheckLevel | null, sessionId: string, insertedAt: string | null } };

export type CompleteSocraticTurnMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  input: CompleteSocraticTurnInput;
}>;


export type CompleteSocraticTurnMutation = { __typename?: 'RootMutationType', completeSocraticTurn: { __typename?: 'CompleteSocraticTurnPayload', error: CompleteSocraticTurnError | null, dialogue: { __typename?: 'SocraticDialogue', id: string, maxTurns: number, attemptNumber: number, startedAt: string | null, expiredAt: string | null, readingTimeSeconds: number, responseTimeSeconds: number, turns: Array<{ __typename?: 'SocraticTurn', id: string, order: number, questionPrompt: string | null, recordingStartedAt: string | null, recordingCompletedAt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null }> } | null } };

export type CreateSocraticDialogueMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  attemptNumber: Scalars['Int']['input'];
}>;


export type CreateSocraticDialogueMutation = { __typename?: 'RootMutationType', createSocraticDialogue: { __typename?: 'CreateSocraticDialoguePayload', error: CreateSocraticDialogueError | null, session: { __typename?: 'SocraticSession', id: string, maxAttempts: number, readingTimeSeconds: number | null, responseTimeSeconds: number | null, reattemptWindowEndsAt: string | null, reattemptWindowSeconds: number | null, answerBlock: { __typename?: 'AnswerBlock', id: string, blockName: string | null, points: number | null, skip: boolean | null, bookmark: boolean | null, order: number | null, orderLabel: string | null, nodeId: string, shuffle: boolean | null, parentNodeId: string | null, confirm: boolean | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }, dialogues: Array<{ __typename?: 'SocraticDialogue', id: string, maxTurns: number, attemptNumber: number, startedAt: string | null, expiredAt: string | null, readingTimeSeconds: number, responseTimeSeconds: number, turns: Array<{ __typename?: 'SocraticTurn', id: string, order: number, questionPrompt: string | null, recordingStartedAt: string | null, recordingCompletedAt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null }> }> } | null } };

export type RecordSocraticTurnPreparationMediaMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  input: RecordSocraticTurnPreparationMediaInput;
}>;


export type RecordSocraticTurnPreparationMediaMutation = { __typename?: 'RootMutationType', recordSocraticTurnPreparationMedia: { __typename?: 'RecordSocraticTurnPreparationMediaPayload', error: RecordSocraticTurnPreparationMediaError | null, turn: { __typename?: 'SocraticTurn', id: string } | null } };

export type SocraticDialogueFragment = { __typename?: 'SocraticDialogue', id: string, maxTurns: number, attemptNumber: number, startedAt: string | null, expiredAt: string | null, readingTimeSeconds: number, responseTimeSeconds: number, turns: Array<{ __typename?: 'SocraticTurn', id: string, order: number, questionPrompt: string | null, recordingStartedAt: string | null, recordingCompletedAt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null }> };

export type SocraticDialogueQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  dialogueId: Scalars['ID']['input'];
}>;


export type SocraticDialogueQuery = { __typename?: 'RootQueryType', socraticDialogue: { __typename?: 'SocraticDialogue', id: string, maxTurns: number, attemptNumber: number, startedAt: string | null, expiredAt: string | null, readingTimeSeconds: number, responseTimeSeconds: number, turns: Array<{ __typename?: 'SocraticTurn', id: string, order: number, questionPrompt: string | null, recordingStartedAt: string | null, recordingCompletedAt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null }> } | null };

export type SocraticSessionFragment = { __typename?: 'SocraticSession', id: string, maxAttempts: number, readingTimeSeconds: number | null, responseTimeSeconds: number | null, reattemptWindowEndsAt: string | null, reattemptWindowSeconds: number | null, answerBlock: { __typename?: 'AnswerBlock', id: string, blockName: string | null, points: number | null, skip: boolean | null, bookmark: boolean | null, order: number | null, orderLabel: string | null, nodeId: string, shuffle: boolean | null, parentNodeId: string | null, confirm: boolean | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }, dialogues: Array<{ __typename?: 'SocraticDialogue', id: string, maxTurns: number, attemptNumber: number, startedAt: string | null, expiredAt: string | null, readingTimeSeconds: number, responseTimeSeconds: number, turns: Array<{ __typename?: 'SocraticTurn', id: string, order: number, questionPrompt: string | null, recordingStartedAt: string | null, recordingCompletedAt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null }> }> };

export type SocraticSessionQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
}>;


export type SocraticSessionQuery = { __typename?: 'RootQueryType', socraticSession: { __typename?: 'SocraticSession', id: string, maxAttempts: number, readingTimeSeconds: number | null, responseTimeSeconds: number | null, reattemptWindowEndsAt: string | null, reattemptWindowSeconds: number | null, answerBlock: { __typename?: 'AnswerBlock', id: string, blockName: string | null, points: number | null, skip: boolean | null, bookmark: boolean | null, order: number | null, orderLabel: string | null, nodeId: string, shuffle: boolean | null, parentNodeId: string | null, confirm: boolean | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }, dialogues: Array<{ __typename?: 'SocraticDialogue', id: string, maxTurns: number, attemptNumber: number, startedAt: string | null, expiredAt: string | null, readingTimeSeconds: number, responseTimeSeconds: number, turns: Array<{ __typename?: 'SocraticTurn', id: string, order: number, questionPrompt: string | null, recordingStartedAt: string | null, recordingCompletedAt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null }> }> } };

export type SocraticTurnFragment = { __typename?: 'SocraticTurn', id: string, order: number, questionPrompt: string | null, recordingStartedAt: string | null, recordingCompletedAt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null };

export type StartSocraticDialogueMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  dialogueId: Scalars['ID']['input'];
}>;


export type StartSocraticDialogueMutation = { __typename?: 'RootMutationType', startSocraticDialogue: { __typename?: 'StartSocraticDialoguePayload', error: StartSocraticDialogueError | null, session: { __typename?: 'SocraticSession', id: string, maxAttempts: number, readingTimeSeconds: number | null, responseTimeSeconds: number | null, reattemptWindowEndsAt: string | null, reattemptWindowSeconds: number | null, answerBlock: { __typename?: 'AnswerBlock', id: string, blockName: string | null, points: number | null, skip: boolean | null, bookmark: boolean | null, order: number | null, orderLabel: string | null, nodeId: string, shuffle: boolean | null, parentNodeId: string | null, confirm: boolean | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }, dialogues: Array<{ __typename?: 'SocraticDialogue', id: string, maxTurns: number, attemptNumber: number, startedAt: string | null, expiredAt: string | null, readingTimeSeconds: number, responseTimeSeconds: number, turns: Array<{ __typename?: 'SocraticTurn', id: string, order: number, questionPrompt: string | null, recordingStartedAt: string | null, recordingCompletedAt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null }> }> } | null, dialogue: { __typename?: 'SocraticDialogue', id: string, maxTurns: number, attemptNumber: number, startedAt: string | null, expiredAt: string | null, readingTimeSeconds: number, responseTimeSeconds: number, turns: Array<{ __typename?: 'SocraticTurn', id: string, order: number, questionPrompt: string | null, recordingStartedAt: string | null, recordingCompletedAt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null }> } | null } };

export type StartSocraticTurnMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  turnId: Scalars['ID']['input'];
  recordingStartedAt: InputMaybe<Scalars['PreciseDateTime']['input']>;
}>;


export type StartSocraticTurnMutation = { __typename?: 'RootMutationType', startSocraticTurn: { __typename?: 'StartSocraticTurnPayload', dialogue: { __typename?: 'SocraticDialogue', id: string, maxTurns: number, attemptNumber: number, startedAt: string | null, expiredAt: string | null, readingTimeSeconds: number, responseTimeSeconds: number, turns: Array<{ __typename?: 'SocraticTurn', id: string, order: number, questionPrompt: string | null, recordingStartedAt: string | null, recordingCompletedAt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null }> } | null } };

export type AnswerBlockFragment = { __typename?: 'AnswerBlock', id: string, blockName: string | null, points: number | null, skip: boolean | null, bookmark: boolean | null, order: number | null, orderLabel: string | null, nodeId: string, shuffle: boolean | null, parentNodeId: string | null, confirm: boolean | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> };

export type BlockAttachmentFragment = { __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null };

export type BlockSnapshotFragment = { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string };

export type WorkTimelineSnapshotTicksQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
  maxSnapshotId: InputMaybe<Scalars['ID']['input']>;
}>;


export type WorkTimelineSnapshotTicksQuery = { __typename?: 'RootQueryType', snapshotTicks: Array<{ __typename?: 'SnapshotTick', id: string, version: number, timestamp: string }> };

export type CommentFragment = { __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } };

export type CommentUserFragment = { __typename?: 'User', id: string, name: string, colourset: number | null };

export type ConversationEventFragment = { __typename?: 'ConversationEvent', eventType: ConversationEventType, threadId: string, title: string | null, comment: { __typename?: 'Comment', insertedAt: string, id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } } | null };

export type CreateBlockAttachmentMutationVariables = Exact<{
  answerBlockId: Scalars['ID']['input'];
  mediaId: Scalars['ID']['input'];
  mediaUrl: Scalars['String']['input'];
}>;


export type CreateBlockAttachmentMutation = { __typename?: 'RootMutationType', createBlockAttachment: { __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null } };

export type CreateCommentMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type CreateCommentMutation = { __typename?: 'RootMutationType', createComment: { __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } } };

export type CreateThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
  input: ThreadInput;
}>;


export type CreateThreadMutation = { __typename?: 'RootMutationType', createThread: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'RootQueryType', me: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null } };

export type DeleteThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type DeleteThreadMutation = { __typename?: 'RootMutationType', deleteThread: { __typename?: 'Thread', id: string, createdBy: { __typename?: 'User', id: string, name: string } } };

export type DeletedAnswerBlockQueryVariables = Exact<{
  answerBlockId: Scalars['ID']['input'];
}>;


export type DeletedAnswerBlockQuery = { __typename?: 'RootQueryType', deletedAnswerBlock: { __typename?: 'AnswerBlock', id: string, blockName: string | null, points: number | null, skip: boolean | null, bookmark: boolean | null, order: number | null, orderLabel: string | null, nodeId: string, shuffle: boolean | null, parentNodeId: string | null, confirm: boolean | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> } | null };

export type WorkTimelineDocumentBaseQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
}>;


export type WorkTimelineDocumentBaseQuery = { __typename?: 'RootQueryType', documentBase: { __typename?: 'DocumentBase', baseDoc: string } };

export type WorkTimelineDocumentWindowQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
  targetVersion: Scalars['Int']['input'];
  haveSnapshotVersion: InputMaybe<Scalars['Int']['input']>;
  buffer: InputMaybe<Scalars['Int']['input']>;
}>;


export type WorkTimelineDocumentWindowQuery = { __typename?: 'RootQueryType', documentWindow: { __typename?: 'DocumentWindow', baseVersion: number, document: string | null, steps: Array<{ __typename?: 'DocumentStep', version: number, data: string }> } };

export type EditCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type EditCommentMutation = { __typename?: 'RootMutationType', editComment: { __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } } };

export type EntityThreadEventFragment = { __typename?: 'EntityThreadEvent', eventType: EntityThreadEventType, threadId: string, status: ThreadStatus, entityId: string | null, entityType: EntityType | null, resolvedAt: string | null, criterionId: string | null, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null };

export type EntityThreadsQueryVariables = Exact<{
  entityType: EntityType;
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type EntityThreadsQuery = { __typename?: 'RootQueryType', entityThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null }> };

export type OnEntityThreadsUpdatedSubscriptionVariables = Exact<{
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
}>;


export type OnEntityThreadsUpdatedSubscription = { __typename?: 'RootSubscriptionType', entityThreadsUpdated: { __typename?: 'EntityThreadEvent', eventType: EntityThreadEventType, threadId: string, status: ThreadStatus, entityId: string | null, entityType: EntityType | null, resolvedAt: string | null, criterionId: string | null, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null } };

export type UpdateExperienceMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  score: Scalars['Int']['input'];
}>;


export type UpdateExperienceMutation = { __typename?: 'RootMutationType', updateExperience: { __typename?: 'Survey', id: string, score: number | null, active: boolean } };

export type ExperienceQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type ExperienceQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, subjectId: string }, work: { __typename?: 'Work', id: string, experience: { __typename?: 'Survey', id: string, score: number | null, active: boolean } } };

export type LatestBlockSnapshotFragment = { __typename?: 'AnswerBlock', id: string, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null };

export type LatestResultQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
  type: SubmissionType;
}>;


export type LatestResultQuery = { __typename?: 'RootQueryType', latestResult: { __typename?: 'Result', id: string, heraResultId: number | null, workId: string, canvasResultUrl: string | null, moodleGraderUrl: string | null, submissionType: SubmissionType, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null, receipt: { __typename?: 'GradebookReceipt', lmsComplete: boolean } | null } };

export type OnResultUpdatedSubscriptionVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type OnResultUpdatedSubscription = { __typename?: 'RootSubscriptionType', workResultUpdated: { __typename?: 'Result', id: string, heraResultId: number | null, workId: string, canvasResultUrl: string | null, moodleGraderUrl: string | null, submissionType: SubmissionType, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null, receipt: { __typename?: 'GradebookReceipt', lmsComplete: boolean } | null } };

export type QuestionBodyFragment = { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null };

export type QuestionFieldFragment = { __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } };

export type QuestionFragment = { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null };

export type RemoveBlockAttachmentMutationVariables = Exact<{
  blockAttachmentId: Scalars['ID']['input'];
}>;


export type RemoveBlockAttachmentMutation = { __typename?: 'RootMutationType', removeBlockAttachment: { __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null } };

export type ReentryStatusQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ReentryStatusQuery = { __typename?: 'RootQueryType', reentryStatus: { __typename?: 'ReentryStatus', requiresReentryCode: boolean, sessionCount: number } };

export type ResolveThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type ResolveThreadMutation = { __typename?: 'RootMutationType', updateThreadResolution: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null } };

export type ResultFragment = { __typename?: 'Result', id: string, heraResultId: number | null, workId: string, canvasResultUrl: string | null, moodleGraderUrl: string | null, submissionType: SubmissionType, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null, receipt: { __typename?: 'GradebookReceipt', lmsComplete: boolean } | null };

export type ResultLineFragment = { __typename?: 'Result', id: string, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null };

export type SaveBlockSnapshotMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
  snapshotContent: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  previousBlockSnapshotId: InputMaybe<Scalars['ID']['input']>;
  wordCountChange: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveBlockSnapshotMutation = { __typename?: 'RootMutationType', saveBlockSnapshot: { __typename?: 'SaveBlockSnapshotResponse', blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, version: number, blockName: string | null } } };

export type SaveFragment = { __typename?: 'Save', id: string, serverId: string, version: string, content: string };

export type SaveMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  dispatchedAt: Scalars['DateTime']['input'];
  metadata: InputMaybe<SaveMetadataInput>;
  editor: InputMaybe<EditorType>;
}>;


export type SaveMutation = { __typename?: 'RootMutationType', save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string, dispatchedAt: string } };

export type SimpleChoiceFragment = { __typename?: 'SimpleChoice', identifier: string, content: string };

export type StartMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type StartMutation = { __typename?: 'RootMutationType', start: { __typename?: 'Work', id: string, startDate: string | null } };

export type StudentOutcomeScoreFragment = { __typename?: 'StudentOutcome', final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number }, individual: { __typename?: 'ComponentScore', score: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number }, individual: { __typename?: 'ComponentScore', score: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null } | null } };

export type SubmissionFragment = { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> };

export type SubmissionMetadataFragment = { __typename?: 'Submission', id: string, type: SubmissionType, submittedAt: string, unsubmittedAt: string | null };

export type SubmissionQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
  submissionType: SubmissionType;
}>;


export type SubmissionQuery = { __typename?: 'RootQueryType', work: { __typename?: 'Work', id: string, result: { __typename?: 'Result', id: string, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null } | null } };

export type SubmitAttemptMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  type: SubmissionType;
  attemptNumber: Scalars['Int']['input'];
  submissionDate: InputMaybe<Scalars['DateTime']['input']>;
  submissionTrigger: InputMaybe<SubmissionTrigger>;
}>;


export type SubmitAttemptMutation = { __typename?: 'RootMutationType', submitAttemptV2: { __typename?: 'SubmitAttemptPayload', nextAttemptNumber: number, result: { __typename?: 'Result', id: string, heraResultId: number | null, workId: string, canvasResultUrl: string | null, moodleGraderUrl: string | null, submissionType: SubmissionType, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null, receipt: { __typename?: 'GradebookReceipt', lmsComplete: boolean } | null } } };

export type SubmitMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  saveId: Scalars['ID']['input'];
  type: SubmissionType;
  submittedAt: Scalars['DateTime']['input'];
  acceptedDeclaration: Scalars['Boolean']['input'];
  sessionId: InputMaybe<Scalars['String']['input']>;
  editor: InputMaybe<EditorType>;
  submissionTrigger: InputMaybe<SubmissionTrigger>;
}>;


export type SubmitMutation = { __typename?: 'RootMutationType', submit: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } };

export type OnThreadConversationUpdatedSubscriptionVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type OnThreadConversationUpdatedSubscription = { __typename?: 'RootSubscriptionType', threadConversationUpdated: { __typename?: 'ConversationEvent', eventType: ConversationEventType, threadId: string, title: string | null, comment: { __typename?: 'Comment', insertedAt: string, id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } } | null } };

export type ThreadFragment = { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null };

export type ThreadQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ThreadQuery = { __typename?: 'RootQueryType', thread: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null } };

export type OnThreadUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnThreadUpdatedSubscription = { __typename?: 'RootSubscriptionType', threadUpdated: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null } };

export type WorkTimelineContributionsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
  versions: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type WorkTimelineContributionsQuery = { __typename?: 'RootQueryType', contributionsAt: Array<{ __typename?: 'Contribution', asOfVersion: number, members: Array<{ __typename?: 'MemberContribution', userId: string, ranges: Array<{ __typename?: 'ContributedRange', from: number, to: number }> }> }> };

export type WorkTimelineSnapshotsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
  versions: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type WorkTimelineSnapshotsQuery = { __typename?: 'RootQueryType', snapshots: Array<{ __typename?: 'Snapshot', asOfVersion: number, document: string }> };

export type UnresolveThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type UnresolveThreadMutation = { __typename?: 'RootMutationType', updateThreadResolution: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null } };

export type UnsubmitMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  submissionId: Scalars['ID']['input'];
}>;


export type UnsubmitMutation = { __typename?: 'RootMutationType', unsubmit: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } };

export type UpdateAnswerBlockMutationVariables = Exact<{
  answerBlockId: Scalars['ID']['input'];
  input: UpdateAnswerBlockInput;
}>;


export type UpdateAnswerBlockMutation = { __typename?: 'RootMutationType', updateAnswerBlock: { __typename?: 'AnswerBlock', id: string, skip: boolean | null, bookmark: boolean | null, confirm: boolean | null } };

export type VerifyAccessCodeV2MutationVariables = Exact<{
  code: Scalars['String']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type VerifyAccessCodeV2Mutation = { __typename?: 'RootMutationType', verifyAccessCodeV2: { __typename?: 'VerifyAccessCodePayload', success: boolean, failureReason: AccessCodeFailureReason | null, session: { __typename?: 'Session', id: string, verified: boolean } } };

export type WorkAnswerBlocksFragment = { __typename?: 'Work', answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, blockName: string | null, points: number | null, skip: boolean | null, bookmark: boolean | null, order: number | null, orderLabel: string | null, nodeId: string, shuffle: boolean | null, parentNodeId: string | null, confirm: boolean | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }> };

export type WorkQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type WorkQuery = { __typename?: 'RootQueryType', token: string, work: { __typename?: 'Work', id: string, startDate: string | null, attemptCount: number, sheet: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, content: string, version: number } | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } | null, group: { __typename?: 'Group', id: string, name: string } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean, enableIndividualCollab: boolean, enableTenantStreams: boolean, enableOfflinePersistence: boolean, enableFontControls: boolean }, settings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examWritingTime: number | null, examDeferred: boolean | null, submitAttemptLimit: number | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, blockName: string | null, points: number | null, skip: boolean | null, bookmark: boolean | null, order: number | null, orderLabel: string | null, nodeId: string, shuffle: boolean | null, parentNodeId: string | null, confirm: boolean | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', readingTime: number | null, responseTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }>, latestSave: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, latestSentimentCheck: { __typename?: 'SentimentCheck', id: string, comment: string | null, skipped: boolean, level: SentimentCheckLevel | null, sessionId: string, insertedAt: string | null } | null, finalResult: { __typename?: 'Result', id: string, heraResultId: number | null, workId: string, canvasResultUrl: string | null, moodleGraderUrl: string | null, submissionType: SubmissionType, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null, receipt: { __typename?: 'GradebookReceipt', lmsComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, heraResultId: number | null, workId: string, canvasResultUrl: string | null, moodleGraderUrl: string | null, submissionType: SubmissionType, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null, receipt: { __typename?: 'GradebookReceipt', lmsComplete: boolean } | null } | null }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, turnitin: boolean, groupAssessment: boolean, extensionSyncing: boolean }, studentOutcome: { __typename?: 'StudentOutcome', final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number }, individual: { __typename?: 'ComponentScore', score: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number }, individual: { __typename?: 'ComponentScore', score: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null } | null } }, workOutcome: { __typename?: 'WorkOutcome', finalRelease: { __typename?: 'WorkOutcomeRelease', feedbackVisibility: { __typename?: 'FeedbackVisibility', feedbackViewLevel: FeedbackLevel } } | null, provisionalRelease: { __typename?: 'WorkOutcomeRelease', feedbackVisibility: { __typename?: 'FeedbackVisibility', feedbackViewLevel: FeedbackLevel } } | null } | null };

export type WorkResultFragment = { __typename?: 'Work', id: string, finalResult: { __typename?: 'Result', submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null } | null };

export type WorkSettingsFragment = { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examWritingTime: number | null, examDeferred: boolean | null, submitAttemptLimit: number | null };

export type OnWorkSettingsUpdatedSubscriptionVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type OnWorkSettingsUpdatedSubscription = { __typename?: 'RootSubscriptionType', workSettingsUpdated: { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examWritingTime: number | null, examDeferred: boolean | null, submitAttemptLimit: number | null } };

export type OnWorkStartedSubscriptionVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type OnWorkStartedSubscription = { __typename?: 'RootSubscriptionType', workStarted: { __typename?: 'Work', id: string, startDate: string | null, sheet: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, content: string, version: number } | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } | null } };

export type WorkSubmitAttemptFragment = { __typename?: 'Work', id: string, attemptCount: number, finalResult: { __typename?: 'Result', id: string, heraResultId: number | null, workId: string, canvasResultUrl: string | null, moodleGraderUrl: string | null, submissionType: SubmissionType, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null, receipt: { __typename?: 'GradebookReceipt', lmsComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, heraResultId: number | null, workId: string, canvasResultUrl: string | null, moodleGraderUrl: string | null, submissionType: SubmissionType, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null, receipt: { __typename?: 'GradebookReceipt', lmsComplete: boolean } | null } | null };

export type OnWorkSubmittedSubscriptionVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type OnWorkSubmittedSubscription = { __typename?: 'RootSubscriptionType', workSubmitted: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } };

export type WorkTimelineWorkVersionsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  answerBlockIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after: InputMaybe<Scalars['String']['input']>;
}>;


export type WorkTimelineWorkVersionsQuery = { __typename?: 'RootQueryType', workVersions: { __typename?: 'WorkVersionConnection', nodes: Array<{ __typename?: 'WorkVersion', id: string, answerBlockId: string, version: number, timestamp: string, author: { __typename?: 'WorkVersionAuthor', userId: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } };

export const FeatureFlagsFragmentDoc = gql`
    fragment FeatureFlags on InstitutionFeatures {
  id
  exams
  respondusLdb
  moodleGrader
  multiformat
  turnitinGrader
  turnitin
  groupAssessment
  extensionSyncing
}
    `;
export const InstitutionFragmentDoc = gql`
    fragment Institution on Institution {
  id
  customDeclarationText
}
    `;
export const SessionFragmentDoc = gql`
    fragment Session on Session {
  id
  verified(assessmentId: $assessmentId)
}
    `;
export const AssessmentSettingsFragmentDoc = gql`
    fragment AssessmentSettings on AssessmentSettings {
  id
  assessmentType
  releaseDate
  dueDate
  openDate
  individualWorkAttachmentEnabled
  groupWorkAttachmentEnabled
  draftDueDate
  draftEnabled
  groupDraftEnabled
  groupDraftDueDate
  individualDraftFeedbackAlwaysAvailable
  groupDraftFeedbackAlwaysAvailable
  draftScoringEnabled
  lateSubmissionTimeLimit
  lateResubmissionEnabled
  submitAttemptLimit
  markingTool
  feedbackDate
  feedbackDateDisabled
  anonymousMarking
  maxGrade
  selfEvaluationMaxGrade
  individualReportMaxGrade
  groupReportMaxGrade
  peerEvaluationMaxGrade
  rubricDisplayDisabled
  tiiSViewReports
  tiiDraftSViewReports
  timeLimit
  timeLimitEnabled
  examType
  examTiming
  examStartDate
  examEndDate
  examReadingTime
  examReadingTimeDisabled
  examWritingTime
  examAutoSubmissionDisabled
  examBacktrackDisabled
  examLdbEnabled
  examSchoolyearEnabled
  examAccessCodeEnabled
  examReentryPreventionEnabled
  examInactivityTimeout
  weight
  weightEnabled
  wordLimit
  wordLimitEnabled
  wordLimitGroup
  referencingStyle
  referencingStyleEnabled
  countReferences
  countFootnotes
  allowGenerativeAi
  spellCheckDisabled
  groupAssessmentEnabled
  groupSelfEnrollmentEnabled
  groupSelfEnrollmentDeadline
  groupChangeRequestsEnabled
  groupChangeRequestCutoff
  groupFinalised
  sentimentCheckEnabled
  sentimentCheckSkipEnabled
  sentimentCheckIntervalInHr
  sentimentCheckScheduleType
  sentimentCheckFirstCheckAt
  sentimentCheckSchedules {
    id
    scheduledAt
  }
  individualReportEnabled
  individualReportWeight
  individualReportDueDate
  peerEvaluationEnabled
  peerEvaluationWeight
  peerEvaluationDueDate
  peerEvaluationMode
  selfEvaluationEnabled
  selfEvaluationWeight
  selfEvaluationMode
  groupCharterEnabled
  groupCharterAvailable
  groupCharterAcceptanceRequired
  groupCharterDueDate
  groupReportWeight
  smartAutomarkingEnabled
  vivaEnabled
  vivaReattemptWindowTime
  vivaCameraRequiredDisabled
}
    `;
export const AssessmentFragmentDoc = gql`
    fragment Assessment on Assessment {
  id
  name
  subjectName
  settings {
    ...AssessmentSettings
  }
}
    ${AssessmentSettingsFragmentDoc}`;
export const TaskNoticeFragmentDoc = gql`
    fragment TaskNotice on TaskNotice {
  id
  content
  version
}
    `;
export const ResourceFragmentDoc = gql`
    fragment Resource on Resource {
  id
  name
  url
  notes
  fileSize
}
    `;
export const SheetFragmentDoc = gql`
    fragment Sheet on Sheet {
  id
  format
  kind
  rawContent
  releaseTimestamp
  nextReleaseTimestamp
  genaiGuidelineNotice {
    ...TaskNotice
  }
  resources {
    ...Resource
  }
}
    ${TaskNoticeFragmentDoc}
${ResourceFragmentDoc}`;
export const SimpleChoiceFragmentDoc = gql`
    fragment SimpleChoice on SimpleChoice {
  identifier
  content
}
    `;
export const QuestionFieldFragmentDoc = gql`
    fragment QuestionField on QuestionField {
  identifier
  interaction {
    ... on ChoiceInteraction {
      choices {
        ...SimpleChoice
      }
      label
      maxChoices
    }
    ... on ExtendedInteraction {
      wordLimit
      attachmentEnabled
      referencingEnabled
    }
    ... on TextEntryInteraction {
      baseType
      expectedLength
      attachmentEnabled
    }
    ... on MatchInteraction {
      targetSet {
        ...SimpleChoice
      }
      sourceSet {
        ...SimpleChoice
      }
    }
    ... on PositionObjectInteraction {
      label
      maxChoices
    }
    ... on SocraticInteraction {
      readingTime
      responseTime
      maxAttempts
    }
  }
}
    ${SimpleChoiceFragmentDoc}`;
export const QuestionBodyFragmentDoc = gql`
    fragment QuestionBody on QuestionBody {
  id
  feedback
  promptDoc
  promptImage {
    ... on PromptImage {
      url
      width
      height
      layers {
        ... on PromptImageLayer {
          identifier
          shape
          coords
        }
      }
    }
  }
  fields {
    ...QuestionField
  }
}
    ${QuestionFieldFragmentDoc}`;
export const QuestionFragmentDoc = gql`
    fragment Question on Question {
  id
  questionType
  shortPrompt
  body {
    ...QuestionBody
  }
}
    ${QuestionBodyFragmentDoc}`;
export const TaskBlockFragmentDoc = gql`
    fragment TaskBlock on TaskBlock {
  id
  order
  orderLabel
  points
  question {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export const WorkGenaiGuidelineNoticeFragmentDoc = gql`
    fragment WorkGenaiGuidelineNotice on Work {
  sheet {
    genaiGuidelineNotice {
      ...TaskNotice
    }
  }
}
    ${TaskNoticeFragmentDoc}`;
export const ComponentBreakdownFragmentDoc = gql`
    fragment ComponentBreakdown on ComponentBreakdown {
  total {
    score
    maxScore
    penaltyScore
    moderatorModifierComponents
    moderatorModifierStudent
  }
  peer {
    score
    maxScore
    weight
    weightedScore
    weightedMaxScore
    modifiersTotal
    moderatorModifier
    penaltyScore
  }
  self {
    score
    maxScore
    weight
    weightedScore
    weightedMaxScore
    modifiersTotal
    moderatorModifier
    penaltyScore
  }
  individual {
    score
    maxScore
    weight
    weightedScore
    weightedMaxScore
    modifiersTotal
    moderatorModifier
    penaltyScore
  }
  group {
    score
    maxScore
    weight
    weightedScore
    weightedMaxScore
    modifiersTotal
    moderatorModifier
    penaltyScore
  }
}
    `;
export const LearningOutcomeSkillFragmentDoc = gql`
    fragment LearningOutcomeSkill on LearningOutcomeSkill {
  id
  skill
}
    `;
export const ScaleItemFragmentDoc = gql`
    fragment ScaleItem on ScaleItem {
  id
  description
  order
  scaleLabel
  rangeFrom
  rangeTo
}
    `;
export const FeedbackCriterionFragmentDoc = gql`
    fragment FeedbackCriterion on Criterion {
  id
  title
  color
  order
  maxScore
  description
  skill {
    ...LearningOutcomeSkill
  }
  scaleItems {
    ...ScaleItem
  }
}
    ${LearningOutcomeSkillFragmentDoc}
${ScaleItemFragmentDoc}`;
export const MarkerRubricFragmentDoc = gql`
    fragment MarkerRubric on MarkerRubric {
  id
  kind
  format
  reversedScale
  hideScores
  publishedAt
  assessmentName
  questionShortPrompt
  criteria {
    ...FeedbackCriterion
  }
  location {
    path
    questionId
  }
}
    ${FeedbackCriterionFragmentDoc}`;
export const FeedbackVisibilityFragmentDoc = gql`
    fragment FeedbackVisibility on FeedbackVisibility {
  id
  feedbackViewLevel
  showPeerComments
  showPeerScores
  withFeedbackPdf
  releaseType
}
    `;
export const CriterionOutcomeReleaseFragmentDoc = gql`
    fragment CriterionOutcomeRelease on CriterionOutcomeRelease {
  id
  markerScore
  markerRubricCriterionId
  markerRubricScaleItemId
}
    `;
export const CommentUserFragmentDoc = gql`
    fragment CommentUser on User {
  id
  name
  colourset
}
    `;
export const CommentReleaseFragmentDoc = gql`
    fragment CommentRelease on CommentRelease {
  id
  content
  userId
  createdBy {
    ...CommentUser
  }
}
    ${CommentUserFragmentDoc}`;
export const ThreadReleaseFragmentDoc = gql`
    fragment ThreadRelease on ThreadRelease {
  id
  title
  criterionId
  threadInsertedAt
  userId
  metadata {
    blockAttachmentName
  }
  commentReleases {
    ...CommentRelease
  }
}
    ${CommentReleaseFragmentDoc}`;
export const FieldOutcomeReleaseFragmentDoc = gql`
    fragment FieldOutcomeRelease on FieldOutcomeRelease {
  id
  score
  criterionOutcomeReleases {
    ...CriterionOutcomeRelease
  }
  threadReleases {
    ...ThreadRelease
  }
  docContent
  docVersion
  referencesDocContent
  referencesDocVersion
}
    ${CriterionOutcomeReleaseFragmentDoc}
${ThreadReleaseFragmentDoc}`;
export const BlockSnapshotFragmentDoc = gql`
    fragment BlockSnapshot on BlockSnapshot {
  id
  cacheId
  answerBlockId
  version
  blockName
  content
}
    `;
export const QuestionOutcomeReleaseFragmentDoc = gql`
    fragment QuestionOutcomeRelease on QuestionOutcomeRelease {
  id
  questionId
  fieldOutcomeReleases {
    ...FieldOutcomeRelease
  }
  blockSnapshot {
    ...BlockSnapshot
  }
  referencesBlockSnapshot {
    ...BlockSnapshot
  }
}
    ${FieldOutcomeReleaseFragmentDoc}
${BlockSnapshotFragmentDoc}`;
export const SubmissionOutcomeReleaseFragmentDoc = gql`
    fragment SubmissionOutcomeRelease on SubmissionOutcomeRelease {
  id
  submissionId
  bodyBlockSnapshotId
  bodyDocVersion
  bodyDoc
  referencesBlockSnapshotId
  referencesDocVersion
  referencesDoc
  criterionOutcomeReleases {
    ...CriterionOutcomeRelease
  }
  threadReleases {
    ...ThreadRelease
  }
}
    ${CriterionOutcomeReleaseFragmentDoc}
${ThreadReleaseFragmentDoc}`;
export const WorkOutcomeReleaseFragmentDoc = gql`
    fragment WorkOutcomeRelease on WorkOutcomeRelease {
  id
  releaseType
  releasedAt
  finalScore
  penaltyScore
  feedbackVisibility {
    ...FeedbackVisibility
  }
  questionOutcomeReleases {
    ...QuestionOutcomeRelease
  }
  submissionOutcomeRelease {
    ...SubmissionOutcomeRelease
  }
}
    ${FeedbackVisibilityFragmentDoc}
${QuestionOutcomeReleaseFragmentDoc}
${SubmissionOutcomeReleaseFragmentDoc}`;
export const BlockAttachmentFragmentDoc = gql`
    fragment BlockAttachment on BlockAttachment {
  id
  name
  mediaUrl
  fileSize
  fileExtension
  insertedAt
  uploadedBy {
    id
    name
  }
}
    `;
export const WorkOutcomeFragmentDoc = gql`
    fragment WorkOutcome on WorkOutcome {
  id
  workId
  groupId
  assessmentId
  maxScore
  feedbackReleased
  workOutcomeRelease {
    ...WorkOutcomeRelease
  }
  draftSubmissionOutcomeRelease {
    ...SubmissionOutcomeRelease
  }
  answerBlocks {
    id
    nodeId
    points
    blockName
    blockAttachments {
      ...BlockAttachment
    }
    question {
      ...Question
    }
  }
}
    ${WorkOutcomeReleaseFragmentDoc}
${SubmissionOutcomeReleaseFragmentDoc}
${BlockAttachmentFragmentDoc}
${QuestionFragmentDoc}`;
export const CriterionOutcomeFragmentDoc = gql`
    fragment CriterionOutcome on CriterionOutcome {
  id
  targetUserId
  markerRubricCriterionId
  markerRubricScaleItemId
  markerUserId
  markerScore
  publishedAt
}
    `;
export const ReceivedPeerOutcomeFragmentDoc = gql`
    fragment ReceivedPeerOutcome on PeerOutcome {
  id
  targetUserId
  peerMaxScore
  selfMaxScore
  peerScore
  selfScore
  criterionOutcomes {
    ...CriterionOutcome
  }
}
    ${CriterionOutcomeFragmentDoc}`;
export const StudentOutcomeFragmentDoc = gql`
    fragment StudentOutcome on StudentOutcome {
  id
  studentId
  groupWorkOutcome {
    ...WorkOutcome
  }
  individualWorkOutcome {
    ...WorkOutcome
  }
  peerOutcome {
    ...ReceivedPeerOutcome
  }
}
    ${WorkOutcomeFragmentDoc}
${ReceivedPeerOutcomeFragmentDoc}`;
export const CharterEditorFragmentDoc = gql`
    fragment CharterEditor on CharterEditor {
  id
  charterFormSectionId
  snapshotDoc
  snapshotVersion
  streamUuid
}
    `;
export const CharterFormFragmentDoc = gql`
    fragment CharterForm on CharterForm {
  id
  published
  publishTimestamp
  sections {
    id
    type
    deleted
    enabled
    milestonePresets {
      id
      description
      dueDate
      title
      id
    }
    promptDoc
    rank
    title
    wordLimit
    wordLimitEnabled
  }
}
    `;
export const CharterAgreementFragmentDoc = gql`
    fragment CharterAgreement on CharterAgreement {
  acceptedAt
  unlockedAt
}
    `;
export const CommentFragmentDoc = gql`
    fragment Comment on Comment {
  id
  content
  insertedAt
  updatedAt
  createdBy {
    ...CommentUser
  }
}
    ${CommentUserFragmentDoc}`;
export const ThreadFragmentDoc = gql`
    fragment Thread on Thread {
  id
  title
  entityType
  entityId
  criterionId
  createdBy {
    ...CommentUser
  }
  insertedAt
  resolvedAt
  resolvedBy {
    ...CommentUser
  }
  status
  comments {
    ...Comment
  }
  metadata {
    charterSectionType
    charterEditorId
    blockAttachmentId
    blockAttachmentName
  }
}
    ${CommentUserFragmentDoc}
${CommentFragmentDoc}`;
export const CharterFragmentDoc = gql`
    fragment Charter on Charter {
  id
  groupId
  milestones {
    id
    title
    description
    dueDate
    deleted
  }
  editors {
    id
    charterFormSectionId
    snapshotDoc
    snapshotVersion
    streamUuid
  }
  latestAgreement {
    ...CharterAgreement
  }
  feedbackThreads {
    ...Thread
  }
}
    ${CharterAgreementFragmentDoc}
${ThreadFragmentDoc}`;
export const CharterMilestoneFragmentDoc = gql`
    fragment CharterMilestone on CharterMilestone {
  id
  title
  description
  dueDate
  deleted
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  email
  name
  givenName
  familyName
  colourset
}
    `;
export const GroupFragmentDoc = gql`
    fragment Group on Group {
  id
  name
  maxLimit
  minLimit
  finalised
  groupMembers {
    id
    isActive
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export const MessageFragmentDoc = gql`
    fragment Message on Message {
  id
  messageType
  reason
  status
  decision
  decisionNote
  decidedAt
  expiresAt
  insertedAt
}
    `;
export const ProjectIssueFragmentDoc = gql`
    fragment ProjectIssue on ProjectIssue {
  id
  groupId
  title
  type
  status
  deleted
  description
  dueDate
  parentId
  assignees
}
    `;
export const CriterionFragmentDoc = gql`
    fragment Criterion on Criterion {
  id
  title
  color
  order
  maxScore
  description
  skill {
    ...LearningOutcomeSkill
  }
  scaleItems {
    ...ScaleItem
  }
}
    ${LearningOutcomeSkillFragmentDoc}
${ScaleItemFragmentDoc}`;
export const FeedbackThreadFragmentDoc = gql`
    fragment FeedbackThread on Thread {
  id
  entityId
  createdBy {
    ...CommentUser
  }
  resolvedAt
  resolvedBy {
    ...CommentUser
  }
  status
  comments {
    ...Comment
  }
}
    ${CommentUserFragmentDoc}
${CommentFragmentDoc}`;
export const GroupPeerOutcomeFragmentDoc = gql`
    fragment GroupPeerOutcome on PeerOutcome {
  id
  targetUserId
  feedbackReleasedTimestamp
  givenCriterionOutcomes {
    ...CriterionOutcome
  }
}
    ${CriterionOutcomeFragmentDoc}`;
export const SentimentCheckFragmentDoc = gql`
    fragment SentimentCheck on SentimentCheck {
  id
  comment
  skipped
  level
  sessionId
  insertedAt
}
    `;
export const AnswerBlockFragmentDoc = gql`
    fragment AnswerBlock on AnswerBlock {
  id
  blockName
  points
  skip
  bookmark
  order
  orderLabel
  nodeId
  shuffle
  parentNodeId
  confirm
  question {
    ...Question
  }
  latestBlockSnapshot {
    ...BlockSnapshot
  }
  blockAttachments {
    ...BlockAttachment
  }
}
    ${QuestionFragmentDoc}
${BlockSnapshotFragmentDoc}
${BlockAttachmentFragmentDoc}`;
export const SocraticTurnFragmentDoc = gql`
    fragment SocraticTurn on SocraticTurn {
  id
  order
  questionPrompt
  recordingStartedAt
  recordingCompletedAt
  response {
    mediaUrl
    durationSeconds
  }
}
    `;
export const SocraticDialogueFragmentDoc = gql`
    fragment SocraticDialogue on SocraticDialogue {
  id
  maxTurns
  attemptNumber
  startedAt
  expiredAt
  readingTimeSeconds
  responseTimeSeconds
  turns {
    ...SocraticTurn
  }
}
    ${SocraticTurnFragmentDoc}`;
export const SocraticSessionFragmentDoc = gql`
    fragment SocraticSession on SocraticSession {
  id
  answerBlock {
    ...AnswerBlock
  }
  maxAttempts
  readingTimeSeconds
  responseTimeSeconds
  reattemptWindowEndsAt
  reattemptWindowSeconds
  dialogues {
    ...SocraticDialogue
  }
}
    ${AnswerBlockFragmentDoc}
${SocraticDialogueFragmentDoc}`;
export const ConversationEventFragmentDoc = gql`
    fragment ConversationEvent on ConversationEvent {
  eventType
  threadId
  comment {
    ...Comment
    insertedAt
  }
  title
}
    ${CommentFragmentDoc}`;
export const EntityThreadEventFragmentDoc = gql`
    fragment EntityThreadEvent on EntityThreadEvent {
  eventType
  threadId
  status
  entityId
  entityType
  resolvedAt
  resolvedBy {
    ...CommentUser
  }
  criterionId
}
    ${CommentUserFragmentDoc}`;
export const LatestBlockSnapshotFragmentDoc = gql`
    fragment LatestBlockSnapshot on AnswerBlock {
  id
  latestBlockSnapshot {
    ...BlockSnapshot
  }
}
    ${BlockSnapshotFragmentDoc}`;
export const ResultLineFragmentDoc = gql`
    fragment ResultLine on Result {
  id
  heraResultId
  canvasResultUrl
  moodleGraderUrl
  grade {
    display
    max
    value
  }
  similarity {
    display
    label
    value
  }
}
    `;
export const StudentOutcomeScoreFragmentDoc = gql`
    fragment StudentOutcomeScore on StudentOutcome {
  final {
    total {
      score
      maxScore
    }
    individual {
      score
    }
    group {
      score
    }
  }
  provisional {
    total {
      score
      maxScore
    }
    individual {
      score
    }
    group {
      score
    }
  }
}
    `;
export const SubmissionMetadataFragmentDoc = gql`
    fragment SubmissionMetadata on Submission {
  id
  type
  submittedAt
  unsubmittedAt
}
    `;
export const WorkAnswerBlocksFragmentDoc = gql`
    fragment WorkAnswerBlocks on Work {
  answerBlocks {
    ...AnswerBlock
  }
}
    ${AnswerBlockFragmentDoc}`;
export const SaveFragmentDoc = gql`
    fragment Save on Save {
  id
  serverId
  version
  content
}
    `;
export const SubmissionFragmentDoc = gql`
    fragment Submission on Submission {
  id
  submittedAt
  unsubmittedAt
  type
  attemptNumber
  save {
    ...Save
  }
  blockSnapshots {
    ...BlockSnapshot
  }
}
    ${SaveFragmentDoc}
${BlockSnapshotFragmentDoc}`;
export const WorkResultFragmentDoc = gql`
    fragment WorkResult on Work {
  id
  finalResult: result(submissionType: FINAL) {
    submission {
      ...Submission
    }
  }
}
    ${SubmissionFragmentDoc}`;
export const WorkSettingsFragmentDoc = gql`
    fragment WorkSettings on WorkSettings {
  id
  dueDate
  timeLimit
  examStartDate
  examEndDate
  examReadingTime
  examWritingTime
  examDeferred
  submitAttemptLimit
}
    `;
export const ResultFragmentDoc = gql`
    fragment Result on Result {
  id
  heraResultId
  workId
  canvasResultUrl
  moodleGraderUrl
  submission {
    ...Submission
  }
  grade {
    display
    max
    value
  }
  similarity {
    display
    label
    value
  }
  receipt {
    lmsComplete
  }
  submissionType
}
    ${SubmissionFragmentDoc}`;
export const WorkSubmitAttemptFragmentDoc = gql`
    fragment WorkSubmitAttempt on Work {
  id
  attemptCount
  finalResult: result(submissionType: FINAL) {
    ...Result
  }
  draftResult: result(submissionType: DRAFT) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export const ApiTokenDocument = gql`
    query ApiToken($assessmentId: ID!, $workId: ID!) {
  apiToken(assessmentId: $assessmentId, workId: $workId)
}
    `;

/**
 * __useApiTokenQuery__
 *
 * To run a query within a React component, call `useApiTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokenQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useApiTokenQuery(baseOptions: Apollo.QueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables> & ({ variables: ApiTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
      }
export function useApiTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export function useApiTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export type ApiTokenQueryHookResult = ReturnType<typeof useApiTokenQuery>;
export type ApiTokenLazyQueryHookResult = ReturnType<typeof useApiTokenLazyQuery>;
export type ApiTokenSuspenseQueryHookResult = ReturnType<typeof useApiTokenSuspenseQuery>;
export type ApiTokenQueryResult = Apollo.QueryResult<ApiTokenQuery, ApiTokenQueryVariables>;
export const AssessmentMarkerRubricsDocument = gql`
    query AssessmentMarkerRubrics($assessmentId: ID!) {
  assessmentMarkerRubrics(assessmentId: $assessmentId) {
    id
    kind
    location {
      questionId
    }
  }
}
    `;

/**
 * __useAssessmentMarkerRubricsQuery__
 *
 * To run a query within a React component, call `useAssessmentMarkerRubricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentMarkerRubricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentMarkerRubricsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentMarkerRubricsQuery(baseOptions: Apollo.QueryHookOptions<AssessmentMarkerRubricsQuery, AssessmentMarkerRubricsQueryVariables> & ({ variables: AssessmentMarkerRubricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentMarkerRubricsQuery, AssessmentMarkerRubricsQueryVariables>(AssessmentMarkerRubricsDocument, options);
      }
export function useAssessmentMarkerRubricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentMarkerRubricsQuery, AssessmentMarkerRubricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentMarkerRubricsQuery, AssessmentMarkerRubricsQueryVariables>(AssessmentMarkerRubricsDocument, options);
        }
export function useAssessmentMarkerRubricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentMarkerRubricsQuery, AssessmentMarkerRubricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentMarkerRubricsQuery, AssessmentMarkerRubricsQueryVariables>(AssessmentMarkerRubricsDocument, options);
        }
export type AssessmentMarkerRubricsQueryHookResult = ReturnType<typeof useAssessmentMarkerRubricsQuery>;
export type AssessmentMarkerRubricsLazyQueryHookResult = ReturnType<typeof useAssessmentMarkerRubricsLazyQuery>;
export type AssessmentMarkerRubricsSuspenseQueryHookResult = ReturnType<typeof useAssessmentMarkerRubricsSuspenseQuery>;
export type AssessmentMarkerRubricsQueryResult = Apollo.QueryResult<AssessmentMarkerRubricsQuery, AssessmentMarkerRubricsQueryVariables>;
export const AssessmentDocument = gql`
    query Assessment($assessmentId: ID!) {
  session {
    ...Session
  }
  institution {
    ...Institution
  }
  me {
    ...User
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
}
    ${SessionFragmentDoc}
${InstitutionFragmentDoc}
${UserFragmentDoc}
${AssessmentFragmentDoc}`;

/**
 * __useAssessmentQuery__
 *
 * To run a query within a React component, call `useAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentQuery(baseOptions: Apollo.QueryHookOptions<AssessmentQuery, AssessmentQueryVariables> & ({ variables: AssessmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentQuery, AssessmentQueryVariables>(AssessmentDocument, options);
      }
export function useAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentQuery, AssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentQuery, AssessmentQueryVariables>(AssessmentDocument, options);
        }
export function useAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentQuery, AssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentQuery, AssessmentQueryVariables>(AssessmentDocument, options);
        }
export type AssessmentQueryHookResult = ReturnType<typeof useAssessmentQuery>;
export type AssessmentLazyQueryHookResult = ReturnType<typeof useAssessmentLazyQuery>;
export type AssessmentSuspenseQueryHookResult = ReturnType<typeof useAssessmentSuspenseQuery>;
export type AssessmentQueryResult = Apollo.QueryResult<AssessmentQuery, AssessmentQueryVariables>;
export const AssessmentSettingsDocument = gql`
    query AssessmentSettings($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      ...AssessmentSettings
    }
  }
}
    ${AssessmentSettingsFragmentDoc}`;

/**
 * __useAssessmentSettingsQuery__
 *
 * To run a query within a React component, call `useAssessmentSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentSettingsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentSettingsQuery(baseOptions: Apollo.QueryHookOptions<AssessmentSettingsQuery, AssessmentSettingsQueryVariables> & ({ variables: AssessmentSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>(AssessmentSettingsDocument, options);
      }
export function useAssessmentSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>(AssessmentSettingsDocument, options);
        }
export function useAssessmentSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>(AssessmentSettingsDocument, options);
        }
export type AssessmentSettingsQueryHookResult = ReturnType<typeof useAssessmentSettingsQuery>;
export type AssessmentSettingsLazyQueryHookResult = ReturnType<typeof useAssessmentSettingsLazyQuery>;
export type AssessmentSettingsSuspenseQueryHookResult = ReturnType<typeof useAssessmentSettingsSuspenseQuery>;
export type AssessmentSettingsQueryResult = Apollo.QueryResult<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>;
export const OnAssessmentSettingsUpdatedDocument = gql`
    subscription onAssessmentSettingsUpdated($assessmentId: ID!) {
  assessmentSettingsUpdated(assessmentId: $assessmentId) {
    ...AssessmentSettings
  }
}
    ${AssessmentSettingsFragmentDoc}`;

/**
 * __useOnAssessmentSettingsUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnAssessmentSettingsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAssessmentSettingsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAssessmentSettingsUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useOnAssessmentSettingsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnAssessmentSettingsUpdatedSubscription, OnAssessmentSettingsUpdatedSubscriptionVariables> & ({ variables: OnAssessmentSettingsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnAssessmentSettingsUpdatedSubscription, OnAssessmentSettingsUpdatedSubscriptionVariables>(OnAssessmentSettingsUpdatedDocument, options);
      }
export type OnAssessmentSettingsUpdatedSubscriptionHookResult = ReturnType<typeof useOnAssessmentSettingsUpdatedSubscription>;
export type OnAssessmentSettingsUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnAssessmentSettingsUpdatedSubscription>;
export const OnFutureReleaseScheduleDocument = gql`
    subscription onFutureReleaseSchedule($assessmentId: ID!) {
  futureReleaseSchedule(assessmentId: $assessmentId)
}
    `;

/**
 * __useOnFutureReleaseScheduleSubscription__
 *
 * To run a query within a React component, call `useOnFutureReleaseScheduleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnFutureReleaseScheduleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnFutureReleaseScheduleSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useOnFutureReleaseScheduleSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnFutureReleaseScheduleSubscription, OnFutureReleaseScheduleSubscriptionVariables> & ({ variables: OnFutureReleaseScheduleSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnFutureReleaseScheduleSubscription, OnFutureReleaseScheduleSubscriptionVariables>(OnFutureReleaseScheduleDocument, options);
      }
export type OnFutureReleaseScheduleSubscriptionHookResult = ReturnType<typeof useOnFutureReleaseScheduleSubscription>;
export type OnFutureReleaseScheduleSubscriptionResult = Apollo.SubscriptionResult<OnFutureReleaseScheduleSubscription>;
export const InstructionSheetDocument = gql`
    query InstructionSheet($assessmentId: ID!, $taskKind: TaskKind) {
  instructionSheet(assessmentId: $assessmentId, kind: $taskKind) {
    ...Sheet
  }
}
    ${SheetFragmentDoc}`;

/**
 * __useInstructionSheetQuery__
 *
 * To run a query within a React component, call `useInstructionSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstructionSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstructionSheetQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      taskKind: // value for 'taskKind'
 *   },
 * });
 */
export function useInstructionSheetQuery(baseOptions: Apollo.QueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables> & ({ variables: InstructionSheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
      }
export function useInstructionSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
        }
export function useInstructionSheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
        }
export type InstructionSheetQueryHookResult = ReturnType<typeof useInstructionSheetQuery>;
export type InstructionSheetLazyQueryHookResult = ReturnType<typeof useInstructionSheetLazyQuery>;
export type InstructionSheetSuspenseQueryHookResult = ReturnType<typeof useInstructionSheetSuspenseQuery>;
export type InstructionSheetQueryResult = Apollo.QueryResult<InstructionSheetQuery, InstructionSheetQueryVariables>;
export const MarkerRubricDocument = gql`
    query MarkerRubric($assessmentId: ID!, $kind: MarkerRubricKind!) {
  markerRubric(assessmentId: $assessmentId, kind: $kind, status: PUBLISHED) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;

/**
 * __useMarkerRubricQuery__
 *
 * To run a query within a React component, call `useMarkerRubricQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkerRubricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkerRubricQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useMarkerRubricQuery(baseOptions: Apollo.QueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables> & ({ variables: MarkerRubricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
      }
export function useMarkerRubricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
        }
export function useMarkerRubricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
        }
export type MarkerRubricQueryHookResult = ReturnType<typeof useMarkerRubricQuery>;
export type MarkerRubricLazyQueryHookResult = ReturnType<typeof useMarkerRubricLazyQuery>;
export type MarkerRubricSuspenseQueryHookResult = ReturnType<typeof useMarkerRubricSuspenseQuery>;
export type MarkerRubricQueryResult = Apollo.QueryResult<MarkerRubricQuery, MarkerRubricQueryVariables>;
export const PublishedMarkerRubricDocument = gql`
    query PublishedMarkerRubric($assessmentId: ID!, $markerRubricId: ID!) {
  publishedMarkerRubric: extendedRubric(
    assessmentId: $assessmentId
    markerRubricId: $markerRubricId
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;

/**
 * __usePublishedMarkerRubricQuery__
 *
 * To run a query within a React component, call `usePublishedMarkerRubricQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedMarkerRubricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedMarkerRubricQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      markerRubricId: // value for 'markerRubricId'
 *   },
 * });
 */
export function usePublishedMarkerRubricQuery(baseOptions: Apollo.QueryHookOptions<PublishedMarkerRubricQuery, PublishedMarkerRubricQueryVariables> & ({ variables: PublishedMarkerRubricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedMarkerRubricQuery, PublishedMarkerRubricQueryVariables>(PublishedMarkerRubricDocument, options);
      }
export function usePublishedMarkerRubricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedMarkerRubricQuery, PublishedMarkerRubricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedMarkerRubricQuery, PublishedMarkerRubricQueryVariables>(PublishedMarkerRubricDocument, options);
        }
export function usePublishedMarkerRubricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishedMarkerRubricQuery, PublishedMarkerRubricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishedMarkerRubricQuery, PublishedMarkerRubricQueryVariables>(PublishedMarkerRubricDocument, options);
        }
export type PublishedMarkerRubricQueryHookResult = ReturnType<typeof usePublishedMarkerRubricQuery>;
export type PublishedMarkerRubricLazyQueryHookResult = ReturnType<typeof usePublishedMarkerRubricLazyQuery>;
export type PublishedMarkerRubricSuspenseQueryHookResult = ReturnType<typeof usePublishedMarkerRubricSuspenseQuery>;
export type PublishedMarkerRubricQueryResult = Apollo.QueryResult<PublishedMarkerRubricQuery, PublishedMarkerRubricQueryVariables>;
export const SheetDocument = gql`
    query Sheet($workId: ID!) {
  work(workId: $workId) {
    id
    group {
      ...Group
    }
    attemptCount
    startDate
    settings {
      ...WorkSettings
    }
    student {
      ...User
    }
    sheet {
      ...Sheet
    }
  }
}
    ${GroupFragmentDoc}
${WorkSettingsFragmentDoc}
${UserFragmentDoc}
${SheetFragmentDoc}`;

/**
 * __useSheetQuery__
 *
 * To run a query within a React component, call `useSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSheetQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useSheetQuery(baseOptions: Apollo.QueryHookOptions<SheetQuery, SheetQueryVariables> & ({ variables: SheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SheetQuery, SheetQueryVariables>(SheetDocument, options);
      }
export function useSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SheetQuery, SheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SheetQuery, SheetQueryVariables>(SheetDocument, options);
        }
export function useSheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SheetQuery, SheetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SheetQuery, SheetQueryVariables>(SheetDocument, options);
        }
export type SheetQueryHookResult = ReturnType<typeof useSheetQuery>;
export type SheetLazyQueryHookResult = ReturnType<typeof useSheetLazyQuery>;
export type SheetSuspenseQueryHookResult = ReturnType<typeof useSheetSuspenseQuery>;
export type SheetQueryResult = Apollo.QueryResult<SheetQuery, SheetQueryVariables>;
export const OnSheetReleasedDocument = gql`
    subscription onSheetReleased($assessmentId: ID!, $workId: ID!) {
  sheetReleased(assessmentId: $assessmentId, workId: $workId) {
    ...Sheet
  }
}
    ${SheetFragmentDoc}`;

/**
 * __useOnSheetReleasedSubscription__
 *
 * To run a query within a React component, call `useOnSheetReleasedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSheetReleasedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSheetReleasedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useOnSheetReleasedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnSheetReleasedSubscription, OnSheetReleasedSubscriptionVariables> & ({ variables: OnSheetReleasedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnSheetReleasedSubscription, OnSheetReleasedSubscriptionVariables>(OnSheetReleasedDocument, options);
      }
export type OnSheetReleasedSubscriptionHookResult = ReturnType<typeof useOnSheetReleasedSubscription>;
export type OnSheetReleasedSubscriptionResult = Apollo.SubscriptionResult<OnSheetReleasedSubscription>;
export const DownloadWorkAttachmentsDocument = gql`
    mutation DownloadWorkAttachments($answerBlockId: ID!, $blockAttachmentIds: [ID!]!) {
  downloadWorkAttachments(
    answerBlockId: $answerBlockId
    blockAttachmentIds: $blockAttachmentIds
  )
}
    `;
export type DownloadWorkAttachmentsMutationFn = Apollo.MutationFunction<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>;

/**
 * __useDownloadWorkAttachmentsMutation__
 *
 * To run a mutation, you first call `useDownloadWorkAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadWorkAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadWorkAttachmentsMutation, { data, loading, error }] = useDownloadWorkAttachmentsMutation({
 *   variables: {
 *      answerBlockId: // value for 'answerBlockId'
 *      blockAttachmentIds: // value for 'blockAttachmentIds'
 *   },
 * });
 */
export function useDownloadWorkAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>(DownloadWorkAttachmentsDocument, options);
      }
export type DownloadWorkAttachmentsMutationHookResult = ReturnType<typeof useDownloadWorkAttachmentsMutation>;
export type DownloadWorkAttachmentsMutationResult = Apollo.MutationResult<DownloadWorkAttachmentsMutation>;
export type DownloadWorkAttachmentsMutationOptions = Apollo.BaseMutationOptions<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>;
export const FeedbackDocument = gql`
    query Feedback($assessmentId: ID!) {
  token
  session {
    id
  }
  me {
    id
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
    tasks {
      id
      kind
      instructionSheet {
        id
        format
      }
    }
  }
}
    ${AssessmentFragmentDoc}`;

/**
 * __useFeedbackQuery__
 *
 * To run a query within a React component, call `useFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useFeedbackQuery(baseOptions: Apollo.QueryHookOptions<FeedbackQuery, FeedbackQueryVariables> & ({ variables: FeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument, options);
      }
export function useFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackQuery, FeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument, options);
        }
export function useFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackQuery, FeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument, options);
        }
export type FeedbackQueryHookResult = ReturnType<typeof useFeedbackQuery>;
export type FeedbackLazyQueryHookResult = ReturnType<typeof useFeedbackLazyQuery>;
export type FeedbackSuspenseQueryHookResult = ReturnType<typeof useFeedbackSuspenseQuery>;
export type FeedbackQueryResult = Apollo.QueryResult<FeedbackQuery, FeedbackQueryVariables>;
export const FeedbackSummaryDocument = gql`
    query FeedbackSummary($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  finalFeedbackVisibility: feedbackVisibilityForType(
    assessmentId: $assessmentId
    releaseType: FINAL
  ) {
    ...FeedbackVisibility
  }
  provisionalFeedbackVisibility: feedbackVisibilityForType(
    assessmentId: $assessmentId
    releaseType: PROVISIONAL
  ) {
    ...FeedbackVisibility
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
  studentOutcome(assessmentId: $assessmentId) {
    id
    studentId
    groupWorkOutcome {
      id
      workId
      workOutcomeRelease {
        ...WorkOutcomeRelease
      }
      draftSubmissionOutcomeRelease {
        id
      }
    }
    individualWorkOutcome {
      id
      workId
      finalScore
      workOutcomeRelease {
        ...WorkOutcomeRelease
      }
      draftSubmissionOutcomeRelease {
        id
      }
    }
    peerOutcome {
      id
      isComplete
      peerMaxScore
      selfMaxScore
      peerScore
      selfScore
      groupReportScaleFactor
    }
    final {
      ...ComponentBreakdown
    }
    provisional {
      ...ComponentBreakdown
    }
  }
}
    ${AssessmentFragmentDoc}
${FeedbackVisibilityFragmentDoc}
${FeatureFlagsFragmentDoc}
${WorkOutcomeReleaseFragmentDoc}
${ComponentBreakdownFragmentDoc}`;

/**
 * __useFeedbackSummaryQuery__
 *
 * To run a query within a React component, call `useFeedbackSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackSummaryQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useFeedbackSummaryQuery(baseOptions: Apollo.QueryHookOptions<FeedbackSummaryQuery, FeedbackSummaryQueryVariables> & ({ variables: FeedbackSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>(FeedbackSummaryDocument, options);
      }
export function useFeedbackSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>(FeedbackSummaryDocument, options);
        }
export function useFeedbackSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>(FeedbackSummaryDocument, options);
        }
export type FeedbackSummaryQueryHookResult = ReturnType<typeof useFeedbackSummaryQuery>;
export type FeedbackSummaryLazyQueryHookResult = ReturnType<typeof useFeedbackSummaryLazyQuery>;
export type FeedbackSummarySuspenseQueryHookResult = ReturnType<typeof useFeedbackSummarySuspenseQuery>;
export type FeedbackSummaryQueryResult = Apollo.QueryResult<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>;
export const GroupFeedbackDocument = gql`
    query GroupFeedback($assessmentId: ID!) {
  individualMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: INDIVIDUAL
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  groupMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: GROUP
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  peerMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: PEER
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  studentWorkGroup(assessmentId: $assessmentId) {
    id
    group {
      id
      activeGroupMembers {
        id
        user {
          id
          name
        }
      }
    }
  }
  studentOutcome(assessmentId: $assessmentId) {
    ...StudentOutcome
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
}
    ${MarkerRubricFragmentDoc}
${StudentOutcomeFragmentDoc}
${FeatureFlagsFragmentDoc}`;

/**
 * __useGroupFeedbackQuery__
 *
 * To run a query within a React component, call `useGroupFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupFeedbackQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupFeedbackQuery(baseOptions: Apollo.QueryHookOptions<GroupFeedbackQuery, GroupFeedbackQueryVariables> & ({ variables: GroupFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupFeedbackQuery, GroupFeedbackQueryVariables>(GroupFeedbackDocument, options);
      }
export function useGroupFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupFeedbackQuery, GroupFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupFeedbackQuery, GroupFeedbackQueryVariables>(GroupFeedbackDocument, options);
        }
export function useGroupFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupFeedbackQuery, GroupFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupFeedbackQuery, GroupFeedbackQueryVariables>(GroupFeedbackDocument, options);
        }
export type GroupFeedbackQueryHookResult = ReturnType<typeof useGroupFeedbackQuery>;
export type GroupFeedbackLazyQueryHookResult = ReturnType<typeof useGroupFeedbackLazyQuery>;
export type GroupFeedbackSuspenseQueryHookResult = ReturnType<typeof useGroupFeedbackSuspenseQuery>;
export type GroupFeedbackQueryResult = Apollo.QueryResult<GroupFeedbackQuery, GroupFeedbackQueryVariables>;
export const IndividualFeedbackDocument = gql`
    query IndividualFeedback($assessmentId: ID!) {
  individualMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: INDIVIDUAL
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  studentWorkOutcome(assessmentId: $assessmentId) {
    ...WorkOutcome
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
}
    ${MarkerRubricFragmentDoc}
${WorkOutcomeFragmentDoc}
${FeatureFlagsFragmentDoc}`;

/**
 * __useIndividualFeedbackQuery__
 *
 * To run a query within a React component, call `useIndividualFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualFeedbackQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useIndividualFeedbackQuery(baseOptions: Apollo.QueryHookOptions<IndividualFeedbackQuery, IndividualFeedbackQueryVariables> & ({ variables: IndividualFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>(IndividualFeedbackDocument, options);
      }
export function useIndividualFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>(IndividualFeedbackDocument, options);
        }
export function useIndividualFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>(IndividualFeedbackDocument, options);
        }
export type IndividualFeedbackQueryHookResult = ReturnType<typeof useIndividualFeedbackQuery>;
export type IndividualFeedbackLazyQueryHookResult = ReturnType<typeof useIndividualFeedbackLazyQuery>;
export type IndividualFeedbackSuspenseQueryHookResult = ReturnType<typeof useIndividualFeedbackSuspenseQuery>;
export type IndividualFeedbackQueryResult = Apollo.QueryResult<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>;
export const MfaFeedbackDocument = gql`
    query MfaFeedback($assessmentId: ID!) {
  assessmentMarkerRubrics(assessmentId: $assessmentId) {
    ...MarkerRubric
  }
  studentWorkOutcome(assessmentId: $assessmentId) {
    ...WorkOutcome
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
}
    ${MarkerRubricFragmentDoc}
${WorkOutcomeFragmentDoc}
${FeatureFlagsFragmentDoc}`;

/**
 * __useMfaFeedbackQuery__
 *
 * To run a query within a React component, call `useMfaFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useMfaFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMfaFeedbackQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useMfaFeedbackQuery(baseOptions: Apollo.QueryHookOptions<MfaFeedbackQuery, MfaFeedbackQueryVariables> & ({ variables: MfaFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MfaFeedbackQuery, MfaFeedbackQueryVariables>(MfaFeedbackDocument, options);
      }
export function useMfaFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MfaFeedbackQuery, MfaFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MfaFeedbackQuery, MfaFeedbackQueryVariables>(MfaFeedbackDocument, options);
        }
export function useMfaFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MfaFeedbackQuery, MfaFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MfaFeedbackQuery, MfaFeedbackQueryVariables>(MfaFeedbackDocument, options);
        }
export type MfaFeedbackQueryHookResult = ReturnType<typeof useMfaFeedbackQuery>;
export type MfaFeedbackLazyQueryHookResult = ReturnType<typeof useMfaFeedbackLazyQuery>;
export type MfaFeedbackSuspenseQueryHookResult = ReturnType<typeof useMfaFeedbackSuspenseQuery>;
export type MfaFeedbackQueryResult = Apollo.QueryResult<MfaFeedbackQuery, MfaFeedbackQueryVariables>;
export const SimilarityDocument = gql`
    query Similarity($submissionType: SubmissionType!, $workId: ID!) {
  latestResult(submissionType: $submissionType, workId: $workId) {
    id
    workId
    heraResultId
    returnedAt
    similarity {
      display
      label
      value
    }
  }
}
    `;

/**
 * __useSimilarityQuery__
 *
 * To run a query within a React component, call `useSimilarityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarityQuery({
 *   variables: {
 *      submissionType: // value for 'submissionType'
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useSimilarityQuery(baseOptions: Apollo.QueryHookOptions<SimilarityQuery, SimilarityQueryVariables> & ({ variables: SimilarityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
      }
export function useSimilarityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarityQuery, SimilarityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
        }
export function useSimilaritySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarityQuery, SimilarityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
        }
export type SimilarityQueryHookResult = ReturnType<typeof useSimilarityQuery>;
export type SimilarityLazyQueryHookResult = ReturnType<typeof useSimilarityLazyQuery>;
export type SimilaritySuspenseQueryHookResult = ReturnType<typeof useSimilaritySuspenseQuery>;
export type SimilarityQueryResult = Apollo.QueryResult<SimilarityQuery, SimilarityQueryVariables>;
export const AcceptStudentCharterDocument = gql`
    mutation AcceptStudentCharter($input: CharterAgreementInput!) {
  acceptStudentCharter(input: $input) {
    ...CharterAgreement
  }
}
    ${CharterAgreementFragmentDoc}`;
export type AcceptStudentCharterMutationFn = Apollo.MutationFunction<AcceptStudentCharterMutation, AcceptStudentCharterMutationVariables>;

/**
 * __useAcceptStudentCharterMutation__
 *
 * To run a mutation, you first call `useAcceptStudentCharterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptStudentCharterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptStudentCharterMutation, { data, loading, error }] = useAcceptStudentCharterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptStudentCharterMutation(baseOptions?: Apollo.MutationHookOptions<AcceptStudentCharterMutation, AcceptStudentCharterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptStudentCharterMutation, AcceptStudentCharterMutationVariables>(AcceptStudentCharterDocument, options);
      }
export type AcceptStudentCharterMutationHookResult = ReturnType<typeof useAcceptStudentCharterMutation>;
export type AcceptStudentCharterMutationResult = Apollo.MutationResult<AcceptStudentCharterMutation>;
export type AcceptStudentCharterMutationOptions = Apollo.BaseMutationOptions<AcceptStudentCharterMutation, AcceptStudentCharterMutationVariables>;
export const CharterDocument = gql`
    query Charter($assessmentId: ID!, $charterId: ID!) {
  token
  charter(charterId: $charterId) {
    ...Charter
  }
  charterForm(assessmentId: $assessmentId, published: true) {
    ...CharterForm
  }
}
    ${CharterFragmentDoc}
${CharterFormFragmentDoc}`;

/**
 * __useCharterQuery__
 *
 * To run a query within a React component, call `useCharterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharterQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      charterId: // value for 'charterId'
 *   },
 * });
 */
export function useCharterQuery(baseOptions: Apollo.QueryHookOptions<CharterQuery, CharterQueryVariables> & ({ variables: CharterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
      }
export function useCharterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharterQuery, CharterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
        }
export function useCharterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CharterQuery, CharterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
        }
export type CharterQueryHookResult = ReturnType<typeof useCharterQuery>;
export type CharterLazyQueryHookResult = ReturnType<typeof useCharterLazyQuery>;
export type CharterSuspenseQueryHookResult = ReturnType<typeof useCharterSuspenseQuery>;
export type CharterQueryResult = Apollo.QueryResult<CharterQuery, CharterQueryVariables>;
export const CharterStatusDocument = gql`
    query CharterStatus($assessmentId: ID!) {
  studentWorkGroup(assessmentId: $assessmentId) {
    charter {
      allMembersAccepted
    }
  }
}
    `;

/**
 * __useCharterStatusQuery__
 *
 * To run a query within a React component, call `useCharterStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharterStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharterStatusQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCharterStatusQuery(baseOptions: Apollo.QueryHookOptions<CharterStatusQuery, CharterStatusQueryVariables> & ({ variables: CharterStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharterStatusQuery, CharterStatusQueryVariables>(CharterStatusDocument, options);
      }
export function useCharterStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharterStatusQuery, CharterStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharterStatusQuery, CharterStatusQueryVariables>(CharterStatusDocument, options);
        }
export function useCharterStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CharterStatusQuery, CharterStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharterStatusQuery, CharterStatusQueryVariables>(CharterStatusDocument, options);
        }
export type CharterStatusQueryHookResult = ReturnType<typeof useCharterStatusQuery>;
export type CharterStatusLazyQueryHookResult = ReturnType<typeof useCharterStatusLazyQuery>;
export type CharterStatusSuspenseQueryHookResult = ReturnType<typeof useCharterStatusSuspenseQuery>;
export type CharterStatusQueryResult = Apollo.QueryResult<CharterStatusQuery, CharterStatusQueryVariables>;
export const SaveCharterEditorDocument = gql`
    mutation saveCharterEditor($input: CharterEditorInput!) {
  saveCharterEditor(input: $input) {
    id
    charterFormSectionId
    snapshotDoc
    snapshotVersion
    streamUuid
  }
}
    `;
export type SaveCharterEditorMutationFn = Apollo.MutationFunction<SaveCharterEditorMutation, SaveCharterEditorMutationVariables>;

/**
 * __useSaveCharterEditorMutation__
 *
 * To run a mutation, you first call `useSaveCharterEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCharterEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCharterEditorMutation, { data, loading, error }] = useSaveCharterEditorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCharterEditorMutation(baseOptions?: Apollo.MutationHookOptions<SaveCharterEditorMutation, SaveCharterEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCharterEditorMutation, SaveCharterEditorMutationVariables>(SaveCharterEditorDocument, options);
      }
export type SaveCharterEditorMutationHookResult = ReturnType<typeof useSaveCharterEditorMutation>;
export type SaveCharterEditorMutationResult = Apollo.MutationResult<SaveCharterEditorMutation>;
export type SaveCharterEditorMutationOptions = Apollo.BaseMutationOptions<SaveCharterEditorMutation, SaveCharterEditorMutationVariables>;
export const SetupCharterDocument = gql`
    mutation SetupCharter($groupId: ID!) {
  setupCharter(groupId: $groupId) {
    ...Charter
  }
}
    ${CharterFragmentDoc}`;
export type SetupCharterMutationFn = Apollo.MutationFunction<SetupCharterMutation, SetupCharterMutationVariables>;

/**
 * __useSetupCharterMutation__
 *
 * To run a mutation, you first call `useSetupCharterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupCharterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupCharterMutation, { data, loading, error }] = useSetupCharterMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSetupCharterMutation(baseOptions?: Apollo.MutationHookOptions<SetupCharterMutation, SetupCharterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupCharterMutation, SetupCharterMutationVariables>(SetupCharterDocument, options);
      }
export type SetupCharterMutationHookResult = ReturnType<typeof useSetupCharterMutation>;
export type SetupCharterMutationResult = Apollo.MutationResult<SetupCharterMutation>;
export type SetupCharterMutationOptions = Apollo.BaseMutationOptions<SetupCharterMutation, SetupCharterMutationVariables>;
export const UnlockStudentCharterDocument = gql`
    mutation UnlockStudentCharter($input: CharterAgreementInput!) {
  unlockStudentCharter(input: $input) {
    ...CharterAgreement
  }
}
    ${CharterAgreementFragmentDoc}`;
export type UnlockStudentCharterMutationFn = Apollo.MutationFunction<UnlockStudentCharterMutation, UnlockStudentCharterMutationVariables>;

/**
 * __useUnlockStudentCharterMutation__
 *
 * To run a mutation, you first call `useUnlockStudentCharterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockStudentCharterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockStudentCharterMutation, { data, loading, error }] = useUnlockStudentCharterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlockStudentCharterMutation(baseOptions?: Apollo.MutationHookOptions<UnlockStudentCharterMutation, UnlockStudentCharterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockStudentCharterMutation, UnlockStudentCharterMutationVariables>(UnlockStudentCharterDocument, options);
      }
export type UnlockStudentCharterMutationHookResult = ReturnType<typeof useUnlockStudentCharterMutation>;
export type UnlockStudentCharterMutationResult = Apollo.MutationResult<UnlockStudentCharterMutation>;
export type UnlockStudentCharterMutationOptions = Apollo.BaseMutationOptions<UnlockStudentCharterMutation, UnlockStudentCharterMutationVariables>;
export const UpdateMilestonesDocument = gql`
    mutation UpdateMilestones($input: UpdateMilestonesInput!) {
  updateMilestones(input: $input) {
    id
    milestones {
      deleted
      description
      dueDate
      id
      title
    }
  }
}
    `;
export type UpdateMilestonesMutationFn = Apollo.MutationFunction<UpdateMilestonesMutation, UpdateMilestonesMutationVariables>;

/**
 * __useUpdateMilestonesMutation__
 *
 * To run a mutation, you first call `useUpdateMilestonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMilestonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMilestonesMutation, { data, loading, error }] = useUpdateMilestonesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMilestonesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMilestonesMutation, UpdateMilestonesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMilestonesMutation, UpdateMilestonesMutationVariables>(UpdateMilestonesDocument, options);
      }
export type UpdateMilestonesMutationHookResult = ReturnType<typeof useUpdateMilestonesMutation>;
export type UpdateMilestonesMutationResult = Apollo.MutationResult<UpdateMilestonesMutation>;
export type UpdateMilestonesMutationOptions = Apollo.BaseMutationOptions<UpdateMilestonesMutation, UpdateMilestonesMutationVariables>;
export const AssessmentEmailConsentDocument = gql`
    query AssessmentEmailConsent($assessmentId: ID!) {
  assessmentEmailConsent(assessmentId: $assessmentId) {
    enabled
    consent
  }
}
    `;

/**
 * __useAssessmentEmailConsentQuery__
 *
 * To run a query within a React component, call `useAssessmentEmailConsentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentEmailConsentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentEmailConsentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentEmailConsentQuery(baseOptions: Apollo.QueryHookOptions<AssessmentEmailConsentQuery, AssessmentEmailConsentQueryVariables> & ({ variables: AssessmentEmailConsentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentEmailConsentQuery, AssessmentEmailConsentQueryVariables>(AssessmentEmailConsentDocument, options);
      }
export function useAssessmentEmailConsentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentEmailConsentQuery, AssessmentEmailConsentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentEmailConsentQuery, AssessmentEmailConsentQueryVariables>(AssessmentEmailConsentDocument, options);
        }
export function useAssessmentEmailConsentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentEmailConsentQuery, AssessmentEmailConsentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentEmailConsentQuery, AssessmentEmailConsentQueryVariables>(AssessmentEmailConsentDocument, options);
        }
export type AssessmentEmailConsentQueryHookResult = ReturnType<typeof useAssessmentEmailConsentQuery>;
export type AssessmentEmailConsentLazyQueryHookResult = ReturnType<typeof useAssessmentEmailConsentLazyQuery>;
export type AssessmentEmailConsentSuspenseQueryHookResult = ReturnType<typeof useAssessmentEmailConsentSuspenseQuery>;
export type AssessmentEmailConsentQueryResult = Apollo.QueryResult<AssessmentEmailConsentQuery, AssessmentEmailConsentQueryVariables>;
export const FinaliseGroupDocument = gql`
    mutation FinaliseGroup($assessmentId: ID!) {
  finaliseGroup(assessmentId: $assessmentId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type FinaliseGroupMutationFn = Apollo.MutationFunction<FinaliseGroupMutation, FinaliseGroupMutationVariables>;

/**
 * __useFinaliseGroupMutation__
 *
 * To run a mutation, you first call `useFinaliseGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinaliseGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finaliseGroupMutation, { data, loading, error }] = useFinaliseGroupMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useFinaliseGroupMutation(baseOptions?: Apollo.MutationHookOptions<FinaliseGroupMutation, FinaliseGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinaliseGroupMutation, FinaliseGroupMutationVariables>(FinaliseGroupDocument, options);
      }
export type FinaliseGroupMutationHookResult = ReturnType<typeof useFinaliseGroupMutation>;
export type FinaliseGroupMutationResult = Apollo.MutationResult<FinaliseGroupMutation>;
export type FinaliseGroupMutationOptions = Apollo.BaseMutationOptions<FinaliseGroupMutation, FinaliseGroupMutationVariables>;
export const GroupUpdatedDocument = gql`
    subscription groupUpdated($assessmentId: ID!) {
  groupUpdated(assessmentId: $assessmentId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;

/**
 * __useGroupUpdatedSubscription__
 *
 * To run a query within a React component, call `useGroupUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGroupUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<GroupUpdatedSubscription, GroupUpdatedSubscriptionVariables> & ({ variables: GroupUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GroupUpdatedSubscription, GroupUpdatedSubscriptionVariables>(GroupUpdatedDocument, options);
      }
export type GroupUpdatedSubscriptionHookResult = ReturnType<typeof useGroupUpdatedSubscription>;
export type GroupUpdatedSubscriptionResult = Apollo.SubscriptionResult<GroupUpdatedSubscription>;
export const ListGroupsDocument = gql`
    query ListGroups($assessmentId: ID!) {
  groupList(assessmentId: $assessmentId) {
    ...Group
  }
  token
  me {
    id
    name
  }
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      id
      groupSelfEnrollmentDeadline
      groupFinalised
    }
  }
}
    ${GroupFragmentDoc}`;

/**
 * __useListGroupsQuery__
 *
 * To run a query within a React component, call `useListGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGroupsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useListGroupsQuery(baseOptions: Apollo.QueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables> & ({ variables: ListGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
      }
export function useListGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
        }
export function useListGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
        }
export type ListGroupsQueryHookResult = ReturnType<typeof useListGroupsQuery>;
export type ListGroupsLazyQueryHookResult = ReturnType<typeof useListGroupsLazyQuery>;
export type ListGroupsSuspenseQueryHookResult = ReturnType<typeof useListGroupsSuspenseQuery>;
export type ListGroupsQueryResult = Apollo.QueryResult<ListGroupsQuery, ListGroupsQueryVariables>;
export const JoinGroupDocument = gql`
    mutation JoinGroup($assessmentId: ID!, $groupId: ID!) {
  joinGroup(assessmentId: $assessmentId, groupId: $groupId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type JoinGroupMutationFn = Apollo.MutationFunction<JoinGroupMutation, JoinGroupMutationVariables>;

/**
 * __useJoinGroupMutation__
 *
 * To run a mutation, you first call `useJoinGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinGroupMutation, { data, loading, error }] = useJoinGroupMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useJoinGroupMutation(baseOptions?: Apollo.MutationHookOptions<JoinGroupMutation, JoinGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinGroupMutation, JoinGroupMutationVariables>(JoinGroupDocument, options);
      }
export type JoinGroupMutationHookResult = ReturnType<typeof useJoinGroupMutation>;
export type JoinGroupMutationResult = Apollo.MutationResult<JoinGroupMutation>;
export type JoinGroupMutationOptions = Apollo.BaseMutationOptions<JoinGroupMutation, JoinGroupMutationVariables>;
export const LeaveGroupDocument = gql`
    mutation leaveGroup($assessmentId: ID!, $groupId: ID!) {
  leaveGroup(assessmentId: $assessmentId, groupId: $groupId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type LeaveGroupMutationFn = Apollo.MutationFunction<LeaveGroupMutation, LeaveGroupMutationVariables>;

/**
 * __useLeaveGroupMutation__
 *
 * To run a mutation, you first call `useLeaveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveGroupMutation, { data, loading, error }] = useLeaveGroupMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useLeaveGroupMutation(baseOptions?: Apollo.MutationHookOptions<LeaveGroupMutation, LeaveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveGroupMutation, LeaveGroupMutationVariables>(LeaveGroupDocument, options);
      }
export type LeaveGroupMutationHookResult = ReturnType<typeof useLeaveGroupMutation>;
export type LeaveGroupMutationResult = Apollo.MutationResult<LeaveGroupMutation>;
export type LeaveGroupMutationOptions = Apollo.BaseMutationOptions<LeaveGroupMutation, LeaveGroupMutationVariables>;
export const SetAssessmentEmailConsentDocument = gql`
    mutation SetAssessmentEmailConsent($assessmentId: ID!, $consent: Boolean!) {
  setAssessmentEmailConsent(assessmentId: $assessmentId, consent: $consent) {
    enabled
    consent
  }
}
    `;
export type SetAssessmentEmailConsentMutationFn = Apollo.MutationFunction<SetAssessmentEmailConsentMutation, SetAssessmentEmailConsentMutationVariables>;

/**
 * __useSetAssessmentEmailConsentMutation__
 *
 * To run a mutation, you first call `useSetAssessmentEmailConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAssessmentEmailConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAssessmentEmailConsentMutation, { data, loading, error }] = useSetAssessmentEmailConsentMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useSetAssessmentEmailConsentMutation(baseOptions?: Apollo.MutationHookOptions<SetAssessmentEmailConsentMutation, SetAssessmentEmailConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAssessmentEmailConsentMutation, SetAssessmentEmailConsentMutationVariables>(SetAssessmentEmailConsentDocument, options);
      }
export type SetAssessmentEmailConsentMutationHookResult = ReturnType<typeof useSetAssessmentEmailConsentMutation>;
export type SetAssessmentEmailConsentMutationResult = Apollo.MutationResult<SetAssessmentEmailConsentMutation>;
export type SetAssessmentEmailConsentMutationOptions = Apollo.BaseMutationOptions<SetAssessmentEmailConsentMutation, SetAssessmentEmailConsentMutationVariables>;
export const PeerOverviewDocument = gql`
    query PeerOverview($assessmentId: ID!) {
  me {
    id
    name
  }
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      selfEvaluationEnabled
      groupCharterEnabled
      groupCharterAvailable
      groupCharterAcceptanceRequired
      peerEvaluationDueDate
      dueDate
    }
  }
  peerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: PEER
    status: PUBLISHED
  ) {
    id
    criteria {
      ...Criterion
    }
  }
  studentWorkGroup(assessmentId: $assessmentId) {
    id
    work {
      id
      settings {
        id
        dueDate
      }
    }
    charter {
      latestAgreement {
        id
        acceptedAt
      }
    }
    group {
      id
      activeGroupMembers {
        id
        user {
          id
          name
        }
      }
    }
  }
  groupPeerOutcomes(assessmentId: $assessmentId) {
    ...GroupPeerOutcome
  }
  studentPeerEvalProgress(assessmentId: $assessmentId) {
    hasEvaluatedAllPeers
    hasCompletedSelfEvaluation
  }
}
    ${CriterionFragmentDoc}
${GroupPeerOutcomeFragmentDoc}`;

/**
 * __usePeerOverviewQuery__
 *
 * To run a query within a React component, call `usePeerOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeerOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeerOverviewQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function usePeerOverviewQuery(baseOptions: Apollo.QueryHookOptions<PeerOverviewQuery, PeerOverviewQueryVariables> & ({ variables: PeerOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeerOverviewQuery, PeerOverviewQueryVariables>(PeerOverviewDocument, options);
      }
export function usePeerOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeerOverviewQuery, PeerOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeerOverviewQuery, PeerOverviewQueryVariables>(PeerOverviewDocument, options);
        }
export function usePeerOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeerOverviewQuery, PeerOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeerOverviewQuery, PeerOverviewQueryVariables>(PeerOverviewDocument, options);
        }
export type PeerOverviewQueryHookResult = ReturnType<typeof usePeerOverviewQuery>;
export type PeerOverviewLazyQueryHookResult = ReturnType<typeof usePeerOverviewLazyQuery>;
export type PeerOverviewSuspenseQueryHookResult = ReturnType<typeof usePeerOverviewSuspenseQuery>;
export type PeerOverviewQueryResult = Apollo.QueryResult<PeerOverviewQuery, PeerOverviewQueryVariables>;
export const ProjectIssuesDocument = gql`
    query ProjectIssues($groupId: ID!) {
  projectIssues(groupId: $groupId) {
    id
    title
    type
    status
    groupId
    deleted
    description
    dueDate
    parentId
    assignees
  }
}
    `;

/**
 * __useProjectIssuesQuery__
 *
 * To run a query within a React component, call `useProjectIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectIssuesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useProjectIssuesQuery(baseOptions: Apollo.QueryHookOptions<ProjectIssuesQuery, ProjectIssuesQueryVariables> & ({ variables: ProjectIssuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectIssuesQuery, ProjectIssuesQueryVariables>(ProjectIssuesDocument, options);
      }
export function useProjectIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectIssuesQuery, ProjectIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectIssuesQuery, ProjectIssuesQueryVariables>(ProjectIssuesDocument, options);
        }
export function useProjectIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectIssuesQuery, ProjectIssuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectIssuesQuery, ProjectIssuesQueryVariables>(ProjectIssuesDocument, options);
        }
export type ProjectIssuesQueryHookResult = ReturnType<typeof useProjectIssuesQuery>;
export type ProjectIssuesLazyQueryHookResult = ReturnType<typeof useProjectIssuesLazyQuery>;
export type ProjectIssuesSuspenseQueryHookResult = ReturnType<typeof useProjectIssuesSuspenseQuery>;
export type ProjectIssuesQueryResult = Apollo.QueryResult<ProjectIssuesQuery, ProjectIssuesQueryVariables>;
export const UpdateProjectIssueDocument = gql`
    mutation UpdateProjectIssue($input: UpdateProjectIssueInput!) {
  updateProjectIssue(input: $input) {
    id
    title
    type
    status
    deleted
    description
    dueDate
    assignees
    parentId
  }
}
    `;
export type UpdateProjectIssueMutationFn = Apollo.MutationFunction<UpdateProjectIssueMutation, UpdateProjectIssueMutationVariables>;

/**
 * __useUpdateProjectIssueMutation__
 *
 * To run a mutation, you first call `useUpdateProjectIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectIssueMutation, { data, loading, error }] = useUpdateProjectIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectIssueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectIssueMutation, UpdateProjectIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectIssueMutation, UpdateProjectIssueMutationVariables>(UpdateProjectIssueDocument, options);
      }
export type UpdateProjectIssueMutationHookResult = ReturnType<typeof useUpdateProjectIssueMutation>;
export type UpdateProjectIssueMutationResult = Apollo.MutationResult<UpdateProjectIssueMutation>;
export type UpdateProjectIssueMutationOptions = Apollo.BaseMutationOptions<UpdateProjectIssueMutation, UpdateProjectIssueMutationVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($assessmentId: ID!, $message: MessageInput!) {
  sendMessage(assessmentId: $assessmentId, message: $message) {
    ...Message
  }
}
    ${MessageFragmentDoc}`;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const SetupGroupWorkDocument = gql`
    mutation SetupGroupWork($groupId: ID!) {
  setupGroupWork(groupId: $groupId) {
    id
    work {
      id
    }
  }
}
    `;
export type SetupGroupWorkMutationFn = Apollo.MutationFunction<SetupGroupWorkMutation, SetupGroupWorkMutationVariables>;

/**
 * __useSetupGroupWorkMutation__
 *
 * To run a mutation, you first call `useSetupGroupWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupGroupWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupGroupWorkMutation, { data, loading, error }] = useSetupGroupWorkMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSetupGroupWorkMutation(baseOptions?: Apollo.MutationHookOptions<SetupGroupWorkMutation, SetupGroupWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupGroupWorkMutation, SetupGroupWorkMutationVariables>(SetupGroupWorkDocument, options);
      }
export type SetupGroupWorkMutationHookResult = ReturnType<typeof useSetupGroupWorkMutation>;
export type SetupGroupWorkMutationResult = Apollo.MutationResult<SetupGroupWorkMutation>;
export type SetupGroupWorkMutationOptions = Apollo.BaseMutationOptions<SetupGroupWorkMutation, SetupGroupWorkMutationVariables>;
export const StudentActionFeedDocument = gql`
    query StudentActionFeed($assessmentId: ID!) {
  studentActionFeed(assessmentId: $assessmentId) {
    state
    badgeCount
    groupWorkViewed
    individualWorkViewed
    peerEvaluationViewed
    actions {
      type
      tier
      tone
      title
      detail
      action {
        label
        targetKind
      }
    }
    waitingOnOthers {
      type
      title
      detail
    }
  }
}
    `;

/**
 * __useStudentActionFeedQuery__
 *
 * To run a query within a React component, call `useStudentActionFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentActionFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentActionFeedQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useStudentActionFeedQuery(baseOptions: Apollo.QueryHookOptions<StudentActionFeedQuery, StudentActionFeedQueryVariables> & ({ variables: StudentActionFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentActionFeedQuery, StudentActionFeedQueryVariables>(StudentActionFeedDocument, options);
      }
export function useStudentActionFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentActionFeedQuery, StudentActionFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentActionFeedQuery, StudentActionFeedQueryVariables>(StudentActionFeedDocument, options);
        }
export function useStudentActionFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentActionFeedQuery, StudentActionFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentActionFeedQuery, StudentActionFeedQueryVariables>(StudentActionFeedDocument, options);
        }
export type StudentActionFeedQueryHookResult = ReturnType<typeof useStudentActionFeedQuery>;
export type StudentActionFeedLazyQueryHookResult = ReturnType<typeof useStudentActionFeedLazyQuery>;
export type StudentActionFeedSuspenseQueryHookResult = ReturnType<typeof useStudentActionFeedSuspenseQuery>;
export type StudentActionFeedQueryResult = Apollo.QueryResult<StudentActionFeedQuery, StudentActionFeedQueryVariables>;
export const UpdateGroupChangeRequestDocument = gql`
    mutation UpdateGroupChangeRequest($assessmentId: ID!, $messageId: ID!, $reason: String!) {
  updateGroupChangeRequest(
    assessmentId: $assessmentId
    messageId: $messageId
    reason: $reason
  ) {
    ...Message
  }
}
    ${MessageFragmentDoc}`;
export type UpdateGroupChangeRequestMutationFn = Apollo.MutationFunction<UpdateGroupChangeRequestMutation, UpdateGroupChangeRequestMutationVariables>;

/**
 * __useUpdateGroupChangeRequestMutation__
 *
 * To run a mutation, you first call `useUpdateGroupChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupChangeRequestMutation, { data, loading, error }] = useUpdateGroupChangeRequestMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      messageId: // value for 'messageId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateGroupChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupChangeRequestMutation, UpdateGroupChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupChangeRequestMutation, UpdateGroupChangeRequestMutationVariables>(UpdateGroupChangeRequestDocument, options);
      }
export type UpdateGroupChangeRequestMutationHookResult = ReturnType<typeof useUpdateGroupChangeRequestMutation>;
export type UpdateGroupChangeRequestMutationResult = Apollo.MutationResult<UpdateGroupChangeRequestMutation>;
export type UpdateGroupChangeRequestMutationOptions = Apollo.BaseMutationOptions<UpdateGroupChangeRequestMutation, UpdateGroupChangeRequestMutationVariables>;
export const WithdrawGroupChangeRequestDocument = gql`
    mutation WithdrawGroupChangeRequest($assessmentId: ID!, $messageId: ID!) {
  withdrawGroupChangeRequest(assessmentId: $assessmentId, messageId: $messageId) {
    ...Message
  }
}
    ${MessageFragmentDoc}`;
export type WithdrawGroupChangeRequestMutationFn = Apollo.MutationFunction<WithdrawGroupChangeRequestMutation, WithdrawGroupChangeRequestMutationVariables>;

/**
 * __useWithdrawGroupChangeRequestMutation__
 *
 * To run a mutation, you first call `useWithdrawGroupChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawGroupChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawGroupChangeRequestMutation, { data, loading, error }] = useWithdrawGroupChangeRequestMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useWithdrawGroupChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawGroupChangeRequestMutation, WithdrawGroupChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawGroupChangeRequestMutation, WithdrawGroupChangeRequestMutationVariables>(WithdrawGroupChangeRequestDocument, options);
      }
export type WithdrawGroupChangeRequestMutationHookResult = ReturnType<typeof useWithdrawGroupChangeRequestMutation>;
export type WithdrawGroupChangeRequestMutationResult = Apollo.MutationResult<WithdrawGroupChangeRequestMutation>;
export type WithdrawGroupChangeRequestMutationOptions = Apollo.BaseMutationOptions<WithdrawGroupChangeRequestMutation, WithdrawGroupChangeRequestMutationVariables>;
export const WorkGroupDocument = gql`
    query WorkGroup($assessmentId: ID!) {
  studentWorkGroup(assessmentId: $assessmentId) {
    id
    finalised
    latestGroupChangeRequest(assessmentId: $assessmentId) {
      ...Message
    }
    charter {
      ...Charter
    }
    group {
      ...Group
    }
    work {
      id
      result(submissionType: FINAL) {
        ...Result
      }
      settings {
        ...WorkSettings
      }
    }
    individualWork {
      id
      result(submissionType: FINAL) {
        ...Result
      }
      settings {
        ...WorkSettings
      }
    }
  }
}
    ${MessageFragmentDoc}
${CharterFragmentDoc}
${GroupFragmentDoc}
${ResultFragmentDoc}
${WorkSettingsFragmentDoc}`;

/**
 * __useWorkGroupQuery__
 *
 * To run a query within a React component, call `useWorkGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkGroupQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useWorkGroupQuery(baseOptions: Apollo.QueryHookOptions<WorkGroupQuery, WorkGroupQueryVariables> & ({ variables: WorkGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkGroupQuery, WorkGroupQueryVariables>(WorkGroupDocument, options);
      }
export function useWorkGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkGroupQuery, WorkGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkGroupQuery, WorkGroupQueryVariables>(WorkGroupDocument, options);
        }
export function useWorkGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkGroupQuery, WorkGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkGroupQuery, WorkGroupQueryVariables>(WorkGroupDocument, options);
        }
export type WorkGroupQueryHookResult = ReturnType<typeof useWorkGroupQuery>;
export type WorkGroupLazyQueryHookResult = ReturnType<typeof useWorkGroupLazyQuery>;
export type WorkGroupSuspenseQueryHookResult = ReturnType<typeof useWorkGroupSuspenseQuery>;
export type WorkGroupQueryResult = Apollo.QueryResult<WorkGroupQuery, WorkGroupQueryVariables>;
export const CompletePeerOutcomesDocument = gql`
    mutation CompletePeerOutcomes($assessmentId: ID!) {
  completePeerOutcomes(assessmentId: $assessmentId) {
    ...GroupPeerOutcome
  }
}
    ${GroupPeerOutcomeFragmentDoc}`;
export type CompletePeerOutcomesMutationFn = Apollo.MutationFunction<CompletePeerOutcomesMutation, CompletePeerOutcomesMutationVariables>;

/**
 * __useCompletePeerOutcomesMutation__
 *
 * To run a mutation, you first call `useCompletePeerOutcomesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePeerOutcomesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePeerOutcomesMutation, { data, loading, error }] = useCompletePeerOutcomesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCompletePeerOutcomesMutation(baseOptions?: Apollo.MutationHookOptions<CompletePeerOutcomesMutation, CompletePeerOutcomesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompletePeerOutcomesMutation, CompletePeerOutcomesMutationVariables>(CompletePeerOutcomesDocument, options);
      }
export type CompletePeerOutcomesMutationHookResult = ReturnType<typeof useCompletePeerOutcomesMutation>;
export type CompletePeerOutcomesMutationResult = Apollo.MutationResult<CompletePeerOutcomesMutation>;
export type CompletePeerOutcomesMutationOptions = Apollo.BaseMutationOptions<CompletePeerOutcomesMutation, CompletePeerOutcomesMutationVariables>;
export const MarkPeerOutcomeDocument = gql`
    mutation MarkPeerOutcome($assessmentId: ID!, $input: MarkPeerOutcomeInput!) {
  markPeerOutcome(assessmentId: $assessmentId, input: $input) {
    ...GroupPeerOutcome
  }
}
    ${GroupPeerOutcomeFragmentDoc}`;
export type MarkPeerOutcomeMutationFn = Apollo.MutationFunction<MarkPeerOutcomeMutation, MarkPeerOutcomeMutationVariables>;

/**
 * __useMarkPeerOutcomeMutation__
 *
 * To run a mutation, you first call `useMarkPeerOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPeerOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPeerOutcomeMutation, { data, loading, error }] = useMarkPeerOutcomeMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkPeerOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<MarkPeerOutcomeMutation, MarkPeerOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPeerOutcomeMutation, MarkPeerOutcomeMutationVariables>(MarkPeerOutcomeDocument, options);
      }
export type MarkPeerOutcomeMutationHookResult = ReturnType<typeof useMarkPeerOutcomeMutation>;
export type MarkPeerOutcomeMutationResult = Apollo.MutationResult<MarkPeerOutcomeMutation>;
export type MarkPeerOutcomeMutationOptions = Apollo.BaseMutationOptions<MarkPeerOutcomeMutation, MarkPeerOutcomeMutationVariables>;
export const PeerAssessmentDocument = gql`
    query PeerAssessment($assessmentId: ID!) {
  me {
    ...User
  }
  studentWorkGroup(assessmentId: $assessmentId) {
    id
    group {
      id
      activeGroupMembers {
        id
        user {
          ...User
        }
      }
    }
  }
  peerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: PEER
    status: PUBLISHED
  ) {
    id
    criteria {
      ...Criterion
    }
  }
  groupPeerOutcomes(assessmentId: $assessmentId) {
    ...GroupPeerOutcome
  }
  instructionSheet(assessmentId: $assessmentId, kind: PEER) {
    ...Sheet
  }
}
    ${UserFragmentDoc}
${CriterionFragmentDoc}
${GroupPeerOutcomeFragmentDoc}
${SheetFragmentDoc}`;

/**
 * __usePeerAssessmentQuery__
 *
 * To run a query within a React component, call `usePeerAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeerAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeerAssessmentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function usePeerAssessmentQuery(baseOptions: Apollo.QueryHookOptions<PeerAssessmentQuery, PeerAssessmentQueryVariables> & ({ variables: PeerAssessmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeerAssessmentQuery, PeerAssessmentQueryVariables>(PeerAssessmentDocument, options);
      }
export function usePeerAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeerAssessmentQuery, PeerAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeerAssessmentQuery, PeerAssessmentQueryVariables>(PeerAssessmentDocument, options);
        }
export function usePeerAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeerAssessmentQuery, PeerAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeerAssessmentQuery, PeerAssessmentQueryVariables>(PeerAssessmentDocument, options);
        }
export type PeerAssessmentQueryHookResult = ReturnType<typeof usePeerAssessmentQuery>;
export type PeerAssessmentLazyQueryHookResult = ReturnType<typeof usePeerAssessmentLazyQuery>;
export type PeerAssessmentSuspenseQueryHookResult = ReturnType<typeof usePeerAssessmentSuspenseQuery>;
export type PeerAssessmentQueryResult = Apollo.QueryResult<PeerAssessmentQuery, PeerAssessmentQueryVariables>;
export const ResetGivenEvaluationsDocument = gql`
    mutation ResetGivenEvaluations($assessmentId: ID!) {
  resetCriterionOutcomes(assessmentId: $assessmentId)
}
    `;
export type ResetGivenEvaluationsMutationFn = Apollo.MutationFunction<ResetGivenEvaluationsMutation, ResetGivenEvaluationsMutationVariables>;

/**
 * __useResetGivenEvaluationsMutation__
 *
 * To run a mutation, you first call `useResetGivenEvaluationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetGivenEvaluationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetGivenEvaluationsMutation, { data, loading, error }] = useResetGivenEvaluationsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResetGivenEvaluationsMutation(baseOptions?: Apollo.MutationHookOptions<ResetGivenEvaluationsMutation, ResetGivenEvaluationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetGivenEvaluationsMutation, ResetGivenEvaluationsMutationVariables>(ResetGivenEvaluationsDocument, options);
      }
export type ResetGivenEvaluationsMutationHookResult = ReturnType<typeof useResetGivenEvaluationsMutation>;
export type ResetGivenEvaluationsMutationResult = Apollo.MutationResult<ResetGivenEvaluationsMutation>;
export type ResetGivenEvaluationsMutationOptions = Apollo.BaseMutationOptions<ResetGivenEvaluationsMutation, ResetGivenEvaluationsMutationVariables>;
export const StudentSentimentChecksDocument = gql`
    query StudentSentimentChecks($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      sentimentCheckSkipEnabled
    }
  }
  studentSentimentChecks(assessmentId: $assessmentId) {
    order
    startTime
    endTime
    sentimentCheck {
      ...SentimentCheck
    }
  }
}
    ${SentimentCheckFragmentDoc}`;

/**
 * __useStudentSentimentChecksQuery__
 *
 * To run a query within a React component, call `useStudentSentimentChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSentimentChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSentimentChecksQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useStudentSentimentChecksQuery(baseOptions: Apollo.QueryHookOptions<StudentSentimentChecksQuery, StudentSentimentChecksQueryVariables> & ({ variables: StudentSentimentChecksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentSentimentChecksQuery, StudentSentimentChecksQueryVariables>(StudentSentimentChecksDocument, options);
      }
export function useStudentSentimentChecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentSentimentChecksQuery, StudentSentimentChecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentSentimentChecksQuery, StudentSentimentChecksQueryVariables>(StudentSentimentChecksDocument, options);
        }
export function useStudentSentimentChecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentSentimentChecksQuery, StudentSentimentChecksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentSentimentChecksQuery, StudentSentimentChecksQueryVariables>(StudentSentimentChecksDocument, options);
        }
export type StudentSentimentChecksQueryHookResult = ReturnType<typeof useStudentSentimentChecksQuery>;
export type StudentSentimentChecksLazyQueryHookResult = ReturnType<typeof useStudentSentimentChecksLazyQuery>;
export type StudentSentimentChecksSuspenseQueryHookResult = ReturnType<typeof useStudentSentimentChecksSuspenseQuery>;
export type StudentSentimentChecksQueryResult = Apollo.QueryResult<StudentSentimentChecksQuery, StudentSentimentChecksQueryVariables>;
export const SubmitSentimentCheckDocument = gql`
    mutation SubmitSentimentCheck($assessmentId: ID!, $input: SentimentCheckInput!) {
  submitSentimentCheck(assessmentId: $assessmentId, input: $input) {
    ...SentimentCheck
  }
}
    ${SentimentCheckFragmentDoc}`;
export type SubmitSentimentCheckMutationFn = Apollo.MutationFunction<SubmitSentimentCheckMutation, SubmitSentimentCheckMutationVariables>;

/**
 * __useSubmitSentimentCheckMutation__
 *
 * To run a mutation, you first call `useSubmitSentimentCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSentimentCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSentimentCheckMutation, { data, loading, error }] = useSubmitSentimentCheckMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSentimentCheckMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSentimentCheckMutation, SubmitSentimentCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSentimentCheckMutation, SubmitSentimentCheckMutationVariables>(SubmitSentimentCheckDocument, options);
      }
export type SubmitSentimentCheckMutationHookResult = ReturnType<typeof useSubmitSentimentCheckMutation>;
export type SubmitSentimentCheckMutationResult = Apollo.MutationResult<SubmitSentimentCheckMutation>;
export type SubmitSentimentCheckMutationOptions = Apollo.BaseMutationOptions<SubmitSentimentCheckMutation, SubmitSentimentCheckMutationVariables>;
export const CompleteSocraticTurnDocument = gql`
    mutation CompleteSocraticTurn($workId: ID!, $input: CompleteSocraticTurnInput!) {
  completeSocraticTurn(workId: $workId, input: $input) {
    dialogue {
      ...SocraticDialogue
    }
    error
  }
}
    ${SocraticDialogueFragmentDoc}`;
export type CompleteSocraticTurnMutationFn = Apollo.MutationFunction<CompleteSocraticTurnMutation, CompleteSocraticTurnMutationVariables>;

/**
 * __useCompleteSocraticTurnMutation__
 *
 * To run a mutation, you first call `useCompleteSocraticTurnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSocraticTurnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSocraticTurnMutation, { data, loading, error }] = useCompleteSocraticTurnMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteSocraticTurnMutation(baseOptions?: Apollo.MutationHookOptions<CompleteSocraticTurnMutation, CompleteSocraticTurnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteSocraticTurnMutation, CompleteSocraticTurnMutationVariables>(CompleteSocraticTurnDocument, options);
      }
export type CompleteSocraticTurnMutationHookResult = ReturnType<typeof useCompleteSocraticTurnMutation>;
export type CompleteSocraticTurnMutationResult = Apollo.MutationResult<CompleteSocraticTurnMutation>;
export type CompleteSocraticTurnMutationOptions = Apollo.BaseMutationOptions<CompleteSocraticTurnMutation, CompleteSocraticTurnMutationVariables>;
export const CreateSocraticDialogueDocument = gql`
    mutation CreateSocraticDialogue($workId: ID!, $sessionId: ID!, $attemptNumber: Int!) {
  createSocraticDialogue(
    workId: $workId
    sessionId: $sessionId
    attemptNumber: $attemptNumber
  ) {
    session {
      ...SocraticSession
    }
    error
  }
}
    ${SocraticSessionFragmentDoc}`;
export type CreateSocraticDialogueMutationFn = Apollo.MutationFunction<CreateSocraticDialogueMutation, CreateSocraticDialogueMutationVariables>;

/**
 * __useCreateSocraticDialogueMutation__
 *
 * To run a mutation, you first call `useCreateSocraticDialogueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSocraticDialogueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSocraticDialogueMutation, { data, loading, error }] = useCreateSocraticDialogueMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      sessionId: // value for 'sessionId'
 *      attemptNumber: // value for 'attemptNumber'
 *   },
 * });
 */
export function useCreateSocraticDialogueMutation(baseOptions?: Apollo.MutationHookOptions<CreateSocraticDialogueMutation, CreateSocraticDialogueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSocraticDialogueMutation, CreateSocraticDialogueMutationVariables>(CreateSocraticDialogueDocument, options);
      }
export type CreateSocraticDialogueMutationHookResult = ReturnType<typeof useCreateSocraticDialogueMutation>;
export type CreateSocraticDialogueMutationResult = Apollo.MutationResult<CreateSocraticDialogueMutation>;
export type CreateSocraticDialogueMutationOptions = Apollo.BaseMutationOptions<CreateSocraticDialogueMutation, CreateSocraticDialogueMutationVariables>;
export const RecordSocraticTurnPreparationMediaDocument = gql`
    mutation RecordSocraticTurnPreparationMedia($workId: ID!, $input: RecordSocraticTurnPreparationMediaInput!) {
  recordSocraticTurnPreparationMedia(workId: $workId, input: $input) {
    turn {
      id
    }
    error
  }
}
    `;
export type RecordSocraticTurnPreparationMediaMutationFn = Apollo.MutationFunction<RecordSocraticTurnPreparationMediaMutation, RecordSocraticTurnPreparationMediaMutationVariables>;

/**
 * __useRecordSocraticTurnPreparationMediaMutation__
 *
 * To run a mutation, you first call `useRecordSocraticTurnPreparationMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordSocraticTurnPreparationMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordSocraticTurnPreparationMediaMutation, { data, loading, error }] = useRecordSocraticTurnPreparationMediaMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordSocraticTurnPreparationMediaMutation(baseOptions?: Apollo.MutationHookOptions<RecordSocraticTurnPreparationMediaMutation, RecordSocraticTurnPreparationMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordSocraticTurnPreparationMediaMutation, RecordSocraticTurnPreparationMediaMutationVariables>(RecordSocraticTurnPreparationMediaDocument, options);
      }
export type RecordSocraticTurnPreparationMediaMutationHookResult = ReturnType<typeof useRecordSocraticTurnPreparationMediaMutation>;
export type RecordSocraticTurnPreparationMediaMutationResult = Apollo.MutationResult<RecordSocraticTurnPreparationMediaMutation>;
export type RecordSocraticTurnPreparationMediaMutationOptions = Apollo.BaseMutationOptions<RecordSocraticTurnPreparationMediaMutation, RecordSocraticTurnPreparationMediaMutationVariables>;
export const SocraticDialogueDocument = gql`
    query SocraticDialogue($assessmentId: ID!, $dialogueId: ID!) {
  socraticDialogue(assessmentId: $assessmentId, dialogueId: $dialogueId) {
    ...SocraticDialogue
  }
}
    ${SocraticDialogueFragmentDoc}`;

/**
 * __useSocraticDialogueQuery__
 *
 * To run a query within a React component, call `useSocraticDialogueQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocraticDialogueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocraticDialogueQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      dialogueId: // value for 'dialogueId'
 *   },
 * });
 */
export function useSocraticDialogueQuery(baseOptions: Apollo.QueryHookOptions<SocraticDialogueQuery, SocraticDialogueQueryVariables> & ({ variables: SocraticDialogueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocraticDialogueQuery, SocraticDialogueQueryVariables>(SocraticDialogueDocument, options);
      }
export function useSocraticDialogueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocraticDialogueQuery, SocraticDialogueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocraticDialogueQuery, SocraticDialogueQueryVariables>(SocraticDialogueDocument, options);
        }
export function useSocraticDialogueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SocraticDialogueQuery, SocraticDialogueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SocraticDialogueQuery, SocraticDialogueQueryVariables>(SocraticDialogueDocument, options);
        }
export type SocraticDialogueQueryHookResult = ReturnType<typeof useSocraticDialogueQuery>;
export type SocraticDialogueLazyQueryHookResult = ReturnType<typeof useSocraticDialogueLazyQuery>;
export type SocraticDialogueSuspenseQueryHookResult = ReturnType<typeof useSocraticDialogueSuspenseQuery>;
export type SocraticDialogueQueryResult = Apollo.QueryResult<SocraticDialogueQuery, SocraticDialogueQueryVariables>;
export const SocraticSessionDocument = gql`
    query SocraticSession($workId: ID!, $answerBlockId: ID!) {
  socraticSession(workId: $workId, answerBlockId: $answerBlockId) {
    ...SocraticSession
  }
}
    ${SocraticSessionFragmentDoc}`;

/**
 * __useSocraticSessionQuery__
 *
 * To run a query within a React component, call `useSocraticSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocraticSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocraticSessionQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *      answerBlockId: // value for 'answerBlockId'
 *   },
 * });
 */
export function useSocraticSessionQuery(baseOptions: Apollo.QueryHookOptions<SocraticSessionQuery, SocraticSessionQueryVariables> & ({ variables: SocraticSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocraticSessionQuery, SocraticSessionQueryVariables>(SocraticSessionDocument, options);
      }
export function useSocraticSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocraticSessionQuery, SocraticSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocraticSessionQuery, SocraticSessionQueryVariables>(SocraticSessionDocument, options);
        }
export function useSocraticSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SocraticSessionQuery, SocraticSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SocraticSessionQuery, SocraticSessionQueryVariables>(SocraticSessionDocument, options);
        }
export type SocraticSessionQueryHookResult = ReturnType<typeof useSocraticSessionQuery>;
export type SocraticSessionLazyQueryHookResult = ReturnType<typeof useSocraticSessionLazyQuery>;
export type SocraticSessionSuspenseQueryHookResult = ReturnType<typeof useSocraticSessionSuspenseQuery>;
export type SocraticSessionQueryResult = Apollo.QueryResult<SocraticSessionQuery, SocraticSessionQueryVariables>;
export const StartSocraticDialogueDocument = gql`
    mutation StartSocraticDialogue($workId: ID!, $dialogueId: ID!) {
  startSocraticDialogue(workId: $workId, dialogueId: $dialogueId) {
    session {
      ...SocraticSession
    }
    dialogue {
      ...SocraticDialogue
    }
    error
  }
}
    ${SocraticSessionFragmentDoc}
${SocraticDialogueFragmentDoc}`;
export type StartSocraticDialogueMutationFn = Apollo.MutationFunction<StartSocraticDialogueMutation, StartSocraticDialogueMutationVariables>;

/**
 * __useStartSocraticDialogueMutation__
 *
 * To run a mutation, you first call `useStartSocraticDialogueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSocraticDialogueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSocraticDialogueMutation, { data, loading, error }] = useStartSocraticDialogueMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      dialogueId: // value for 'dialogueId'
 *   },
 * });
 */
export function useStartSocraticDialogueMutation(baseOptions?: Apollo.MutationHookOptions<StartSocraticDialogueMutation, StartSocraticDialogueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSocraticDialogueMutation, StartSocraticDialogueMutationVariables>(StartSocraticDialogueDocument, options);
      }
export type StartSocraticDialogueMutationHookResult = ReturnType<typeof useStartSocraticDialogueMutation>;
export type StartSocraticDialogueMutationResult = Apollo.MutationResult<StartSocraticDialogueMutation>;
export type StartSocraticDialogueMutationOptions = Apollo.BaseMutationOptions<StartSocraticDialogueMutation, StartSocraticDialogueMutationVariables>;
export const StartSocraticTurnDocument = gql`
    mutation StartSocraticTurn($workId: ID!, $turnId: ID!, $recordingStartedAt: PreciseDateTime) {
  startSocraticTurn(
    workId: $workId
    turnId: $turnId
    recordingStartedAt: $recordingStartedAt
  ) {
    dialogue {
      ...SocraticDialogue
    }
  }
}
    ${SocraticDialogueFragmentDoc}`;
export type StartSocraticTurnMutationFn = Apollo.MutationFunction<StartSocraticTurnMutation, StartSocraticTurnMutationVariables>;

/**
 * __useStartSocraticTurnMutation__
 *
 * To run a mutation, you first call `useStartSocraticTurnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSocraticTurnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSocraticTurnMutation, { data, loading, error }] = useStartSocraticTurnMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      turnId: // value for 'turnId'
 *      recordingStartedAt: // value for 'recordingStartedAt'
 *   },
 * });
 */
export function useStartSocraticTurnMutation(baseOptions?: Apollo.MutationHookOptions<StartSocraticTurnMutation, StartSocraticTurnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSocraticTurnMutation, StartSocraticTurnMutationVariables>(StartSocraticTurnDocument, options);
      }
export type StartSocraticTurnMutationHookResult = ReturnType<typeof useStartSocraticTurnMutation>;
export type StartSocraticTurnMutationResult = Apollo.MutationResult<StartSocraticTurnMutation>;
export type StartSocraticTurnMutationOptions = Apollo.BaseMutationOptions<StartSocraticTurnMutation, StartSocraticTurnMutationVariables>;
export const WorkTimelineSnapshotTicksDocument = gql`
    query WorkTimelineSnapshotTicks($assessmentId: ID!, $answerBlockId: ID!, $maxSnapshotId: ID) {
  snapshotTicks(
    assessmentId: $assessmentId
    answerBlockId: $answerBlockId
    maxSnapshotId: $maxSnapshotId
  ) {
    id
    version
    timestamp
  }
}
    `;

/**
 * __useWorkTimelineSnapshotTicksQuery__
 *
 * To run a query within a React component, call `useWorkTimelineSnapshotTicksQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkTimelineSnapshotTicksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkTimelineSnapshotTicksQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      answerBlockId: // value for 'answerBlockId'
 *      maxSnapshotId: // value for 'maxSnapshotId'
 *   },
 * });
 */
export function useWorkTimelineSnapshotTicksQuery(baseOptions: Apollo.QueryHookOptions<WorkTimelineSnapshotTicksQuery, WorkTimelineSnapshotTicksQueryVariables> & ({ variables: WorkTimelineSnapshotTicksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkTimelineSnapshotTicksQuery, WorkTimelineSnapshotTicksQueryVariables>(WorkTimelineSnapshotTicksDocument, options);
      }
export function useWorkTimelineSnapshotTicksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkTimelineSnapshotTicksQuery, WorkTimelineSnapshotTicksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkTimelineSnapshotTicksQuery, WorkTimelineSnapshotTicksQueryVariables>(WorkTimelineSnapshotTicksDocument, options);
        }
export function useWorkTimelineSnapshotTicksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkTimelineSnapshotTicksQuery, WorkTimelineSnapshotTicksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkTimelineSnapshotTicksQuery, WorkTimelineSnapshotTicksQueryVariables>(WorkTimelineSnapshotTicksDocument, options);
        }
export type WorkTimelineSnapshotTicksQueryHookResult = ReturnType<typeof useWorkTimelineSnapshotTicksQuery>;
export type WorkTimelineSnapshotTicksLazyQueryHookResult = ReturnType<typeof useWorkTimelineSnapshotTicksLazyQuery>;
export type WorkTimelineSnapshotTicksSuspenseQueryHookResult = ReturnType<typeof useWorkTimelineSnapshotTicksSuspenseQuery>;
export type WorkTimelineSnapshotTicksQueryResult = Apollo.QueryResult<WorkTimelineSnapshotTicksQuery, WorkTimelineSnapshotTicksQueryVariables>;
export const CreateBlockAttachmentDocument = gql`
    mutation CreateBlockAttachment($answerBlockId: ID!, $mediaId: ID!, $mediaUrl: String!) {
  createBlockAttachment(
    answerBlockId: $answerBlockId
    mediaId: $mediaId
    mediaUrl: $mediaUrl
  ) {
    ...BlockAttachment
  }
}
    ${BlockAttachmentFragmentDoc}`;
export type CreateBlockAttachmentMutationFn = Apollo.MutationFunction<CreateBlockAttachmentMutation, CreateBlockAttachmentMutationVariables>;

/**
 * __useCreateBlockAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateBlockAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlockAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlockAttachmentMutation, { data, loading, error }] = useCreateBlockAttachmentMutation({
 *   variables: {
 *      answerBlockId: // value for 'answerBlockId'
 *      mediaId: // value for 'mediaId'
 *      mediaUrl: // value for 'mediaUrl'
 *   },
 * });
 */
export function useCreateBlockAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlockAttachmentMutation, CreateBlockAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlockAttachmentMutation, CreateBlockAttachmentMutationVariables>(CreateBlockAttachmentDocument, options);
      }
export type CreateBlockAttachmentMutationHookResult = ReturnType<typeof useCreateBlockAttachmentMutation>;
export type CreateBlockAttachmentMutationResult = Apollo.MutationResult<CreateBlockAttachmentMutation>;
export type CreateBlockAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateBlockAttachmentMutation, CreateBlockAttachmentMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($threadId: ID!, $content: String!) {
  createComment(threadId: $threadId, content: $content) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateThreadDocument = gql`
    mutation CreateThread($threadId: ID!, $input: ThreadInput!) {
  createThread(threadId: $threadId, input: $input) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;
export type CreateThreadMutationFn = Apollo.MutationFunction<CreateThreadMutation, CreateThreadMutationVariables>;

/**
 * __useCreateThreadMutation__
 *
 * To run a mutation, you first call `useCreateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadMutation, { data, loading, error }] = useCreateThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateThreadMutation, CreateThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThreadMutation, CreateThreadMutationVariables>(CreateThreadDocument, options);
      }
export type CreateThreadMutationHookResult = ReturnType<typeof useCreateThreadMutation>;
export type CreateThreadMutationResult = Apollo.MutationResult<CreateThreadMutation>;
export type CreateThreadMutationOptions = Apollo.BaseMutationOptions<CreateThreadMutation, CreateThreadMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  me {
    id
    email
    name
    givenName
    familyName
    colourset
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const DeleteThreadDocument = gql`
    mutation DeleteThread($threadId: ID!) {
  deleteThread(threadId: $threadId) {
    id
    createdBy {
      id
      name
    }
  }
}
    `;
export type DeleteThreadMutationFn = Apollo.MutationFunction<DeleteThreadMutation, DeleteThreadMutationVariables>;

/**
 * __useDeleteThreadMutation__
 *
 * To run a mutation, you first call `useDeleteThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThreadMutation, { data, loading, error }] = useDeleteThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useDeleteThreadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThreadMutation, DeleteThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThreadMutation, DeleteThreadMutationVariables>(DeleteThreadDocument, options);
      }
export type DeleteThreadMutationHookResult = ReturnType<typeof useDeleteThreadMutation>;
export type DeleteThreadMutationResult = Apollo.MutationResult<DeleteThreadMutation>;
export type DeleteThreadMutationOptions = Apollo.BaseMutationOptions<DeleteThreadMutation, DeleteThreadMutationVariables>;
export const DeletedAnswerBlockDocument = gql`
    query DeletedAnswerBlock($answerBlockId: ID!) {
  deletedAnswerBlock(answerBlockId: $answerBlockId) {
    ...AnswerBlock
  }
}
    ${AnswerBlockFragmentDoc}`;

/**
 * __useDeletedAnswerBlockQuery__
 *
 * To run a query within a React component, call `useDeletedAnswerBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeletedAnswerBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedAnswerBlockQuery({
 *   variables: {
 *      answerBlockId: // value for 'answerBlockId'
 *   },
 * });
 */
export function useDeletedAnswerBlockQuery(baseOptions: Apollo.QueryHookOptions<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables> & ({ variables: DeletedAnswerBlockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>(DeletedAnswerBlockDocument, options);
      }
export function useDeletedAnswerBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>(DeletedAnswerBlockDocument, options);
        }
export function useDeletedAnswerBlockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>(DeletedAnswerBlockDocument, options);
        }
export type DeletedAnswerBlockQueryHookResult = ReturnType<typeof useDeletedAnswerBlockQuery>;
export type DeletedAnswerBlockLazyQueryHookResult = ReturnType<typeof useDeletedAnswerBlockLazyQuery>;
export type DeletedAnswerBlockSuspenseQueryHookResult = ReturnType<typeof useDeletedAnswerBlockSuspenseQuery>;
export type DeletedAnswerBlockQueryResult = Apollo.QueryResult<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>;
export const WorkTimelineDocumentBaseDocument = gql`
    query WorkTimelineDocumentBase($assessmentId: ID!, $answerBlockId: ID!) {
  documentBase(assessmentId: $assessmentId, answerBlockId: $answerBlockId) {
    baseDoc
  }
}
    `;

/**
 * __useWorkTimelineDocumentBaseQuery__
 *
 * To run a query within a React component, call `useWorkTimelineDocumentBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkTimelineDocumentBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkTimelineDocumentBaseQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      answerBlockId: // value for 'answerBlockId'
 *   },
 * });
 */
export function useWorkTimelineDocumentBaseQuery(baseOptions: Apollo.QueryHookOptions<WorkTimelineDocumentBaseQuery, WorkTimelineDocumentBaseQueryVariables> & ({ variables: WorkTimelineDocumentBaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkTimelineDocumentBaseQuery, WorkTimelineDocumentBaseQueryVariables>(WorkTimelineDocumentBaseDocument, options);
      }
export function useWorkTimelineDocumentBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkTimelineDocumentBaseQuery, WorkTimelineDocumentBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkTimelineDocumentBaseQuery, WorkTimelineDocumentBaseQueryVariables>(WorkTimelineDocumentBaseDocument, options);
        }
export function useWorkTimelineDocumentBaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkTimelineDocumentBaseQuery, WorkTimelineDocumentBaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkTimelineDocumentBaseQuery, WorkTimelineDocumentBaseQueryVariables>(WorkTimelineDocumentBaseDocument, options);
        }
export type WorkTimelineDocumentBaseQueryHookResult = ReturnType<typeof useWorkTimelineDocumentBaseQuery>;
export type WorkTimelineDocumentBaseLazyQueryHookResult = ReturnType<typeof useWorkTimelineDocumentBaseLazyQuery>;
export type WorkTimelineDocumentBaseSuspenseQueryHookResult = ReturnType<typeof useWorkTimelineDocumentBaseSuspenseQuery>;
export type WorkTimelineDocumentBaseQueryResult = Apollo.QueryResult<WorkTimelineDocumentBaseQuery, WorkTimelineDocumentBaseQueryVariables>;
export const WorkTimelineDocumentWindowDocument = gql`
    query WorkTimelineDocumentWindow($assessmentId: ID!, $answerBlockId: ID!, $targetVersion: Int!, $haveSnapshotVersion: Int, $buffer: Int) {
  documentWindow(
    assessmentId: $assessmentId
    answerBlockId: $answerBlockId
    targetVersion: $targetVersion
    haveSnapshotVersion: $haveSnapshotVersion
    buffer: $buffer
  ) {
    baseVersion
    document
    steps {
      version
      data
    }
  }
}
    `;

/**
 * __useWorkTimelineDocumentWindowQuery__
 *
 * To run a query within a React component, call `useWorkTimelineDocumentWindowQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkTimelineDocumentWindowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkTimelineDocumentWindowQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      answerBlockId: // value for 'answerBlockId'
 *      targetVersion: // value for 'targetVersion'
 *      haveSnapshotVersion: // value for 'haveSnapshotVersion'
 *      buffer: // value for 'buffer'
 *   },
 * });
 */
export function useWorkTimelineDocumentWindowQuery(baseOptions: Apollo.QueryHookOptions<WorkTimelineDocumentWindowQuery, WorkTimelineDocumentWindowQueryVariables> & ({ variables: WorkTimelineDocumentWindowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkTimelineDocumentWindowQuery, WorkTimelineDocumentWindowQueryVariables>(WorkTimelineDocumentWindowDocument, options);
      }
export function useWorkTimelineDocumentWindowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkTimelineDocumentWindowQuery, WorkTimelineDocumentWindowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkTimelineDocumentWindowQuery, WorkTimelineDocumentWindowQueryVariables>(WorkTimelineDocumentWindowDocument, options);
        }
export function useWorkTimelineDocumentWindowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkTimelineDocumentWindowQuery, WorkTimelineDocumentWindowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkTimelineDocumentWindowQuery, WorkTimelineDocumentWindowQueryVariables>(WorkTimelineDocumentWindowDocument, options);
        }
export type WorkTimelineDocumentWindowQueryHookResult = ReturnType<typeof useWorkTimelineDocumentWindowQuery>;
export type WorkTimelineDocumentWindowLazyQueryHookResult = ReturnType<typeof useWorkTimelineDocumentWindowLazyQuery>;
export type WorkTimelineDocumentWindowSuspenseQueryHookResult = ReturnType<typeof useWorkTimelineDocumentWindowSuspenseQuery>;
export type WorkTimelineDocumentWindowQueryResult = Apollo.QueryResult<WorkTimelineDocumentWindowQuery, WorkTimelineDocumentWindowQueryVariables>;
export const EditCommentDocument = gql`
    mutation EditComment($commentId: ID!, $content: String!) {
  editComment(commentId: $commentId, content: $content) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export type EditCommentMutationFn = Apollo.MutationFunction<EditCommentMutation, EditCommentMutationVariables>;

/**
 * __useEditCommentMutation__
 *
 * To run a mutation, you first call `useEditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCommentMutation, { data, loading, error }] = useEditCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useEditCommentMutation(baseOptions?: Apollo.MutationHookOptions<EditCommentMutation, EditCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCommentMutation, EditCommentMutationVariables>(EditCommentDocument, options);
      }
export type EditCommentMutationHookResult = ReturnType<typeof useEditCommentMutation>;
export type EditCommentMutationResult = Apollo.MutationResult<EditCommentMutation>;
export type EditCommentMutationOptions = Apollo.BaseMutationOptions<EditCommentMutation, EditCommentMutationVariables>;
export const EntityThreadsDocument = gql`
    query EntityThreads($entityType: EntityType!, $entityIds: [ID!]!) {
  entityThreads(entityType: $entityType, entityIds: $entityIds) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;

/**
 * __useEntityThreadsQuery__
 *
 * To run a query within a React component, call `useEntityThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityThreadsQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useEntityThreadsQuery(baseOptions: Apollo.QueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables> & ({ variables: EntityThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
      }
export function useEntityThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
        }
export function useEntityThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
        }
export type EntityThreadsQueryHookResult = ReturnType<typeof useEntityThreadsQuery>;
export type EntityThreadsLazyQueryHookResult = ReturnType<typeof useEntityThreadsLazyQuery>;
export type EntityThreadsSuspenseQueryHookResult = ReturnType<typeof useEntityThreadsSuspenseQuery>;
export type EntityThreadsQueryResult = Apollo.QueryResult<EntityThreadsQuery, EntityThreadsQueryVariables>;
export const OnEntityThreadsUpdatedDocument = gql`
    subscription onEntityThreadsUpdated($entityId: ID!, $entityType: EntityType!) {
  entityThreadsUpdated(entityId: $entityId, entityType: $entityType) {
    ...EntityThreadEvent
  }
}
    ${EntityThreadEventFragmentDoc}`;

/**
 * __useOnEntityThreadsUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnEntityThreadsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEntityThreadsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEntityThreadsUpdatedSubscription({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useOnEntityThreadsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnEntityThreadsUpdatedSubscription, OnEntityThreadsUpdatedSubscriptionVariables> & ({ variables: OnEntityThreadsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnEntityThreadsUpdatedSubscription, OnEntityThreadsUpdatedSubscriptionVariables>(OnEntityThreadsUpdatedDocument, options);
      }
export type OnEntityThreadsUpdatedSubscriptionHookResult = ReturnType<typeof useOnEntityThreadsUpdatedSubscription>;
export type OnEntityThreadsUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnEntityThreadsUpdatedSubscription>;
export const UpdateExperienceDocument = gql`
    mutation UpdateExperience($workId: ID!, $score: Int!) {
  updateExperience(workId: $workId, score: $score) {
    id
    score
    active
  }
}
    `;
export type UpdateExperienceMutationFn = Apollo.MutationFunction<UpdateExperienceMutation, UpdateExperienceMutationVariables>;

/**
 * __useUpdateExperienceMutation__
 *
 * To run a mutation, you first call `useUpdateExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExperienceMutation, { data, loading, error }] = useUpdateExperienceMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      score: // value for 'score'
 *   },
 * });
 */
export function useUpdateExperienceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExperienceMutation, UpdateExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExperienceMutation, UpdateExperienceMutationVariables>(UpdateExperienceDocument, options);
      }
export type UpdateExperienceMutationHookResult = ReturnType<typeof useUpdateExperienceMutation>;
export type UpdateExperienceMutationResult = Apollo.MutationResult<UpdateExperienceMutation>;
export type UpdateExperienceMutationOptions = Apollo.BaseMutationOptions<UpdateExperienceMutation, UpdateExperienceMutationVariables>;
export const ExperienceDocument = gql`
    query Experience($workId: ID!, $assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    subjectId
  }
  work(workId: $workId) {
    id
    experience {
      id
      score
      active
    }
  }
}
    `;

/**
 * __useExperienceQuery__
 *
 * To run a query within a React component, call `useExperienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperienceQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useExperienceQuery(baseOptions: Apollo.QueryHookOptions<ExperienceQuery, ExperienceQueryVariables> & ({ variables: ExperienceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperienceQuery, ExperienceQueryVariables>(ExperienceDocument, options);
      }
export function useExperienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperienceQuery, ExperienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperienceQuery, ExperienceQueryVariables>(ExperienceDocument, options);
        }
export function useExperienceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperienceQuery, ExperienceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperienceQuery, ExperienceQueryVariables>(ExperienceDocument, options);
        }
export type ExperienceQueryHookResult = ReturnType<typeof useExperienceQuery>;
export type ExperienceLazyQueryHookResult = ReturnType<typeof useExperienceLazyQuery>;
export type ExperienceSuspenseQueryHookResult = ReturnType<typeof useExperienceSuspenseQuery>;
export type ExperienceQueryResult = Apollo.QueryResult<ExperienceQuery, ExperienceQueryVariables>;
export const LatestResultDocument = gql`
    query LatestResult($workId: ID!, $type: SubmissionType!) {
  latestResult(workId: $workId, submissionType: $type) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;

/**
 * __useLatestResultQuery__
 *
 * To run a query within a React component, call `useLatestResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestResultQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLatestResultQuery(baseOptions: Apollo.QueryHookOptions<LatestResultQuery, LatestResultQueryVariables> & ({ variables: LatestResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestResultQuery, LatestResultQueryVariables>(LatestResultDocument, options);
      }
export function useLatestResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestResultQuery, LatestResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestResultQuery, LatestResultQueryVariables>(LatestResultDocument, options);
        }
export function useLatestResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestResultQuery, LatestResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestResultQuery, LatestResultQueryVariables>(LatestResultDocument, options);
        }
export type LatestResultQueryHookResult = ReturnType<typeof useLatestResultQuery>;
export type LatestResultLazyQueryHookResult = ReturnType<typeof useLatestResultLazyQuery>;
export type LatestResultSuspenseQueryHookResult = ReturnType<typeof useLatestResultSuspenseQuery>;
export type LatestResultQueryResult = Apollo.QueryResult<LatestResultQuery, LatestResultQueryVariables>;
export const OnResultUpdatedDocument = gql`
    subscription onResultUpdated($workId: ID!) {
  workResultUpdated(workId: $workId) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;

/**
 * __useOnResultUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnResultUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnResultUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnResultUpdatedSubscription({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useOnResultUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnResultUpdatedSubscription, OnResultUpdatedSubscriptionVariables> & ({ variables: OnResultUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnResultUpdatedSubscription, OnResultUpdatedSubscriptionVariables>(OnResultUpdatedDocument, options);
      }
export type OnResultUpdatedSubscriptionHookResult = ReturnType<typeof useOnResultUpdatedSubscription>;
export type OnResultUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnResultUpdatedSubscription>;
export const RemoveBlockAttachmentDocument = gql`
    mutation RemoveBlockAttachment($blockAttachmentId: ID!) {
  removeBlockAttachment(blockAttachmentId: $blockAttachmentId) {
    ...BlockAttachment
  }
}
    ${BlockAttachmentFragmentDoc}`;
export type RemoveBlockAttachmentMutationFn = Apollo.MutationFunction<RemoveBlockAttachmentMutation, RemoveBlockAttachmentMutationVariables>;

/**
 * __useRemoveBlockAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveBlockAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBlockAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBlockAttachmentMutation, { data, loading, error }] = useRemoveBlockAttachmentMutation({
 *   variables: {
 *      blockAttachmentId: // value for 'blockAttachmentId'
 *   },
 * });
 */
export function useRemoveBlockAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBlockAttachmentMutation, RemoveBlockAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBlockAttachmentMutation, RemoveBlockAttachmentMutationVariables>(RemoveBlockAttachmentDocument, options);
      }
export type RemoveBlockAttachmentMutationHookResult = ReturnType<typeof useRemoveBlockAttachmentMutation>;
export type RemoveBlockAttachmentMutationResult = Apollo.MutationResult<RemoveBlockAttachmentMutation>;
export type RemoveBlockAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveBlockAttachmentMutation, RemoveBlockAttachmentMutationVariables>;
export const ReentryStatusDocument = gql`
    query ReentryStatus($assessmentId: ID!) {
  reentryStatus(assessmentId: $assessmentId) {
    requiresReentryCode
    sessionCount
  }
}
    `;

/**
 * __useReentryStatusQuery__
 *
 * To run a query within a React component, call `useReentryStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReentryStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReentryStatusQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useReentryStatusQuery(baseOptions: Apollo.QueryHookOptions<ReentryStatusQuery, ReentryStatusQueryVariables> & ({ variables: ReentryStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReentryStatusQuery, ReentryStatusQueryVariables>(ReentryStatusDocument, options);
      }
export function useReentryStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReentryStatusQuery, ReentryStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReentryStatusQuery, ReentryStatusQueryVariables>(ReentryStatusDocument, options);
        }
export function useReentryStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReentryStatusQuery, ReentryStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReentryStatusQuery, ReentryStatusQueryVariables>(ReentryStatusDocument, options);
        }
export type ReentryStatusQueryHookResult = ReturnType<typeof useReentryStatusQuery>;
export type ReentryStatusLazyQueryHookResult = ReturnType<typeof useReentryStatusLazyQuery>;
export type ReentryStatusSuspenseQueryHookResult = ReturnType<typeof useReentryStatusSuspenseQuery>;
export type ReentryStatusQueryResult = Apollo.QueryResult<ReentryStatusQuery, ReentryStatusQueryVariables>;
export const ResolveThreadDocument = gql`
    mutation ResolveThread($threadId: ID!) {
  updateThreadResolution(threadId: $threadId, resolved: true) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;
export type ResolveThreadMutationFn = Apollo.MutationFunction<ResolveThreadMutation, ResolveThreadMutationVariables>;

/**
 * __useResolveThreadMutation__
 *
 * To run a mutation, you first call `useResolveThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveThreadMutation, { data, loading, error }] = useResolveThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useResolveThreadMutation(baseOptions?: Apollo.MutationHookOptions<ResolveThreadMutation, ResolveThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveThreadMutation, ResolveThreadMutationVariables>(ResolveThreadDocument, options);
      }
export type ResolveThreadMutationHookResult = ReturnType<typeof useResolveThreadMutation>;
export type ResolveThreadMutationResult = Apollo.MutationResult<ResolveThreadMutation>;
export type ResolveThreadMutationOptions = Apollo.BaseMutationOptions<ResolveThreadMutation, ResolveThreadMutationVariables>;
export const SaveBlockSnapshotDocument = gql`
    mutation SaveBlockSnapshot($workId: ID!, $answerBlockId: ID!, $snapshotContent: String!, $version: Int!, $previousBlockSnapshotId: ID, $wordCountChange: String) {
  saveBlockSnapshot(
    workId: $workId
    answerBlockId: $answerBlockId
    snapshotContent: $snapshotContent
    version: $version
    previousBlockSnapshotId: $previousBlockSnapshotId
    wordCountChange: $wordCountChange
  ) {
    blockSnapshot {
      id
      cacheId
      version
      blockName
    }
  }
}
    `;
export type SaveBlockSnapshotMutationFn = Apollo.MutationFunction<SaveBlockSnapshotMutation, SaveBlockSnapshotMutationVariables>;

/**
 * __useSaveBlockSnapshotMutation__
 *
 * To run a mutation, you first call `useSaveBlockSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBlockSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBlockSnapshotMutation, { data, loading, error }] = useSaveBlockSnapshotMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      answerBlockId: // value for 'answerBlockId'
 *      snapshotContent: // value for 'snapshotContent'
 *      version: // value for 'version'
 *      previousBlockSnapshotId: // value for 'previousBlockSnapshotId'
 *      wordCountChange: // value for 'wordCountChange'
 *   },
 * });
 */
export function useSaveBlockSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<SaveBlockSnapshotMutation, SaveBlockSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBlockSnapshotMutation, SaveBlockSnapshotMutationVariables>(SaveBlockSnapshotDocument, options);
      }
export type SaveBlockSnapshotMutationHookResult = ReturnType<typeof useSaveBlockSnapshotMutation>;
export type SaveBlockSnapshotMutationResult = Apollo.MutationResult<SaveBlockSnapshotMutation>;
export type SaveBlockSnapshotMutationOptions = Apollo.BaseMutationOptions<SaveBlockSnapshotMutation, SaveBlockSnapshotMutationVariables>;
export const SaveDocument = gql`
    mutation Save($workId: ID!, $content: String!, $dispatchedAt: DateTime!, $metadata: SaveMetadataInput, $editor: EditorType) {
  save(
    editor: $editor
    workId: $workId
    content: $content
    dispatchedAt: $dispatchedAt
    metadata: $metadata
  ) {
    id
    serverId
    version
    content
    dispatchedAt
  }
}
    `;
export type SaveMutationFn = Apollo.MutationFunction<SaveMutation, SaveMutationVariables>;

/**
 * __useSaveMutation__
 *
 * To run a mutation, you first call `useSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMutation, { data, loading, error }] = useSaveMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      content: // value for 'content'
 *      dispatchedAt: // value for 'dispatchedAt'
 *      metadata: // value for 'metadata'
 *      editor: // value for 'editor'
 *   },
 * });
 */
export function useSaveMutation(baseOptions?: Apollo.MutationHookOptions<SaveMutation, SaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMutation, SaveMutationVariables>(SaveDocument, options);
      }
export type SaveMutationHookResult = ReturnType<typeof useSaveMutation>;
export type SaveMutationResult = Apollo.MutationResult<SaveMutation>;
export type SaveMutationOptions = Apollo.BaseMutationOptions<SaveMutation, SaveMutationVariables>;
export const StartDocument = gql`
    mutation Start($workId: ID!) {
  start(workId: $workId) {
    id
    startDate
  }
}
    `;
export type StartMutationFn = Apollo.MutationFunction<StartMutation, StartMutationVariables>;

/**
 * __useStartMutation__
 *
 * To run a mutation, you first call `useStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMutation, { data, loading, error }] = useStartMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useStartMutation(baseOptions?: Apollo.MutationHookOptions<StartMutation, StartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMutation, StartMutationVariables>(StartDocument, options);
      }
export type StartMutationHookResult = ReturnType<typeof useStartMutation>;
export type StartMutationResult = Apollo.MutationResult<StartMutation>;
export type StartMutationOptions = Apollo.BaseMutationOptions<StartMutation, StartMutationVariables>;
export const SubmissionDocument = gql`
    query Submission($workId: ID!, $submissionType: SubmissionType!) {
  work(workId: $workId) {
    id
    result(submissionType: $submissionType) {
      id
      submission {
        ...Submission
      }
    }
  }
}
    ${SubmissionFragmentDoc}`;

/**
 * __useSubmissionQuery__
 *
 * To run a query within a React component, call `useSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *      submissionType: // value for 'submissionType'
 *   },
 * });
 */
export function useSubmissionQuery(baseOptions: Apollo.QueryHookOptions<SubmissionQuery, SubmissionQueryVariables> & ({ variables: SubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
      }
export function useSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmissionQuery, SubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
        }
export function useSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubmissionQuery, SubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
        }
export type SubmissionQueryHookResult = ReturnType<typeof useSubmissionQuery>;
export type SubmissionLazyQueryHookResult = ReturnType<typeof useSubmissionLazyQuery>;
export type SubmissionSuspenseQueryHookResult = ReturnType<typeof useSubmissionSuspenseQuery>;
export type SubmissionQueryResult = Apollo.QueryResult<SubmissionQuery, SubmissionQueryVariables>;
export const SubmitAttemptDocument = gql`
    mutation submitAttempt($workId: ID!, $type: SubmissionType!, $attemptNumber: Int!, $submissionDate: DateTime, $submissionTrigger: SubmissionTrigger) {
  submitAttemptV2(
    workId: $workId
    type: $type
    attemptNumber: $attemptNumber
    submissionDate: $submissionDate
    submissionTrigger: $submissionTrigger
  ) {
    nextAttemptNumber
    result {
      ...Result
    }
  }
}
    ${ResultFragmentDoc}`;
export type SubmitAttemptMutationFn = Apollo.MutationFunction<SubmitAttemptMutation, SubmitAttemptMutationVariables>;

/**
 * __useSubmitAttemptMutation__
 *
 * To run a mutation, you first call `useSubmitAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAttemptMutation, { data, loading, error }] = useSubmitAttemptMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      type: // value for 'type'
 *      attemptNumber: // value for 'attemptNumber'
 *      submissionDate: // value for 'submissionDate'
 *      submissionTrigger: // value for 'submissionTrigger'
 *   },
 * });
 */
export function useSubmitAttemptMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAttemptMutation, SubmitAttemptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAttemptMutation, SubmitAttemptMutationVariables>(SubmitAttemptDocument, options);
      }
export type SubmitAttemptMutationHookResult = ReturnType<typeof useSubmitAttemptMutation>;
export type SubmitAttemptMutationResult = Apollo.MutationResult<SubmitAttemptMutation>;
export type SubmitAttemptMutationOptions = Apollo.BaseMutationOptions<SubmitAttemptMutation, SubmitAttemptMutationVariables>;
export const SubmitDocument = gql`
    mutation Submit($workId: ID!, $saveId: ID!, $type: SubmissionType!, $submittedAt: DateTime!, $acceptedDeclaration: Boolean!, $sessionId: String, $editor: EditorType, $submissionTrigger: SubmissionTrigger) {
  submit(
    editor: $editor
    workId: $workId
    saveId: $saveId
    type: $type
    submittedAt: $submittedAt
    acceptedDeclaration: $acceptedDeclaration
    sessionId: $sessionId
    submissionTrigger: $submissionTrigger
  ) {
    ...Submission
  }
}
    ${SubmissionFragmentDoc}`;
export type SubmitMutationFn = Apollo.MutationFunction<SubmitMutation, SubmitMutationVariables>;

/**
 * __useSubmitMutation__
 *
 * To run a mutation, you first call `useSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMutation, { data, loading, error }] = useSubmitMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      saveId: // value for 'saveId'
 *      type: // value for 'type'
 *      submittedAt: // value for 'submittedAt'
 *      acceptedDeclaration: // value for 'acceptedDeclaration'
 *      sessionId: // value for 'sessionId'
 *      editor: // value for 'editor'
 *      submissionTrigger: // value for 'submissionTrigger'
 *   },
 * });
 */
export function useSubmitMutation(baseOptions?: Apollo.MutationHookOptions<SubmitMutation, SubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMutation, SubmitMutationVariables>(SubmitDocument, options);
      }
export type SubmitMutationHookResult = ReturnType<typeof useSubmitMutation>;
export type SubmitMutationResult = Apollo.MutationResult<SubmitMutation>;
export type SubmitMutationOptions = Apollo.BaseMutationOptions<SubmitMutation, SubmitMutationVariables>;
export const OnThreadConversationUpdatedDocument = gql`
    subscription onThreadConversationUpdated($threadId: ID!) {
  threadConversationUpdated(threadId: $threadId) {
    ...ConversationEvent
  }
}
    ${ConversationEventFragmentDoc}`;

/**
 * __useOnThreadConversationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnThreadConversationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnThreadConversationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnThreadConversationUpdatedSubscription({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useOnThreadConversationUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnThreadConversationUpdatedSubscription, OnThreadConversationUpdatedSubscriptionVariables> & ({ variables: OnThreadConversationUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnThreadConversationUpdatedSubscription, OnThreadConversationUpdatedSubscriptionVariables>(OnThreadConversationUpdatedDocument, options);
      }
export type OnThreadConversationUpdatedSubscriptionHookResult = ReturnType<typeof useOnThreadConversationUpdatedSubscription>;
export type OnThreadConversationUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnThreadConversationUpdatedSubscription>;
export const ThreadDocument = gql`
    query Thread($id: ID!) {
  thread(threadId: $id) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;

/**
 * __useThreadQuery__
 *
 * To run a query within a React component, call `useThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThreadQuery(baseOptions: Apollo.QueryHookOptions<ThreadQuery, ThreadQueryVariables> & ({ variables: ThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreadQuery, ThreadQueryVariables>(ThreadDocument, options);
      }
export function useThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreadQuery, ThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreadQuery, ThreadQueryVariables>(ThreadDocument, options);
        }
export function useThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThreadQuery, ThreadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThreadQuery, ThreadQueryVariables>(ThreadDocument, options);
        }
export type ThreadQueryHookResult = ReturnType<typeof useThreadQuery>;
export type ThreadLazyQueryHookResult = ReturnType<typeof useThreadLazyQuery>;
export type ThreadSuspenseQueryHookResult = ReturnType<typeof useThreadSuspenseQuery>;
export type ThreadQueryResult = Apollo.QueryResult<ThreadQuery, ThreadQueryVariables>;
export const OnThreadUpdatedDocument = gql`
    subscription onThreadUpdated($id: ID!) {
  threadUpdated(threadId: $id) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;

/**
 * __useOnThreadUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnThreadUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnThreadUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnThreadUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnThreadUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnThreadUpdatedSubscription, OnThreadUpdatedSubscriptionVariables> & ({ variables: OnThreadUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnThreadUpdatedSubscription, OnThreadUpdatedSubscriptionVariables>(OnThreadUpdatedDocument, options);
      }
export type OnThreadUpdatedSubscriptionHookResult = ReturnType<typeof useOnThreadUpdatedSubscription>;
export type OnThreadUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnThreadUpdatedSubscription>;
export const WorkTimelineContributionsDocument = gql`
    query WorkTimelineContributions($assessmentId: ID!, $answerBlockId: ID!, $versions: [Int!]!) {
  contributionsAt(
    assessmentId: $assessmentId
    answerBlockId: $answerBlockId
    versions: $versions
  ) {
    asOfVersion
    members {
      userId
      ranges {
        from
        to
      }
    }
  }
}
    `;

/**
 * __useWorkTimelineContributionsQuery__
 *
 * To run a query within a React component, call `useWorkTimelineContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkTimelineContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkTimelineContributionsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      answerBlockId: // value for 'answerBlockId'
 *      versions: // value for 'versions'
 *   },
 * });
 */
export function useWorkTimelineContributionsQuery(baseOptions: Apollo.QueryHookOptions<WorkTimelineContributionsQuery, WorkTimelineContributionsQueryVariables> & ({ variables: WorkTimelineContributionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkTimelineContributionsQuery, WorkTimelineContributionsQueryVariables>(WorkTimelineContributionsDocument, options);
      }
export function useWorkTimelineContributionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkTimelineContributionsQuery, WorkTimelineContributionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkTimelineContributionsQuery, WorkTimelineContributionsQueryVariables>(WorkTimelineContributionsDocument, options);
        }
export function useWorkTimelineContributionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkTimelineContributionsQuery, WorkTimelineContributionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkTimelineContributionsQuery, WorkTimelineContributionsQueryVariables>(WorkTimelineContributionsDocument, options);
        }
export type WorkTimelineContributionsQueryHookResult = ReturnType<typeof useWorkTimelineContributionsQuery>;
export type WorkTimelineContributionsLazyQueryHookResult = ReturnType<typeof useWorkTimelineContributionsLazyQuery>;
export type WorkTimelineContributionsSuspenseQueryHookResult = ReturnType<typeof useWorkTimelineContributionsSuspenseQuery>;
export type WorkTimelineContributionsQueryResult = Apollo.QueryResult<WorkTimelineContributionsQuery, WorkTimelineContributionsQueryVariables>;
export const WorkTimelineSnapshotsDocument = gql`
    query WorkTimelineSnapshots($assessmentId: ID!, $answerBlockId: ID!, $versions: [Int!]!) {
  snapshots(
    assessmentId: $assessmentId
    answerBlockId: $answerBlockId
    versions: $versions
  ) {
    asOfVersion
    document
  }
}
    `;

/**
 * __useWorkTimelineSnapshotsQuery__
 *
 * To run a query within a React component, call `useWorkTimelineSnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkTimelineSnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkTimelineSnapshotsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      answerBlockId: // value for 'answerBlockId'
 *      versions: // value for 'versions'
 *   },
 * });
 */
export function useWorkTimelineSnapshotsQuery(baseOptions: Apollo.QueryHookOptions<WorkTimelineSnapshotsQuery, WorkTimelineSnapshotsQueryVariables> & ({ variables: WorkTimelineSnapshotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkTimelineSnapshotsQuery, WorkTimelineSnapshotsQueryVariables>(WorkTimelineSnapshotsDocument, options);
      }
export function useWorkTimelineSnapshotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkTimelineSnapshotsQuery, WorkTimelineSnapshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkTimelineSnapshotsQuery, WorkTimelineSnapshotsQueryVariables>(WorkTimelineSnapshotsDocument, options);
        }
export function useWorkTimelineSnapshotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkTimelineSnapshotsQuery, WorkTimelineSnapshotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkTimelineSnapshotsQuery, WorkTimelineSnapshotsQueryVariables>(WorkTimelineSnapshotsDocument, options);
        }
export type WorkTimelineSnapshotsQueryHookResult = ReturnType<typeof useWorkTimelineSnapshotsQuery>;
export type WorkTimelineSnapshotsLazyQueryHookResult = ReturnType<typeof useWorkTimelineSnapshotsLazyQuery>;
export type WorkTimelineSnapshotsSuspenseQueryHookResult = ReturnType<typeof useWorkTimelineSnapshotsSuspenseQuery>;
export type WorkTimelineSnapshotsQueryResult = Apollo.QueryResult<WorkTimelineSnapshotsQuery, WorkTimelineSnapshotsQueryVariables>;
export const UnresolveThreadDocument = gql`
    mutation UnresolveThread($threadId: ID!) {
  updateThreadResolution(threadId: $threadId, resolved: false) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;
export type UnresolveThreadMutationFn = Apollo.MutationFunction<UnresolveThreadMutation, UnresolveThreadMutationVariables>;

/**
 * __useUnresolveThreadMutation__
 *
 * To run a mutation, you first call `useUnresolveThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnresolveThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unresolveThreadMutation, { data, loading, error }] = useUnresolveThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useUnresolveThreadMutation(baseOptions?: Apollo.MutationHookOptions<UnresolveThreadMutation, UnresolveThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnresolveThreadMutation, UnresolveThreadMutationVariables>(UnresolveThreadDocument, options);
      }
export type UnresolveThreadMutationHookResult = ReturnType<typeof useUnresolveThreadMutation>;
export type UnresolveThreadMutationResult = Apollo.MutationResult<UnresolveThreadMutation>;
export type UnresolveThreadMutationOptions = Apollo.BaseMutationOptions<UnresolveThreadMutation, UnresolveThreadMutationVariables>;
export const UnsubmitDocument = gql`
    mutation Unsubmit($workId: ID!, $submissionId: ID!) {
  unsubmit(workId: $workId, submissionId: $submissionId) {
    ...Submission
  }
}
    ${SubmissionFragmentDoc}`;
export type UnsubmitMutationFn = Apollo.MutationFunction<UnsubmitMutation, UnsubmitMutationVariables>;

/**
 * __useUnsubmitMutation__
 *
 * To run a mutation, you first call `useUnsubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubmitMutation, { data, loading, error }] = useUnsubmitMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useUnsubmitMutation(baseOptions?: Apollo.MutationHookOptions<UnsubmitMutation, UnsubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubmitMutation, UnsubmitMutationVariables>(UnsubmitDocument, options);
      }
export type UnsubmitMutationHookResult = ReturnType<typeof useUnsubmitMutation>;
export type UnsubmitMutationResult = Apollo.MutationResult<UnsubmitMutation>;
export type UnsubmitMutationOptions = Apollo.BaseMutationOptions<UnsubmitMutation, UnsubmitMutationVariables>;
export const UpdateAnswerBlockDocument = gql`
    mutation UpdateAnswerBlock($answerBlockId: ID!, $input: UpdateAnswerBlockInput!) {
  updateAnswerBlock(answerBlockId: $answerBlockId, input: $input) {
    id
    skip
    bookmark
    confirm
  }
}
    `;
export type UpdateAnswerBlockMutationFn = Apollo.MutationFunction<UpdateAnswerBlockMutation, UpdateAnswerBlockMutationVariables>;

/**
 * __useUpdateAnswerBlockMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerBlockMutation, { data, loading, error }] = useUpdateAnswerBlockMutation({
 *   variables: {
 *      answerBlockId: // value for 'answerBlockId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnswerBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnswerBlockMutation, UpdateAnswerBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnswerBlockMutation, UpdateAnswerBlockMutationVariables>(UpdateAnswerBlockDocument, options);
      }
export type UpdateAnswerBlockMutationHookResult = ReturnType<typeof useUpdateAnswerBlockMutation>;
export type UpdateAnswerBlockMutationResult = Apollo.MutationResult<UpdateAnswerBlockMutation>;
export type UpdateAnswerBlockMutationOptions = Apollo.BaseMutationOptions<UpdateAnswerBlockMutation, UpdateAnswerBlockMutationVariables>;
export const VerifyAccessCodeV2Document = gql`
    mutation VerifyAccessCodeV2($code: String!, $assessmentId: ID!) {
  verifyAccessCodeV2(code: $code, assessmentId: $assessmentId) {
    success
    failureReason
    session {
      ...Session
    }
  }
}
    ${SessionFragmentDoc}`;
export type VerifyAccessCodeV2MutationFn = Apollo.MutationFunction<VerifyAccessCodeV2Mutation, VerifyAccessCodeV2MutationVariables>;

/**
 * __useVerifyAccessCodeV2Mutation__
 *
 * To run a mutation, you first call `useVerifyAccessCodeV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAccessCodeV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAccessCodeV2Mutation, { data, loading, error }] = useVerifyAccessCodeV2Mutation({
 *   variables: {
 *      code: // value for 'code'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useVerifyAccessCodeV2Mutation(baseOptions?: Apollo.MutationHookOptions<VerifyAccessCodeV2Mutation, VerifyAccessCodeV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAccessCodeV2Mutation, VerifyAccessCodeV2MutationVariables>(VerifyAccessCodeV2Document, options);
      }
export type VerifyAccessCodeV2MutationHookResult = ReturnType<typeof useVerifyAccessCodeV2Mutation>;
export type VerifyAccessCodeV2MutationResult = Apollo.MutationResult<VerifyAccessCodeV2Mutation>;
export type VerifyAccessCodeV2MutationOptions = Apollo.BaseMutationOptions<VerifyAccessCodeV2Mutation, VerifyAccessCodeV2MutationVariables>;
export const WorkDocument = gql`
    query Work($workId: ID!, $assessmentId: ID!) {
  token
  work(workId: $workId) {
    id
    startDate
    sheet {
      ...Sheet
    }
    group {
      id
      name
    }
    features {
      id
      enableWorkAuthority
      enableIndividualCollab
      enableTenantStreams
      enableOfflinePersistence
      enableFontControls(assessmentId: $assessmentId)
    }
    ...WorkSubmitAttempt
    settings {
      ...WorkSettings
    }
    answerBlocks {
      ...AnswerBlock
    }
    latestSave {
      ...Save
    }
    latestSentimentCheck {
      ...SentimentCheck
    }
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
  studentOutcome(assessmentId: $assessmentId) {
    ...StudentOutcomeScore
  }
  workOutcome(workId: $workId) {
    finalRelease {
      feedbackVisibility {
        feedbackViewLevel
      }
    }
    provisionalRelease {
      feedbackVisibility {
        feedbackViewLevel
      }
    }
  }
}
    ${SheetFragmentDoc}
${WorkSubmitAttemptFragmentDoc}
${WorkSettingsFragmentDoc}
${AnswerBlockFragmentDoc}
${SaveFragmentDoc}
${SentimentCheckFragmentDoc}
${FeatureFlagsFragmentDoc}
${StudentOutcomeScoreFragmentDoc}`;

/**
 * __useWorkQuery__
 *
 * To run a query within a React component, call `useWorkQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useWorkQuery(baseOptions: Apollo.QueryHookOptions<WorkQuery, WorkQueryVariables> & ({ variables: WorkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkQuery, WorkQueryVariables>(WorkDocument, options);
      }
export function useWorkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkQuery, WorkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkQuery, WorkQueryVariables>(WorkDocument, options);
        }
export function useWorkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkQuery, WorkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkQuery, WorkQueryVariables>(WorkDocument, options);
        }
export type WorkQueryHookResult = ReturnType<typeof useWorkQuery>;
export type WorkLazyQueryHookResult = ReturnType<typeof useWorkLazyQuery>;
export type WorkSuspenseQueryHookResult = ReturnType<typeof useWorkSuspenseQuery>;
export type WorkQueryResult = Apollo.QueryResult<WorkQuery, WorkQueryVariables>;
export const OnWorkSettingsUpdatedDocument = gql`
    subscription onWorkSettingsUpdated($workId: ID!) {
  workSettingsUpdated(workId: $workId) {
    ...WorkSettings
  }
}
    ${WorkSettingsFragmentDoc}`;

/**
 * __useOnWorkSettingsUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnWorkSettingsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkSettingsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkSettingsUpdatedSubscription({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useOnWorkSettingsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnWorkSettingsUpdatedSubscription, OnWorkSettingsUpdatedSubscriptionVariables> & ({ variables: OnWorkSettingsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkSettingsUpdatedSubscription, OnWorkSettingsUpdatedSubscriptionVariables>(OnWorkSettingsUpdatedDocument, options);
      }
export type OnWorkSettingsUpdatedSubscriptionHookResult = ReturnType<typeof useOnWorkSettingsUpdatedSubscription>;
export type OnWorkSettingsUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnWorkSettingsUpdatedSubscription>;
export const OnWorkStartedDocument = gql`
    subscription onWorkStarted($workId: ID!) {
  workStarted(workId: $workId) {
    id
    startDate
    sheet {
      ...Sheet
    }
  }
}
    ${SheetFragmentDoc}`;

/**
 * __useOnWorkStartedSubscription__
 *
 * To run a query within a React component, call `useOnWorkStartedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkStartedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkStartedSubscription({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useOnWorkStartedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnWorkStartedSubscription, OnWorkStartedSubscriptionVariables> & ({ variables: OnWorkStartedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkStartedSubscription, OnWorkStartedSubscriptionVariables>(OnWorkStartedDocument, options);
      }
export type OnWorkStartedSubscriptionHookResult = ReturnType<typeof useOnWorkStartedSubscription>;
export type OnWorkStartedSubscriptionResult = Apollo.SubscriptionResult<OnWorkStartedSubscription>;
export const OnWorkSubmittedDocument = gql`
    subscription onWorkSubmitted($workId: ID!) {
  workSubmitted(workId: $workId) {
    ...Submission
  }
}
    ${SubmissionFragmentDoc}`;

/**
 * __useOnWorkSubmittedSubscription__
 *
 * To run a query within a React component, call `useOnWorkSubmittedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkSubmittedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkSubmittedSubscription({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useOnWorkSubmittedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnWorkSubmittedSubscription, OnWorkSubmittedSubscriptionVariables> & ({ variables: OnWorkSubmittedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkSubmittedSubscription, OnWorkSubmittedSubscriptionVariables>(OnWorkSubmittedDocument, options);
      }
export type OnWorkSubmittedSubscriptionHookResult = ReturnType<typeof useOnWorkSubmittedSubscription>;
export type OnWorkSubmittedSubscriptionResult = Apollo.SubscriptionResult<OnWorkSubmittedSubscription>;
export const WorkTimelineWorkVersionsDocument = gql`
    query WorkTimelineWorkVersions($assessmentId: ID!, $answerBlockIds: [ID!]!, $first: Int!, $after: String) {
  workVersions(
    assessmentId: $assessmentId
    answerBlockIds: $answerBlockIds
    first: $first
    after: $after
  ) {
    nodes {
      id
      answerBlockId
      version
      timestamp
      author {
        userId
        name
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useWorkTimelineWorkVersionsQuery__
 *
 * To run a query within a React component, call `useWorkTimelineWorkVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkTimelineWorkVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkTimelineWorkVersionsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      answerBlockIds: // value for 'answerBlockIds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useWorkTimelineWorkVersionsQuery(baseOptions: Apollo.QueryHookOptions<WorkTimelineWorkVersionsQuery, WorkTimelineWorkVersionsQueryVariables> & ({ variables: WorkTimelineWorkVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkTimelineWorkVersionsQuery, WorkTimelineWorkVersionsQueryVariables>(WorkTimelineWorkVersionsDocument, options);
      }
export function useWorkTimelineWorkVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkTimelineWorkVersionsQuery, WorkTimelineWorkVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkTimelineWorkVersionsQuery, WorkTimelineWorkVersionsQueryVariables>(WorkTimelineWorkVersionsDocument, options);
        }
export function useWorkTimelineWorkVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkTimelineWorkVersionsQuery, WorkTimelineWorkVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkTimelineWorkVersionsQuery, WorkTimelineWorkVersionsQueryVariables>(WorkTimelineWorkVersionsDocument, options);
        }
export type WorkTimelineWorkVersionsQueryHookResult = ReturnType<typeof useWorkTimelineWorkVersionsQuery>;
export type WorkTimelineWorkVersionsLazyQueryHookResult = ReturnType<typeof useWorkTimelineWorkVersionsLazyQuery>;
export type WorkTimelineWorkVersionsSuspenseQueryHookResult = ReturnType<typeof useWorkTimelineWorkVersionsSuspenseQuery>;
export type WorkTimelineWorkVersionsQueryResult = Apollo.QueryResult<WorkTimelineWorkVersionsQuery, WorkTimelineWorkVersionsQueryVariables>;